
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eiCiP", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $i6sMX = parcelRequire("i6sMX");

async function $ce9420cf2e1537b9$export$aa71e886f3713f68() {
    const { userId: userId, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $i6sMX.getRemoteLocalStorage)({
        userId: userId,
        isLicensed: isLicensed
    });
}
module.exports["preloadLocalStorage"] = $ce9420cf2e1537b9$export$aa71e886f3713f68;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);

var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("bgmQP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $dTk3A = parcelRequire("dTk3A");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $cgtv4.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_zulp1b66 _1e0c1txw _2lx21bp4"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $dTk3A.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $dTk3A.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6T8v4.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("cbHql", function(module, exports) {
/**
 * @generated SignedSource<<3153bcb981f4a517d68dcc1b4a115e37>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5
const $40163854596f3729$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c67b40e0841cbe3641e147b8f635e291",
            "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
            "metadata": {},
            "name": "EditorPreferencesQuery",
            "operationKind": "query",
            "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$40163854596f3729$var$node.hash = "49dd5f6cf6c26477ad455a4c7f501e60";
var $40163854596f3729$export$2e2bcd8739ae039 = $40163854596f3729$var$node;
module.exports["default"] = $40163854596f3729$export$2e2bcd8739ae039;

});

parcelRegister("iUV81", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

parcelRequire("furnK");
var $7WOVi = parcelRequire("7WOVi");


var $4zhNK = parcelRequire("4zhNK");


var $iV8Fk = parcelRequire("iV8Fk");


var $fyUox = parcelRequire("fyUox");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $aOHMQ = parcelRequire("aOHMQ");


var $cvj7x = parcelRequire("cvj7x");


var $7tT2b = parcelRequire("7tT2b");


var $d9tcB = parcelRequire("d9tcB");


var $wPrRK = parcelRequire("wPrRK");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");


var $kkLBe = parcelRequire("kkLBe");


var $9ycGg = parcelRequire("9ycGg");


var $lcQ5b = parcelRequire("lcQ5b");

parcelRequire("8nle6");
var $5SzHz = parcelRequire("5SzHz");


var $gBI6h = parcelRequire("gBI6h");


var $h8QBE = parcelRequire("h8QBE");


var $lt4mJ = parcelRequire("lt4mJ");


var $dhOY2 = parcelRequire("dhOY2");


var $4VJDS = parcelRequire("4VJDS");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");


var $28DDG = parcelRequire("28DDG");


var $gDMf3 = parcelRequire("gDMf3");




/**
 * @generated SignedSource<<dc8e87d991fa3d0a0656b1eb680e982b>>
 * @relayHash bba66764bbafcab2a61fad47a47389c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329
const $f3a2015b254b5cf4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isUsdSsr"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "value"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v8 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ], v11 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v12 = {
        "alias": "emojiTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-draft\")"
    }, v13 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "defaultTitleEmoji"
                    }
                ]
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-draft\")"
    }, v15 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "coverPictureWidth"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "color"
    }, v18 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isCallerPermitted"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v21 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v23 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v25 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v26 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                v16 /*: any*/ 
            ]
        }
    ], v27 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SpaceSettingsMetadata",
                        "kind": "LinkedField",
                        "name": "customHeaderAndFooter",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": v26 /*: any*/ 
                            },
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "footer",
                                "plural": false,
                                "selections": v26 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "AvailableContentStates",
        "kind": "LinkedField",
        "name": "availableContentStates",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "customContentStates",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            },
            {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "spaceContentStates",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v5 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ]
    }, v29 = {
        "condition": "isUsdSsr",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    }
                ]
            }
        ]
    }, v30 = {
        "alias": "user",
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "userId"
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "displayName"
            },
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadLivePageDataQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadLivePageDataQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v7 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "bba66764bbafcab2a61fad47a47389c3",
            "id": "6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329",
            "metadata": {},
            "name": "preloadLivePageDataQuery",
            "operationKind": "query",
            "text": "query preloadLivePageDataQuery($userId:ID,$contentId:ID!,$spaceKey:String!,$isUsdSsr:Boolean!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,status,type,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}},properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth},currentuser{favourited{isFavourite}}},contentState(isDraft:false){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY){value},operations{operation,targetType},subType,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},labels{nodes{id,name}}}},space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}},publicLinkPage(pageId:$contentId)@include(if:$isUsdSsr){pageId,pageStatus},user:confluence_atlassianUser(id:$userId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$f3a2015b254b5cf4$var$node.hash = "fc27c69a6916f3d6cce88a681314b6ab";
var $f3a2015b254b5cf4$export$2e2bcd8739ae039 = $f3a2015b254b5cf4$var$node;









var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");





var $4vyfK = parcelRequire("4vyfK");


var $9OYfw = parcelRequire("9OYfw");


var $7Ndnw = parcelRequire("7Ndnw");


var $8CHHT = parcelRequire("8CHHT");


var $hr9NW = parcelRequire("hr9NW");


var $6GukH = parcelRequire("6GukH");


var $kDt9L = parcelRequire("kDt9L");


var $cRQNp = parcelRequire("cRQNp");





var $l1kdf = parcelRequire("l1kdf");


var $4trRg = parcelRequire("4trRg");


var $9sGCn = parcelRequire("9sGCn");

const $fcf64901f9c33eb1$var$preloadLivePageDataQuery = (0, $f3a2015b254b5cf4$export$2e2bcd8739ae039);
function $fcf64901f9c33eb1$export$1806ccc2683c4734({ userId: userId, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId }) {
    const preloaders = [];
    // 1. Editor data
    // specific native collab editor queries
    if (!!contentId) {
        preloaders.push((0, $9OYfw.preloadCollabDraftContent)(contentId, '', false));
        preloaders.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, false));
        if (!(0, $9wGTI.fg)('platform_synced_block_ssr_v2')) // assume live pages are not blogs
        preloaders.push((0, $6GukH.preloadEditorSyncedBlocksData)(contentId, cloudId, false));
        if ((0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
            // Get isArchived from cached page data
            const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
            preloaders.push((0, $4trRg.preloadContentMode)({
                contentId: contentId,
                isDraft: false,
                useCache: false,
                isArchived: isArchived
            }));
        }
        preloaders.push((0, $kDt9L.preloadMentionsProvider)());
    }
    preloaders.push(// Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
    (0, $4vyfK.preloadWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
    }), (0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey || '',
        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
    }));
    preloaders.push((0, $cRQNp.preloadReadTime)({
        contentId: contentId,
        useCache: false
    }));
    // 2. Unified data
    return (0, $lyWac.waitForAllReturnWhenError)([
        (()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $dYU3e.query)({
                query: $fcf64901f9c33eb1$var$preloadLivePageDataQuery,
                variables: {
                    userId: userId,
                    contentId: contentId,
                    spaceKey: spaceKey,
                    isUsdSsr: (0, $9wGTI.fg)('confluence_frontend_usd_ssr')
                },
                fetchPolicy: 'network-only'
            }).then((response)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                if (response.data) {
                    const nativeCollabVariables = {
                        contentId: contentId,
                        status: [
                            'draft',
                            'current'
                        ]
                    };
                    (0, $fEmGS.writeQueryInterop)({
                        /* @ts-expect-error http://go/cfe-use-relay-artifacts */ query: (0, $l1kdf.NativeCollabQuery),
                        variables: nativeCollabVariables,
                        data: response.data
                    });
                }
            });
        })(),
        ...preloaders
    ]);
}









var $ePnB5 = parcelRequire("ePnB5");


var $3U5ab = parcelRequire("3U5ab");


var $jsQRz = parcelRequire("jsQRz");


var $1swiX = parcelRequire("1swiX");


var $kM8fE = parcelRequire("kM8fE");


var $dpyxe = parcelRequire("dpyxe");


var $22UVa = parcelRequire("22UVa");


var $1k2r8 = parcelRequire("1k2r8");

const $9ca0f3e234cc6f7f$export$b30d199cd0e05754 = async (match, url)=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, environment: environment } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    if ((0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true)) // replaces preloadEditorData
    tasks.push((0, $fcf64901f9c33eb1$export$1806ccc2683c4734)({
        userId: userId,
        contentId: contentId,
        spaceKey: spaceKey,
        cloudId: cloudId
    }));
    else tasks.push((0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
            spaceKey: spaceKey,
            contentId: contentId,
            shouldPreloadMentionsProvider: true,
            useCache: false,
            cloudId: cloudId,
            isBlog: isBlog,
            isLivePage: true
        })));
    // 1. Byline and possibly content prerequisites
    tasks.push((()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $7WOVi.preloadContentHeader)({
            spaceKey: spaceKey,
            contentId: contentId,
            isLicensed: isLicensed,
            userId: userId,
            username: username,
            edition: edition,
            isPrevEditRoute: false,
            useNewContentTopper: true,
            isLivePageRoute: true
        }).then((resultOrHasErrorBoolean)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (typeof resultOrHasErrorBoolean === 'boolean') {
                if (resultOrHasErrorBoolean) return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
            } else {
                const { results: results, hasErrors: hasErrors } = resultOrHasErrorBoolean;
                if (!hasErrors) return results;
                return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
            }
        });
    })(), (0, $lt4mJ.preloadLegacyBridge)({
        contentId: contentId,
        isBlog: isBlog
    }));
    if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true)) tasks.push((0, $gBI6h.preloadPageStatusQuery)(contentId));
    // 2. Page title
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceKey
    }));
    // 3. Space details
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // 4. Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    // 4a. Unified Share and Restrict Button
    if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    // 5. Navigation and page tree
    if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog));
    // 6. Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $aOHMQ.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // 7. Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // TODO: delete
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // 10. Stuff only needed for initial load
    tasks.push(// We only refresh token when it is about to expire.
    (0, $1i2qc.preloadMediaToken)(contentId));
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey);
    // Preload onboarding state for live page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) tasks.push((0, $1k2r8.preloadAllOnboardingState)());
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // 11. Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog));
    // 12. Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // 14. Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    // 15. Preload footer comments
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // this query is needed for the new redesigned footer comment experience
    {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            // Use new preloadObjectComments when experiment is enabled, otherwise use legacy
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) tasks.push((0, $3U5ab.preloadObjectComments)(contentId));
            else tasks.push((0, $ePnB5.preloadFooterComments)(contentId));
        }
    }
    // 16. Preload add comment permission check
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $jsQRz.preloadAddCommentPermissionCheck)(contentId));
    }
    // 17. Recommendations
    const recommendationsTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_preload_recommendation_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
        return (0, $dhOY2.preloadEndOfPageRecommendation)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlog ? 'blogpost' : 'page'
        });
    }, recommendationsTimeout));
    //18. Preload Smart Create Feedback Banner
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    //19. Add Onboarding State for revamped bpqa
    if ((0, $9wGTI.fg)('cfind-5063-revamped-bpqa-live-page-preload-gate')) tasks.push((0, $h8QBE.preloadLandUsersInEditorWithRevampedBpqa)());
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadLivePageRoute"] = $9ca0f3e234cc6f7f$export$b30d199cd0e05754;

});

parcelRegister("furnK", function(module, exports) {
$parcel$export(module.exports, "preloadContentHeader", () => (parcelRequire("7WOVi")).preloadContentHeader);

var $7WOVi = parcelRequire("7WOVi");


});

parcelRegister("wPrRK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $3mugH = parcelRequire("3mugH");


var $9WAeG = parcelRequire("9WAeG");


var $4VJDS = parcelRequire("4VJDS");

const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            // eslint-disable-next-line no-console
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`SlowQueryGuard "${name}" timed out after ${finalTimeout}ms`));
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (timer) clearTimeout(timer);
        return true;
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("3D1KL", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

/**
 * @generated SignedSource<<5fc362164b35d39c956698aa73e6331d>>
 * @relayHash 28437bd051bb517523bd8bb255843261
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60
const $11a6e253e07228af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "embedded"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "collabService"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "28437bd051bb517523bd8bb255843261",
            "id": "85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60",
            "metadata": {},
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadEditButtonWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id,key},spaceHomepage(spaceKey:$spaceKey){id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType}}"
        }
    };
}();
$11a6e253e07228af$var$node.hash = "d44363b7caa9c4f4861198079067c51c";
var $11a6e253e07228af$export$2e2bcd8739ae039 = $11a6e253e07228af$var$node;



var $dYU3e = parcelRequire("dYU3e");


var $4YBSq = parcelRequire("4YBSq");

const $da246eeeea807732$var$preloadEditButtonWithSpaceKeyQuery = (0, $11a6e253e07228af$export$2e2bcd8739ae039);
function $da246eeeea807732$export$ba72223e933caac5({ spaceKey: spaceKey, contentId: contentId = '' }) {
    // spaceKey will always be passed for both space overviews and view pages, but contentId is
    // distinct for the latter
    if (spaceKey && !contentId) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            query: $da246eeeea807732$var$preloadEditButtonWithSpaceKeyQuery,
            variables: {
                spaceKey: spaceKey
            }
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (data?.spaceHomepage?.id) (0, $dYU3e.writeQuery)({
                query: (0, $4YBSq.default),
                variables: {
                    contentId: data?.spaceHomepage?.id
                },
                data: {
                    content: data?.spaceHomepage ? {
                        nodes: [
                            {
                                ...data.spaceHomepage,
                                space: data?.space || null
                            }
                        ],
                        // @ts-ignore
                        __typename: 'PaginatedContentListWithChild'
                    } : null
                }
            });
        });
    })();
    return (0, $dYU3e.query)({
        query: (0, $4YBSq.default),
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadEditButton"] = $da246eeeea807732$export$ba72223e933caac5;

});

parcelRegister("3Tnjq", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $7tFTF = parcelRequire("7tFTF");


var $gYXuI = parcelRequire("gYXuI");

function $9c352464269d89b9$export$112a35af77c910a7(contentId, includeAncestors) {
    return (0, $dYU3e.query)({
        query: (0, $7tFTF.default),
        variables: {
            contentId: contentId,
            status: (0, $gYXuI.ALLOWED_CONTENT_STATUSES),
            includeAncestors: includeAncestors
        },
        // Preloaders are called both on server at initial load AND transition on client-side.
        // On server-side it doesn't matter fetch policy because we only gonna request once.
        // On client-side it must be network-only to get fresh data.
        fetchPolicy: 'network-only'
    });
}
module.exports["preloadPageRestrictionsQuery"] = $9c352464269d89b9$export$112a35af77c910a7;

});

parcelRegister("kb8ij", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

/**
 * @generated SignedSource<<86f05ceac5033a23eeeaa02f2bbd9562>>
 * @relayHash 04c55ca7b366178d730867d5ea7049fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a922c0f82a84390c673f50db9f7a55b398efabbb3e679d6d012b44c92e5423
const $efa3fddf99d4a618$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isWatched"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWatchingBlogs"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatching"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWatchDialogWithSpaceKeyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWatchDialogWithSpaceKeyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "04c55ca7b366178d730867d5ea7049fd",
            "id": "89a922c0f82a84390c673f50db9f7a55b398efabbb3e679d6d012b44c92e5423",
            "metadata": {},
            "name": "preloadWatchDialogWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWatchDialogWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}},spaceHomepage(spaceKey:$spaceKey){id,type,currentUserIsWatching}}"
        }
    };
}();
$efa3fddf99d4a618$var$node.hash = "146cb904d7e466de7e4cfcac13477faa";
var $efa3fddf99d4a618$export$2e2bcd8739ae039 = $efa3fddf99d4a618$var$node;



var $fEmGS = parcelRequire("fEmGS");


var $dYU3e = parcelRequire("dYU3e");


var $jroIa = parcelRequire("jroIa");

const $55455580d8d27fff$export$f6dca0a968d300b0 = (0, $efa3fddf99d4a618$export$2e2bcd8739ae039);
function $55455580d8d27fff$export$cc2a3c9139245546({ spaceKey: spaceKey, isLicensed: isLicensed = false, userId: userId, contentId: contentId }) {
    // do nothing if user is unlicensed, no userId is provided, or spaceKey and contentId are BOTH undefined
    if (!isLicensed || !userId || !spaceKey && !contentId) return Promise.resolve({});
    // the only scenario in which spaceKey is passed but contentId is not is in Space Overview via preloadGroupedButtons
    if (spaceKey && !contentId) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            query: $55455580d8d27fff$export$f6dca0a968d300b0,
            variables: {
                spaceKey: spaceKey
            },
            fetchPolicy: 'network-only'
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (data?.spaceHomepage?.id) (0, $fEmGS.writeQueryInterop)({
                query: (0, $jroIa.default),
                variables: {
                    contentId: data?.spaceHomepage?.id
                },
                data: {
                    singleContent: data?.spaceHomepage && data?.space ? {
                        currentUserIsWatching: data?.spaceHomepage?.currentUserIsWatching,
                        currentUserHasAncestorWatchingChildren: undefined,
                        currentUserIsWatchingChildren: undefined,
                        id: data?.spaceHomepage?.id,
                        space: data?.space,
                        type: data?.spaceHomepage?.type,
                        __typename: 'Content'
                    } : null
                }
            });
        });
    })();
    return (0, $dYU3e.query)({
        query: (0, $jroIa.default),
        variables: {
            contentId: contentId
        },
        // Must be preloaded with network only to get fresh data
        fetchPolicy: 'network-only'
    });
}
module.exports["preloadWatchDialog"] = $55455580d8d27fff$export$cc2a3c9139245546;

});

parcelRegister("4zhNK", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6LsQQ = parcelRequire("6LsQQ");

function $391f3ac88e545944$export$9da8ccc82535deaf(contentId, useObjectHeader) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $6LsQQ.ContentTypesHeaderQuery),
        variables: {
            contentId: contentId,
            useObjectHeader: useObjectHeader
        }
    });
}
module.exports["preloadContentTypesHeader"] = $391f3ac88e545944$export$9da8ccc82535deaf;

});

parcelRegister("iV8Fk", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lPNkm = parcelRequire("lPNkm");

function $c05bed830e3069e7$export$87b3e636f25ecc1e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lPNkm.default),
        variables: {
            spaceKey: spaceKey
        }
    });
}
module.exports["preloadCustomHeaderAndFooter"] = $c05bed830e3069e7$export$87b3e636f25ecc1e;

});

parcelRegister("aOHMQ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $k5dl6 = parcelRequire("k5dl6");

function $e0d84e65a2045ce5$export$2d90e27e1463a533(commentId, contentId) {
    return (0, $dYU3e.query)({
        query: (0, $k5dl6.default),
        variables: {
            commentId: commentId,
            contentId: contentId
        }
    });
}
module.exports["preloadFocusedInlineComment"] = $e0d84e65a2045ce5$export$2d90e27e1463a533;

});

parcelRegister("7tT2b", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");


var $d9tcB = parcelRequire("d9tcB");


var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");





var $8dwdz = parcelRequire("8dwdz");




const $613de45c1bdfbc89$export$2e09de8d75f18000 = ({ accessStatus: accessStatus, isLoggedIn: isLoggedIn })=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};











const $9f6d8fef975ab9be$export$3380c638fe82cae3 = (accessStatus)=>{
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};



var $5CUwy = parcelRequire("5CUwy");


var $2gAEP = parcelRequire("2gAEP");


var $dHiKK = parcelRequire("dHiKK");


var $i8Ofl = parcelRequire("i8Ofl");

async function $147f74e0bc8a9b5a$export$da2224e4c5ce5572({ cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, userId: userId, environment: environment }) {
    const isLoomDisabled = (0, $613de45c1bdfbc89$export$2e09de8d75f18000)({
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn
    });
    const isBetaEnabled = (0, $9f6d8fef975ab9be$export$3380c638fe82cae3)(accessStatus);
    const [isLoomEntryPointsEnabledResult, licensedProductsQueryResult] = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await Promise.allSettled([
            $147f74e0bc8a9b5a$var$preloadIsLoomEntryPointsEnabledQuery(cloudId, activationId, accessStatus),
            (0, $dYU3e.query)({
                query: (0, $2gAEP.default)
            })
        ]);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    const isLoomEntryPointsEnabled = isLoomEntryPointsEnabledResult.status === 'fulfilled' ? isLoomEntryPointsEnabledResult.value : true;
    if (window['__SSR_LOOM_ENTRY_POINT__']) return Promise.resolve();
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    if (isBetaEnabled) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'BETA'
        };
        return Promise.resolve();
    }
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    if (licensedProductsQueryResult.status === 'fulfilled') {
        const licenseQueryData = licensedProductsQueryResult.value.data;
        const isTenantLicensed = licenseQueryData?.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        const loomTenantProvisionStatus = isTenantLicensed ? (0, $5CUwy.LoomTenantProvisionStatus).PROVISIONED : (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED;
        if (loomTenantProvisionStatus === (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED) {
            window['__SSR_LOOM_ENTRY_POINT__'] = {
                entryPointVariant: 'CROSS_FLOW'
            };
            // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
            if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) window['__SSR_LOOM_ENTRY_POINT__'] = {
                entryPointVariant: 'DISABLED'
            };
            return Promise.resolve();
        }
    } else {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'CROSS_FLOW',
            error: true
        };
        // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
        if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    // tenant is provisioned at this point, switch to "CROSS_JOIN" and attempt permissions check
    window['__SSR_LOOM_ENTRY_POINT__'] = {
        entryPointVariant: 'CROSS_JOIN'
    };
    // PERMISSIONS CHECK
    const loomUserPermissionStatus = await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await (0, $5CUwy.getLoomUserPermissionStatus)(cloudId, userId, environment);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).NOT_PERMITTED) // if not permitted, entryPointVariant is already 'CROSS_JOIN' so resolve promise
    return Promise.resolve();
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).ERROR) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (Boolean(undefined) && Boolean(undefined)) window['__SSR_LOOM_ENTRY_POINT__'] = null;
        else window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'CROSS_JOIN',
            error: true
        };
        return Promise.resolve();
    }
    window['__SSR_LOOM_ENTRY_POINT__'] = {
        entryPointVariant: 'CO_USE'
    };
    return Promise.resolve();
}
const $147f74e0bc8a9b5a$var$preloadIsLoomEntryPointsEnabledQuery = async (cloudId, activationId, accessStatus)=>{
    const shouldSkip = !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS);
    if (shouldSkip) return;
    const { data: data, hasErrors: hasErrors } = await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult3 = await (0, $dYU3e.queryAgg)({
            query: (0, $dHiKK.default),
            variables: {
                cloudId: cloudId
            },
            context: {
                headers: {
                    ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
                }
            },
            errorPolicy: 'all'
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult3;
    })();
    if (hasErrors) return true;
    return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["preloadRecordLoomButton"] = $147f74e0bc8a9b5a$export$da2224e4c5ce5572;

});

parcelRegister("kkLBe", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");

const $b973d0b9aa217224$export$14621363d65ac00 = [];
const $b973d0b9aa217224$export$53a56b40d8963332 = async (queryName, task)=>{
    const wrappedTask = (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/guardException:${queryName}`, task);
    $b973d0b9aa217224$export$14621363d65ac00.push(wrappedTask);
    return wrappedTask;
};
module.exports["prepareGuardExceptionTask"] = $b973d0b9aa217224$export$53a56b40d8963332;

});

parcelRegister("9ycGg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8wyJO = parcelRequire("8wyJO");

function $8ac918fba64f5f59$export$de4621222fb13b43({ pageId: pageId, containerId: containerId }) {
    const { query: reactionsQuery, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(false, pageId, containerId);
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: reactionsQuery,
        variables: queryVariables
    });
}
module.exports["preloadPageReactions"] = $8ac918fba64f5f59$export$de4621222fb13b43;

});

parcelRegister("lcQ5b", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $9inwL = parcelRequire("9inwL");


var $4uNpa = parcelRequire("4uNpa");

const $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery = (contentId, spaceKey)=>(0, $dYU3e.query)({
        query: (0, $9inwL.default),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: !spaceKey,
            spaceKey: spaceKey
        }
    });
const $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery = ({ contentId: contentId, versionOverride: versionOverride })=>(0, $dYU3e.query)({
        query: (0, $4uNpa.default),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        }
    });
const $dbc6a71de2a3ffc4$export$22caa92111fd8d1d = (contentId, spaceKey, namedArgs)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery(contentId, spaceKey),
        $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery({
            contentId: contentId,
            ...namedArgs
        })
    ]);
};
module.exports["preloadContentPrerequisites"] = $dbc6a71de2a3ffc4$export$22caa92111fd8d1d;

});

parcelRegister("gBI6h", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");

function $8d43735f3bb06581$export$ad9216fbfde1ea82(contentId) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $eSUdr.default)`query preloadPageStatusQueryDataQuery($contentId:ID!){content(id:$contentId status:["archived" "current"]){nodes{id status}}}`,
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadPageStatusQuery"] = $8d43735f3bb06581$export$ad9216fbfde1ea82;

});

parcelRegister("h8QBE", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $8Z78B = parcelRequire("8Z78B");

const $0b2e6fb8cfab3270$export$6554070330cad05b = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9wGTI.fg)('cfind-4971-improved-templates-bar-gate') ? [
                ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)),
                (0, $dBcar.FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE)
            ] : [
                ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA))
            ]
        }
    });
};
module.exports["preloadLandUsersInEditorWithRevampedBpqa"] = $0b2e6fb8cfab3270$export$6554070330cad05b;

});

parcelRegister("lt4mJ", function(module, exports) {

var $98Fgg = parcelRequire("98Fgg");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/view-page/src/LegacyBridgeNextInner.tsx for the query usage
 */ const $66b1e969a9746f31$var$PreloadLegacyBridgeQuery = (0, $98Fgg.default);
async function $66b1e969a9746f31$export$aca348026d93fa81({ contentId: contentId, isBlog: isBlog }) {
    if (!contentId) return;
    return (0, $dYU3e.query)({
        query: $66b1e969a9746f31$var$PreloadLegacyBridgeQuery,
        variables: {
            contentId: contentId,
            isBlog: isBlog
        },
        errorPolicy: 'all'
    });
}
module.exports["preloadLegacyBridge"] = $66b1e969a9746f31$export$aca348026d93fa81;

});

parcelRegister("dhOY2", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $4XcQZ = parcelRequire("4XcQZ");

function $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd({ contentId: contentId, spaceKey: spaceKey, contentType: contentType }) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $4XcQZ.EndOfPageRecommendationQuery),
        variables: {
            type: contentType,
            id: contentId,
            exp: (0, $6mKj3.expVal)('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5'),
            key: spaceKey,
            keyString: spaceKey
        },
        // Must be preloaded with network only to get fresh data
        fetchPolicy: 'network-only'
    });
}
module.exports["preloadEndOfPageRecommendation"] = $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd;

});

parcelRegister("5Rwa0", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $eq95w = parcelRequire("eq95w");

function $9736b8942eb99a2e$export$fe7f338d767a5e6b(variables) {
    return (0, $dYU3e.query)({
        query: (0, $eq95w.default),
        variables: variables
    });
}
module.exports["preloadWebPanelLocation"] = $9736b8942eb99a2e$export$fe7f338d767a5e6b;

});

parcelRegister("28DDG", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8G3G6 = parcelRequire("8G3G6");

function $83b608e86b4ad2f7$export$6f71137e78694699(contentId, isBlog) {
    const contentType = isBlog ? 'BLOGPOST' : 'PAGE';
    return (0, $dYU3e.query)({
        query: (0, $8G3G6.default),
        variables: {
            contentId: contentId,
            contentType: contentType
        }
    });
}
module.exports["preloadAIFloatingContextMenu"] = $83b608e86b4ad2f7$export$6f71137e78694699;

});

parcelRegister("gDMf3", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $6mKj3 = parcelRequire("6mKj3");


var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $38Ncj = parcelRequire("38Ncj");

/**
 * @generated SignedSource<<a42da004fe707d70f5ca56f91fd7f24f>>
 * @relayHash 7238294bac8d5857c56c3c4ea7c78b36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812
const $df54146d5a704aad$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v2 = [
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                v1 /*: any*/ 
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "confluence_publicLinkSpaceHomePage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7238294bac8d5857c56c3c4ea7c78b36",
            "id": "3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812",
            "metadata": {},
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "operationKind": "query",
            "text": "query preloadShareAndRestrictButtonQuerySpaceOverviewQuery($cloudId:ID!,$spaceKey:String!){spaceHomepage(spaceKey:$spaceKey){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},confluence_publicLinkSpaceHomePage(cloudId:$cloudId,spaceKey:$spaceKey)@optIn(to:\"AskInCcApiPlatformBeforeUsing\"){pageId,pageStatus}}"
        }
    };
}();
$df54146d5a704aad$var$node.hash = "d2db11b68f255ee089316a1bfb1d4b92";
var $df54146d5a704aad$export$2e2bcd8739ae039 = $df54146d5a704aad$var$node;


function $ef82cacd2239f1cb$var$transformSpaceHomepageData(data) {
    return {
        singleContent: data?.spaceHomepage || null,
        publicLinkPage: data?.confluence_publicLinkSpaceHomePage || null
    };
}
async function $ef82cacd2239f1cb$export$be8d82af5bf2b0e(contentId, spaceKey) {
    const { isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    if (!contentId && spaceKey && (0, $6mKj3.expValEquals)('fix_preload_share_and_restrict_query_chaining_', 'cohort', 'test')) {
        const result = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $dYU3e.query)({
                query: (0, $df54146d5a704aad$export$2e2bcd8739ae039),
                variables: {
                    cloudId: cloudId,
                    spaceKey: spaceKey
                },
                errorPolicy: 'all'
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (result.hasErrors) return result;
        const data = result.data;
        const homepageId = data?.spaceHomepage?.id;
        if (!homepageId) return;
        const transformedData = $ef82cacd2239f1cb$var$transformSpaceHomepageData(data);
        // Prime Apollo cache so the button component finds its data already cached
        (0, $dYU3e.writeQuery)({
            query: (0, $38Ncj.default),
            variables: {
                contentId: homepageId,
                isContentTypePublicLinkEligible: true
            },
            data: transformedData
        });
        return;
    }
    if (contentId) {
        const result = await (async ()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult2 = await (0, $dYU3e.query)({
                query: (0, $38Ncj.default),
                variables: {
                    contentId: contentId,
                    isContentTypePublicLinkEligible: true
                },
                errorPolicy: 'all'
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            return _asyncResult2;
        })();
        if (result.hasErrors) return result;
        return;
    }
    // eslint-disable-next-line no-console
    console.error('Either contentId or spaceKey must be provided');
    return;
}
module.exports["preloadShareAndRestrictButtonQuery"] = $ef82cacd2239f1cb$export$be8d82af5bf2b0e;

});

parcelRegister("ePnB5", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $7W8i8 = parcelRequire("7W8i8");


var $b1hSc = parcelRequire("b1hSc");


var $9rE3H = parcelRequire("9rE3H");

const $a52f1fd1c70157af$var$logger = (0, $7W8i8.getLogger)('preloadFooterComments');
function $a52f1fd1c70157af$export$430e678301eccf5d(contentId, isArchived) {
    // Clear the cache BEFORE load. This query only every gets called with cache-only, so this prevents stale cache errors
    try {
        // On the server, we can sometimes fail to update the cache either at all, or at least in the expected order, which causes this query to look like it's forever loading
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $b1hSc.default),
            variables: (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(contentId, isArchived),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG),
                    // We can't do cache.evict based on apollo version, so use 	a flag
                    __typename: 'PaginatedCommentList'
                }
            }
        });
        // Always write to the main footer cache - ObjectCommentContainer reads from it directly in SPA (rather than using preload vars)
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $b1hSc.default),
            variables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: contentId,
                type: 'FOOTER',
                isArchived: isArchived
            }),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG),
                    // We can't do cache.evict based on apollo version, so use 	a flag
                    __typename: 'PaginatedCommentList'
                }
            }
        });
    } catch (error) {
        // Do nothing, this is expected if the query is not in the cache
        $a52f1fd1c70157af$var$logger.error`Error clearing preload cache for footer comments for contentId: ${contentId}, error: ${error}`;
    }
    if (contentId) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            query: (0, $b1hSc.default),
            variables: (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(contentId, isArchived),
            fetchPolicy: 'network-only'
        }).then((response)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            try {
                // Always write to the main footer cache - ObjectCommentContainer reads from it directly in SPA (rather than using preload vars)
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $b1hSc.default),
                    variables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                        pageId: contentId,
                        type: 'FOOTER',
                        isArchived: isArchived
                    }),
                    data: response.data
                });
            } catch (error) {
                $a52f1fd1c70157af$var$logger.error`Error writing to full cache for footer comments for contentId: ${contentId}, error: ${error}`;
            }
        });
    })();
    else return Promise.resolve({});
}
module.exports["preloadFooterComments"] = $a52f1fd1c70157af$export$430e678301eccf5d;

});

parcelRegister("3U5ab", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $1ydBT = parcelRequire("1ydBT");


var $MJaSd = parcelRequire("MJaSd");

const $c1e059434ab4dff9$export$b4767927145ffa8f = async (contentId)=>{
    if (!contentId) return Promise.resolve({
        data: null
    });
    // Clear the cache BEFORE load
    // Don't clear in SSR - if the preload times out there we won't have a way to overwrite this
    try {
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $1ydBT.default),
            variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $MJaSd.PRELOAD_LOADING_FLAG),
                    __typename: 'PaginatedCommentList'
                }
            }
        });
    } catch  {
    // Do nothing, this is expected if the query is not in the cache
    }
    // Use query from preloader-tools to trigger the network-only query
    // This will fetch the data and update the cache automatically
    // The hook query will pick up the changes from cache
    const result = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            query: (0, $1ydBT.default),
            variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId),
            fetchPolicy: 'network-only'
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    // Return in the same format as queryInterop for compatibility
    return {
        data: result.data
    };
};
module.exports["preloadObjectComments"] = $c1e059434ab4dff9$export$b4767927145ffa8f;

});

parcelRegister("jsQRz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");

/**
 * @generated SignedSource<<87dae781ac1a4043df88d24aa4f600ca>>
 * @relayHash de86fc84348e13b32c99266ab09fdd15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d28f479a584c65d21cfc6be5ba0b8e0680e7c4c73253a16db371a14cc265297
const $53e8528240c564b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "de86fc84348e13b32c99266ab09fdd15",
            "id": "2d28f479a584c65d21cfc6be5ba0b8e0680e7c4c73253a16db371a14cc265297",
            "metadata": {},
            "name": "PermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query PermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$53e8528240c564b4$var$node.hash = "3e9291acefbd65375263a2c6c3f07da2";
var $53e8528240c564b4$export$2e2bcd8739ae039 = $53e8528240c564b4$var$node;


const $b6cc849a4b8357af$export$f4722265894c4b45 = (0, $53e8528240c564b4$export$2e2bcd8739ae039);


function $23dc12875344febc$export$d9630e5941a0faf1(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $b6cc849a4b8357af$export$f4722265894c4b45),
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadAddCommentPermissionCheck"] = $23dc12875344febc$export$d9630e5941a0faf1;

});

parcelRegister("1swiX", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $2da08b1abbbb9472$export$914b80ef7b05e6be = (match)=>Boolean(match?.query.embedded || match?.query.parentProduct);
const $2da08b1abbbb9472$export$b04bf7ed076c9866 = (feature, match)=>match?.query.initialAllowedFeatures?.indexOf(feature) || match?.query.initialAllowedFeatures === 'all';
const $2da08b1abbbb9472$export$204da773c0191bd8 = (match)=>{
    const username = match?.query.username;
    if (!username) return '';
    if (Array.isArray(username)) return username[0];
    return username;
};
const $2da08b1abbbb9472$export$96d52eb4c89741b4 = (previousMatch)=>previousMatch?.name === (0, $1NBp8.HOME).name || previousMatch?.name === (0, $1NBp8.ADVANCED_SEARCH).name || previousMatch?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
module.exports["getIsEmbeddedConfluence"] = $2da08b1abbbb9472$export$914b80ef7b05e6be;
module.exports["hasEmbeddedAllowedFeatures"] = $2da08b1abbbb9472$export$b04bf7ed076c9866;
module.exports["getUsername"] = $2da08b1abbbb9472$export$204da773c0191bd8;
module.exports["shouldPreloadNavigationForTransition"] = $2da08b1abbbb9472$export$96d52eb4c89741b4;

});

parcelRegister("kM8fE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $9sGCn = parcelRequire("9sGCn");

const $04e58c16bcbc1952$export$74e73cc91cadfbcb = (url)=>(0, $1NBp8.BASE).match(url) || (0, $1NBp8.WIKI).match(url) || (0, $1NBp8.HOME).match(url);
const $04e58c16bcbc1952$export$9b5271c8016c128c = (url)=>{
    const viewMatch = (0, $1NBp8.VIEW_PAGE).match(url);
    const contentId = viewMatch?.params?.contentId;
    if (contentId) {
        const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
        if (subType === 'live' && !isArchived) return viewMatch;
    }
    return null;
};
const $04e58c16bcbc1952$export$3e3db362037b34f = (url)=>{
    return (0, $1NBp8.VIEW_PAGE).match(url) || $04e58c16bcbc1952$export$192c834e0bea39fe(url);
};
const $04e58c16bcbc1952$export$192c834e0bea39fe = (url)=>(0, $1NBp8.VIEW_BLOG).match(url) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(url);
const $04e58c16bcbc1952$export$a5aebc3364387341 = (url)=>(0, $1NBp8.WHITEBOARD_BOARD).match(url);
const $04e58c16bcbc1952$export$3f2440066ae1f23 = (url)=>(0, $1NBp8.DATABASE_VIEW).match(url);
const $04e58c16bcbc1952$export$b1c34ea376f57e50 = (url)=>(0, $1NBp8.EMBED_VIEW).match(url);
const $04e58c16bcbc1952$export$60329dc4f3d156ce = (url)=>(0, $1NBp8.SPACE_OVERVIEW).match(url) || (0, $1NBp8.SPACE_INDEX).match(url);
const $04e58c16bcbc1952$export$56eec48d64616d8b = (url)=>(0, $1NBp8.COMPANY_HUB).match(url);
const $04e58c16bcbc1952$export$3f29957b70348eca = (url)=>(0, $1NBp8.EDIT_PAGE_V2).match(url) || (0, $1NBp8.EDIT_BLOG_V2).match(url) || (0, $1NBp8.COMPANY_HUB_EDIT).match(url) || (0, $1NBp8.HUB_EDIT).match(url);
const $04e58c16bcbc1952$export$9449ab1a743aa4d4 = (url)=>(0, $1NBp8.EDIT_BLOG_V2).match(url);
const $04e58c16bcbc1952$export$3ce40e86c460686d = (url)=>(0, $1NBp8.EXTERNAL_SHARE).match(url);
const $04e58c16bcbc1952$export$efe2eb904cd9c81a = (url)=>(0, $1NBp8.SPACE_PAGES).match(url);
const $04e58c16bcbc1952$export$3c3929e91c626c02 = (url)=>(0, $1NBp8.CONTENT_HISTORY).match(url);
const $04e58c16bcbc1952$export$552d39bb9dd5531a = (url)=>(0, $1NBp8.ATTACHMENTS_PAGE).match(url);
const $04e58c16bcbc1952$export$7c8524eeca3a9c2d = (url)=>(0, $1NBp8.EDIT_PAGE_EMBED).match(url);
const $04e58c16bcbc1952$export$a8abe18ba382dbab = (url)=>(0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(url);
const $04e58c16bcbc1952$export$b5c8ff5b11237476 = (url)=>(0, $1NBp8.CREATE_CONTENT).match(url);
const $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e = (url)=>(0, $1NBp8.PDF_EXPORT_PAGE).match(url);
const $04e58c16bcbc1952$export$87f5c7a0305c2dc7 = (url)=>(0, $1NBp8.ADVANCED_SEARCH).match(url);
module.exports["matchHome"] = $04e58c16bcbc1952$export$74e73cc91cadfbcb;
module.exports["matchLivePage"] = $04e58c16bcbc1952$export$9b5271c8016c128c;
module.exports["matchViewPage"] = $04e58c16bcbc1952$export$3e3db362037b34f;
module.exports["matchBlogPage"] = $04e58c16bcbc1952$export$192c834e0bea39fe;
module.exports["matchWhiteboardPage"] = $04e58c16bcbc1952$export$a5aebc3364387341;
module.exports["matchDatabasePage"] = $04e58c16bcbc1952$export$3f2440066ae1f23;
module.exports["matchEmbedPage"] = $04e58c16bcbc1952$export$b1c34ea376f57e50;
module.exports["matchSpaceOverview"] = $04e58c16bcbc1952$export$60329dc4f3d156ce;
module.exports["matchCompanyHub"] = $04e58c16bcbc1952$export$56eec48d64616d8b;
module.exports["matchFabricEditor"] = $04e58c16bcbc1952$export$3f29957b70348eca;
module.exports["matchEditBlog"] = $04e58c16bcbc1952$export$9449ab1a743aa4d4;
module.exports["matchExternalShare"] = $04e58c16bcbc1952$export$3ce40e86c460686d;
module.exports["matchSpacePages"] = $04e58c16bcbc1952$export$efe2eb904cd9c81a;
module.exports["matchContentHistory"] = $04e58c16bcbc1952$export$3c3929e91c626c02;
module.exports["matchAttachmentsPage"] = $04e58c16bcbc1952$export$552d39bb9dd5531a;
module.exports["matchEmbeddedEditor"] = $04e58c16bcbc1952$export$7c8524eeca3a9c2d;
module.exports["matchSmartCreateEditor"] = $04e58c16bcbc1952$export$a8abe18ba382dbab;
module.exports["matchCreateContent"] = $04e58c16bcbc1952$export$b5c8ff5b11237476;
module.exports["matchPdfExport"] = $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e;
module.exports["matchSearch"] = $04e58c16bcbc1952$export$87f5c7a0305c2dc7;

});

parcelRegister("dpyxe", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lj2R9 = parcelRequire("lj2R9");

function $d0a9c91d619f4c3a$export$768c9c91046a1ca6(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lj2R9.default),
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $4JHZe = parcelRequire("4JHZe");


var $9WAeG = parcelRequire("9WAeG");


var $jhATi = parcelRequire("jhATi");


var $hR977 = parcelRequire("hR977");

// string begins with 1+ characters other than "/", has a "/", and is followed by one character other than "/"
// OR string begins with "/", is followed by 1 character other than "/", ends with any # of any character
// while ignoring capitalization
const $03224f8a12cf9d3e$var$relativeUrlMatch = new RegExp(`^[^\/]+\/[^\/].*$|^\/[^\/].*$`, 'i');
const $03224f8a12cf9d3e$var$isSpaceSidebarLink = (node)=>{
    return node?.['__typename'] === 'SpaceSidebarLink';
};
const $03224f8a12cf9d3e$export$52277eb7dc68d9b = (res)=>{
    const content = res?.data?.spaceSidebarLinks?.quick ?? [];
    return content.filter($03224f8a12cf9d3e$var$isSpaceSidebarLink).map((node)=>{
        return {
            appearance: 'inline',
            // adding domain to relative confluence URLs so smart links don't error
            resourceUrl: $03224f8a12cf9d3e$var$relativeUrlMatch.test(node?.url) ? window.location.origin + node?.url : node?.url
        };
    });
};



var $8tmcF = parcelRequire("8tmcF");





var $3mugH = parcelRequire("3mugH");


var $60cDW = parcelRequire("60cDW");


var $4VJDS = parcelRequire("4VJDS");


var $g2a13 = parcelRequire("g2a13");

const $7f218a294dcdf804$var$SMART_LINK_MAX_TIME = 250;
const $7f218a294dcdf804$export$ce708b69aef66f83 = async (spaceKey)=>{
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    // If we don't receive a URL - no reason to try and run queries
    const objectResolverURL = customURLs?.['object-resolver-service'];
    if (!objectResolverURL) return;
    // Call cc-graphql and get SmartLink URLs for the current space's shortcuts
    const res = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            query: (0, $g2a13.default),
            variables: {
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    // Loop through query data and pull out smart links
    const smartLinks = (0, $03224f8a12cf9d3e$export$52277eb7dc68d9b)(res);
    // If there are no valid SmartLinks shortcuts - exit
    if (!smartLinks?.length) return;
    await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:sidenavSmartLinksORS', async ()=>{
            const timeout = (0, $4VJDS.default).getNumber('confluence_ssr_sidenav_smart_link_max_time', $7f218a294dcdf804$var$SMART_LINK_MAX_TIME);
            const resolvedSmartLinks = await (async ()=>{
                const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
                const _asyncResult3 = await (0, $8tmcF.timeGuard)(async ()=>{
                    try {
                        const res = await (async ()=>{
                            const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
                            const _asyncResult4 = await (0, $jhATi.fetchORSForSSR)({
                                url: `${objectResolverURL}?timeout=${timeout}`,
                                userContext: userContext,
                                body: JSON.stringify(smartLinks)
                            });
                            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
                            return _asyncResult4;
                        })();
                        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
                        return res.json();
                    } catch (e) {
                        (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link shortcuts ORS call failed: ${e.message}`));
                    }
                    return [];
                }, [], timeout);
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
                return _asyncResult3;
            })();
            if (resolvedSmartLinks.length) // Format response to fit SmartCard Provider storeOptions initial state
            // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
            window['__SSR_SHORTCUTS__'] = (0, $hR977.getInitialState)(resolvedSmartLinks);
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
};


parcelRequire("bFNdd");
var $cdE3K = parcelRequire("cdE3K");


var $9wGTI = parcelRequire("9wGTI");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");





var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $4vyfK = parcelRequire("4vyfK");


var $1dnxO = parcelRequire("1dnxO");


var $2fsJn = parcelRequire("2fsJn");


var $dGmBZ = parcelRequire("dGmBZ");

async function $ffe798577d563302$export$f5bb385ed55e90ad(spaceKey) {
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const tasks = [];
    tasks.push((0, $dYU3e.query)({
        query: (0, $dGmBZ.default),
        variables: {
            spaceKey: spaceKey,
            isLicensed: preloadedSessionContext.isLicensed
        }
    }));
    tasks.push((0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE)
    }));
    tasks.push((0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: spaceKey
    }, false));
    if (isNav4Enabled) tasks.push((0, $4vyfK.preloadWebItemLocation)({
        location: 'system.header/left'
    }));
    if ((0, $9wGTI.fg)('po-connie-side-nav-ssr-shadow')) tasks.push((0, $cdE3K.preloadPostOfficeConfluenceSideNav)(preloadedSessionContext));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}



var $7A94k = parcelRequire("7A94k");


var $6anVB = parcelRequire("6anVB");


var $5iG5Q = parcelRequire("5iG5Q");


var $ivyMZ = parcelRequire("ivyMZ");




const $b40f909d573440e2$export$9a7c1b3da2b1bad4 = async (spaceKey, contentId, isLicensed, isBlog)=>{
    const tasks = [];
    tasks.push((0, $d0a9c91d619f4c3a$export$768c9c91046a1ca6)(spaceKey), (0, $7f218a294dcdf804$export$ce708b69aef66f83)(spaceKey), (0, $ffe798577d563302$export$f5bb385ed55e90ad)(spaceKey), (0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    tasks.push((0, $6anVB.preloadPageTree)({
        spaceKey: spaceKey,
        ...isBlog ? {} : {
            contentId: contentId
        },
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        isSuperAdmin: false
    }), (0, $5iG5Q.preloadBlogTree)({
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadNavigationTasks"] = $b40f909d573440e2$export$9a7c1b3da2b1bad4;

});

parcelRegister("jhATi", function(module, exports) {
/* eslint-disable check-credentials-option/has-credentials-option */ 
var $f7B1p = parcelRequire("f7B1p");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");


var $jQQYu = parcelRequire("jQQYu");

const $7be97be7622c4c18$export$206df200416da93b = async ({ url: url, userContext: userContext, body: body })=>{
    const { host: host, cloudId: cloudId } = (0, $60cDW.getSSRRenderInputs)();
    const fetchOptions = {
        method: 'POST',
        headers: {
            Cookie: (0, $jQQYu.createCookie)(userContext),
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Origin: host.startsWith('http') ? host : `https://${host}`,
            CloudId: cloudId,
            'X-Product': 'CONFLUENCE',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'object-resolver-service'
            } : {}
        },
        body: body
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions);
};
module.exports["fetchORSForSSR"] = $7be97be7622c4c18$export$206df200416da93b;

});

parcelRegister("hR977", function(module, exports) {
// Exported for testing
const $6f18789dfc68c5f3$export$483989a9813b3c0d = 'resolved';
const $6f18789dfc68c5f3$export$a3269a3914b007e3 = 'forbidden';
const $6f18789dfc68c5f3$export$67d19e9a991baa07 = 'unauthorized';
const $6f18789dfc68c5f3$export$8bca792d963eb0ef = 'not_found';
const $6f18789dfc68c5f3$export$b70265791d2079d4 = (statusCode, access)=>{
    const statusMap = {
        200: $6f18789dfc68c5f3$export$483989a9813b3c0d,
        401: $6f18789dfc68c5f3$export$67d19e9a991baa07,
        403: $6f18789dfc68c5f3$export$a3269a3914b007e3,
        404: $6f18789dfc68c5f3$export$8bca792d963eb0ef
    };
    if (access === $6f18789dfc68c5f3$export$a3269a3914b007e3 || access === $6f18789dfc68c5f3$export$67d19e9a991baa07) return access;
    return statusMap[statusCode] || 'errored';
};


const $ef12576e8da2e6e5$export$53ac33307b5acee9 = (smartLinksResponse)=>{
    // If we didn't get a response from SmartLinks endpoint, exit
    if (!Array.isArray(smartLinksResponse) || smartLinksResponse?.length < 1) return {};
    return smartLinksResponse?.reduce((map, metadata)=>{
        const status = metadata?.status;
        const body = metadata?.body;
        const url = metadata?.body?.data?.url;
        if (!url) {
            // failed to resolve url
            window['__SSR_SMARTLINKS_ERRORS__'] = window['__SSR_SMARTLINKS_ERRORS__'] || {};
            const smartLinksSSRErrorsByStatus = window['__SSR_SMARTLINKS_ERRORS__'];
            smartLinksSSRErrorsByStatus[status] = smartLinksSSRErrorsByStatus[status] ? smartLinksSSRErrorsByStatus[status] + 1 : 1;
            return map;
        }
        const cardState = {
            status: (0, $6f18789dfc68c5f3$export$b70265791d2079d4)(status, metadata?.body?.meta?.access),
            details: body
        };
        return {
            ...map,
            [url]: cardState
        };
    }, {});
};
module.exports["getInitialState"] = $ef12576e8da2e6e5$export$53ac33307b5acee9;

});

parcelRegister("8tmcF", function(module, exports) {
function $5c639d7819ef31f1$export$baa85236a0d673f4(task, returnValueOnTimeout, timeout) {
    return Promise.race([
        task(),
        new Promise((resolve)=>setTimeout(()=>{
                resolve(typeof returnValueOnTimeout === 'function' ? returnValueOnTimeout() : returnValueOnTimeout);
            }, timeout))
    ]);
}
module.exports["timeGuard"] = $5c639d7819ef31f1$export$baa85236a0d673f4;

});

parcelRegister("bFNdd", function(module, exports) {
$parcel$export(module.exports, "preloadPostOfficeConfluenceSideNav", () => (parcelRequire("cdE3K")).preloadPostOfficeConfluenceSideNav);

var $cdE3K = parcelRequire("cdE3K");


});

parcelRegister("2fsJn", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");


var $eSUdr = parcelRequire("eSUdr");

const $8f090db6c0dc0794$export$6987d8916b4890c6 = (0, $eSUdr.default)`query PersistentInviteEligibleQuery($spaceKey:String$skipLicenseQuery:Boolean!$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id currentUser{isAnonymouslyAuthorized}}license@skip(if:$skipLicenseQuery){licenseConsumingUserCount trialEndDate}}`;


async function $c17fd2752a43fba2$export$350d5cfce01a6908({ spaceKey: spaceKey }, skipSpaceQuery = false) {
    if ((0, $9wGTI.fg)('confluence_nav4_global-invite')) {
        const { edition: edition, isLicensed: isLicensed, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
        const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
        return (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $8f090db6c0dc0794$export$6987d8916b4890c6),
            variables: {
                spaceKey: spaceKey,
                skipLicenseQuery: isFreeEdition || !isLicensed || !Boolean(userId) || skipSpaceQuery,
                skipSpaceQuery: !Boolean(spaceKey)
            },
            context: {
                headers: {
                    'X-ATL-WARM-CACHE-HINT': 'get'
                }
            }
        });
    }
}
module.exports["preloadPersistentInviteButtonEligible"] = $c17fd2752a43fba2$export$350d5cfce01a6908;

});

parcelRegister("7A94k", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $3AeIf = parcelRequire("3AeIf");


var $e5i8U = parcelRequire("e5i8U");

function $5600fd3490744a04$export$d5a6f6937168d07d(spaceKey, isLicensed) {
    const queries = [];
    queries.push((0, $dYU3e.query)({
        query: (0, $e5i8U.default),
        variables: {
            spaceKey: spaceKey
        }
    }));
    if (isLicensed) queries.push((0, $dYU3e.query)({
        query: (0, $3AeIf.default),
        variables: {
            spaceKey: spaceKey
        }
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadSpaceViews"] = $5600fd3490744a04$export$d5a6f6937168d07d;

});

parcelRegister("6anVB", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");





var $2fQCH = parcelRequire("2fQCH");

function $c0d8eea1db3e88bb$export$6b492303c3449855(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $2fQCH.default),
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $1oGPE = parcelRequire("1oGPE");


var $inLKs = parcelRequire("inLKs");

async function $d25c822192ffc860$export$45a75125fd859f7b({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '' }) {
    const promises = [
        $d25c822192ffc860$export$75e59f1581543cac({
            spaceKey: spaceKey,
            statuses: statuses,
            isSuperAdmin: isSuperAdmin,
            contentId: contentId
        }),
        (0, $c0d8eea1db3e88bb$export$6b492303c3449855)(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}
async function $d25c822192ffc860$export$75e59f1581543cac({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '' }) {
    // only fetch using PageTreeWithSpaceKeyQuery if contentId does not exist AND FF is enabled (only for SSR space overviews).
    // This is to differentiate between other use cases where contentId is not passed (according to prop types, it is an optional param)
    if (spaceKey && !contentId) {
        const { data: data } = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $inLKs.PageTreeWithSpaceKeyQuery),
                variables: {
                    spaceKey: spaceKey,
                    isSuperAdmin: isSuperAdmin,
                    statuses: statuses,
                    // @ts-ignore
                    ptStatuses: statuses,
                    paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                    isReplacePagesWithPTPageEnabled: true
                }
            });
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (data?.space?.homepageId && data?.space?.id) (0, $dYU3e.writeQuery)({
            /* @ts-expect-error http://go/cfe-use-relay-artifacts */ query: (0, $inLKs.PageTreeQuery),
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                contentId: data?.space?.homepageId,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                isReplacePagesWithPTPageEnabled: true
            },
            data: {
                currentPage: data?.space?.pageTree || null,
                ptpage: data?.ptpage || null,
                space: data?.space ? {
                    id: data?.space?.id,
                    homepage: {
                        id: data?.space?.homepageId,
                        // @ts-ignore
                        __typename: 'Content'
                    },
                    operations: data?.space?.operations,
                    // @ts-ignore
                    __typename: 'Space'
                } : null
            }
        });
    } else await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await (0, $dYU3e.query)({
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $inLKs.PageTreeQuery),
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                ptStatuses: statuses,
                ...contentId && {
                    contentId: contentId
                },
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                isReplacePagesWithPTPageEnabled: true
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
}
module.exports["preloadPageTree"] = $d25c822192ffc860$export$45a75125fd859f7b;

});

parcelRegister("5iG5Q", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dYU3e = parcelRequire("dYU3e");


var $eiCiP = parcelRequire("eiCiP");


var $1UApO = parcelRequire("1UApO");


var $fL5TY = parcelRequire("fL5TY");


var $6DMfJ = parcelRequire("6DMfJ");

async function $704f9f1df7736cb5$var$isBlogTreeExpanded() {
    try {
        const entries = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $eiCiP.preloadLocalStorage)();
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        const sideNavExpandState = entries.find((entry)=>entry.key.endsWith((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES));
        if (sideNavExpandState.value) {
            const expandedStates = JSON.parse(sideNavExpandState.value);
            if (expandedStates.blogTree) return true;
        }
    } catch  {
    // Return value might be malformed
    }
    return false;
}
const $704f9f1df7736cb5$export$af00c4ac24735b9 = async ({ spaceKey: spaceKey })=>{
    // blog tree is default collapsed, and is only expanded when user lands directly on a blog.
    // Or use explicity expanded the blog tree section
    const blogTreeQueryPromise = (0, $dYU3e.query)({
        query: (0, $fL5TY.default),
        variables: {
            spaceKey: spaceKey,
            first: (0, $6DMfJ.PAGE_SIZE),
            statuses: (0, $6DMfJ.BLOG_STATUSES),
            orderBy: 'metadata.createdDate desc'
        }
    });
    // isBlogTreeExpanded() is much faster then blogTreeQueryPromise
    // If section is not expanded we don't wait for the blog tree query to finish
    return (()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        return $704f9f1df7736cb5$var$isBlogTreeExpanded().then((expanded)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            if (expanded) return blogTreeQueryPromise;
        });
    })();
};
module.exports["preloadBlogTree"] = $704f9f1df7736cb5$export$af00c4ac24735b9;

});

parcelRegister("22UVa", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gRzR4 = parcelRequire("gRzR4");

function $30395b5fc2e6a8bf$export$c15cbaa44f10b9f1(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $gRzR4.default),
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadSmartCreateFeedbackBanner"] = $30395b5fc2e6a8bf$export$c15cbaa44f10b9f1;

});

parcelRegister("2JYae", function(module, exports) {

var $bmTgR = parcelRequire("bmTgR");

const $ea5e64ad86524752$export$e31fbf0af7c148e4 = ()=>{
    return {
        isDesktop: (0, $bmTgR.isDesktop)()
    };
};
module.exports["useIsDesktop"] = $ea5e64ad86524752$export$e31fbf0af7c148e4;

});

parcelRegister("2E0F0", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $l6okE = parcelRequire("l6okE");


var $iHzeA = parcelRequire("iHzeA");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");







const $fd0b1a7899796485$export$4d3f50627e188696 = new (0, $ks2lK.PluginKey)('selectionPreservationPlugin');


const $ad55c0625fa8df26$export$4c9c90f81bda40ce = ({ tr: tr })=>{
    const meta = {
        type: 'startPreserving'
    };
    return tr.setMeta((0, $fd0b1a7899796485$export$4d3f50627e188696), meta);
};
const $ad55c0625fa8df26$export$7ee148889ab74bda = ({ tr: tr })=>{
    const meta = {
        type: 'stopPreserving'
    };
    return tr.setMeta((0, $fd0b1a7899796485$export$4d3f50627e188696), meta);
};


const $60e9e01ab3795199$var$getKeyboardEventInfo = (event)=>{
    const key = event.key.toLowerCase();
    const isMetaCtrl = event.metaKey || event.ctrlKey;
    const isDelete = [
        'backspace',
        'delete'
    ].includes(key);
    const isCut = isMetaCtrl && key === 'x';
    const isPaste = isMetaCtrl && key === 'v';
    const isUndo = isMetaCtrl && key === 'z' && !event.shiftKey;
    const isRedo = isMetaCtrl && (key === 'y' || key === 'z' && event.shiftKey);
    const isDestructive = isDelete || isCut || isPaste || isUndo || isRedo;
    const isModifierOnly = [
        'control',
        'meta',
        'alt',
        'shift'
    ].includes(key) && !isMetaCtrl;
    const isCopy = isMetaCtrl && key === 'c';
    const isInert = isModifierOnly || isCopy;
    return {
        isDelete: isDelete,
        isDestructive: isDestructive,
        isInert: isInert
    };
};
const $60e9e01ab3795199$export$f38920f5272efc06 = (api)=>(event)=>({ tr: tr })=>{
            if (!api) return tr;
            const { isDelete: isDelete, isDestructive: isDestructive, isInert: isInert } = $60e9e01ab3795199$var$getKeyboardEventInfo(event);
            // Handle delete/backspace key presses with custom logic to ensure preserved selection is used
            if (isDelete) tr = (0, $l6okE.deleteSelectedRange)(tr, api.blockControls?.sharedState.currentState()?.preservedSelection);
            const isBlockMenuOpen = api.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen';
            // When selected content is being removed/modified/undo/redo and the block menu is open
            // close the block menu and refocus the editor
            const shouldCloseBlockMenu = isDestructive && isBlockMenuOpen;
            if (shouldCloseBlockMenu) {
                api.blockControls?.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api.core.actions.focus({
                    scrollIntoView: false
                });
            }
            // Stop preserving when:
            // 1. Content is being removed (delete/cut/paste) OR
            // 2. Menu is closed AND user pressed a non-inert key (i.e. action which modifies selection or content)
            // 3. undo/redo actions
            const shouldStopPreservingSelection = isDestructive || !isBlockMenuOpen && !isInert;
            if (shouldStopPreservingSelection) (0, $ad55c0625fa8df26$export$7ee148889ab74bda)({
                tr: tr
            });
            return tr;
        };



var $2P8Ax = parcelRequire("2P8Ax");


var $d925B = parcelRequire("d925B");


var $d7ZU3 = parcelRequire("d7ZU3");


var $b7atO = parcelRequire("b7atO");


var $2T4ch = parcelRequire("2T4ch");


var $1S4f7 = parcelRequire("1S4f7");


var $Yqd3z = parcelRequire("Yqd3z");





var $f9zLy = parcelRequire("f9zLy");


var $2pjJ5 = parcelRequire("2pjJ5");





var $ftzrq = parcelRequire("ftzrq");





var $51lK8 = parcelRequire("51lK8");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $1oCLl = parcelRequire("1oCLl");










const $d89c90893897930c$export$ea34df48337a3b78 = 'data-node-anchor';
const $d89c90893897930c$export$195bd9e1fd438938 = 'data-prosemirror-node-name';
const $d89c90893897930c$export$684dbfb461b166c3 = ()=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return $d89c90893897930c$export$ea34df48337a3b78;
    return 'data-drag-handler-anchor-name';
};
const $d89c90893897930c$export$916bc5085eed228a = ()=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return $d89c90893897930c$export$195bd9e1fd438938;
    return 'data-drag-handler-node-type';
};
const $d89c90893897930c$var$isHeadingElement = (element)=>{
    const headingTags = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    return headingTags.includes(element.tagName);
};
const $d89c90893897930c$export$374251d21964e516 = (element)=>{
    if (!element) return '';
    const nodeType = element?.getAttribute($d89c90893897930c$export$195bd9e1fd438938);
    if (!nodeType) return '';
    if ($d89c90893897930c$var$isHeadingElement(element)) switch(element.tagName){
        case 'H1':
            return 'heading-1';
        case 'H2':
            return 'heading-2';
        case 'H3':
            return 'heading-3';
        case 'H4':
            return 'heading-4';
        case 'H5':
            return 'heading-5';
        case 'H6':
            return 'heading-6';
    }
    return nodeType;
};












var $jTxSS = parcelRequire("jTxSS");


var $dQl1W = parcelRequire("dQl1W");

const $94da9623b41bcf3c$export$4a66a44681ab4c77 = 'drop-target-decoration';
const $94da9623b41bcf3c$export$eac9eb77d42744c8 = 'drag-handle';
const $94da9623b41bcf3c$export$ab0e97a1d4f97633 = 'node-decoration';
const $94da9623b41bcf3c$export$4a19606d812406a7 = 100;
const $94da9623b41bcf3c$export$20dcf6d6c6a1b068 = (node)=>{
    const handleId = $94da9623b41bcf3c$var$ObjHash.getForNode(node);
    return `--node-anchor-${node.type.name}-${handleId}`;
};
const $94da9623b41bcf3c$export$b0da2ac7a61aa72c = (node)=>{
    const subType = node.attrs.level ? `-${node.attrs.level}` : '';
    return node.type.name + subType;
};
class $94da9623b41bcf3c$var$ObjHash {
    static getForNode(node) {
        if (this.caching.has(node)) return this.caching.get(node);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const uniqueId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        this.caching.set(node, uniqueId);
        return uniqueId;
    }
}
$94da9623b41bcf3c$var$ObjHash.caching = new WeakMap();
const $94da9623b41bcf3c$export$ad2994468d2cac1a = (nodeViewPortalProviderAPI, selector, key)=>{
    // Removing decorations manually instead of using native destroy function in prosemirror API
    // as it was more responsive and causes less re-rendering
    const decorationsToRemove = document.querySelectorAll(`[${selector}="true"]`);
    decorationsToRemove.forEach((el)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(el);
    });
};


const $8653f788c2b076b7$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption',
    'layoutColumn'
];
const $8653f788c2b076b7$export$4b59c90449151b37 = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption'
];
const $8653f788c2b076b7$var$IGNORE_NODE_DESCENDANTS = [
    'listItem',
    'taskList',
    'decisionList',
    'mediaSingle'
];
const $8653f788c2b076b7$export$9cba0273af9f9727 = [
    'listItem',
    'taskList',
    'decisionList'
];
const $8653f788c2b076b7$export$d43a1c4953e0600e = (node)=>{
    // Optimisation to avoid drawing node decorations for empty table cells
    if ([
        'tableCell',
        'tableHeader'
    ].includes(node.type.name)) {
        if (node.childCount === 1 && node.firstChild?.type.name === 'paragraph' && node.firstChild.childCount === 0) return false;
    }
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return !$8653f788c2b076b7$export$9cba0273af9f9727.includes(node.type.name);
    return !$8653f788c2b076b7$var$IGNORE_NODE_DESCENDANTS.includes(node.type.name);
};
const $8653f788c2b076b7$var$shouldIgnoreNode = (node, ignore_nodes, depth, parent)=>{
    const isEmbedCard = node.type.name === 'embedCard';
    const isMediaSingle = node.type.name === 'mediaSingle';
    const nodeTypes = node.type.schema.nodes;
    const isTable = node.type.name === nodeTypes?.table?.name;
    const parentIsTable = parent && [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
    const isNestedTable = isTable && parentIsTable;
    if (isNestedTable) return true;
    const isFirstTableRow = parent?.type.name === 'table' && depth === 1 && node === parent.firstChild && 'tableRow' === node.type.name && (0, $iu6m9.editorExperiment)('advanced_layouts', true);
    if (isFirstTableRow) return false;
    const isLegacyContentMacroExtension = node.type.name === 'extension' && node.attrs?.extensionType === 'com.atlassian.confluence.migration' && node.attrs?.extensionKey === 'legacy-content';
    if (isLegacyContentMacroExtension) return true;
    return (isEmbedCard || isMediaSingle) && [
        'wrap-right',
        'wrap-left'
    ].includes(node.attrs.layout) ? true : ignore_nodes.includes(node.type.name);
};
const $8653f788c2b076b7$var$getPositionBeforeNodeAtPos = (state, pos)=>{
    if (pos <= 0 || pos >= state.doc.nodeSize - 2) return pos;
    const $pos = state.doc.resolve(pos);
    if ($pos.depth > 0) return $pos.before();
    return pos;
};
const $8653f788c2b076b7$export$562fc95beb8a58d3 = (state, decorations, from, to)=>{
    let newFrom = from;
    if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) {
        // return empty array if range reversed
        if (typeof to === 'number' && typeof newFrom === 'number' && newFrom > to) return [];
        let decs = decorations.find(newFrom, to, (spec)=>spec.type === (0, $94da9623b41bcf3c$export$ab0e97a1d4f97633));
        // Prosemirror finds any decorations that overlap with the provided position range, but we don't want to include decorations of nodes that start outside of the range
        if (typeof to === 'number' && typeof newFrom === 'number') decs = decs.filter((dec)=>{
            return dec.from >= (newFrom || 0) && dec.from < to;
        });
        return decs;
    } else {
        let newTo = to;
        // make it non-inclusive
        if (newFrom !== undefined) newFrom++;
        // make it non-inclusive
        if (newTo !== undefined) newTo--;
        // return empty array if range reversed
        if (newFrom !== undefined && newTo !== undefined && newFrom > newTo) return [];
        return decorations.find(newFrom, newTo, (spec)=>spec.type === (0, $94da9623b41bcf3c$export$ab0e97a1d4f97633));
    }
};
const $8653f788c2b076b7$export$a3bb13b1e97d70c7 = (newState, from, to)=>{
    const decs = [];
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return [];
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > newState.doc.nodeSize - 2 ? newState.doc.nodeSize - 2 : to;
    const ignore_nodes = (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $8653f788c2b076b7$export$4b59c90449151b37 : $8653f788c2b076b7$var$IGNORE_NODES;
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, _)=>{
        let depth = 0;
        const shouldDescend = $8653f788c2b076b7$export$d43a1c4953e0600e(node);
        const anchorName = (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(node);
        const nodeTypeWithLevel = (0, $94da9623b41bcf3c$export$b0da2ac7a61aa72c)(node);
        if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) {
            // We don't want to create decorations for nodes that start outside of the provided position range
            if (pos < $8653f788c2b076b7$var$getPositionBeforeNodeAtPos(newState, docFrom)) return shouldDescend;
        }
        // Doesn't descend into a node
        if (node.isInline) return false;
        depth = newState.doc.resolve(pos).depth;
        if ($8653f788c2b076b7$var$shouldIgnoreNode(node, ignore_nodes, depth, parent)) return shouldDescend; //skip over, don't consider it a valid depth
        const anchorStyles = `anchor-name: ${anchorName};`;
        decs.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            style: anchorStyles,
            ['data-drag-handler-anchor-name']: anchorName,
            ['data-drag-handler-node-type']: nodeTypeWithLevel,
            ['data-drag-handler-anchor-depth']: `${depth}`
        }, {
            type: (0, $94da9623b41bcf3c$export$ab0e97a1d4f97633),
            anchorName: anchorName,
            nodeType: node.type.name,
            nodeTypeWithLevel: nodeTypeWithLevel
        }));
        return shouldDescend && depth < (0, $94da9623b41bcf3c$export$4a19606d812406a7);
    });
    return decs;
};



var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");



















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $hTKp4 = parcelRequire("hTKp4");








var $eiA8Z = parcelRequire("eiA8Z");


var $hgeg8 = parcelRequire("hgeg8");


var $dwl7L = parcelRequire("dwl7L");







var $1zav4 = parcelRequire("1zav4");


var $b3YrF = parcelRequire("b3YrF");





var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $kEbNW = parcelRequire("kEbNW");


var $8aNCk = parcelRequire("8aNCk");








var $afUmf = parcelRequire("afUmf");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");











var $3gadb = parcelRequire("3gadb");










const $c506554d919477c1$export$991fd708287269fd = (tr, inputMethod, fromDepth, fromNodeType, toDepth, toNodeType, isSameParent, api, fromNodeTypes, hasSelectedMultipleNodes)=>{
    return api?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: (0, $d925B.ACTION).MOVED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
        attributes: {
            nodeDepth: fromDepth,
            nodeType: fromNodeType,
            nodeTypes: fromNodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            destinationNodeDepth: toDepth,
            destinationNodeType: toNodeType,
            isSameParent: isSameParent,
            inputMethod: inputMethod
        }
    })(tr);
};
const $c506554d919477c1$export$9d441c3a20655711 = (tr, api, nodeTypes, hasSelectedMultipleNodes, columnCount)=>{
    api?.analytics?.actions?.attachAnalyticsEvent({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).DRAG_AND_DROP,
            nodeTypes: nodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            columnCount: columnCount
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(tr);
};
const $c506554d919477c1$export$9f4024dd9bfa7336 = (tr, anchor, head)=>{
    const nodeTypes = [];
    const from = Math.min(anchor, head);
    const to = Math.max(anchor, head);
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (pos < from) // ignore parent node
        return true;
        nodeTypes.push(node.type.name);
        // only care about the top level (relatively in the range) nodes
        return false;
    });
    return {
        nodeTypes: (0, $dh538.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};












var $fJNzZ = parcelRequire("fJNzZ");







const $30636d6b7963f251$export$f373eda827748b3 = 24;
const $30636d6b7963f251$export$aa77a5cc2a5f88a7 = 4;
const $30636d6b7963f251$export$5ad27d778a09d25c = (0, $aFUXX.akRichMediaResizeZIndex) + (0, $aFUXX.akEditorUnitZIndex); //place above legacy resizer
const $30636d6b7963f251$export$2cbe83499bf11891 = 8;
const $30636d6b7963f251$export$afbc9d6595284dfa = 4;
const $30636d6b7963f251$export$28e15aedc0c878e3 = 12;
const $30636d6b7963f251$export$f0af6742db040d57 = (0, $Yqd3z.DRAG_HANDLE_WIDTH) + $30636d6b7963f251$export$28e15aedc0c878e3;
const $30636d6b7963f251$export$d2a2373f7346fed2 = 6; // 4px for the divider vertical padding and 2px for the divider height
const $30636d6b7963f251$export$d5bafa9c4e821a51 = 5;
const $30636d6b7963f251$export$1e2b3336ca8c087c = 2;
const $30636d6b7963f251$export$f8ee0d00a7415eee = 1;
const $30636d6b7963f251$export$7ca48bd6d02a13e0 = 3;
const $30636d6b7963f251$export$40d0d70c288e6373 = 3;
const $30636d6b7963f251$export$51dbe10140b62321 = 3;
const $30636d6b7963f251$export$45051ba26713425e = 8;
const $30636d6b7963f251$export$2d43c475787cc3b2 = 2;
const $30636d6b7963f251$export$c8181a575a7964ef = 3;
const $30636d6b7963f251$export$acab25f15fd410d6 = 8;
const $30636d6b7963f251$export$355f64931df48ac6 = 24;
const $30636d6b7963f251$export$b2fc508ca59eba40 = 24;
const $30636d6b7963f251$export$c5ab994ee6fdf098 = 24;
const $30636d6b7963f251$export$8b6a8ea78955a3a3 = {
    width: $30636d6b7963f251$export$c5ab994ee6fdf098,
    height: $30636d6b7963f251$export$b2fc508ca59eba40
};
const $30636d6b7963f251$export$37704ab652bb303e = 16;
const $30636d6b7963f251$var$nodeTypeExcludeList = [
    'embedCard',
    'mediaSingle',
    'table'
];
const $30636d6b7963f251$var$breakoutResizableNodes = [
    'expand',
    'layoutSection',
    'codeBlock'
];
const $30636d6b7963f251$export$e5ea166c620fdfb2 = (nodeType, parentNodeType)=>{
    if (parentNodeType && parentNodeType !== 'doc') return $30636d6b7963f251$export$afbc9d6595284dfa;
    const breakoutResizableNodesList = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? (0, $fJNzZ.breakoutResizableNodes) : $30636d6b7963f251$var$breakoutResizableNodes;
    if ((0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) && breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $30636d6b7963f251$export$28e15aedc0c878e3 + 20;
        else return $30636d6b7963f251$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $30636d6b7963f251$export$2cbe83499bf11891 + 20;
    if ($30636d6b7963f251$var$nodeTypeExcludeList.includes(nodeType)) return $30636d6b7963f251$export$28e15aedc0c878e3;
    return $30636d6b7963f251$export$2cbe83499bf11891;
};
const $30636d6b7963f251$export$5002400b4eb1f7c6 = (nodeType)=>{
    const breakoutResizableNodesList = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? (0, $fJNzZ.breakoutResizableNodes) : $30636d6b7963f251$var$breakoutResizableNodes;
    if ($30636d6b7963f251$var$nodeTypeExcludeList.includes(nodeType) || (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) && breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $30636d6b7963f251$export$28e15aedc0c878e3 + 20;
        else return $30636d6b7963f251$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $30636d6b7963f251$export$28e15aedc0c878e3 + 12;
    return $30636d6b7963f251$export$2cbe83499bf11891;
};
const $30636d6b7963f251$export$5721e547e9b6cc17 = (nodeType)=>{
    switch(nodeType){
        case 'bodiedExtension':
            return '28px';
        case 'expand':
        case 'nestedExpand':
            return '24px';
        case 'layoutColumn':
            return '20px';
        case 'panel':
            return '40px';
        case 'tableCell':
            return '8px';
        case 'tableHeader':
            return '8px';
        default:
            return `${(0, $Yqd3z.DRAG_HANDLE_WIDTH) + $30636d6b7963f251$export$afbc9d6595284dfa}px`;
    }
};
const $30636d6b7963f251$export$403b33ae238c7c59 = (nodeType)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) switch(nodeType){
        case 'layoutSection':
            return $30636d6b7963f251$export$45051ba26713425e;
    }
    switch(nodeType){
        case 'rule':
            return -$30636d6b7963f251$export$d2a2373f7346fed2;
        case 'table':
            return $30636d6b7963f251$export$f373eda827748b3;
        case 'paragraph':
            return $30636d6b7963f251$export$2d43c475787cc3b2;
        case 'heading-1':
            return $30636d6b7963f251$export$d5bafa9c4e821a51;
        case 'heading-2':
            return $30636d6b7963f251$export$1e2b3336ca8c087c;
        case 'heading-3':
            return -$30636d6b7963f251$export$f8ee0d00a7415eee;
        case 'heading-4':
            return -$30636d6b7963f251$export$7ca48bd6d02a13e0;
        case 'heading-5':
            return -$30636d6b7963f251$export$40d0d70c288e6373;
        case 'heading-6':
            return -$30636d6b7963f251$export$51dbe10140b62321;
        default:
            return 0;
    }
};
const $30636d6b7963f251$export$6475396024cc89ff = {
    [-24]: "var(--ds-space-negative-300, -24px)",
    [-20]: "var(--ds-space-negative-250, -20px)",
    [-16]: "var(--ds-space-negative-200, -16px)",
    [-12]: "var(--ds-space-negative-150, -12px)",
    [-8]: "var(--ds-space-negative-100, -8px)",
    [-6]: "var(--ds-space-negative-075, -6px)",
    [-4]: "var(--ds-space-negative-050, -4px)",
    [-2]: "var(--ds-space-negative-025, -2px)",
    0: "var(--ds-space-0, 0)",
    2: "var(--ds-space-025, 2px)",
    4: "var(--ds-space-050, 4px)",
    6: "var(--ds-space-075, 6px)",
    8: "var(--ds-space-100, 8px)",
    12: "var(--ds-space-150, 12px)",
    16: "var(--ds-space-200, 16px)",
    20: "var(--ds-space-250, 20px)",
    24: "var(--ds-space-300, 24px)"
};
const $30636d6b7963f251$export$c4b2eae94cb9784e = Object.fromEntries(// 49 = -24 -> 0 -> 24 totaling 49 entries.
Array.from({
    length: 49
}, (_, index)=>{
    const currKeyValue = index - 24;
    const keyValues = Object.keys($30636d6b7963f251$export$6475396024cc89ff).map(Number);
    const value = keyValues.reduce((acc, curr)=>{
        return Math.abs(currKeyValue - curr) < Math.abs(currKeyValue - acc) ? curr : acc;
    }, 1000);
    return [
        currKeyValue,
        $30636d6b7963f251$export$6475396024cc89ff[value]
    ];
}));
const $30636d6b7963f251$export$67c6a77242c01faa = {
    paragraph: {
        top: '0.75rem',
        bottom: '0'
    },
    heading1: {
        top: '1.45833em',
        bottom: '0'
    },
    heading2: {
        top: '1.4em',
        bottom: '0'
    },
    heading3: {
        top: '1.31249em',
        bottom: '0'
    },
    heading4: {
        top: '1.25em',
        bottom: '0'
    },
    heading5: {
        top: '1.45833em',
        bottom: '0'
    },
    heading6: {
        top: '1.59091em',
        bottom: '0'
    },
    table: {
        top: '0',
        bottom: '0'
    },
    bulletList: {
        top: '10px',
        bottom: '0'
    },
    orderedList: {
        top: '10px',
        bottom: '0'
    },
    decisionList: {
        top: '0.5rem',
        bottom: '0'
    },
    taskList: {
        top: '0.75rem',
        bottom: '0'
    },
    codeBlock: {
        top: '0.75rem',
        bottom: '0'
    },
    panel: {
        top: '0.75rem',
        bottom: '0'
    },
    rule: {
        top: '1.5rem',
        bottom: '1.5rem'
    },
    mediaSingle: {
        top: '24px',
        bottom: '24px'
    },
    media: {
        top: '24px',
        bottom: '24px'
    },
    bodiedExtension: {
        top: '0',
        bottom: '0'
    },
    extension: {
        top: '0',
        bottom: '0'
    },
    layoutSection: {
        top: '0',
        bottom: '0'
    },
    blockquote: {
        top: '0',
        bottom: '0'
    },
    embedCard: {
        top: '24px',
        bottom: '24px'
    },
    blockCard: {
        top: '0.75rem',
        bottom: '0'
    },
    default: {
        top: '0',
        bottom: '0'
    }
};
const $30636d6b7963f251$export$ffe7e67ee4ab1502 = {
    table: {
        top: 24,
        bottom: 16
    },
    paragraph: {
        top: 12,
        bottom: 6
    },
    bulletList: {
        top: 16,
        bottom: 0
    },
    orderedList: {
        top: 16,
        bottom: 0
    },
    decisionList: {
        top: 12,
        bottom: 0
    },
    taskList: {
        top: 8,
        bottom: 0
    },
    codeBlock: {
        top: 12,
        bottom: 0
    },
    panel: {
        top: 8,
        bottom: 0
    },
    rule: {
        top: 24,
        bottom: 24
    },
    mediaSingle: {
        top: 24,
        bottom: 24
    },
    media: {
        top: 24,
        bottom: 24
    },
    bodiedExtension: {
        top: 0,
        bottom: 0
    },
    extension: {
        top: 12,
        bottom: 12
    },
    heading1: {
        top: 40,
        bottom: 0
    },
    heading2: {
        top: 40,
        bottom: 0
    },
    heading3: {
        top: 36,
        bottom: 0
    },
    heading4: {
        top: 22,
        bottom: 0
    },
    heading5: {
        top: 22,
        bottom: 0
    },
    heading6: {
        top: 18,
        bottom: 0
    },
    layoutSection: {
        top: 8,
        bottom: 0
    },
    blockquote: {
        top: 12,
        bottom: 0
    },
    expand: {
        top: 4,
        bottom: 0
    },
    nestedExpand: {
        top: 1,
        bottom: 0
    },
    default: {
        top: 0,
        bottom: 0
    }
};
const $30636d6b7963f251$export$d77e6458bbcae98b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};


const $13c274f989e663fd$var$STICKY_NODES = [
    'panel',
    'table',
    'expand',
    'layoutSection',
    'bodiedExtension'
];
const $13c274f989e663fd$export$3c9c03fbeb71a88 = (dom, type)=>{
    if (!dom) return 'auto';
    const table = dom.querySelector('table');
    const isTable = table && (!type || type === 'table');
    if (isTable) return `${dom.offsetTop + (table?.offsetTop || 0)}px`;
    else if (type === 'rule') return `${dom.offsetTop - (0, $30636d6b7963f251$export$d2a2373f7346fed2)}px`;
    else if (type === 'layoutColumn') return `${-dom.offsetTop / 2}px`;
    else if (type === 'heading-1') return `${dom.offsetTop + (0, $30636d6b7963f251$export$d5bafa9c4e821a51)}px`;
    else if (type === 'heading-2') return `${dom.offsetTop + (0, $30636d6b7963f251$export$1e2b3336ca8c087c)}px`;
    else if (type === 'heading-3') return `${dom.offsetTop}px`;
    else if (type === 'heading-4') return `${dom.offsetTop - (0, $30636d6b7963f251$export$7ca48bd6d02a13e0)}px`;
    else if (type === 'heading-5') return `${dom.offsetTop - (0, $30636d6b7963f251$export$40d0d70c288e6373)}px`;
    else if (type === 'heading-6') return `${dom.offsetTop - (0, $30636d6b7963f251$export$51dbe10140b62321)}px`;
    else if (type === 'paragraph') return `${dom.offsetTop + (0, $30636d6b7963f251$export$2d43c475787cc3b2)}px`;
    else return `${dom.offsetTop}px`;
};
const $13c274f989e663fd$export$c3d34436f1edd9bd = (dom, type, innerContainer, macroInteractionUpdates, parentType)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return type === 'layoutColumn' ? `${dom.offsetLeft + dom.clientWidth / 2 - (0, $30636d6b7963f251$export$f373eda827748b3) / 2}px` : `${dom.offsetLeft - (0, $30636d6b7963f251$export$e5ea166c620fdfb2)(type, parentType) - (0, $Yqd3z.DRAG_HANDLE_WIDTH)}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $30636d6b7963f251$export$e5ea166c620fdfb2)(type, parentType) - (0, $Yqd3z.DRAG_HANDLE_WIDTH)}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $30636d6b7963f251$export$e5ea166c620fdfb2)(type, parentType) - (0, $Yqd3z.DRAG_HANDLE_WIDTH)}px`;
};
const $13c274f989e663fd$export$d106346a0f891cc2 = (dom, anchor, anchorRectCache)=>anchorRectCache?.getHeight(anchor) || dom?.offsetHeight;
const $13c274f989e663fd$export$f988e74eefbc47fc = (nodeType)=>{
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && $13c274f989e663fd$var$STICKY_NODES.includes(nodeType);
};
const $13c274f989e663fd$export$cc6777b6e60d5179 = (anchor, isSticky, isTopLevelNode, isLayoutColumn)=>{
    return (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        bottom: 'unset'
    } : {
        bottom: `anchor(${anchor} end)`
    };
};
const $13c274f989e663fd$export$738fa80805cb522c = (nodeHeight, isSticky, isTopLevelNode, fallbackPxHeight, isLayoutColumn)=>{
    return (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        height: 'unset'
    } : {
        height: `${nodeHeight || fallbackPxHeight}px`
    };
};
const $13c274f989e663fd$export$9a1c84c70b9df34 = (nodeType, isTopLevelNode)=>{
    return(// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    isTopLevelNode && [
        'table'
    ].includes(nodeType) && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1'));
};



var $adhil = parcelRequire("adhil");
















const $b9aa051abc8155ab$export$eefc237c5f2aa5b9 = (doc, start, nodeSize)=>{
    const $startPos = doc.resolve(start);
    // To trigger the annotation floating toolbar for non-selectable node, we need to select inline nodes
    // Find the first inline node in the node
    let inlineNodePos = start;
    let foundInlineNode = false;
    let inlineNodeEndPos = 0;
    doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n, pos)=>{
        if (n.isInline) inlineNodeEndPos = pos + n.nodeSize;
        if (n.isInline && !foundInlineNode) {
            inlineNodePos = pos;
            foundInlineNode = true;
        }
        return true;
    });
    return {
        inlineNodePos: inlineNodePos,
        inlineNodeEndPos: inlineNodeEndPos
    };
};
const $b9aa051abc8155ab$export$e7d12bf383139ed5 = (tr, start, nodeSize)=>{
    const $startPos = tr.doc.resolve(start);
    let hasCodeBlock = false;
    tr.doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n)=>{
        if ([
            'codeBlock'
        ].includes(n.type.name)) hasCodeBlock = true;
    });
    return hasCodeBlock;
};
const $b9aa051abc8155ab$var$isNodeWithMediaOrExtension = (doc, start, nodeSize)=>{
    const $startPos = doc.resolve(start);
    let hasMediaOrExtension = false;
    doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n)=>{
        if ([
            'media',
            'extension'
        ].includes(n.type.name)) hasMediaOrExtension = true;
    });
    return hasMediaOrExtension;
};
const $b9aa051abc8155ab$var$oldGetSelection = (tr, start)=>{
    const node = tr.doc.nodeAt(start);
    const isNodeSelection = node && (0, $ks2lK.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    const $startPos = tr.doc.resolve(start);
    const nodeName = node?.type.name;
    const isBlockQuoteWithMediaOrExtension = nodeName === 'blockquote' && $b9aa051abc8155ab$var$isNodeWithMediaOrExtension(tr.doc, start, nodeSize);
    const isListWithMediaOrExtension = nodeName === 'bulletList' && $b9aa051abc8155ab$var$isNodeWithMediaOrExtension(tr.doc, start, nodeSize) || nodeName === 'orderedList' && $b9aa051abc8155ab$var$isNodeWithMediaOrExtension(tr.doc, start, nodeSize);
    if (isNodeSelection && nodeName !== 'blockquote' || isListWithMediaOrExtension || isBlockQuoteWithMediaOrExtension || // decisionList/layoutColumn node is not selectable, but we want to select the whole node not just text
    [
        'decisionList',
        'layoutColumn'
    ].includes(nodeName || '')) return new (0, $ks2lK.NodeSelection)($startPos);
    else if (nodeName === 'mediaGroup' && node?.childCount === 1) {
        const $mediaStartPos = tr.doc.resolve(start + 1);
        return new (0, $ks2lK.NodeSelection)($mediaStartPos);
    } else if (// Even though mediaGroup is not selectable,
    // we need a quick way to make all child media nodes appear as selected without the need for a custom selection
    nodeName === 'mediaGroup') return new (0, $ks2lK.NodeSelection)($startPos);
    else if (nodeName === 'taskList') return (0, $ks2lK.TextSelection).create(tr.doc, start, start + nodeSize);
    else {
        const { inlineNodePos: inlineNodePos, inlineNodeEndPos: inlineNodeEndPos } = $b9aa051abc8155ab$export$eefc237c5f2aa5b9(tr.doc, start, nodeSize);
        return new (0, $ks2lK.TextSelection)(tr.doc.resolve(inlineNodePos), tr.doc.resolve(inlineNodeEndPos));
    }
};
const $b9aa051abc8155ab$export$2ad544f897362d62 = (doc, selectionEmpty, start)=>{
    const node = doc.nodeAt(start);
    const isNodeSelection = node && (0, $ks2lK.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    const nodeName = node?.type.name;
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
        // if mediaGroup only has a single child, we want to select the child
        if (nodeName === 'mediaGroup' && node?.childCount === 1) {
            const $mediaStartPos = doc.resolve(start + 1);
            return new (0, $ks2lK.NodeSelection)($mediaStartPos);
        }
        // if heading with alignment nested inside a layout column, return TextSelection
        // As NodeSelection cause the desc.selectNode is not a function error in the syncNodeSelection in prosemirror view
        // Results in block menu not open on the first 2 clicks for a heading with alignment nested inside a layout column
        if (nodeName === 'heading' && node?.marks.some((mark)=>mark.type.name === 'alignment') && doc.nodeAt(start - 1)?.type.name === 'layoutColumn') return (0, $ks2lK.TextSelection).create(doc, start, start + nodeSize);
        return new (0, $ks2lK.NodeSelection)(doc.resolve(start));
    }
    // this is a fix for empty paragraph selection - put first to avoid any extra work
    if (nodeName === 'paragraph' && selectionEmpty && node?.childCount === 0) return false;
    const isBlockQuoteWithMediaOrExtension = nodeName === 'blockquote' && $b9aa051abc8155ab$var$isNodeWithMediaOrExtension(doc, start, nodeSize);
    const isListWithMediaOrExtension = nodeName === 'bulletList' && $b9aa051abc8155ab$var$isNodeWithMediaOrExtension(doc, start, nodeSize) || nodeName === 'orderedList' && $b9aa051abc8155ab$var$isNodeWithMediaOrExtension(doc, start, nodeSize);
    if (isNodeSelection && nodeName !== 'blockquote' || isListWithMediaOrExtension || isBlockQuoteWithMediaOrExtension || // decisionList/layoutColumn node is not selectable, but we want to select the whole node not just text
    [
        'decisionList',
        'layoutColumn'
    ].includes(nodeName || '') || nodeName === 'mediaGroup' && typeof node?.childCount === 'number' && node?.childCount > 1) return new (0, $ks2lK.NodeSelection)(doc.resolve(start));
    // if mediaGroup only has a single child, we want to select the child
    if (nodeName === 'mediaGroup') {
        const $mediaStartPos = doc.resolve(start + 1);
        return new (0, $ks2lK.NodeSelection)($mediaStartPos);
    }
    if (nodeName === 'taskList') return (0, $ks2lK.TextSelection).create(doc, start, start + nodeSize);
    const { inlineNodePos: inlineNodePos, inlineNodeEndPos: inlineNodeEndPos } = $b9aa051abc8155ab$export$eefc237c5f2aa5b9(doc, start, nodeSize);
    return new (0, $ks2lK.TextSelection)(doc.resolve(inlineNodePos), doc.resolve(inlineNodeEndPos));
};
const $b9aa051abc8155ab$export$ca798a7e6e94638c = (tr, start, api)=>{
    if ((0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) return $b9aa051abc8155ab$export$2ad544f897362d62(tr.doc, tr.selection.empty, start);
    return $b9aa051abc8155ab$var$oldGetSelection(tr, start);
};
const $b9aa051abc8155ab$export$cbcb4f775d907a9e = (tr, start, nodeType, api)=>{
    // For table, we need to do cell selection instead of node selection
    if (nodeType === 'table') {
        tr = (0, $kEbNW.selectTableClosestToPos)(tr, tr.doc.resolve(start + 1));
        return tr;
    }
    const selection = $b9aa051abc8155ab$export$ca798a7e6e94638c(tr, start, api);
    if (selection) tr.setSelection(selection);
    return tr;
};
const $b9aa051abc8155ab$export$4b5c09668d5b4e01 = (tr, start, api)=>{
    const node = tr.doc.nodeAt(start);
    const isNodeSelection = node && (0, $ks2lK.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    let selection;
    // decisionList node is not selectable, but we want to select the whole node not just text
    // blockQuote is selectable, but we want to set cursor at the inline end Pos instead of the gap cursor as this causes jittering post drop
    if (isNodeSelection && node.type.name !== 'blockquote' || node?.type.name === 'decisionList') {
        selection = new (0, $adhil.GapCursorSelection)(tr.doc.resolve(start + node.nodeSize), (0, $adhil.Side).RIGHT);
        tr.setSelection(selection);
        return tr;
    }
    // this is a fix for empty paragraph selection - can safely use start position as the paragraph is empty
    if (node?.type.name === 'paragraph' && node?.childCount === 0 && (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) {
        const selection = new (0, $ks2lK.TextSelection)(tr.doc.resolve(start));
        tr.setSelection(selection);
        return tr;
    }
    const { inlineNodeEndPos: inlineNodeEndPos } = $b9aa051abc8155ab$export$eefc237c5f2aa5b9(tr.doc, start, nodeSize);
    selection = new (0, $ks2lK.TextSelection)(tr.doc.resolve(inlineNodeEndPos));
    tr.setSelection(selection);
    return tr;
};
const $b9aa051abc8155ab$export$e89bc339b843c7b = (state, selection, handlePos)=>{
    if (selection.empty) return false;
    let nodeStart;
    const $selectionFrom = selection.$from;
    nodeStart = $selectionFrom.before($selectionFrom.sharedDepth(selection.to) + 1);
    if (nodeStart === $selectionFrom.pos) nodeStart = $selectionFrom.depth ? $selectionFrom.before() : $selectionFrom.pos;
    const $resolvedNodePos = state.doc.resolve(nodeStart);
    if ([
        'tableRow',
        'tableCell',
        'tableHeader'
    ].includes($resolvedNodePos.node().type.name)) {
        const parentNodeFindRes = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes['table'])(selection);
        const tablePos = parentNodeFindRes?.pos;
        nodeStart = typeof tablePos === 'undefined' ? nodeStart : tablePos;
    } else if ([
        'listItem'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before($b9aa051abc8155ab$export$3ee0594e8fdf55d5($resolvedNodePos));
    else if ([
        'taskList'
    ].includes($resolvedNodePos.node().type.name)) {
        const listdepth = $b9aa051abc8155ab$export$7116b8011b79af5e($resolvedNodePos);
        nodeStart = $resolvedNodePos.before(listdepth);
    } else if ([
        'blockquote'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before();
    return Boolean(handlePos < selection.$to.pos && handlePos >= nodeStart);
};
const $b9aa051abc8155ab$export$3ee0594e8fdf55d5 = (itemPos)=>{
    let depth;
    for(let i = itemPos.depth; i > 1; i -= 2){
        const node = itemPos.node(i);
        if (node.type.name === 'listItem') depth = i - 1;
        else break;
    }
    return depth;
};
const $b9aa051abc8155ab$export$7116b8011b79af5e = (taskListPos)=>{
    let depth;
    for(let i = taskListPos.depth; i > 0; i--){
        const node = taskListPos.node(i);
        if (node.type.name === 'taskList' || node.type.name === 'taskItem') depth = i;
        else break;
    }
    return depth;
};













const $d37e2d7c197cf61b$export$4e8a3dde481e0452 = (api, pos, tr)=>{
    const pluginState = api?.blockControls?.sharedState.currentState();
    // With move nodes shortcut, we expand selection and move node within one transaction,
    // Hence we also look for `multiSelectDnD` in transaction meta
    const multiSelectDnD = pluginState?.multiSelectDnD ?? tr?.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0))?.multiSelectDnD;
    if (multiSelectDnD && multiSelectDnD.anchor >= 0 && multiSelectDnD.head >= 0) {
        const multiFrom = Math.min(multiSelectDnD.anchor, multiSelectDnD.head);
        const multiTo = Math.max(multiSelectDnD.anchor, multiSelectDnD.head);
        // We subtract one as the handle position is before the node
        return pos >= multiFrom - 1 && pos < multiTo ? {
            anchor: multiSelectDnD.anchor,
            head: multiSelectDnD.head
        } : {};
    }
    return {};
};
const $d37e2d7c197cf61b$export$5e3fa240bc795f26 = (handlePos, tr, api)=>{
    const { anchor: anchor, head: head } = $d37e2d7c197cf61b$export$4e8a3dde481e0452(api, handlePos, tr);
    const inSelection = anchor !== undefined && head !== undefined;
    const from = inSelection ? Math.min(anchor || 0, head || 0) : handlePos;
    const activeNode = tr.doc.nodeAt(handlePos);
    const activeNodeEndPos = handlePos + (activeNode?.nodeSize ?? 1);
    const to = inSelection ? Math.max(anchor || 0, head || 0) : activeNodeEndPos;
    return {
        from: from,
        to: to
    };
};
const $d37e2d7c197cf61b$export$20b0d24b8a2c2db1 = (selection, nodePos)=>{
    const doc = selection.$anchor.doc;
    if (nodePos < 0 || nodePos > doc.nodeSize - 2 || selection.empty) return selection;
    const $pos = doc.resolve(nodePos);
    const node = $pos.nodeAfter;
    if ($pos.node().isTextblock || !node) return selection;
    const $newHead = nodePos < selection.anchor ? $pos : doc.resolve(node.nodeSize + nodePos);
    const textSelection = new (0, $ks2lK.TextSelection)(selection.$anchor, $newHead);
    return textSelection;
};
const $d37e2d7c197cf61b$export$d7b7394e7527c1b6 = (selection, pos)=>{
    return selection instanceof (0, $ks2lK.NodeSelection) && Math.max(pos, selection.anchor) === selection.anchor ? new (0, $ks2lK.TextSelection)(selection.$head, selection.$anchor) : selection;
};
const $d37e2d7c197cf61b$export$e21678cf246ba963 = (selection, tr)=>{
    const { preservedSelectionMapping: preservedSelectionMapping } = (0, $253f56923cf8d759$export$e75bc9902db1596f)(tr) || {};
    const mapping = preservedSelectionMapping || tr.mapping;
    const from = mapping.map(selection.from);
    const to = mapping.map(selection.to);
    const isSelectionEmpty = from === to;
    const wasSelectionEmpty = selection.from === selection.to;
    if (isSelectionEmpty && !wasSelectionEmpty) // If selection has become empty i.e. content has been deleted, stop preserving
    return undefined;
    return $d37e2d7c197cf61b$export$fa43757966d274e3(tr.doc.resolve(from), tr.doc.resolve(to));
};
const $d37e2d7c197cf61b$var$isInsideEmptyTextblock = ($pos)=>$pos.parent.isTextblock && $pos.parent.content.size === 0;
const $d37e2d7c197cf61b$var$isAtEndOfParent = ($pos)=>$pos.parentOffset === $pos.parent.content.size;
const $d37e2d7c197cf61b$var$isAtStartOfParent = ($pos)=>$pos.parentOffset === 0;
const $d37e2d7c197cf61b$export$59e281d427887933 = ($from, $to)=>{
    const { doc: doc } = $from;
    // Walk $from forward while at end of ancestors
    let adjustedFrom = $from;
    if (!$d37e2d7c197cf61b$var$isInsideEmptyTextblock($from)) while(adjustedFrom.depth > 0 && $d37e2d7c197cf61b$var$isAtEndOfParent(adjustedFrom)){
        const nextPos = adjustedFrom.after();
        if (nextPos > doc.content.size || nextPos === adjustedFrom.pos) break;
        adjustedFrom = doc.resolve(nextPos);
    }
    // Walk $to backward while at start of ancestors
    let adjustedTo = $to;
    if (!$d37e2d7c197cf61b$var$isInsideEmptyTextblock($to)) while(adjustedTo.depth > 0 && $d37e2d7c197cf61b$var$isAtStartOfParent(adjustedTo)){
        const prevPos = adjustedTo.before();
        if (prevPos < 0 || prevPos === adjustedTo.pos) break;
        adjustedTo = doc.resolve(prevPos);
    }
    return {
        $from: adjustedFrom,
        $to: adjustedTo
    };
};
const $d37e2d7c197cf61b$export$fa43757966d274e3 = ($from, $to)=>{
    const { doc: doc } = $from;
    const isCollapsed = $from.pos === $to.pos;
    const adjusted = isCollapsed ? {
        $from: $from,
        $to: $to
    } : $d37e2d7c197cf61b$export$59e281d427887933($from, $to);
    if (!isCollapsed && adjusted.$from.pos >= adjusted.$to.pos) return undefined;
    // expand the selection range to block boundaries, so selection always includes whole nodes
    const expanded = (0, $l6okE.expandToBlockRange)(adjusted.$from, adjusted.$to);
    // stop preserving if selection becomes invalid
    if (expanded.$from.pos < 0 || expanded.$to.pos > doc.content.size || expanded.$from.pos >= expanded.$to.pos) return undefined;
    // If multiple blocks selected, create TextSelection from start of first node to end of last node
    if (expanded.range && (0, $l6okE.isMultiBlockRange)(expanded.range)) return new (0, $ks2lK.TextSelection)(expanded.$from, expanded.$to);
    const nodeType = doc.nodeAt(expanded.$from.pos)?.type?.name;
    if (!nodeType) return undefined;
    if (nodeType === 'table') return (0, $kEbNW.getTableSelectionClosesToPos)($from);
    return (0, $b9aa051abc8155ab$export$2ad544f897362d62)(doc, false, expanded.$from.pos) || undefined;
};



/** @jsxRuntime classic */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



function $8c383f2b153ebbcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c383f2b153ebbcb$var$spanStyles = {
    name: "jpyn4z",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0"
};
const $8c383f2b153ebbcb$var$svgSizeStyles = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
const $8c383f2b153ebbcb$var$svgStyles = {
    name: "1l1mozn",
    styles: "color:currentColor;overflow:hidden;pointer-events:none;vertical-align:bottom"
};
const $8c383f2b153ebbcb$export$bd2793d885851030 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "aria-hidden": true,
        css: $8c383f2b153ebbcb$var$spanStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "-8 -8 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        css: [
            $8c383f2b153ebbcb$var$svgStyles,
            $8c383f2b153ebbcb$var$svgSizeStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("circle", {
        cx: "8",
        cy: "2.75",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("circle", {
        cx: "8",
        cy: "13.25",
        r: "1.75",
        fill: "currentColor"
    })));
};






var $6fnsQ = parcelRequire("6fnsQ");




const $55e0dbd70e64de9d$var$previewStyle = {
    borderColor: `var(--ds-border, ${(0, $6fnsQ.N30)})`,
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 3px)",
    borderWidth: "var(--ds-border-width-selected, 2px)",
    backgroundColor: `var(--ds-skeleton-subtle, ${(0, $6fnsQ.N20)})`
};
const $55e0dbd70e64de9d$var$getPreviewContainerDimensionsForSingle = (dom, nodeType)=>{
    let nodeContainer = dom;
    const iframeContainer = dom.querySelector('iframe');
    if (nodeType === 'embedCard') nodeContainer = dom.querySelector('.rich-media-item') || dom;
    else if (nodeType === 'extension' && iframeContainer) nodeContainer = iframeContainer;
    const nodeContainerRect = nodeContainer.getBoundingClientRect();
    return {
        width: nodeContainerRect.width,
        height: nodeContainerRect.height
    };
};
const $55e0dbd70e64de9d$var$getPreviewContainerDimensions = (dragPreviewContent)=>{
    let maxWidth = 0;
    let heightSum = 0;
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const { width: width, height: height } = $55e0dbd70e64de9d$var$getPreviewContainerDimensionsForSingle(element.dom, element.nodeType);
        if (width > maxWidth) maxWidth = width;
        heightSum += height;
    }
    return {
        width: maxWidth,
        height: heightSum
    };
};
const $55e0dbd70e64de9d$var$createGenericPreview = ()=>{
    const generalPreview = document.createElement('div');
    // ProseMirror class is required to make sure the cloned dom is styled correctly
    generalPreview.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    generalPreview.style.border = `${$55e0dbd70e64de9d$var$previewStyle.borderWidth} ${$55e0dbd70e64de9d$var$previewStyle.borderStyle} ${$55e0dbd70e64de9d$var$previewStyle.borderColor}`;
    generalPreview.style.borderRadius = $55e0dbd70e64de9d$var$previewStyle.borderRadius;
    generalPreview.style.backgroundColor = $55e0dbd70e64de9d$var$previewStyle.backgroundColor;
    generalPreview.style.height = '100%';
    generalPreview.setAttribute('data-testid', 'block-ctrl-generic-drag-preview');
    return generalPreview;
};
const $55e0dbd70e64de9d$var$createContentPreviewElement = (dom, nodeType, nodeSpacing)=>{
    const contentPreviewOneElement = document.createElement('div');
    contentPreviewOneElement.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    const resizer = dom.querySelector('.resizer-item');
    const clonedDom = resizer && [
        'mediaSingle',
        'table'
    ].includes(nodeType) ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    resizer.cloneNode(true) : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom.cloneNode(true);
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    clonedDom.style.marginLeft = '0';
    clonedDom.style.marginTop = nodeSpacing ? `${nodeSpacing.top}` : '0';
    clonedDom.style.marginRight = '0';
    clonedDom.style.marginBottom = nodeSpacing ? `${nodeSpacing.bottom}` : '0';
    clonedDom.style.boxShadow = 'none';
    clonedDom.style.opacity = browser.windows ? '1' : '0.31';
    contentPreviewOneElement.appendChild(clonedDom);
    return contentPreviewOneElement;
};
const $55e0dbd70e64de9d$var$isGenericPreview = (dom, nodeType)=>{
    const embedCard = dom.querySelector('.embedCardView-content-wrap');
    return nodeType === 'embedCard' || !!embedCard || nodeType === 'extension' && !!dom.querySelector('iframe');
};
const $55e0dbd70e64de9d$var$createPreviewForElement = (dom, nodeType, nodeSpacing)=>{
    const shouldBeGenericPreview = $55e0dbd70e64de9d$var$isGenericPreview(dom, nodeType);
    if (shouldBeGenericPreview) return $55e0dbd70e64de9d$var$createGenericPreview();
    else return $55e0dbd70e64de9d$var$createContentPreviewElement(dom, nodeType, nodeSpacing);
};
const $55e0dbd70e64de9d$export$3ec2e625089820fa = (container, dragPreviewContent)=>{
    container.style.pointerEvents = 'none';
    if (!Array.isArray(dragPreviewContent) && typeof dragPreviewContent === 'object') dragPreviewContent = [
        dragPreviewContent
    ];
    const { width: maxWidth, height: maxHeight } = $55e0dbd70e64de9d$var$getPreviewContainerDimensions(dragPreviewContent);
    container.style.width = `${maxWidth}px`;
    container.style.height = `${maxHeight}px`;
    const previewWrapperFragment = document.createDocumentFragment();
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const contentPreviewOneElement = $55e0dbd70e64de9d$var$createPreviewForElement(element.dom, element.nodeType, element.nodeSpacing);
        previewWrapperFragment.appendChild(contentPreviewOneElement);
    }
    container.appendChild(previewWrapperFragment);
    const scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    const scrollParentClassNames = scrollParent?.className;
    // Add the scroll parent class to the container to ensure the cloned element is styled correctly
    container.className = scrollParentClassNames || '';
    container.classList.remove('fabric-editor-popup-scroll-parent');
    // Prevents a scrollbar from showing
    container.style.overflow = 'visible';
    return ()=>container;
};







const $143218ef1333fcee$export$79a8e1d39d3c2449 = ({ getPos: getPos, view: view, anchorName: anchorName })=>{
    let newAnchorName = anchorName || '';
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return newAnchorName;
    const pos = getPos();
    if (anchorName || pos === undefined) return newAnchorName;
    const node = view.state.doc.nodeAt(pos);
    const state = (0, $253f56923cf8d759$export$df61b30b684217c0).getState(view.state);
    if (state?.decorations) {
        const nodeDecs = (0, $8653f788c2b076b7$export$562fc95beb8a58d3)(view.state, state.decorations, pos, pos + (node?.nodeSize ?? 0));
        const nodeDec = nodeDecs.at(0);
        if (!nodeDec) return newAnchorName;
        newAnchorName = nodeDec.spec.anchorName;
    }
    return newAnchorName;
};



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


















function $32afabcec12ede12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32afabcec12ede12$var$baseStyles = (0, $ecnYn.xcss)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out'
});
const $32afabcec12ede12$var$visibleStyles = (0, $ecnYn.xcss)({
    opacity: 1,
    visibility: 'visible'
});
const $32afabcec12ede12$var$hiddenStyles = (0, $ecnYn.xcss)({
    opacity: 0,
    visibility: 'hidden'
});
const $32afabcec12ede12$var$baseStylesCSS = /*#__PURE__*/ (0, $9K4OG.css)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $32afabcec12ede12$var$visibleStylesCSS = {
    name: "nk3zlf",
    styles: "opacity:1;visibility:visible"
};
const $32afabcec12ede12$var$hiddenStylesCSS = {
    name: "8792bh",
    styles: "opacity:0;visibility:hidden"
};
const $32afabcec12ede12$export$e7448669708130cc = ({ api: api, children: children })=>{
    const isTypeAheadOpen = (0, $b3YrF.useSharedPluginStateSelector)(api, 'typeAhead.isOpen');
    const isEditing = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockControls.isEditing');
    const isMouseOut = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockControls.isMouseOut');
    // when ai streaming, hide the block controls
    const userIntent = (0, $b3YrF.useSharedPluginStateSelector)(api, 'userIntent.currentUserIntent');
    const shouldHide = isTypeAheadOpen || isEditing || isMouseOut || userIntent === 'aiStreaming';
    if ((0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $32afabcec12ede12$var$baseStylesCSS,
            shouldHide ? $32afabcec12ede12$var$hiddenStylesCSS : $32afabcec12ede12$var$visibleStylesCSS
        ]
    }, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: [
            $32afabcec12ede12$var$baseStyles,
            shouldHide ? $32afabcec12ede12$var$hiddenStyles : $32afabcec12ede12$var$visibleStyles
        ]
    }, children);
};


function $5ea3bace04a19703$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5ea3bace04a19703$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $5ea3bace04a19703$var$buttonWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        background: `linear-gradient(to bottom, ${"var(--ds-surface, #FFFFFF)"} 90%, transparent)`,
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        background: `linear-gradient(to bottom, ${"var(--ds-surface, #FFFFFF)"} 90%, transparent)`,
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    }
});
const $5ea3bace04a19703$var$buttonWrapperStylesPatch = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $aFUXX.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $aFUXX.akEditorTableToolbarSize)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $aFUXX.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $aFUXX.akEditorTableToolbarSize)
    }
});
// update color to match quick insert button for new editor controls
const $5ea3bace04a19703$var$dragHandleColor = {
    name: "101f0nf",
    styles: "color:var(--ds-icon-subtle, #505258)"
};
const $5ea3bace04a19703$var$dragHandleButtonStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $30636d6b7963f251$export$f373eda827748b3),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $Yqd3z.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $30636d6b7963f251$export$aa77a5cc2a5f88a7),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #44546F)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $30636d6b7963f251$export$5ad27d778a09d25c),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #8993A4)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, transparent)"
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24h x 12w, Dense: 13px -> 18h x 9w
const $5ea3bace04a19703$var$dragHandleButtonDenseModeStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $aFUXX.relativeSizeToBaseFontSize)((0, $30636d6b7963f251$export$f373eda827748b3)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $aFUXX.relativeSizeToBaseFontSize)((0, $Yqd3z.DRAG_HANDLE_WIDTH))
});
const $5ea3bace04a19703$var$dragHandleButtonSmallScreenStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $5ea3bace04a19703$var$dragHandleButtonStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    paddingTop: `${"var(--ds-space-025, 2px)"}`,
    paddingBottom: `${"var(--ds-space-025, 2px)"}`,
    paddingLeft: '0',
    paddingRight: '0',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $30636d6b7963f251$export$f373eda827748b3),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $Yqd3z.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $30636d6b7963f251$export$aa77a5cc2a5f88a7),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #44546F)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $30636d6b7963f251$export$5ad27d778a09d25c),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #8993A4)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, transparent)"
    }
});
const $5ea3bace04a19703$var$focusedStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});
const $5ea3bace04a19703$var$focusedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:focus-visible': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});
const $5ea3bace04a19703$var$keyboardFocusedDragHandleStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`
});
const $5ea3bace04a19703$var$dragHandleContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    boxSizing: 'border-box'
});
const $5ea3bace04a19703$var$tooltipContainerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    bottom: `-${(0, $30636d6b7963f251$export$acab25f15fd410d6)}px`,
    position: 'sticky',
    display: 'block',
    zIndex: 100 // card = 100
});
const $5ea3bace04a19703$var$tooltipContainerStylesStickyHeaderWithMask = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $30636d6b7963f251$export$acab25f15fd410d6)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    }
});
const $5ea3bace04a19703$var$tooltipContainerStylesImprovedStickyHeaderWithMask = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $30636d6b7963f251$export$acab25f15fd410d6)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] > [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    }
});
const $5ea3bace04a19703$var$tooltipContainerStylesStickyHeaderWithoutMask = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $30636d6b7963f251$export$acab25f15fd410d6)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    }
});
const $5ea3bace04a19703$var$dragHandleMultiLineSelectionFixFirefox = {
    name: "ut0e3u",
    styles: "&::selection{background-color:transparent;}"
};
const $5ea3bace04a19703$var$layoutColumnDragHandleStyles = {
    name: "jbgpyq",
    styles: "transform:rotate(90deg)"
};
const $5ea3bace04a19703$var$selectedStyles = {
    name: "19uky9m",
    styles: "background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-icon-selected, #0C66E4)"
};
// [Chrome only] When selection contains multiple nodes and then drag a drag handle that is within the selection range,
// icon span receives dragStart event, instead of button, and since it is not registered as a draggable element
// with pragmatic DnD and pragmatic DnD is not triggered
const $5ea3bace04a19703$var$handleIconDragStart = (e)=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    if (!browser.chrome) return;
    // prevent dragStart handler triggered by icon
    e.stopPropagation();
    const dragEvent = new DragEvent('dragstart', {
        bubbles: true,
        cancelable: true,
        dataTransfer: e.dataTransfer
    });
    if (e.target instanceof HTMLElement) // re-dispatch drag event on button so that pragmatic DnD can be triggered properly
    e.target.closest('button')?.dispatchEvent(dragEvent);
};
const $5ea3bace04a19703$var$getNodeSpacingForPreview = (node)=>{
    if (!node) return (0, $30636d6b7963f251$export$67c6a77242c01faa)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $30636d6b7963f251$export$67c6a77242c01faa)[`heading${node.attrs.level}`] || (0, $30636d6b7963f251$export$67c6a77242c01faa)['default'];
    return (0, $30636d6b7963f251$export$67c6a77242c01faa)[nodeTypeName] || (0, $30636d6b7963f251$export$67c6a77242c01faa)['default'];
};
const $5ea3bace04a19703$var$getNodeMargins = (node)=>{
    if (!node) return (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)[`heading${node.attrs.level}`] || (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)['default'];
    return (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)[nodeTypeName] || (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)['default'];
};
const $5ea3bace04a19703$var$isPosWithinRange = (pos, range)=>{
    return range.start <= pos && range.end >= pos + 1;
};
/**
 * From the current selection and the position of the drag handle being clicked,
 * calculate the expanded block range up to the common ancestor.
 */ const $5ea3bace04a19703$var$getExpandedSelectionRange = ({ selection: selection, doc: doc, resolvedStartPos: resolvedStartPos, isShiftPressed: isShiftPressed })=>{
    // When not pressing shift, expand the current selection
    // When shift selecting upwards, expand from start of node to selection end
    // When shift selecting downwards, expand from selection start to end of node
    const selectUp = resolvedStartPos.pos < selection.from;
    const $from = isShiftPressed && selectUp ? resolvedStartPos : selection.$from;
    const $to = isShiftPressed && !selectUp ? doc.resolve(resolvedStartPos.pos + 1) : selection.$to;
    const adjusted = isShiftPressed ? {
        $from: $from,
        $to: $to
    } : (0, $d37e2d7c197cf61b$export$59e281d427887933)($from, $to);
    return (0, $l6okE.expandToBlockRange)(adjusted.$from, adjusted.$to);
};
/**
 * Updates the transaction with preserved selection logic.
 * Sets selection to expanded selection range if it encompasses the clicked drag handle,
 * otherwise selects the clicked drag handle's node only.
 */ const $5ea3bace04a19703$var$expandAndUpdateSelection = ({ tr: tr, selection: selection, startPos: startPos, isShiftPressed: isShiftPressed, nodeType: nodeType, api: api })=>{
    const resolvedStartPos = tr.doc.resolve(startPos);
    const expandedRange = $5ea3bace04a19703$var$getExpandedSelectionRange({
        doc: tr.doc,
        selection: selection,
        resolvedStartPos: resolvedStartPos,
        isShiftPressed: isShiftPressed
    });
    // Set selection to expanded selection range if it encompases the clicked drag handle
    if (expandedRange.range && $5ea3bace04a19703$var$isPosWithinRange(startPos, expandedRange.range) && (0, $l6okE.isMultiBlockRange)(expandedRange.range)) // Then create a selection from the start of the first node to the end of the last node
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(selection.from, expandedRange.$from.pos), Math.max(selection.to, expandedRange.$to.pos)));
    else if (nodeType === 'table') (0, $kEbNW.selectTableClosestToPos)(tr, tr.doc.resolve(startPos + 1));
    else // Select the clicked drag handle's node only
    (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, startPos, nodeType, api);
};
const $5ea3bace04a19703$export$a0c24614540b0efb = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, isTopLevelNode: isTopLevelNode = true, anchorRectCache: anchorRectCache })=>{
    const buttonRef = (0, $42omo.useRef)(null);
    const [dragHandleSelected, setDragHandleSelected] = (0, $42omo.useState)(false);
    const [dragHandleDisabled, setDragHandleDisabled] = (0, $42omo.useState)(false);
    const [blockCardWidth, setBlockCardWidth] = (0, $42omo.useState)(768);
    const [recalculatePosition, setRecalculatePosition] = (0, $42omo.useState)(false);
    const [positionStylesOld, setPositionStylesOld] = (0, $42omo.useState)({
        display: 'none'
    });
    const [isFocused, setIsFocused] = (0, $42omo.useState)(Boolean(handleOptions?.isFocused));
    const { macroInteractionUpdates: macroInteractionUpdates } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates
        }));
    const selection = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selection.selection');
    const isShiftDown = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockControls.isShiftDown');
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'interaction.interactionState');
    const start = getPos();
    const isLayoutColumn = nodeType === 'layoutColumn';
    const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    // Dynamically calculate if node is top-level based on current position (gated by experiment)
    const isTopLevelNodeDynamic = (0, $42omo.useMemo)(()=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_nested_drag_handle_icon', 'isEnabled', true)) return isTopLevelNode;
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            return $pos?.parent.type.name === 'doc';
        }
        return true;
    }, [
        getPos,
        view.state.doc,
        isTopLevelNode
    ]);
    // Use the dynamic value when experiment is on, otherwise use the prop
    // When cleaning up the experiment, you can safely remove the isTopLevelNode as an prop and
    // just rely on the dynamic value (rename it to isTopLevelNode for simplicitiy)
    const isTopLevelNodeValue = (0, $1oCLl.expValEquals)('platform_editor_nested_drag_handle_icon', 'isEnabled', true) ? isTopLevelNodeDynamic : isTopLevelNode;
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) return;
        // blockCard/datasource width is rendered correctly after this decoraton does. We need to observe for changes.
        if (nodeType === 'blockCard') {
            const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${anchorName}"]`);
            const container = dom?.querySelector('.datasourceView-content-inner-wrap');
            if (container) {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const width = entries[0].contentBoxSize[0].inlineSize;
                    setBlockCardWidth(width);
                });
                resizeObserver.observe(container);
                return ()=>resizeObserver.unobserve(container);
            }
        }
    }, [
        anchorName,
        nodeType,
        view.dom
    ]);
    const handleMouseUp = (0, $42omo.useCallback)((e)=>{
        // Stop propagation so that for drag handles in nested scenarios the click is captured
        // and doesn't propagate to the edge of the element and trigger a node selection
        // on the parent element
        e.stopPropagation();
    }, []);
    const handleOnClickNew = (0, $42omo.useCallback)((e)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            const startPos = getPos();
            if (startPos === undefined) return tr;
            const resolvedStartPos = tr.doc.resolve(startPos);
            const selection = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(view.state)?.preservedSelection || tr.selection;
            api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).UI,
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedStartPos.depth,
                    nodeType: resolvedStartPos.nodeAfter?.type.name || ''
                }
            })(tr);
            $5ea3bace04a19703$var$expandAndUpdateSelection({
                tr: tr,
                selection: selection,
                startPos: startPos,
                isShiftPressed: e.shiftKey,
                nodeType: nodeType,
                api: api
            });
            api?.blockControls?.commands.startPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands.toggleBlockMenu({
                anchorName: anchorName,
                openedViaKeyboard: false,
                triggerByNode: (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: tr.doc.resolve(startPos).before(1)
                } : undefined
            })({
                tr: tr
            });
            tr.setMeta('scrollIntoView', false);
            return tr;
        });
        view.focus();
    }, [
        api,
        view,
        getPos,
        nodeType,
        anchorName
    ]);
    const handleOnClick = (0, $42omo.useCallback)((e)=>{
        if (!isMultiSelect) setDragHandleSelected(!dragHandleSelected);
        api?.core?.actions.execute(({ tr: tr })=>{
            const startPos = getPos();
            if (startPos === undefined) return tr;
            const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
            const $anchor = mSelect?.anchor !== undefined ? tr.doc.resolve(mSelect?.anchor) : tr.selection.$anchor;
            if (!isMultiSelect || tr.selection.empty || !e.shiftKey) tr = (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, startPos, nodeType, api);
            else if (isTopLevelNodeValue && $anchor.depth <= (0, $30636d6b7963f251$export$c8181a575a7964ef) && e.shiftKey && (0, $dh538.fg)('platform_editor_elements_dnd_shift_click_select')) {
                const alignAnchorHeadToSel = (0, $d37e2d7c197cf61b$export$d7b7394e7527c1b6)(tr.selection, startPos);
                const selectionWithExpandedHead = (0, $d37e2d7c197cf61b$export$20b0d24b8a2c2db1)(alignAnchorHeadToSel, startPos);
                tr.setSelection(selectionWithExpandedHead);
                api?.blockControls?.commands.setMultiSelectPositions()({
                    tr: tr
                });
            }
            const resolvedMovingNode = tr.doc.resolve(startPos);
            const maybeNode = resolvedMovingNode.nodeAfter;
            tr.setMeta('scrollIntoView', false);
            api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).UI,
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedMovingNode.depth,
                    nodeType: maybeNode?.type.name || ''
                }
            })(tr);
            return tr;
        });
        view.focus();
    }, [
        isMultiSelect,
        api,
        view,
        dragHandleSelected,
        getPos,
        isTopLevelNodeValue,
        nodeType
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((e)=>{
        // allow user to use spacebar to select the node
        if (!e.repeat && e.key === ' ') {
            const startPos = getPos();
            api?.core?.actions.execute(({ tr: tr })=>{
                if (startPos === undefined) return tr;
                const node = tr.doc.nodeAt(startPos);
                if (!node) return tr;
                const $startPos = tr.doc.resolve(startPos + node.nodeSize);
                const selection = new (0, $ks2lK.TextSelection)($startPos);
                tr.setSelection(selection);
                !isMultiSelect && tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                    pos: startPos
                });
                return tr;
            });
        } else if (![
            e.altKey,
            e.ctrlKey,
            e.shiftKey
        ].some((pressed)=>pressed)) // If not trying to press shortcut keys,
        // return focus to editor to resume editing from caret position
        view.focus();
    }, [
        getPos,
        api?.core?.actions,
        isMultiSelect,
        view
    ]);
    const handleKeyDownNew = (0, $42omo.useCallback)((e)=>{
        // allow user to use spacebar to select the node
        if (e.key === 'Enter' || !e.repeat && e.key === ' ') {
            if ((0, $hTKp4.getDocument)()?.activeElement !== buttonRef.current) return;
            e.preventDefault();
            e.stopPropagation();
            const startPos = getPos();
            api?.core?.actions.execute(({ tr: tr })=>{
                if (startPos === undefined) return tr;
                const selection = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(view.state)?.preservedSelection || tr.selection;
                $5ea3bace04a19703$var$expandAndUpdateSelection({
                    tr: tr,
                    selection: selection,
                    startPos: startPos,
                    isShiftPressed: e.shiftKey,
                    nodeType: nodeType,
                    api: api
                });
                api?.blockControls?.commands.startPreservingSelection()({
                    tr: tr
                });
                const rootPos = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? tr.doc.resolve(startPos).before(1) : undefined;
                const triggerByNode = (0, $dZ8uq.expValEqualsNoExposure)('platform_synced_block', 'isEnabled', true) ? {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: rootPos
                } : undefined;
                api?.blockControls?.commands.toggleBlockMenu({
                    anchorName: anchorName,
                    triggerByNode: triggerByNode,
                    openedViaKeyboard: true
                })({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('blockMenuOpen')({
                    tr: tr
                });
                return tr;
            });
            view.focus();
        } else if (![
            e.altKey,
            e.ctrlKey,
            e.shiftKey
        ].some((pressed)=>pressed)) // If not trying to press shortcut keys,
        // return focus to editor to resume editing from caret position
        view.focus();
    }, [
        getPos,
        api,
        nodeType,
        anchorName,
        view
    ]);
    (0, $42omo.useEffect)(()=>{
        const element = buttonRef.current;
        if (!element) return;
        return (0, $4T4vf.draggable)({
            element: element,
            getInitialData: ()=>({
                    type: 'element',
                    start: start
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                if (isMultiSelect) api?.core?.actions.execute(({ tr: tr })=>{
                    const handlePos = getPos();
                    if (typeof handlePos !== 'number') return tr;
                    const newHandlePosCheck = (0, $b9aa051abc8155ab$export$e89bc339b843c7b)(view.state, tr.selection, handlePos);
                    if (!tr.selection.empty && newHandlePosCheck) api?.blockControls?.commands.setMultiSelectPositions()({
                        tr: tr
                    });
                    else tr = (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, handlePos, nodeType, api);
                    return tr;
                });
                const startPos = getPos();
                const state = view.state;
                const { doc: doc, selection: selection } = state;
                let sliceFrom = selection.from;
                let sliceTo = selection.to;
                const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                if (mSelect) {
                    const { anchor: anchor, head: head } = mSelect;
                    sliceFrom = Math.min(anchor, head);
                    sliceTo = Math.max(anchor, head);
                }
                const expandedSlice = doc.slice(sliceFrom, sliceTo);
                const isDraggingMultiLine = isMultiSelect && startPos !== undefined && startPos >= sliceFrom && startPos < sliceTo && expandedSlice.content.childCount > 1;
                (0, $afUmf.setCustomNativeDragPreview)({
                    getOffset: ()=>{
                        if (!isDraggingMultiLine) return {
                            x: 0,
                            y: 0
                        };
                        else {
                            // Calculate the offset of the preview container,
                            // So when drag multiple nodes, the preview align with the position of the selected nodes
                            const domAtPos = view.domAtPos.bind(view);
                            let domElementsHeightBeforeHandle = 0;
                            const nodesStartPos = [];
                            const nodesEndPos = [];
                            let activeNodeMarginTop = 0;
                            for(let i = 0; i < expandedSlice.content.childCount; i++){
                                if (i === 0) {
                                    nodesStartPos[i] = sliceFrom;
                                    nodesEndPos[i] = sliceFrom + (expandedSlice.content.maybeChild(i)?.nodeSize || 0);
                                } else {
                                    nodesStartPos[i] = nodesEndPos[i - 1];
                                    nodesEndPos[i] = nodesStartPos[i] + (expandedSlice.content.maybeChild(i)?.nodeSize || 0);
                                }
                                // when the node is before the handle, calculate the height of the node
                                if (nodesEndPos[i] <= startPos) {
                                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                                    const currentNodeElement = (0, $8m4tT.findDomRefAtPos)(nodesStartPos[i], domAtPos);
                                    const maybeCurrentNode = expandedSlice.content.maybeChild(i);
                                    const currentNodeSpacing = maybeCurrentNode ? $5ea3bace04a19703$var$getNodeMargins(maybeCurrentNode).top + $5ea3bace04a19703$var$getNodeMargins(maybeCurrentNode).bottom : 0;
                                    domElementsHeightBeforeHandle = domElementsHeightBeforeHandle + currentNodeElement.offsetHeight + currentNodeSpacing;
                                } else {
                                    // when the node is after the handle, calculate the top margin of the active node
                                    const maybeNextNode = expandedSlice.content.maybeChild(i);
                                    activeNodeMarginTop = maybeNextNode ? $5ea3bace04a19703$var$getNodeMargins(maybeNextNode).top : 0;
                                    break;
                                }
                            }
                            return {
                                x: 0,
                                y: domElementsHeightBeforeHandle + activeNodeMarginTop
                            };
                        }
                    },
                    render: ({ container: container })=>{
                        const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${anchorName}"]`);
                        if (!dom) return;
                        if (!isDraggingMultiLine) return (0, $55e0dbd70e64de9d$export$3ec2e625089820fa)(container, {
                            dom: dom,
                            nodeType: nodeType
                        });
                        else {
                            const domAtPos = view.domAtPos.bind(view);
                            const previewContent = [];
                            expandedSlice.content.descendants((node, pos)=>{
                                // Get the dom element of the node
                                //eslint-disable-next-line @atlaskit/editor/no-as-casting
                                const nodeDomElement = (0, $8m4tT.findDomRefAtPos)(sliceFrom + pos, domAtPos);
                                const currentNodeSpacing = $5ea3bace04a19703$var$getNodeSpacingForPreview(node);
                                previewContent.push({
                                    dom: nodeDomElement,
                                    nodeType: node.type.name,
                                    nodeSpacing: currentNodeSpacing
                                });
                                return false; // Only iterate through the first level of nodes
                            });
                            return (0, $55e0dbd70e64de9d$export$3ec2e625089820fa)(container, previewContent);
                        }
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart () {
                if (start === undefined) return;
                api?.core?.actions.execute(({ tr: tr })=>{
                    let nodeTypes, hasSelectedMultipleNodes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const maybeNode = resolvedMovingNode.nodeAfter;
                    const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                    if (mSelect) {
                        const attributes = (0, $c506554d919477c1$export$9f4024dd9bfa7336)(tr, mSelect.anchor, mSelect.head);
                        nodeTypes = attributes.nodeTypes;
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                    } else {
                        nodeTypes = maybeNode?.type.name;
                        hasSelectedMultipleNodes = false;
                    }
                    api?.blockControls?.commands.setNodeDragged(getPos, anchorName, nodeType)({
                        tr: tr
                    });
                    tr.setMeta('scrollIntoView', false);
                    api?.analytics?.actions.attachAnalyticsEvent({
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        action: (0, $d925B.ACTION).DRAGGED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeType: maybeNode?.type.name || '',
                            ...isMultiSelect && {
                                nodeTypes: nodeTypes,
                                hasSelectedMultipleNodes: hasSelectedMultipleNodes
                            }
                        }
                    })(tr);
                    return tr;
                });
                view.focus();
            }
        });
    }, [
        anchorName,
        api,
        getPos,
        isMultiSelect,
        nodeType,
        start,
        view
    ]);
    const positionStyles = (0, $42omo.useMemo)(()=>{
        if (!(0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) return {};
        // This is a no-op to allow recalculatePosition to be used as a dependency
        if (recalculatePosition) setRecalculatePosition(recalculatePosition);
        const pos = getPos();
        const $pos = (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? typeof pos === 'number' && view.state.doc.resolve(pos) : pos && view.state.doc.resolve(pos);
        const parentPos = $pos && $pos.depth ? $pos.before() : undefined;
        const node = parentPos !== undefined ? view.state.doc.nodeAt(parentPos) : undefined;
        const parentNodeType = node?.type.name;
        const supportsAnchor = CSS.supports('top', `anchor(${anchorName} start)`) && CSS.supports('left', `anchor(${anchorName} start)`);
        const safeAnchorName = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $143218ef1333fcee$export$79a8e1d39d3c2449)({
            getPos: getPos,
            view: view,
            anchorName: anchorName
        }) : anchorName;
        const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${safeAnchorName}"]`);
        const hasResizer = nodeType === 'table' || nodeType === 'mediaSingle';
        const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension' || nodeType === 'multiBodiedExtension';
        const isBlockCard = nodeType === 'blockCard';
        const isEmbedCard = nodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $13c274f989e663fd$export$f988e74eefbc47fc)(nodeType);
        if (supportsAnchor) {
            const bottom = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $13c274f989e663fd$export$cc6777b6e60d5179)(safeAnchorName, isSticky, isTopLevelNodeValue, isLayoutColumn) : {};
            return {
                left: isEdgeCase ? `calc(anchor(${safeAnchorName} start) + ${(0, $13c274f989e663fd$export$c3d34436f1edd9bd)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc((anchor(${safeAnchorName} right) + anchor(${safeAnchorName} left))/2 - ${(0, $30636d6b7963f251$export$f373eda827748b3) / 2}px)` : `calc(anchor(${safeAnchorName} start) - ${0, $Yqd3z.DRAG_HANDLE_WIDTH}px - ${(0, $30636d6b7963f251$export$e5ea166c620fdfb2)(nodeType, parentNodeType)}px)`,
                top: (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc(anchor(${safeAnchorName} top) - ${0, $Yqd3z.DRAG_HANDLE_WIDTH}px)` : `calc(anchor(${safeAnchorName} start)+ ${(0, $30636d6b7963f251$export$403b33ae238c7c59)((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $pos && $pos.nodeAfter && (0, $94da9623b41bcf3c$export$b0da2ac7a61aa72c)($pos.nodeAfter) || nodeType : nodeType)}px)`,
                ...bottom
            };
        }
        const height = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $13c274f989e663fd$export$738fa80805cb522c)((0, $13c274f989e663fd$export$d106346a0f891cc2)(dom, safeAnchorName, anchorRectCache) || 0, isSticky, isTopLevelNodeValue, `${(0, $30636d6b7963f251$export$f373eda827748b3)}`, isLayoutColumn) : {};
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $13c274f989e663fd$export$c3d34436f1edd9bd)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $13c274f989e663fd$export$c3d34436f1edd9bd)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType),
            top: (0, $13c274f989e663fd$export$3c9c03fbeb71a88)(dom, nodeType),
            ...height
        };
    }, [
        anchorName,
        getPos,
        view,
        nodeType,
        macroInteractionUpdates,
        anchorRectCache,
        isTopLevelNodeValue,
        isLayoutColumn,
        recalculatePosition
    ]);
    const calculatePositionOld = (0, $42omo.useCallback)(()=>{
        const pos = getPos();
        const $pos = (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? typeof pos === 'number' && view.state.doc.resolve(pos) : pos && view.state.doc.resolve(pos);
        const parentPos = $pos && $pos.depth ? $pos.before() : undefined;
        const node = parentPos !== undefined ? view.state.doc.nodeAt(parentPos) : undefined;
        const parentNodeType = node?.type.name;
        const supportsAnchor = CSS.supports('top', `anchor(${anchorName} start)`) && CSS.supports('left', `anchor(${anchorName} start)`);
        const safeAnchorName = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $143218ef1333fcee$export$79a8e1d39d3c2449)({
            getPos: getPos,
            view: view,
            anchorName: anchorName
        }) : anchorName;
        const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${safeAnchorName}"]`);
        const hasResizer = nodeType === 'table' || nodeType === 'mediaSingle';
        const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension' || nodeType === 'multiBodiedExtension';
        const isBlockCard = nodeType === 'blockCard' && !!blockCardWidth;
        const isEmbedCard = nodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $13c274f989e663fd$export$f988e74eefbc47fc)(nodeType);
        if (supportsAnchor) {
            const bottom = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $13c274f989e663fd$export$cc6777b6e60d5179)(safeAnchorName, isSticky, isTopLevelNodeValue, isLayoutColumn) : {};
            return {
                left: isEdgeCase ? `calc(anchor(${safeAnchorName} start) + ${(0, $13c274f989e663fd$export$c3d34436f1edd9bd)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc((anchor(${safeAnchorName} right) + anchor(${safeAnchorName} left))/2 - ${(0, $30636d6b7963f251$export$f373eda827748b3) / 2}px)` : `calc(anchor(${safeAnchorName} start) - ${0, $Yqd3z.DRAG_HANDLE_WIDTH}px - ${(0, $30636d6b7963f251$export$e5ea166c620fdfb2)(nodeType, parentNodeType)}px)`,
                top: (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc(anchor(${safeAnchorName} top) - ${0, $Yqd3z.DRAG_HANDLE_WIDTH}px)` : `calc(anchor(${safeAnchorName} start) + ${(0, $30636d6b7963f251$export$403b33ae238c7c59)((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $pos && $pos.nodeAfter && (0, $94da9623b41bcf3c$export$b0da2ac7a61aa72c)($pos.nodeAfter) || nodeType : nodeType)}px)`,
                ...bottom
            };
        }
        const height = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $13c274f989e663fd$export$738fa80805cb522c)((0, $13c274f989e663fd$export$d106346a0f891cc2)(dom, safeAnchorName, anchorRectCache) || 0, isSticky, isTopLevelNodeValue, `${(0, $30636d6b7963f251$export$f373eda827748b3)}`, isLayoutColumn) : {};
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $13c274f989e663fd$export$c3d34436f1edd9bd)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $13c274f989e663fd$export$c3d34436f1edd9bd)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType),
            top: (0, $13c274f989e663fd$export$3c9c03fbeb71a88)(dom, nodeType),
            ...height
        };
    }, [
        anchorName,
        getPos,
        view,
        nodeType,
        blockCardWidth,
        macroInteractionUpdates,
        anchorRectCache,
        isTopLevelNodeValue,
        isLayoutColumn
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) return;
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $fFa3V.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) return;
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $fFa3V.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setRecalculatePosition(!recalculatePosition);
                }
            });
        }
        return ()=>{
            cleanUpTransitionListener?.();
        };
    }, [
        view,
        anchorName,
        nodeType,
        recalculatePosition
    ]);
    (0, $42omo.useEffect)(()=>{
        if (handleOptions?.isFocused && buttonRef.current) {
            const id = requestAnimationFrame(()=>{
                buttonRef.current?.focus();
            });
            return ()=>{
                cancelAnimationFrame(id);
                if (!(0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true)) view.focus();
            };
        }
    }, [
        buttonRef,
        handleOptions?.isFocused,
        view
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isMultiSelect || typeof start !== 'number' || !selection) return;
        setDragHandleSelected((0, $b9aa051abc8155ab$export$e89bc339b843c7b)(view.state, selection, start));
    }, [
        start,
        selection,
        view,
        isMultiSelect
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isMultiSelect || isShiftDown === undefined || view.state.selection.empty || !(0, $dh538.fg)('platform_editor_elements_dnd_shift_click_select')) return;
        const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
        const $anchor = mSelect?.anchor !== undefined ? view.state.doc.resolve(mSelect?.anchor) : view.state.selection.$anchor;
        if (isShiftDown && (!isTopLevelNodeValue || isTopLevelNodeValue && $anchor.depth > (0, $30636d6b7963f251$export$c8181a575a7964ef))) setDragHandleDisabled(true);
        else setDragHandleDisabled(false);
    }, [
        api?.blockControls.sharedState,
        isMultiSelect,
        isShiftDown,
        isTopLevelNodeValue,
        view
    ]);
    const dragHandleMessage = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? formatMessage((0, $dwl7L.messages).dragToMoveClickToOpen, {
        br: /*#__PURE__*/ (0, $9K4OG.jsx)("br", null)
    }) : formatMessage((0, $dwl7L.messages).dragToMove);
    // Create a string version for aria-label
    const dragHandleAriaLabel = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? formatMessage((0, $dwl7L.messages).dragToMoveClickToOpen, {
        br: ' '
    }) : formatMessage((0, $dwl7L.messages).dragToMove);
    let helpDescriptors = isTopLevelNodeValue ? [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveUp),
            keymap: (0, $hgeg8.dragToMoveUp)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveDown),
            keymap: (0, $hgeg8.dragToMoveDown)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveLeft),
            keymap: (0, $hgeg8.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveRight),
            keymap: (0, $hgeg8.dragToMoveRight)
        }
    ] : [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveUp),
            keymap: (0, $hgeg8.dragToMoveUp)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveDown),
            keymap: (0, $hgeg8.dragToMoveDown)
        }
    ];
    let isParentNodeOfTypeLayout;
    if (!isTopLevelNodeValue) {
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            isParentNodeOfTypeLayout = $pos?.parent?.type.name === 'layoutColumn';
        }
        if (isParentNodeOfTypeLayout) helpDescriptors = [
            ...helpDescriptors,
            {
                description: formatMessage((0, $dwl7L.messages).moveLeft),
                keymap: (0, $hgeg8.dragToMoveLeft)
            },
            {
                description: formatMessage((0, $dwl7L.messages).moveRight),
                keymap: (0, $hgeg8.dragToMoveRight)
            }
        ];
    }
    // When advanced layout is on, layout column drag handle show only show 'Drag to move', no shortcuts
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && nodeType === 'layoutColumn') helpDescriptors = [
        {
            description: formatMessage((0, $dwl7L.messages).dragToRearrange)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveUp),
            keymap: (0, $hgeg8.dragToMoveUp)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveDown),
            keymap: (0, $hgeg8.dragToMoveDown)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveLeft),
            keymap: (0, $hgeg8.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $dwl7L.messages).moveRight),
            keymap: (0, $hgeg8.dragToMoveRight)
        }
    ];
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) helpDescriptors = [
        {
            description: dragHandleMessage
        }
    ];
    const message = helpDescriptors.map((descriptor)=>{
        return descriptor.keymap ? [
            descriptor.description,
            (0, $hgeg8.getAriaKeyshortcuts)(descriptor.keymap)
        ] : [
            descriptor.description
        ];
    }).join('. ');
    const handleOnDrop = (event)=>{
        (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true) && event.stopPropagation();
    };
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    const renderButton = ()=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
            type: "button",
            css: [
                (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? $5ea3bace04a19703$var$dragHandleButtonStyles : $5ea3bace04a19703$var$dragHandleButtonStylesOld,
                (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && $5ea3bace04a19703$var$dragHandleColor,
                // ED-26266: Fixed the drag handle highlight when selecting multiple line in Firefox
                // See https://product-fabric.atlassian.net/browse/ED-26266
                browser.gecko && $5ea3bace04a19703$var$dragHandleMultiLineSelectionFixFirefox,
                (0, $iu6m9.editorExperiment)('advanced_layouts', true) && isLayoutColumn && $5ea3bace04a19703$var$layoutColumnDragHandleStyles,
                dragHandleSelected && hasHadInteraction && $5ea3bace04a19703$var$selectedStyles,
                (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') && $5ea3bace04a19703$var$dragHandleButtonSmallScreenStyles,
                (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && isFocused && $5ea3bace04a19703$var$keyboardFocusedDragHandleStyles,
                (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? $5ea3bace04a19703$var$focusedStyles : $5ea3bace04a19703$var$focusedStylesOld,
                ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $5ea3bace04a19703$var$dragHandleButtonDenseModeStyles
            ],
            ref: buttonRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) ? positionStyles : positionStylesOld : {},
            onMouseUp: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? handleMouseUp : undefined,
            onClick: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? handleOnClickNew : handleOnClick,
            onKeyDown: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? handleKeyDownNew : handleKeyDown,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDrop: handleOnDrop,
            disabled: dragHandleDisabled,
            "data-editor-block-ctrl-drag-handle": true,
            "data-testid": "block-ctrl-drag-handle",
            "aria-label": (0, $1oCLl.expValEquals)('platform_editor_drag_handle_aria_label', 'isEnabled', true) ? dragHandleAriaLabel : '',
            onBlur: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? ()=>setIsFocused(false) : undefined
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            xcss: $5ea3bace04a19703$var$iconWrapperStyles,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: $5ea3bace04a19703$var$handleIconDragStart
        }, (0, $1oCLl.expValEquals)('platform_editor_nested_drag_handle_icon', 'isEnabled', true) && !isTopLevelNodeValue ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8c383f2b153ebbcb$export$bd2793d885851030), null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
            spacing: "spacious",
            label: "",
            size: "small"
        })));
    const stickyWithTooltip = ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: (0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) ? positionStyles : positionStylesOld,
            xcss: [
                $5ea3bace04a19703$var$dragHandleContainerStyles
            ],
            as: "span",
            testId: "block-ctrl-drag-handle-container"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                $5ea3bace04a19703$var$tooltipContainerStyles,
                (0, $13c274f989e663fd$export$9a1c84c70b9df34)(nodeType, isTopLevelNodeValue) && ((0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_6') ? $5ea3bace04a19703$var$tooltipContainerStylesImprovedStickyHeaderWithMask : $5ea3bace04a19703$var$tooltipContainerStylesStickyHeaderWithMask),
                !(0, $13c274f989e663fd$export$9a1c84c70b9df34)(nodeType, isTopLevelNodeValue) && $5ea3bace04a19703$var$tooltipContainerStylesStickyHeaderWithoutMask
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.TooltipContentWithMultipleShortcuts), {
                helpDescriptors: helpDescriptors
            }),
            ignoreTooltipPointerEvents: true,
            position: 'top',
            onShow: ()=>{
                api?.accessibilityUtils?.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                (0, $13c274f989e663fd$export$9a1c84c70b9df34)(nodeType, isTopLevelNodeValue) && $5ea3bace04a19703$var$buttonWrapperStyles,
                $5ea3bace04a19703$var$buttonWrapperStylesPatch
            ]
        }, renderButton()))));
    const stickyWithoutTooltip = ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: (0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) ? positionStyles : positionStylesOld,
            xcss: [
                $5ea3bace04a19703$var$dragHandleContainerStyles
            ],
            as: "span",
            testId: "block-ctrl-drag-handle-container"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                $5ea3bace04a19703$var$tooltipContainerStyles,
                (0, $13c274f989e663fd$export$9a1c84c70b9df34)(nodeType, isTopLevelNodeValue) && $5ea3bace04a19703$var$tooltipContainerStylesStickyHeaderWithMask,
                !(0, $13c274f989e663fd$export$9a1c84c70b9df34)(nodeType, isTopLevelNodeValue) && $5ea3bace04a19703$var$tooltipContainerStylesStickyHeaderWithoutMask
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                (0, $13c274f989e663fd$export$9a1c84c70b9df34)(nodeType, isTopLevelNodeValue) && $5ea3bace04a19703$var$buttonWrapperStyles,
                $5ea3bace04a19703$var$buttonWrapperStylesPatch
            ]
        }, renderButton())));
    const buttonWithTooltip = ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.TooltipContentWithMultipleShortcuts), {
                helpDescriptors: helpDescriptors
            }),
            ignoreTooltipPointerEvents: true,
            onShow: ()=>{
                api?.accessibilityUtils?.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, renderButton());
    const isTooltip = !dragHandleDisabled;
    const stickyRender = isTooltip ? stickyWithTooltip() : stickyWithoutTooltip();
    const render = isTooltip ? buttonWithTooltip() : renderButton();
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? stickyRender : render;
};
const $5ea3bace04a19703$export$c3c91925cdbf4b0b = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, isTopLevelNode: isTopLevelNode, anchorRectCache: anchorRectCache })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $32afabcec12ede12$export$e7448669708130cc), {
        api: api
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($5ea3bace04a19703$export$a0c24614540b0efb, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        anchorName: anchorName,
        nodeType: nodeType,
        handleOptions: handleOptions,
        isTopLevelNode: isTopLevelNode,
        anchorRectCache: anchorRectCache
    }));
};









const $271e6ebabf680389$export$73aa3a42f47c0775 = (state, pos)=>{
    const { alignment: alignment } = state.schema.marks;
    const resolvedPos = state.doc.resolve(pos);
    // find all active marks at the position
    const marks = resolvedPos.marks();
    const supportedMarks = marks.filter((mark)=>mark.type === alignment);
    /**
	 * Fix for widget positioning at alignment mark boundaries.
	 * When the previous node has alignment but the next node doesn't, we need to prevent
	 * the widget from inheriting alignment marks. This ensures the widget is positioned
	 * correctly at the boundary rather than being absorbed into the alignment wrapper.
	 */ if (supportedMarks.length > 0 && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_native_anchor_patch_1')) {
        const nextNodeMarks = resolvedPos.nodeAfter?.marks.filter((mark)=>mark.type === alignment) || [];
        // Compare alignment values to ensure they are the same
        const alignmentValuesMatch = supportedMarks.length === nextNodeMarks.length && supportedMarks.some((mark)=>nextNodeMarks.some((nextMark)=>nextMark.eq(mark)));
        // previous node has alignment but next node does not have alignment or alignment values differ
        if (nextNodeMarks.length === 0 || !alignmentValuesMatch) return [];
    }
    return supportedMarks;
};


const $07725a88f79f2db7$export$613641ee4757989 = ()=>{
    const anchorName = `--node-anchor-paragraph-0`;
    const style = `anchor-name: ${anchorName}; margin-top: 0px;`;
    return (0, $ftzrq.Decoration).node(0, 2, {
        style: style,
        ['data-drag-handler-anchor-name']: anchorName
    }, {
        type: (0, $94da9623b41bcf3c$export$ab0e97a1d4f97633)
    });
};
const $07725a88f79f2db7$export$3ec2b0df4b056a96 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $94da9623b41bcf3c$export$eac9eb77d42744c8));
};
const $07725a88f79f2db7$export$38a5c9b9faf26cd8 = ({ api: api, formatMessage: formatMessage, pos: pos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, handleOptions: handleOptions, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    if (!(0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true, {
        exposure: true
    })) (0, $94da9623b41bcf3c$export$ad2994468d2cac1a)(nodeViewPortalProviderAPI, 'data-blocks-drag-handle-container', 'data-blocks-drag-handle-key');
    let unbind;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    const widgetSpec = (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) ? {
        side: -1,
        type: (0, $94da9623b41bcf3c$export$eac9eb77d42744c8),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${0, $94da9623b41bcf3c$export$eac9eb77d42744c8}-${(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()}`,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $271e6ebabf680389$export$73aa3a42f47c0775)(editorState, pos),
        destroy: (node)=>{
            unbind && unbind();
            if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) && node instanceof HTMLElement) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(node);
        }
    } : {
        side: -1,
        type: (0, $94da9623b41bcf3c$export$eac9eb77d42744c8),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${0, $94da9623b41bcf3c$export$eac9eb77d42744c8}-${(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()}`,
        marks: (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_native_anchor_patch_1') ? (0, $271e6ebabf680389$export$73aa3a42f47c0775)(editorState, pos) : undefined,
        destroy: (node)=>{
            unbind && unbind();
            if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) && node instanceof HTMLElement) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(node);
        }
    };
    return (0, $ftzrq.Decoration).widget(pos, (view, getPosUnsafe)=>{
        const element = document.createElement('span');
        // inline decoration causes focus issues when refocusing Editor into first line
        element.style.display = 'block';
        element.setAttribute('data-testid', 'block-ctrl-decorator-widget');
        element.setAttribute('data-blocks-drag-handle-container', 'true');
        element.setAttribute('data-blocks-drag-handle-key', key);
        let isTopLevelNode = true;
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch  {
                // Ignore errors from getPosUnsafe
                return undefined;
            }
        };
        const newPos = getPos();
        if (typeof newPos === 'number') {
            const $pos = view.state.doc.resolve(newPos);
            isTopLevelNode = $pos?.parent.type.name === 'doc';
        }
        /*
     * We disable mouseover event to fix flickering issue on hover
     * However, the tooltip for nested drag handle is no long working.
     */ if (newPos === undefined || !isTopLevelNode) {
            if ((0, $dh538.fg)('platform_editor_fix_widget_destroy')) element.onmouseover = (e)=>{
                e.stopPropagation();
            };
            else unbind = (0, $fFa3V.bind)(element, {
                type: 'mouseover',
                listener: (e)=>{
                    e.stopPropagation();
                }
            });
        }
        // There are times when global clear: "both" styles are applied to this decoration causing jumpiness
        // due to margins applied to other nodes eg. Headings
        element.style.clear = 'unset';
        // temporarily re-instating ReactDOM.render to fix drag handle focus issue, fix to
        // follow via ED-26546
        // previous under platform_editor_react18_plugin_portalprovider
        // 	nodeViewPortalProviderAPI.render(
        // 		() =>
        // 			createElement(DragHandle, {
        // 				view,
        // 				api,
        // 				formatMessage,
        // 				getPos,
        // 				anchorName,
        // 				nodeType,
        // 				handleOptions,
        // 				isTopLevelNode,
        // 			}),
        // 		element,
        // 		key,
        // 	);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render((0, $42omo.createElement)((0, $5ea3bace04a19703$export$c3c91925cdbf4b0b), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        else (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render((0, $42omo.createElement)((0, $5ea3bace04a19703$export$a0c24614540b0efb), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        return element;
    }, widgetSpec);
};












var $l9G9n = parcelRequire("l9G9n");











/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $2n8po = parcelRequire("2n8po");





var $dTk3A = parcelRequire("dTk3A");









var $5rDjV = parcelRequire("5rDjV");







class $e89e2e6fe979fcda$export$d16dfd16e2bbb367 {
    getActiveAnchor() {
        return this.lastActiveAnchor;
    }
    subscribe(anchorName, callback) {
        if (this.emitter) this.emitter.on(anchorName, callback);
    }
    unsubscribe(anchorName, callback) {
        if (this.emitter) this.emitter.removeListener(anchorName, callback);
    }
    emit(anchorName) {
        if (this.lastActiveAnchor !== anchorName && this.emitter) {
            this.emitter.emit(this.lastActiveAnchor, false);
            this.emitter.emit(anchorName, true);
            this.lastActiveAnchor = anchorName;
        }
    }
    reset() {
        if (this.emitter) {
            // To prevent any potential memory leaks,
            // we set the event emitter to null and then create a new event emitter.
            this.emitter.removeAllListeners();
            this.emitter = null;
            this.emitter = new (0, $5rDjV.EventEmitter)();
        }
    }
    constructor(){
        this.emitter = void 0;
        this.lastActiveAnchor = '';
        this.emitter = new (0, $5rDjV.EventEmitter)();
    }
}
const $e89e2e6fe979fcda$export$73b394ea452decfd = new $e89e2e6fe979fcda$export$d16dfd16e2bbb367();
const $e89e2e6fe979fcda$export$8f015ea2e0aa57d4 = (anchorName, activeAnchorTracker = $e89e2e6fe979fcda$export$73b394ea452decfd)=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const onActive = (eventIsActive)=>{
        setIsActive(eventIsActive);
    };
    (0, $42omo.useEffect)(()=>{
        if (activeAnchorTracker && anchorName && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
            activeAnchorTracker.subscribe(anchorName, onActive);
            if (activeAnchorTracker.getActiveAnchor() === anchorName) setIsActive(true);
            const unsubscribe = ()=>{
                activeAnchorTracker.unsubscribe(anchorName, onActive);
            };
            return unsubscribe;
        }
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    const setActive = (0, $42omo.useCallback)(()=>{
        activeAnchorTracker.emit(anchorName);
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    return [
        isActive,
        setActive
    ];
};



var $2XqLN = parcelRequire("2XqLN");


const $b0c29e8b0584a1ce$export$2073a24f9367a16f = (0, $2XqLN.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $b0c29e8b0584a1ce$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}]`) || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute((0, $d89c90893897930c$export$684dbfb461b166c3)());
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $b0c29e8b0584a1ce$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}








const $f56b7fa0195bc28e$export$a5a8e8321fc18ce = (node)=>{
    if ('mediaSingle' === node?.type.name) {
        if ([
            'wrap-right',
            'wrap-left'
        ].includes(node.attrs.layout)) return true;
    }
    return false;
};





const $38ae61d92a71d752$export$b8ad888c900fcbc2 = ()=>{
    return (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? 5 : 3;
};
const $38ae61d92a71d752$export$8a51600ccf088851 = 2;


const $490dde8b4167f1cf$var$syncedBlockTypes = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $490dde8b4167f1cf$export$9d1974d3f03f9d59 = (isNested, node, /**
	 * Is the active node in the same layout as the target node
	 */ isSameLayout = false, activeNode)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', false) || isNested) return false;
    if ((0, $f56b7fa0195bc28e$export$a5a8e8321fc18ce)(node)) return false;
    if (activeNode?.nodeType === 'layoutSection') return false;
    if (($490dde8b4167f1cf$var$syncedBlockTypes.includes(activeNode?.nodeType || '') || $490dde8b4167f1cf$var$syncedBlockTypes.includes(node?.type.name || '')) && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) return false;
    if (node?.type.name === 'layoutSection') return node.childCount < (0, $38ae61d92a71d752$export$b8ad888c900fcbc2)() || isSameLayout;
    return !(0, $l9G9n.isEmptyParagraph)(node);
};



/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






























var $aXG5V = parcelRequire("aXG5V");

const $a673071a38c5eb36$export$fc81c36e83ce2f6b = (tr)=>tr.steps.find((step)=>step instanceof (0, $aXG5V.ReplaceStep) && [
            'layoutSection',
            'layoutColumn'
        ].includes(step.slice.content.firstChild?.type.name || ''));
const $a673071a38c5eb36$export$2e8776145e31b87 = (tr, to, insertAtRight)=>{
    const $to = tr.doc.resolve(to);
    const toNode = $to.nodeAfter;
    let lastNode = toNode?.content.lastChild;
    if (!toNode || !lastNode) return tr;
    let offset = toNode.nodeSize;
    // drop at the start of the layoutSection or to create a new layoutSection
    if (toNode.type.name === 'layoutSection') {
        if (insertAtRight) {
            lastNode = toNode.content.lastChild?.lastChild;
            offset = toNode.nodeSize - 1;
        } else {
            lastNode = toNode.content.firstChild?.lastChild;
            offset = 1 + (toNode.content.firstChild?.nodeSize || 0);
        }
    }
    if ([
        'paragraph',
        'heading'
    ].includes(lastNode?.type.name || '')) tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(to + offset - 2)));
    else if (lastNode) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(to + offset - 1), (0, $adhil.Side).RIGHT));
    return tr;
};


function $4ba7181f843f8e6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4ba7181f843f8e6f$var$HOVER_ZONE_WIDTH = '--editor-blocks-inline-hover-zone-width';
const $4ba7181f843f8e6f$var$HOVER_ZONE_HEIGHT = '--editor-blocks-inline-hover-zone-height';
const $4ba7181f843f8e6f$var$HOVER_ZONE_TOP = '--editor-blocks-inline-hover-zone-top';
const $4ba7181f843f8e6f$var$HOVER_ZONE_BOTTOM = '--editor-blocks-inline-hover-zone-bottom';
const $4ba7181f843f8e6f$var$HOVER_ZONE_ANCHOR_NAME = '--editor-blocks-inline-hover-zone-anchor-name';
const $4ba7181f843f8e6f$var$hoverZoneCommonStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    // above the top and bottom drop zone as block hover zone
    zIndex: 120,
    positionAnchor: `var(${$4ba7181f843f8e6f$var$HOVER_ZONE_ANCHOR_NAME})`,
    minWidth: "var(--ds-space-100, 8px)",
    left: 0,
    right: 0,
    width: `var(${$4ba7181f843f8e6f$var$HOVER_ZONE_WIDTH})`,
    height: `var(${$4ba7181f843f8e6f$var$HOVER_ZONE_HEIGHT})`
});
const $4ba7181f843f8e6f$var$leftHoverZoneStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    right: `unset`,
    top: `var(${$4ba7181f843f8e6f$var$HOVER_ZONE_TOP})`,
    bottom: 'unset'
});
const $4ba7181f843f8e6f$var$rightHoverZoneStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    left: `unset`,
    top: 'unset',
    bottom: `var(${$4ba7181f843f8e6f$var$HOVER_ZONE_BOTTOM})`
});
// gap between node boundary and drop indicator/drop zone
const $4ba7181f843f8e6f$var$GAP = 4;
const $4ba7181f843f8e6f$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    height: '100%',
    position: 'absolute',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${`var(--ds-border-focused, ${(0, $6fnsQ.B200)})`}`,
    width: 0,
    left: 0
});
const $4ba7181f843f8e6f$var$dropTargetLayoutHintLeftStyle = {
    name: "go864d",
    styles: "left:unset;right:0"
};
const $4ba7181f843f8e6f$var$defaultNodeDimension = {
    width: '0',
    height: '0',
    top: 'unset',
    bottom: 'unset'
};
const $4ba7181f843f8e6f$var$getWidthOffset = (node, width, position)=>{
    if ([
        'mediaSingle',
        'table',
        'embedCard'
    ].includes(node.type.name) || // block card (without datasource) is positioned left-aligned, hence share the same logic as align-start
    node.type.name === 'blockCard' && !node.attrs.datasource) {
        const isLeftPosition = position === 'left';
        if (node.attrs.layout === 'align-start' || node.type.name === 'blockCard') return isLeftPosition ? `-0.5*(var(--ak-editor--line-length) - ${width})` : `0.5*(var(--ak-editor--line-length) - ${width})`;
        else if (node?.attrs.layout === 'align-end') return isLeftPosition ? `0.5*(var(--ak-editor--line-length) - ${width})` : `-0.5*(var(--ak-editor--line-length) - ${width})`;
    }
    if (node.type.name === 'bodiedExtension' || node.type.name === 'extension') return '-12px';
};
const $4ba7181f843f8e6f$var$TABLE_NUMBERED_COLUMN_WIDTH = 42;
const $4ba7181f843f8e6f$export$ade48236ff38648e = ({ api: api, nextNode: nextNode, position: position, anchorRectCache: anchorRectCache, getPos: getPos })=>{
    const ref = (0, $42omo.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $42omo.useState)(false);
    const anchorName = (0, $42omo.useMemo)(()=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return nextNode ? api?.core.actions.getAnchorIdForNode(nextNode, getPos() ?? -1) || '' : '';
        return nextNode ? (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(nextNode) : '';
    }, [
        api,
        getPos,
        nextNode
    ]);
    const [isActiveAnchor] = (0, $e89e2e6fe979fcda$export$8f015ea2e0aa57d4)(anchorName);
    const isLeftPosition = position === 'left';
    const nodeDimension = (0, $42omo.useMemo)(()=>{
        if (!nextNode) return $4ba7181f843f8e6f$var$defaultNodeDimension;
        const nextNodePos = getPos();
        let innerContainerWidth = null;
        let targetAnchorName = anchorName;
        if ([
            'blockCard',
            'embedCard',
            'extension'
        ].includes(nextNode.type.name)) {
            if (nextNode.attrs.layout === 'wide') innerContainerWidth = `max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))`;
            else if (nextNode.attrs.layout === 'full-width') innerContainerWidth = `min(calc(100cqw - ${0, $aFUXX.akEditorBreakoutPadding}px), 1800px)`;
            if (nextNode.type.name === 'blockCard' && !nextNode.attrs.layout && nextNode.attrs.datasource) // block card with sourceNode and without layout has different width in full-width vs fixed-width editor
            // Hence we need to set it based on editor mode
            innerContainerWidth = 'var(--ak-editor-block-card-width)';
            if (nextNode.type.name === 'embedCard' && [
                'center',
                'align-start',
                'align-end'
            ].includes(nextNode.attrs.layout)) {
                const percentageWidth = ((parseFloat(nextNode.attrs.width) || 100) / 100).toFixed(2);
                innerContainerWidth = `calc(var(--ak-editor--line-length) * ${percentageWidth})`;
            }
        } else if (nextNode.type.name === 'table' && nextNode.firstChild) {
            const tableWidthAnchor = (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? typeof nextNodePos === 'number' ? api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '' : '' : (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(nextNode.firstChild);
            const isNumberColumnEnabled = Boolean(nextNode.attrs.isNumberColumnEnabled);
            if ((0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)()) innerContainerWidth = isNumberColumnEnabled ? `calc(anchor-size(${tableWidthAnchor} width) + ${$4ba7181f843f8e6f$var$TABLE_NUMBERED_COLUMN_WIDTH}px)` : `anchor-size(${tableWidthAnchor} width)`;
            else innerContainerWidth = `${(anchorRectCache?.getRect(tableWidthAnchor)?.width || 0) + $4ba7181f843f8e6f$var$TABLE_NUMBERED_COLUMN_WIDTH}px`;
            if (nextNode.attrs.width) // when the table has horizontal scroll
            innerContainerWidth = `min(${nextNode.attrs.width}px, ${innerContainerWidth})`;
        } else if (nextNode.type.name === 'mediaSingle' && nextNode.firstChild) {
            if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) // check pos is a number
            {
                if (typeof nextNodePos === 'number' && nextNode.firstChild?.type.name === 'media') targetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '';
            } else targetAnchorName = (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(nextNode.firstChild);
        }
        // Set the height target anchor name to the first or last column of the layout section so that it also works for stacked layout
        let heightTargetAnchorName = targetAnchorName;
        if (nextNode.type.name === 'layoutSection' && nextNode.firstChild && nextNode.lastChild) {
            if (isLeftPosition) {
                if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                    if (typeof nextNodePos === 'number') heightTargetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '';
                    else heightTargetAnchorName = '';
                } else heightTargetAnchorName = (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(nextNode.firstChild);
            } else if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                if (typeof nextNodePos === 'number') {
                    const lastNodeStartPos = nextNode.content.size - nextNode.lastChild.nodeSize;
                    heightTargetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.lastChild, lastNodeStartPos + 1) || '';
                } else heightTargetAnchorName = '';
            } else heightTargetAnchorName = (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(nextNode.lastChild);
        }
        if ((0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)()) {
            const width = innerContainerWidth || `anchor-size(${targetAnchorName} width)`;
            const height = `anchor-size(${heightTargetAnchorName} height)`;
            return {
                width: width,
                height: height,
                top: 'anchor(top)',
                bottom: 'anchor(bottom)',
                widthOffset: $4ba7181f843f8e6f$var$getWidthOffset(nextNode, width, position)
            };
        }
        if (anchorRectCache) {
            const nodeRect = anchorRectCache.getRect(targetAnchorName);
            const width = innerContainerWidth || `${nodeRect?.width || 0}px`;
            const top = nodeRect?.top ? `${nodeRect?.top}px` : 'unset';
            const bottom = `100% - ${nodeRect?.bottom || 0}px + ${$4ba7181f843f8e6f$var$GAP}px`;
            let height = `${nodeRect?.height || 0}px`;
            if (heightTargetAnchorName !== targetAnchorName) {
                const nodeHeightRect = anchorRectCache.getRect(heightTargetAnchorName);
                height = `${nodeHeightRect?.height || 0}px + ${$4ba7181f843f8e6f$var$GAP}px`;
            }
            return {
                width: width,
                height: height,
                top: top,
                bottom: bottom,
                widthOffset: $4ba7181f843f8e6f$var$getWidthOffset(nextNode, width, position)
            };
        }
        return $4ba7181f843f8e6f$var$defaultNodeDimension;
    }, [
        nextNode,
        anchorName,
        anchorRectCache,
        getPos,
        api,
        isLeftPosition,
        position
    ]);
    const onDrop = (0, $42omo.useCallback)(()=>{
        const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
        if (!activeNode) return;
        const toPos = getPos();
        let mappedTo;
        if (activeNode && toPos !== undefined) {
            const { pos: start } = activeNode;
            const moveToEnd = position === 'right';
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(start, toPos, {
                    moveToEnd: moveToEnd
                })({
                    tr: tr
                });
                const insertLayoutStep = (0, $a673071a38c5eb36$export$fc81c36e83ce2f6b)(tr);
                mappedTo = insertLayoutStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $a673071a38c5eb36$export$2e8776145e31b87)(tr, mappedTo, moveToEnd);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        position
    ]);
    const hoverZoneRectStyle = (0, $42omo.useMemo)(()=>{
        const isLayoutNode = nextNode?.type.name === 'layoutSection';
        const layoutAdjustment = isLayoutNode ? {
            width: 11,
            height: 4,
            top: 6,
            bottom: 2
        } : undefined;
        return {
            [$4ba7181f843f8e6f$var$HOVER_ZONE_WIDTH]: nodeDimension.widthOffset ? `calc((100% - ${nodeDimension.width})/2 - ${$4ba7181f843f8e6f$var$GAP}px + ${nodeDimension.widthOffset} - ${layoutAdjustment?.width || 0}px)` : `calc((100% - ${nodeDimension.width})/2 - ${$4ba7181f843f8e6f$var$GAP}px - ${layoutAdjustment?.width || 0}px)`,
            [$4ba7181f843f8e6f$var$HOVER_ZONE_HEIGHT]: `calc(${nodeDimension.height} + ${layoutAdjustment?.height || 0}px)`,
            [$4ba7181f843f8e6f$var$HOVER_ZONE_TOP]: `calc(${nodeDimension.top} + ${layoutAdjustment?.top || 0}px)`,
            [$4ba7181f843f8e6f$var$HOVER_ZONE_BOTTOM]: `calc(${nodeDimension.bottom} - ${layoutAdjustment?.bottom || 0}px)`,
            [$4ba7181f843f8e6f$var$HOVER_ZONE_ANCHOR_NAME]: anchorName
        };
    }, [
        nextNode?.type.name,
        nodeDimension,
        anchorName
    ]);
    const dropIndicatorPos = (0, $42omo.useMemo)(()=>{
        return isLeftPosition ? 'right' : 'left';
    }, [
        isLeftPosition
    ]);
    (0, $42omo.useEffect)(()=>{
        if (ref.current) return (0, $4T4vf.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        setIsDraggedOver
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        "data-testid": `drop-target-hover-zone-${position}`,
        css: [
            $4ba7181f843f8e6f$var$hoverZoneCommonStyle,
            isLeftPosition ? $4ba7181f843f8e6f$var$leftHoverZoneStyle : $4ba7181f843f8e6f$var$rightHoverZoneStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hoverZoneRectStyle
    }, isDraggedOver ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2n8po.DropIndicator), {
        edge: dropIndicatorPos
    }) : isActiveAnchor && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: [
            $4ba7181f843f8e6f$var$dropTargetLayoutHintStyle,
            isLeftPosition && $4ba7181f843f8e6f$var$dropTargetLayoutHintLeftStyle
        ]
    }));
};


function $7b54db346c95f93f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b54db346c95f93f$var$DEFAULT_DROP_INDICATOR_WIDTH = 760;
const $7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH = '--editor-block-controls-drop-indicator-width';
const $7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN = '--editor-block-controls-drop-target-leftMargin';
const $7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX = '--editor-block-controls-drop-target-zindex';
const $7b54db346c95f93f$export$b172475a7115c36a = '--editor-block-controls-drop-indicator-offset';
const $7b54db346c95f93f$export$d522271cd3bfae1d = '--editor-block-controls-drop-indicator-gap';
const $7b54db346c95f93f$var$styleDropTarget = /*#__PURE__*/ (0, $9K4OG.css)({
    marginLeft: `calc(-1 * var(${$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0))`,
    paddingLeft: `var(${$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0)`,
    position: 'absolute',
    left: '0',
    display: 'block',
    zIndex: `var(${$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX}, 110)`,
    transform: `translateY(var(${$7b54db346c95f93f$export$b172475a7115c36a}, 0))`
});
const $7b54db346c95f93f$var$styleDropIndicator = /*#__PURE__*/ (0, $9K4OG.css)({
    height: '100%',
    margin: '0 auto',
    position: 'relative',
    width: `var(${$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH}, 100%)`,
    display: 'none'
});
const $7b54db346c95f93f$var$styleDropIndicatorVisible = {
    name: "4zleql",
    styles: "display:block"
};
const $7b54db346c95f93f$var$nestedDropIndicatorStyle = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $7b54db346c95f93f$var$dropZoneStyles = {
    name: "y3ufic",
    styles: "margin:0;position:absolute;width:100%;z-index:110;min-height:4px"
};
const $7b54db346c95f93f$var$nestedDropZoneStyle = {
    name: "1h4fcj3",
    styles: "left:4px;right:4px;width:unset"
};
const $7b54db346c95f93f$var$enableDropZone = [
    'paragraph',
    'mediaSingle',
    'heading',
    'codeBlock',
    'decisionList',
    'bulletList',
    'orderedList',
    'taskList',
    'extension',
    'blockCard'
];
// This z index is used in container like layout
const $7b54db346c95f93f$var$fullHeightStyleAdjustZIndexStyle = {
    name: "125wnaz",
    styles: "z-index:0"
};
const $7b54db346c95f93f$var$HoverZone = ({ onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDrop: onDrop, node: node, pos: pos, parent: parent, editorWidth: editorWidth, anchorRectCache: anchorRectCache, position: position, isNestedDropTarget: isNestedDropTarget, dropTargetStyle: dropTargetStyle, api: api })=>{
    const ref = (0, $42omo.useRef)(null);
    const isRemainingheight = dropTargetStyle === 'remainingHeight';
    const anchorName = (0, $42omo.useMemo)(()=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            if (node && typeof pos === 'number') {
                const posOffset = position === 'upper' ? -node.nodeSize : 0;
                return api?.core.actions.getAnchorIdForNode(node, pos + posOffset) || '';
            }
            return '';
        }
        return node ? (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(node) : '';
    }, [
        api,
        node,
        pos,
        position
    ]);
    const [_isActive, setActiveAnchor] = (0, $e89e2e6fe979fcda$export$8f015ea2e0aa57d4)(anchorName);
    (0, $42omo.useEffect)(()=>{
        if (ref.current) return (0, $4T4vf.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                if (!isNestedDropTarget && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) setActiveAnchor();
                onDragEnter();
            },
            onDragLeave: onDragLeave,
            onDrop: onDrop
        });
    }, [
        isNestedDropTarget,
        onDragEnter,
        onDragLeave,
        onDrop,
        setActiveAnchor
    ]);
    const hoverZoneUpperStyle = (0, $42omo.useMemo)(()=>{
        const heightStyleOffset = `var(--editor-block-controls-drop-indicator-gap, 0)/2`;
        const transformOffset = `var(${$7b54db346c95f93f$export$b172475a7115c36a}, 0)`;
        const heightStyle = anchorName && $7b54db346c95f93f$var$enableDropZone.includes(node?.type.name || '') ? (0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)() ? `calc(anchor-size(${anchorName} height)/2 + ${heightStyleOffset})` : `calc(${(anchorRectCache?.getHeight(anchorName) || 0) / 2}px + ${heightStyleOffset})` : '4px';
        const transform = position === 'upper' ? `translateY(calc(-100% + ${transformOffset}))` : `translateY(${transformOffset})`;
        return /*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: heightStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            transform: transform,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxWidth: `${editorWidth || 0}px`
        });
    }, [
        anchorName,
        anchorRectCache,
        editorWidth,
        node?.type.name,
        position
    ]);
    /**
   * 1. Above the last empty line
   * 2. Below the last element
   *
   * Both cases will take the remaining height of the the container
   */ const heightStyle = (0, $42omo.useMemo)(()=>{
        // only apply upper drop zone
        if (isRemainingheight && position === 'upper') {
            // previous node
            const anchorName = node ? (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? api?.core.actions.getAnchorIdForNode(node, pos || -1) || '' : (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(node) : '';
            let top = 'unset';
            if (anchorName) {
                const enabledDropZone = $7b54db346c95f93f$var$enableDropZone.includes(node?.type.name || '');
                if ((0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)()) top = enabledDropZone ? `calc(anchor(${anchorName} 50%))` : `calc(anchor(${anchorName} bottom) - 4px)`;
                else if (anchorRectCache) {
                    const preNodeTopPos = anchorRectCache.getTop(anchorName) || 0;
                    const prevNodeHeight = anchorRectCache.getHeight(anchorName) || 0;
                    top = enabledDropZone ? `calc(${preNodeTopPos}px + ${prevNodeHeight / 2}px)` : `calc(${preNodeTopPos}px + ${prevNodeHeight}px - 4px)`;
                } else // Should not happen
                return null;
            } else // first empty paragraph
            top = '4px';
            return /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                top: top,
                bottom: '4px',
                height: 'unset',
                zIndex: 10,
                transform: 'none'
            });
        }
        return null;
    }, [
        anchorRectCache,
        api,
        isRemainingheight,
        node,
        pos,
        position
    ]);
    const isFullHeightInLayout = isRemainingheight && parent?.type.name === 'layoutColumn';
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `drop-target-hover-zone-${position}`,
        "data-testid": `drop-target-zone-${position}`,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $7b54db346c95f93f$var$dropZoneStyles,
            isNestedDropTarget && $7b54db346c95f93f$var$nestedDropZoneStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            hoverZoneUpperStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            heightStyle,
            isFullHeightInLayout && $7b54db346c95f93f$var$fullHeightStyleAdjustZIndexStyle
        ]
    });
};
const $7b54db346c95f93f$export$79660a248b11010 = (props)=>{
    const { api: api, getPos: getPos, prevNode: prevNode, nextNode: nextNode, parentNode: parentNode, formatMessage: formatMessage, anchorRectCache: anchorRectCache, dropTargetStyle: dropTargetStyle = 'default', isSameLayout: isSameLayout } = props;
    const [isDraggedOver, setIsDraggedOver] = (0, $42omo.useState)(false);
    const { lineLength: lineLength } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>({
            lineLength: states.widthState?.lineLength || $7b54db346c95f93f$var$DEFAULT_DROP_INDICATOR_WIDTH
        }));
    const isNestedDropTarget = parentNode?.type.name !== 'doc';
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = ()=>{
        if (!activeNode) return;
        const pos = getPos();
        if (activeNode && pos !== undefined) {
            const { pos: start } = activeNode;
            api?.core?.actions.execute(api?.blockControls?.commands?.moveNode(start, pos, undefined, formatMessage));
        }
    };
    const dynamicStyle = {
        width: isNestedDropTarget ? 'unset' : '100%',
        [$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH]: isNestedDropTarget ? '100%' : `${lineLength || $7b54db346c95f93f$var$DEFAULT_DROP_INDICATOR_WIDTH}px`,
        [$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN]: isNestedDropTarget ? (0, $30636d6b7963f251$export$5721e547e9b6cc17)(parentNode?.type.name) : '0',
        [$7b54db346c95f93f$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX]: (0, $dTk3A.layers).navigation()
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)($7b54db346c95f93f$var$HoverZone, {
        onDragEnter: ()=>setIsDraggedOver(true),
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: prevNode,
        pos: getPos(),
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "upper",
        isNestedDropTarget: isNestedDropTarget,
        dropTargetStyle: dropTargetStyle,
        api: api
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $7b54db346c95f93f$var$styleDropTarget,
            isNestedDropTarget && $7b54db346c95f93f$var$nestedDropIndicatorStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyle,
        "data-testid": "block-ctrl-drop-target"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $7b54db346c95f93f$var$styleDropIndicator,
            isDraggedOver && $7b54db346c95f93f$var$styleDropIndicatorVisible
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2n8po.DropIndicator), {
        edge: "bottom"
    }))), dropTargetStyle !== 'remainingHeight' && /*#__PURE__*/ (0, $9K4OG.jsx)($7b54db346c95f93f$var$HoverZone, {
        onDragEnter: ()=>setIsDraggedOver(true),
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: nextNode,
        pos: getPos(),
        parent: parentNode,
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "lower",
        isNestedDropTarget: isNestedDropTarget,
        api: api
    }), (0, $490dde8b4167f1cf$export$9d1974d3f03f9d59)(isNestedDropTarget, nextNode, isSameLayout, activeNode) && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4ba7181f843f8e6f$export$ade48236ff38648e), {
        ...props,
        position: "left"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4ba7181f843f8e6f$export$ade48236ff38648e), {
        ...props,
        position: "right"
    })));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

























// 8px gap + 16px on left and right
const $5fac1fc642e1565b$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH = 40;
const $5fac1fc642e1565b$var$dropTargetLayoutStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    height: '100%',
    width: `${$5fac1fc642e1565b$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`,
    transform: 'translateX(-50%)',
    zIndex: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
});
const $5fac1fc642e1565b$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    height: '100%',
    position: 'relative',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${`var(--ds-border-focused, ${(0, $6fnsQ.B200)})`}`,
    width: 0
});
const $5fac1fc642e1565b$export$448a3db73d1a77fe = (props)=>{
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $42omo.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $42omo.useState)(false);
    const anchorName = (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(parent);
    const nextNodeAnchorName = ref.current?.parentElement?.nextElementSibling?.getAttribute((0, $d89c90893897930c$export$684dbfb461b166c3)());
    let height = '100%';
    if (nextNodeAnchorName) {
        if ((0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)()) height = `anchor-size(${nextNodeAnchorName} height)`;
        else if (anchorRectCache) {
            const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
            height = `${layoutColumnRect?.height || 0}px`;
        }
    }
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $9K4OG.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $aFUXX.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $e89e2e6fe979fcda$export$8f015ea2e0aa57d4)(anchorName);
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = (0, $42omo.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            const { pos: from } = activeNode;
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $a673071a38c5eb36$export$fc81c36e83ce2f6b)(tr);
                mappedTo = insertColumnStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $a673071a38c5eb36$export$2e8776145e31b87)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (ref.current) return (0, $4T4vf.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop
    ]);
    if (activeNode?.nodeType === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $5fac1fc642e1565b$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2n8po.DropIndicator), {
        edge: "right",
        gap: `-${$5fac1fc642e1565b$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $5fac1fc642e1565b$var$dropTargetLayoutHintStyle
    }));
};
const $5fac1fc642e1565b$export$2afcb78657666b75 = (props)=>{
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $42omo.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $42omo.useState)(false);
    const anchorName = (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(parent);
    const [nextNodeAnchorName, setNextNodeAnchorName] = (0, $42omo.useState)(null);
    const readNextNodeAnchor = (0, $42omo.useCallback)(()=>{
        const nextElementSibling = ref.current?.parentElement?.nextElementSibling;
        const attrName = (0, $d89c90893897930c$export$684dbfb461b166c3)();
        const nextAnchorName = nextElementSibling?.getAttribute(attrName) ?? null;
        setNextNodeAnchorName((prev)=>prev === nextAnchorName ? prev : nextAnchorName);
    }, []);
    const height = (0, $42omo.useMemo)(()=>{
        if (nextNodeAnchorName) {
            if ((0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)()) return `anchor-size(${nextNodeAnchorName} height)`;
            else if (anchorRectCache) {
                const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
                return `${layoutColumnRect?.height || 0}px`;
            }
        }
        // Stacked mode fallback: minimal height to avoid oversized hint on first render
        return '0px';
    }, [
        nextNodeAnchorName,
        anchorRectCache
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const raf = requestAnimationFrame(()=>{
            readNextNodeAnchor();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        readNextNodeAnchor
    ]);
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $9K4OG.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $aFUXX.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $e89e2e6fe979fcda$export$8f015ea2e0aa57d4)(anchorName);
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = (0, $42omo.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            const { pos: from } = activeNode;
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $a673071a38c5eb36$export$fc81c36e83ce2f6b)(tr);
                mappedTo = insertColumnStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $a673071a38c5eb36$export$2e8776145e31b87)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (ref.current) return (0, $4T4vf.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
                readNextNodeAnchor();
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        readNextNodeAnchor
    ]);
    if (activeNode?.nodeType === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $5fac1fc642e1565b$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2n8po.DropIndicator), {
        edge: "right",
        gap: `-${$5fac1fc642e1565b$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $5fac1fc642e1565b$var$dropTargetLayoutHintStyle
    }));
};








var $sxTNo = parcelRequire("sxTNo");


var $5SAOw = parcelRequire("5SAOw");







const $d389fba940977935$export$199dae4875feadcd = (nodeType)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = nodeType.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].indexOf(nodeType) >= 0;
};
const $d389fba940977935$export$51b69e9dc2d60fca = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.layoutColumn;
};
const $d389fba940977935$export$a528a4f84f239e18 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.doc;
};
const $d389fba940977935$export$a1d4506bfd61c0e4 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.expand;
};
const $d389fba940977935$export$174a46ad1de68ba = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.nestedExpand;
};
const $d389fba940977935$export$9d5fcdcf2394fab8 = ($from, $to)=>{
    const fromNode = $from.nodeAfter;
    const toNode = $to.nodeAfter;
    return !!(fromNode && toNode && fromNode.type.name === 'layoutColumn' && [
        'layoutSection',
        'layoutColumn'
    ].includes(toNode.type.name) && // fromNode can either be in the same layoutSection as toNode or is a layoutColumn inside the toNode (type layoutSection)
    ($from.sameParent($to) || $from.parent === toNode));
};
const $d389fba940977935$export$c78c24bf7f1a36c2 = (expandNode)=>{
    const { expand: expand, nestedExpand: nestedExpand } = expandNode.type.schema.nodes;
    if (expandNode.type === expand) return nestedExpand.createChecked(expandNode.attrs, expandNode.content, expandNode.marks);
    return null;
};
const $d389fba940977935$export$ca1d8e12fb5b3277 = (fragment)=>{
    const children = [];
    try {
        fragment.forEach((node)=>{
            if ($d389fba940977935$export$a1d4506bfd61c0e4(node.type)) {
                const nestedExpandNode = $d389fba940977935$export$c78c24bf7f1a36c2(node);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $5SAOw.Fragment).fromArray(children);
};
const $d389fba940977935$export$447e90e618548243 = (slice)=>{
    const fragment = $d389fba940977935$export$ca1d8e12fb5b3277(slice.content);
    if (!fragment) return null;
    return new (0, $5SAOw.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $d389fba940977935$export$e639988f4c2f87a3 = (0, $2XqLN.default)((node)=>{
    try {
        return $d389fba940977935$export$c78c24bf7f1a36c2(node);
    } catch (e) {
        return null;
    }
});
const $d389fba940977935$export$bfcc41199ff04884 = (nodeTypesToCreate, nodeWithTargetFragment)=>{
    try {
        return !!nodeTypesToCreate.every((nodeTypeToCreate)=>nodeTypeToCreate.createChecked({}, nodeWithTargetFragment));
    } catch (e) {
        return false;
    }
};
function $d389fba940977935$export$918b4fd27bccdab5(destParent, indexIntoParent, srcNode, $destNodePos, destNode) {
    let srcNodeType = srcNode.type;
    const schema = srcNodeType.schema;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader, expand: expand, nestedExpand: nestedExpand, doc: doc, panel: panel, layoutColumn: layoutColumn, layoutSection: layoutSection } = schema.nodes;
    const destParentNodeType = destParent?.type;
    const activeNodeType = srcNode?.type;
    const layoutColumnContent = srcNode.content;
    const isNestingTablesSupported = (0, $sxTNo.isNestedTablesSupported)(schema) && (0, $iu6m9.editorExperiment)('nested-tables-in-tables', true, {
        exposure: true
    });
    if (activeNodeType === layoutColumn && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
        // Allow drag layout column and drop into layout section
        if (destNode?.type === layoutSection || destParentNodeType === doc) return true;
        if (destParentNodeType === tableCell || destParentNodeType === tableHeader) {
            const contentContainsExpand = (0, $8m4tT.findChildrenByType)(srcNode, expand).length > 0;
            //convert expand to nestedExpand if there are expands inside the layout column
            // otherwise, the createChecked will fail as expand is not a valid child of tableCell/tableHeader, but nestedExpand is
            const convertedFragment = contentContainsExpand ? $d389fba940977935$export$ca1d8e12fb5b3277(layoutColumnContent) : layoutColumnContent;
            if (!convertedFragment) return false;
            return $d389fba940977935$export$bfcc41199ff04884([
                tableCell,
                tableHeader
            ], convertedFragment);
        }
        if (destParentNodeType === panel) return $d389fba940977935$export$bfcc41199ff04884([
            panel
        ], layoutColumnContent);
        if (destParentNodeType === expand) return $d389fba940977935$export$bfcc41199ff04884([
            expand
        ], layoutColumnContent);
        if (destParentNodeType === nestedExpand) return $d389fba940977935$export$bfcc41199ff04884([
            nestedExpand
        ], layoutColumnContent);
    }
    // NOTE: this will block drop targets from showing for dragging a table into another table
    // unless nested tables are supported and the nesting depth does not exceed 1
    if ((destParentNodeType === tableCell || destParentNodeType === tableHeader) && activeNodeType === table) {
        const nestingDepth = (0, $sxTNo.getParentOfTypeCount)(table)($destNodePos);
        if (!isNestingTablesSupported || isNestingTablesSupported && nestingDepth > 1) return false;
    }
    if ($d389fba940977935$export$199dae4875feadcd(destParent.type) && $d389fba940977935$export$a1d4506bfd61c0e4(srcNodeType)) {
        if ($d389fba940977935$export$e639988f4c2f87a3(srcNode)) srcNodeType = nestedExpand;
        else return false;
    } else if (($d389fba940977935$export$a528a4f84f239e18(destParent.type) || $d389fba940977935$export$51b69e9dc2d60fca(destParent.type)) && $d389fba940977935$export$174a46ad1de68ba(srcNodeType)) srcNodeType = expand;
    return destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType);
}
function $d389fba940977935$export$35c44269895720b6(slice, sliceFromPos, sliceToPos, destParent, indexIntoParent, $destNodePos, destNode) {
    let canMoveNodes = true;
    const doc = $destNodePos.doc;
    const nodesPos = [];
    // Drag multiple nodes to be inside themselves not allowed
    if ($destNodePos.pos < sliceToPos && $destNodePos.pos >= sliceFromPos) return false;
    // Multiple layout columns do not drop correctly.
    if (slice.content.firstChild?.type.name === 'layoutColumn') return false;
    for(let i = 0; i < slice.content.childCount; i++){
        const node = slice.content.maybeChild(i);
        if (i === 0) nodesPos[i] = sliceFromPos;
        else nodesPos[i] = nodesPos[i - 1] + (slice.content.maybeChild(i - 1)?.nodeSize || 0);
        if (node && node.isInline) {
            // If the node is an inline node, we need to find the parent node
            // as passing in them into canMoveNodeToIndex will return false
            const $nodePos = doc.resolve(nodesPos[i]);
            const parentNode = $nodePos.parent;
            if (!parentNode || parentNode && !$d389fba940977935$export$918b4fd27bccdab5(destParent, indexIntoParent, parentNode, $destNodePos, destNode)) {
                canMoveNodes = false;
                break;
            }
        } else if (node && !$d389fba940977935$export$918b4fd27bccdab5(destParent, indexIntoParent, node, $destNodePos, destNode)) {
            canMoveNodes = false;
            break;
        }
    }
    return canMoveNodes;
}


const $79ac2953323ad1e7$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'layoutColumn',
    'listItem',
    'caption'
];
const $79ac2953323ad1e7$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
const $79ac2953323ad1e7$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $79ac2953323ad1e7$var$shouldDescend = (node)=>{
    return ![
        'mediaSingle',
        'paragraph',
        'heading'
    ].includes(node.type.name);
};
const $79ac2953323ad1e7$var$getNodeMargins = (node)=>{
    if (!node) return (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)[`heading${node.attrs.level}`] || (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)['default'];
    return (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)[nodeTypeName] || (0, $30636d6b7963f251$export$ffe7e67ee4ab1502)['default'];
};
const $79ac2953323ad1e7$var$shouldCollapseMargin = (prevNode, nextNode)=>{
    if ((prevNode?.type.name === 'mediaSingle' || nextNode?.type.name === 'mediaSingle') && prevNode?.type.name !== nextNode?.type.name) return false;
    return true;
};
const $79ac2953323ad1e7$var$getGapAndOffset = (prevNode, nextNode, parentNode)=>{
    if (!prevNode && nextNode) // first node
    return {
        gap: 0,
        offset: 0
    };
    else if (prevNode && !nextNode) return {
        gap: 0,
        offset: 0
    };
    const top = $79ac2953323ad1e7$var$getNodeMargins(nextNode).top || 4;
    const bottom = $79ac2953323ad1e7$var$getNodeMargins(prevNode).bottom || 4;
    const gap = $79ac2953323ad1e7$var$shouldCollapseMargin(prevNode, nextNode) ? Math.max(top, bottom) : top + bottom;
    let offset = top - gap / 2;
    if (prevNode?.type.name === 'mediaSingle' && nextNode?.type.name === 'mediaSingle') offset = -offset;
    else if (prevNode?.type.name && [
        'tableCell',
        'tableHeader'
    ].includes(prevNode?.type.name)) offset = 0;
    return {
        gap: gap,
        offset: offset
    };
};
const $79ac2953323ad1e7$export$99bd791313c07808 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $94da9623b41bcf3c$export$4a66a44681ab4c77));
};
const $79ac2953323ad1e7$export$fc632359c395fc7 = (pos, props, nodeViewPortalProviderAPI, side, anchorRectCache, isSameLayout)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    return (0, $ftzrq.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const { gap: gap, offset: offset } = $79ac2953323ad1e7$var$getGapAndOffset(props.prevNode, props.nextNode, props.parentNode);
        element.style.setProperty((0, $7b54db346c95f93f$export$b172475a7115c36a), `${offset}px`);
        element.style.setProperty((0, $7b54db346c95f93f$export$d522271cd3bfae1d), `${gap}px`);
        element.style.setProperty('display', 'block');
        nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $7b54db346c95f93f$export$79660a248b11010), {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache,
                isSameLayout: isSameLayout
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $94da9623b41bcf3c$export$4a66a44681ab4c77),
        side: side,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $79ac2953323ad1e7$export$eb62fe530f14234e = (pos, props, nodeViewPortalProviderAPI, anchorRectCache)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    return (0, $ftzrq.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const DropTargetLayoutComponent = (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? (0, $5fac1fc642e1565b$export$2afcb78657666b75) : (0, $5fac1fc642e1565b$export$448a3db73d1a77fe);
        nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)(DropTargetLayoutComponent, {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $94da9623b41bcf3c$export$4a66a44681ab4c77),
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $79ac2953323ad1e7$export$248c2f3619ca4fdf = (newState, api, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache, from, to)=>{
    const decs = [];
    const POS_END_OF_DOC = newState.doc.nodeSize - 2;
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > POS_END_OF_DOC ? POS_END_OF_DOC : to;
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && newState.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    anchorRectCache?.clear();
    const prevNodeStack = [];
    const popNodeStack = (depth)=>{
        let result;
        const toDepth = Math.max(depth, 0);
        while(prevNodeStack.length > toDepth)result = prevNodeStack.pop();
        return result;
    };
    const pushNodeStack = (node, depth)=>{
        popNodeStack(depth);
        prevNodeStack.push(node);
    };
    const isAdvancedLayoutsPreRelease2 = (0, $iu6m9.editorExperiment)('advanced_layouts', true);
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = newState.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $l6okE.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, index)=>{
        let depth = 0;
        // drop target deco at the end position
        let endPos;
        const $pos = newState.doc.resolve(pos);
        const isSameLayout = $activeNodePos && (0, $d389fba940977935$export$9d5fcdcf2394fab8)($activeNodePos, $pos);
        depth = $pos.depth;
        if (isAdvancedLayoutsPreRelease2) {
            if (activeNode?.pos === pos && activeNode.nodeType !== 'layoutColumn') return false;
            if (node.type.name === 'layoutColumn' && parent?.type.name === 'layoutSection' && index !== 0 && // Not the first node
            (parent?.childCount < (0, $38ae61d92a71d752$export$b8ad888c900fcbc2)() || isSameLayout)) // Add drop target for layout columns
            decs.push($79ac2953323ad1e7$export$eb62fe530f14234e(pos, {
                api: api,
                parent: parent,
                formatMessage: formatMessage
            }, nodeViewPortalProviderAPI, anchorRectCache));
        }
        if (node.isInline || !parent || $79ac2953323ad1e7$var$DISABLE_CHILD_DROP_TARGET.includes(parent.type.name)) {
            pushNodeStack(node, depth);
            return false;
        }
        if ($79ac2953323ad1e7$var$IGNORE_NODES.includes(node.type.name)) {
            pushNodeStack(node, depth);
            return $79ac2953323ad1e7$var$shouldDescend(node); //skip over, don't consider it a valid depth
        }
        // When multi select is on, validate all the nodes in the selection instead of just the handle node
        if (isMultiSelect) {
            const selectionSlice = newState.doc.slice(selectionFrom, selectionTo, false);
            const selectionSliceChildCount = selectionSlice.content.childCount;
            let canDropSingleNode = true;
            let canDropMultipleNodes = true;
            // when there is only one node in the slice, use the same logic as when multi select is not on
            if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $d389fba940977935$export$35c44269895720b6)(selectionSlice, selectionFrom, selectionTo, parent, index, $pos);
            else canDropSingleNode = !!(activePMNode && (0, $d389fba940977935$export$918b4fd27bccdab5)(parent, index, activePMNode, $pos, node));
            if (!canDropMultipleNodes || !canDropSingleNode) {
                pushNodeStack(node, depth);
                return false; //not valid pos, so nested not valid either
            }
        } else {
            const canDrop = activePMNode && (0, $d389fba940977935$export$918b4fd27bccdab5)(parent, index, activePMNode, $pos, node);
            //NOTE: This will block drop targets showing for nodes that are valid after transformation (i.e. expand -> nestedExpand)
            if (!canDrop) {
                pushNodeStack(node, depth);
                return false; //not valid pos, so nested not valid either
            }
        }
        if (parent.lastChild === node && !(0, $l9G9n.isEmptyParagraph)(node) && $79ac2953323ad1e7$var$PARENT_WITH_END_DROP_TARGET.includes(parent.type.name)) endPos = pos + node.nodeSize;
        const previousNode = popNodeStack(depth); // created scoped variable
        // only table and layout need to render full height drop target
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes(parent?.type.name || '');
        const shouldShowFullHeight = isInSupportedContainer && parent?.lastChild === node && (0, $l9G9n.isEmptyParagraph)(node);
        decs.push($79ac2953323ad1e7$export$fc632359c395fc7(pos, {
            api: api,
            prevNode: previousNode,
            nextNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        if (endPos !== undefined) decs.push($79ac2953323ad1e7$export$fc632359c395fc7(endPos, {
            api: api,
            prevNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'remainingHeight'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache));
        pushNodeStack(node, depth);
        return depth < (0, $94da9623b41bcf3c$export$4a19606d812406a7) && $79ac2953323ad1e7$var$shouldDescend(node);
    });
    if (docTo === POS_END_OF_DOC) decs.push($79ac2953323ad1e7$export$fc632359c395fc7(POS_END_OF_DOC, {
        api: api,
        formatMessage: formatMessage,
        prevNode: newState.doc.lastChild || undefined,
        parentNode: newState.doc
    }, nodeViewPortalProviderAPI, undefined, anchorRectCache));
    return decs;
};
















const $6f35b85d8e5fa8ec$var$IGNORE_NODES = [
    'tableRow',
    'listItem',
    'caption',
    'media'
];
const $6f35b85d8e5fa8ec$var$blockLeafNodes = [
    'blockCard',
    'rule',
    'extension'
];
const $6f35b85d8e5fa8ec$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $6f35b85d8e5fa8ec$export$2f588816c7e80081 = (state, $pos, nodeType)=>{
    const depth = $pos.depth;
    const blockLeafNodeList = $6f35b85d8e5fa8ec$var$blockLeafNodes;
    // special cases like hr rule here
    if (blockLeafNodeList.includes(nodeType || '') || $pos.pos === 0) {
        const parent = $pos.node(depth);
        const node = $pos.nodeAfter;
        const index = $pos.index();
        const before = index > 0 ? parent.child(index - 1) : null;
        const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
        return {
            pos: $pos.pos,
            node: node,
            parent: parent,
            before: before,
            after: after,
            index: index,
            depth: depth
        };
    }
    const isRootNode = depth === 1;
    const node = $pos.node(depth);
    // go through the path to find the first node that is not allow child drop target
    // From top to bottom, we check the node types at each depth
    for(let i = 1; i < depth; i++){
        const nodeType = $pos.node(i).type.name;
        if ($6f35b85d8e5fa8ec$var$DISABLE_CHILD_DROP_TARGET.includes(nodeType)) return $6f35b85d8e5fa8ec$export$2f588816c7e80081(state, state.doc.resolve($pos.before(i + 1)), nodeType);
    }
    if ($6f35b85d8e5fa8ec$var$IGNORE_NODES.includes(node.type.name) && !isRootNode) // If the node is an ignored node, we return the surrounding nodes of its parent
    return $6f35b85d8e5fa8ec$export$2f588816c7e80081(state, state.doc.resolve($pos.before(depth - 1)));
    const pos = depth > 0 ? $pos.before(depth) : 0;
    const parent = isRootNode ? state.doc : $pos.node(depth - 1);
    const index = $pos.index(depth - 1);
    const before = index > 0 ? parent.child(index - 1) : null;
    const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
    return {
        pos: pos,
        node: node,
        parent: parent,
        before: before,
        after: after,
        index: index,
        depth: depth
    };
};





/**
 * List of parent node types that can have child nodes
 */ const $db1bc3ef2f702e84$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
const $db1bc3ef2f702e84$var$PARENT_WITH_END_DROP_TARGET_SYNC_BLOCK = [
    ...$db1bc3ef2f702e84$var$PARENT_WITH_END_DROP_TARGET,
    'bodiedSyncBlock'
];
/**
 * List of node types that does not allow drop targets at before or after the node.
 */ const $db1bc3ef2f702e84$var$NODE_WITH_NO_PARENT_POS = [
    'tableCell',
    'tableHeader',
    'layoutColumn'
];
const $db1bc3ef2f702e84$var$UNSUPPORTED_LAYOUT_CONTENT = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $db1bc3ef2f702e84$var$isContainerNode = (node)=>{
    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) return $db1bc3ef2f702e84$var$PARENT_WITH_END_DROP_TARGET_SYNC_BLOCK.includes(node.type.name);
    return $db1bc3ef2f702e84$var$PARENT_WITH_END_DROP_TARGET.includes(node.type.name);
};
const $db1bc3ef2f702e84$export$40c317c5c02ece25 = (state, node, parent, index, $toPos, activeNode)=>{
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = state.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $l6okE.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    if ((0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) {
        const selectionSlice = state.doc.slice(selectionFrom, selectionTo, false);
        const selectionSliceChildCount = selectionSlice.content.childCount;
        let canDropSingleNode = true;
        let canDropMultipleNodes = true;
        // when there is only one node in the slice, use the same logic as when multi select is not on
        if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $d389fba940977935$export$35c44269895720b6)(selectionSlice, selectionFrom, selectionTo, parent, index, $toPos);
        else canDropSingleNode = !!(activePMNode && (0, $d389fba940977935$export$918b4fd27bccdab5)(parent, index, activePMNode, $toPos, node));
        if (!canDropMultipleNodes || !canDropSingleNode) return false;
    } else {
        const canDrop = activePMNode && (0, $d389fba940977935$export$918b4fd27bccdab5)(parent, index, activePMNode, $toPos, node);
        return canDrop;
    }
    return true;
};
const $db1bc3ef2f702e84$export$181f339130769cb6 = (activeDropTargetNode, state, api, existingDecs, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache)=>{
    const decsToAdd = [];
    let decsToRemove = existingDecs.filter((dec)=>!!dec);
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const $toPos = state.doc.resolve(activeDropTargetNode.pos);
    const existingDecsPos = decsToRemove.map((dec)=>dec.from);
    const { parent: parent, index: index, node: node, pos: pos, before: before, after: after, depth: depth } = (0, $6f35b85d8e5fa8ec$export$2f588816c7e80081)(state, $toPos, activeDropTargetNode.nodeTypeName);
    /**
   * If the current node is a container node, we show the drop targets
   * above the first child and below the last child.
   */ if ($db1bc3ef2f702e84$var$isContainerNode(node)) {
        const isEmptyContainer = node.childCount === 0 || node.childCount === 1 && (0, $l9G9n.isEmptyParagraph)(node.firstChild);
        // can move to before first child
        const posBeforeFirstChild = pos + 1; // +1 to get the position of the first child
        if (node.firstChild && $db1bc3ef2f702e84$export$40c317c5c02ece25(state, node.firstChild, node, 0, state.doc.resolve(posBeforeFirstChild), activeNode)) {
            if (existingDecsPos.includes(posBeforeFirstChild)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posBeforeFirstChild);
            else decsToAdd.push((0, $79ac2953323ad1e7$export$fc632359c395fc7)(posBeforeFirstChild, {
                api: api,
                prevNode: undefined,
                nextNode: node.firstChild,
                parentNode: node,
                formatMessage: formatMessage,
                dropTargetStyle: isEmptyContainer ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, 1, anchorRectCache));
        }
        // can move to after last child
        // if the node is empty, we don't show the drop target at the end of the node
        if (!isEmptyContainer) {
            const posAfterLastChild = pos + node.nodeSize - 1; // -1 to get the position after last child
            if (node.lastChild && $db1bc3ef2f702e84$export$40c317c5c02ece25(state, node.lastChild, node, node.childCount - 1, state.doc.resolve(posAfterLastChild), // -1 to get the position after last child
            activeNode)) {
                if (existingDecsPos.includes(posAfterLastChild)) // if the decoration already exists, we don't add it again.
                decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterLastChild);
                else decsToAdd.push((0, $79ac2953323ad1e7$export$fc632359c395fc7)(posAfterLastChild, {
                    api: api,
                    prevNode: node.lastChild,
                    nextNode: undefined,
                    parentNode: node,
                    formatMessage: formatMessage,
                    dropTargetStyle: 'remainingHeight'
                }, nodeViewPortalProviderAPI, -1, anchorRectCache));
            }
        }
    }
    /**
   * Create drop target before and after the current node
   */ if (!$db1bc3ef2f702e84$var$NODE_WITH_NO_PARENT_POS.includes(node.type.name)) {
        const isSameLayout = $activeNodePos && (0, $d389fba940977935$export$9d5fcdcf2394fab8)($activeNodePos, $toPos);
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes(parent?.type.name || '');
        const shouldShowFullHeight = isInSupportedContainer && parent?.lastChild === node && (0, $l9G9n.isEmptyParagraph)(node);
        if ($db1bc3ef2f702e84$export$40c317c5c02ece25(state, node, parent, index, $toPos, activeNode)) {
            if (existingDecsPos.includes(pos)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== pos);
            else decsToAdd.push((0, $79ac2953323ad1e7$export$fc632359c395fc7)(pos, {
                api: api,
                prevNode: before || undefined,
                nextNode: node,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
        // if the node is a container node, we show the drop target after the node
        const posAfterNode = pos + node.nodeSize;
        if ($db1bc3ef2f702e84$export$40c317c5c02ece25(state, node, parent, index + 1, state.doc.resolve(posAfterNode), activeNode)) {
            if (existingDecsPos.includes(posAfterNode)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterNode);
            else decsToAdd.push((0, $79ac2953323ad1e7$export$fc632359c395fc7)(posAfterNode, {
                api: api,
                prevNode: node,
                nextNode: after || undefined,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
    }
    let rootNodeWithPos = {
        node: node,
        pos: pos
    };
    // if the current node is not a top level node, we create one for advanced layout drop targets
    if (depth > 1) {
        const root = (0, $6f35b85d8e5fa8ec$export$2f588816c7e80081)(state, state.doc.resolve($toPos.before(2)));
        if (existingDecsPos.includes(root.pos)) // if the decoration already exists, we don't add it again.
        decsToRemove = decsToRemove.filter((dec)=>dec.from !== root.pos);
        else decsToAdd.push((0, $79ac2953323ad1e7$export$fc632359c395fc7)(root.pos, {
            api: api,
            prevNode: root.before || undefined,
            nextNode: root.node,
            parentNode: state.doc || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, false));
        rootNodeWithPos = {
            node: root.node,
            pos: root.pos
        };
    }
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
        const isSameLayout = $activeNodePos && (0, $d389fba940977935$export$9d5fcdcf2394fab8)($activeNodePos, state.doc.resolve(rootNodeWithPos.pos));
        const hasUnsupportedContent = $db1bc3ef2f702e84$var$UNSUPPORTED_LAYOUT_CONTENT.includes(activeNode?.nodeType || '') && (0, $iu6m9.editorExperiment)('platform_synced_block', true);
        if (rootNodeWithPos.node.type.name === 'layoutSection' && !hasUnsupportedContent) {
            const layoutSectionNode = rootNodeWithPos.node;
            if (layoutSectionNode.childCount < (0, $38ae61d92a71d752$export$b8ad888c900fcbc2)() || isSameLayout) layoutSectionNode.descendants((childNode, childPos, parent, index)=>{
                if (childNode.type.name === 'layoutColumn' && parent?.type.name === 'layoutSection' && index !== 0 // Not the first node
                ) {
                    const currentPos = rootNodeWithPos.pos + childPos + 1;
                    if (existingDecsPos.includes(currentPos)) // if the decoration already exists, we don't add it again.
                    decsToRemove = decsToRemove.filter((dec)=>dec.from !== currentPos);
                    else decsToAdd.push((0, $79ac2953323ad1e7$export$eb62fe530f14234e)(rootNodeWithPos.pos + childPos + 1, {
                        api: api,
                        parent: parent,
                        formatMessage: formatMessage
                    }, nodeViewPortalProviderAPI, anchorRectCache));
                }
                return false;
            });
        }
    }
    (0, $e89e2e6fe979fcda$export$73b394ea452decfd).emit((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? api.core.actions.getAnchorIdForNode(rootNodeWithPos.node, rootNodeWithPos.pos) || '' : (0, $94da9623b41bcf3c$export$20dcf6d6c6a1b068)(rootNodeWithPos.node));
    return {
        decsToAdd: decsToAdd,
        decsToRemove: decsToRemove
    };
};




















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






























var $7XFGZ = parcelRequire("7XFGZ");


var $g5gZt = parcelRequire("g5gZt");







var $2W0qg = parcelRequire("2W0qg");











const $3ee14a41a5b5094d$export$78de92b32db40bc4 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return `${dom.offsetLeft - (0, $30636d6b7963f251$export$5002400b4eb1f7c6)(nodeType) - widgetDimensions.width}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $30636d6b7963f251$export$5002400b4eb1f7c6)(nodeType) - widgetDimensions.width}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $30636d6b7963f251$export$5002400b4eb1f7c6)(nodeType) - widgetDimensions.width}px`;
};







const $7624781dadaf2c82$export$714e822c87fefc18 = (view)=>{
    const selection = view.state.selection;
    return selection instanceof (0, $ks2lK.NodeSelection) && selection.$from.depth > 0;
};
const $7624781dadaf2c82$export$9aa13fc11fb69569 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    const endPos = start + node.nodeSize;
    const startPos = start;
    const { $from: $from, $to: $to } = view.state.selection;
    return $from.pos >= startPos && endPos >= $to.pos;
};
const $7624781dadaf2c82$export$ec6e1e8159855f97 = (view)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $ks2lK.TextSelection)) return true;
    else if (selection instanceof (0, $ks2lK.NodeSelection)) // check if this is a node that can appear among text
    return selection.node.isInline;
};
const $7624781dadaf2c82$export$907327ee9908a2 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    // We want to treat some elements as if they are non-editable blocks for
    // the purposes of quick insert.
    switch(node.type.name){
        // mediaSingle and mediaGroup always contain a media child node, which is
        // both a block and an atom. mediaSingle can also have a caption child node
        // which is an editable block.
        case 'mediaGroup':
        case 'mediaSingle':
            return true;
    }
    return node.isBlock && (node.isAtom || node.isLeaf);
};






const $80f7124e6b95f642$export$3ca0fafcb5f79c56 = (start)=>({ tr: tr })=>{
        const nodeSize = tr.doc.nodeAt(start)?.nodeSize;
        if (nodeSize === undefined) return tr;
        const position = start + nodeSize;
        tr.insert(position, tr.doc.type.schema.nodes.paragraph.create());
        return tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(position)));
    };



function $cbf1f72785039644$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cbf1f72785039644$var$TEXT_PARENT_TYPES = [
    'paragraph',
    'heading',
    'blockquote',
    'taskItem',
    'decisionItem'
];
const $cbf1f72785039644$var$stickyButtonStyles = (0, $ecnYn.xcss)({
    top: '0',
    position: 'sticky',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)",
    border: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.full',
    zIndex: 'card',
    outline: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    ':focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24px x 24px, Dense: 13px -> ~18.5px x ~18.5px
const $cbf1f72785039644$var$stickyButtonDenseModeStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $aFUXX.relativeSizeToBaseFontSize)((0, $30636d6b7963f251$export$b2fc508ca59eba40)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $aFUXX.relativeSizeToBaseFontSize)((0, $30636d6b7963f251$export$c5ab994ee6fdf098))
});
const $cbf1f72785039644$var$containerStaticStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    zIndex: 'card'
});
const $cbf1f72785039644$var$tooltipContainerStyles = {
    name: "1hhl1l9",
    styles: "top:8px;bottom:-8px;position:sticky;display:block;z-index:card"
};
const $cbf1f72785039644$var$tooltipContainerStylesStickyHeader = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    }
});
const $cbf1f72785039644$var$tooltipContainerImprovedStylesStickyHeader = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $cbf1f72785039644$var$tooltipContainerStylesStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $cbf1f72785039644$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $30636d6b7963f251$export$355f64931df48ac6)}px`
    }
});
const $cbf1f72785039644$export$c64bb72e819f7e01 = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const macroInteractionUpdates = (0, $b3YrF.useSharedPluginStateSelector)(api, 'featureFlags.macroInteractionUpdates');
    const [positionStyles, setPositionStyles] = (0, $42omo.useState)({
        display: 'none'
    });
    // Adapted from `src/ui/drag-handle.tsx` as positioning logic is similar
    // CHANGES - added an offset so quick insert button can be positioned beside drag handle
    // CHANGES - removed `editorExperiment('nested-dnd', true)` check and rootNodeType calculation
    // CHANGES - replace anchorName with rootAnchorName
    // CHANGES - `removed editorExperiment('advanced_layouts', true) && isLayoutColumn` checks as quick insert button will not be positioned for layout column
    const calculatePosition = (0, $42omo.useCallback)(()=>{
        const supportsAnchor = CSS.supports('top', `anchor(${rootAnchorName} start)`) && CSS.supports('left', `anchor(${rootAnchorName} start)`);
        const safeAnchorName = (0, $143218ef1333fcee$export$79a8e1d39d3c2449)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName
        });
        const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${safeAnchorName}"]`);
        const hasResizer = rootNodeType === 'table' || rootNodeType === 'mediaSingle';
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension';
        const isBlockCard = rootNodeType === 'blockCard';
        const isEmbedCard = rootNodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $13c274f989e663fd$export$f988e74eefbc47fc)(rootNodeType);
        const bottom = (0, $13c274f989e663fd$export$cc6777b6e60d5179)(safeAnchorName || anchorName, isSticky, true);
        if (supportsAnchor) return {
            left: isEdgeCase ? `calc(anchor(${safeAnchorName} start) + ${(0, $3ee14a41a5b5094d$export$78de92b32db40bc4)(dom, rootNodeType, (0, $30636d6b7963f251$export$8b6a8ea78955a3a3), innerContainer, isMacroInteractionUpdates)} + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)` : `calc(anchor(${safeAnchorName} start) - ${(0, $30636d6b7963f251$export$8b6a8ea78955a3a3).width}px - ${(0, $30636d6b7963f251$export$5002400b4eb1f7c6)(rootNodeType)}px + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)`,
            top: `calc(anchor(${safeAnchorName} start) + ${(0, $30636d6b7963f251$export$403b33ae238c7c59)(rootNodeType)}px)`,
            ...bottom
        };
        // expensive, calls offsetHeight
        const nodeHeight = (0, $13c274f989e663fd$export$d106346a0f891cc2)(dom, safeAnchorName || anchorName, anchorRectCache) || 0;
        const height = (0, $13c274f989e663fd$export$738fa80805cb522c)(nodeHeight, isSticky, true, "var(--ds-space-300, 24px)");
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $3ee14a41a5b5094d$export$78de92b32db40bc4)(dom, rootNodeType, (0, $30636d6b7963f251$export$8b6a8ea78955a3a3), innerContainer, isMacroInteractionUpdates)} + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)` : `calc(${(0, $3ee14a41a5b5094d$export$78de92b32db40bc4)(dom, rootNodeType, (0, $30636d6b7963f251$export$8b6a8ea78955a3a3), innerContainer, isMacroInteractionUpdates)} + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)`,
            top: (0, $13c274f989e663fd$export$3c9c03fbeb71a88)(dom, rootNodeType),
            ...height
        };
    }, [
        rootAnchorName,
        getPos,
        view,
        rootNodeType,
        macroInteractionUpdates,
        anchorName,
        anchorRectCache
    ]);
    (0, $42omo.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${rootAnchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $fFa3V.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStyles(calculatePosition());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStyles(calculatePosition());
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType
    ]);
    const handleQuickInsert = (0, $42omo.useCallback)(()=>{
        // if the selection is not within the node this decoration is rendered at
        // then insert a newline and trigger quick insert
        const start = getPos();
        if (start !== undefined) {
            // if the selection is not within the node this decoration is rendered at
            // or the node is non-editable, then insert a newline and trigger quick insert
            const isSelectionInsideNode = (0, $7624781dadaf2c82$export$9aa13fc11fb69569)(start, view);
            if (!isSelectionInsideNode || (0, $7624781dadaf2c82$export$907327ee9908a2)(start, view)) api.core.actions.execute((0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(start));
            const { codeBlock: codeBlock } = view.state.schema.nodes;
            const { selection: selection } = view.state;
            const codeBlockParentNode = (0, $8m4tT.findParentNodeOfType)(codeBlock)(selection);
            if (codeBlockParentNode) // Slash command is not meant to be triggered inside code block, hence always insert slash in a new line following
            api.core.actions.execute((0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(codeBlockParentNode.pos));
            else if (isSelectionInsideNode) {
                // text or element with be deselected and the / added immediately after the paragraph
                // unless the selection is empty
                const currentSelection = view.state.selection;
                if ((0, $7624781dadaf2c82$export$ec6e1e8159855f97)(view) && currentSelection.from !== currentSelection.to) {
                    const currentParagraphNode = (0, $8m4tT.findParentNode)((node)=>$cbf1f72785039644$var$TEXT_PARENT_TYPES.includes(node.type.name))(currentSelection);
                    if (currentParagraphNode) {
                        const newPos = //if the current selection is selected from right to left, then set the selection to the start of the paragraph
                        currentSelection.anchor === currentSelection.to ? currentParagraphNode.pos : currentParagraphNode.pos + currentParagraphNode.node.nodeSize - 1;
                        api.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $ks2lK.TextSelection).create(view.state.selection.$from.doc, newPos));
                            return tr;
                        });
                    }
                }
                if ((0, $7624781dadaf2c82$export$714e822c87fefc18)(view)) {
                    // if the nested selected node is non-editable, then insert a newline below the selected node
                    if ((0, $7624781dadaf2c82$export$907327ee9908a2)(view.state.selection.from, view)) api.core.actions.execute((0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(view.state.selection.from));
                    else // otherwise need to force the selection to be at the start of the node, because
                    // prosemirror is keeping it as NodeSelection for nested nodes. Do this to keep it
                    // consistent NodeSelection for root level nodes.
                    api.core.actions.execute(({ tr: tr })=>{
                        (0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(view.state.selection.from)({
                            tr: tr
                        });
                        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, view.state.selection.from));
                        return tr;
                    });
                }
                if (currentSelection instanceof (0, $7XFGZ.CellSelection)) {
                    // find the last inline position in the selection
                    const lastInlinePosition = (0, $ks2lK.TextSelection).near(view.state.selection.$to, -1);
                    lastInlinePosition && api.core.actions.execute(({ tr: tr })=>{
                        if (!(lastInlinePosition instanceof (0, $ks2lK.TextSelection))) {
                            // this will create a new line after the node
                            (0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(lastInlinePosition.from)({
                                tr: tr
                            });
                            // this will find the next valid text position after the node
                            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, lastInlinePosition.to));
                        } else tr.setSelection(lastInlinePosition);
                        return tr;
                    });
                }
            }
        }
        api.quickInsert?.actions.openTypeAhead('blockControl', true);
    }, [
        api,
        getPos,
        view
    ]);
    const handleMouseDown = (0, $42omo.useCallback)(()=>{
        // close typeahead if it is open, must happen in mouseDown otherwise typeAhead popup will be dismissed and text is left
        if (api.typeAhead?.actions.isOpen(view.state)) api.typeAhead.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        api,
        view.state
    ]);
    const tooltipPressable = ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            position: "top",
            content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                description: formatMessage((0, $dwl7L.messages).insert)
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2W0qg.default), {
            testId: "editor-quick-insert-button",
            type: "button",
            "aria-label": formatMessage((0, $dwl7L.messages).insert),
            xcss: [
                $cbf1f72785039644$var$stickyButtonStyles,
                ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $cbf1f72785039644$var$stickyButtonDenseModeStyles
            ],
            onClick: handleQuickInsert,
            onMouseDown: handleMouseDown
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: "add",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        })));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: positionStyles,
        xcss: [
            $cbf1f72785039644$var$containerStaticStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            $cbf1f72785039644$var$tooltipContainerStyles,
            (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_6') ? $cbf1f72785039644$var$tooltipContainerImprovedStylesStickyHeader : $cbf1f72785039644$var$tooltipContainerStylesStickyHeader,
            (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_6') ? $cbf1f72785039644$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix : $cbf1f72785039644$var$tooltipContainerStylesStickyHeaderWithMarksFix
        ]
    }, tooltipPressable()));
};
const $cbf1f72785039644$export$6ffb15bf86dea6dd = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, nodeType: nodeType, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $32afabcec12ede12$export$e7448669708130cc), {
        api: api
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($cbf1f72785039644$export$c64bb72e819f7e01, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        nodeType: nodeType,
        anchorName: anchorName,
        rootAnchorName: rootAnchorName,
        rootNodeType: rootNodeType,
        anchorRectCache: anchorRectCache
    }));
};




var $24P9d = parcelRequire("24P9d");























const $f195357aab4cfdf6$export$b3ceb0cbf1056d98 = ({ rootAnchorName: rootAnchorName, anchorName: anchorName, view: view, getPos: getPos, rootNodeType: rootNodeType, macroInteractionUpdates: macroInteractionUpdates, anchorRectCache: anchorRectCache })=>{
    const supportsAnchor = CSS.supports('top', `anchor(${rootAnchorName} start)`) && CSS.supports('left', `anchor(${rootAnchorName} start)`);
    const safeAnchorName = (0, $143218ef1333fcee$export$79a8e1d39d3c2449)({
        getPos: getPos,
        view: view,
        anchorName: rootAnchorName
    });
    const dom = view.dom.querySelector(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}="${safeAnchorName}"]`);
    const hasResizer = rootNodeType === 'table' || rootNodeType === 'mediaSingle';
    const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension';
    const isBlockCard = rootNodeType === 'blockCard';
    const isEmbedCard = rootNodeType === 'embedCard';
    const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
    let innerContainer = null;
    if (dom) {
        if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
        else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
        else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
        else if (isBlockCard) //specific to datasource blockCard
        innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
    }
    const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
    const isSticky = (0, $13c274f989e663fd$export$f988e74eefbc47fc)(rootNodeType);
    const bottom = (0, $13c274f989e663fd$export$cc6777b6e60d5179)(safeAnchorName || anchorName, isSticky, true);
    if (supportsAnchor) return {
        left: isEdgeCase ? `calc(anchor(${safeAnchorName} start) + ${(0, $3ee14a41a5b5094d$export$78de92b32db40bc4)(dom, rootNodeType, (0, $30636d6b7963f251$export$8b6a8ea78955a3a3), innerContainer, isMacroInteractionUpdates)} + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)` : `calc(anchor(${safeAnchorName} start) - ${(0, $30636d6b7963f251$export$8b6a8ea78955a3a3).width}px - ${(0, $30636d6b7963f251$export$5002400b4eb1f7c6)(rootNodeType)}px + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)`,
        top: `calc(anchor(${safeAnchorName} start) + ${(0, $30636d6b7963f251$export$403b33ae238c7c59)(rootNodeType)}px)`,
        ...bottom
    };
    // expensive, calls offsetHeight
    const nodeHeight = (0, $13c274f989e663fd$export$d106346a0f891cc2)(dom, safeAnchorName || anchorName, anchorRectCache) || 0;
    const height = (0, $13c274f989e663fd$export$738fa80805cb522c)(nodeHeight, isSticky, true, "var(--ds-space-300, 24px)");
    return {
        left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $3ee14a41a5b5094d$export$78de92b32db40bc4)(dom, rootNodeType, (0, $30636d6b7963f251$export$8b6a8ea78955a3a3), innerContainer, isMacroInteractionUpdates)} + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)` : `calc(${(0, $3ee14a41a5b5094d$export$78de92b32db40bc4)(dom, rootNodeType, (0, $30636d6b7963f251$export$8b6a8ea78955a3a3), innerContainer, isMacroInteractionUpdates)} + -${0, $30636d6b7963f251$export$37704ab652bb303e}px)`,
        top: (0, $13c274f989e663fd$export$3c9c03fbeb71a88)(dom, rootNodeType),
        ...height
    };
};



var $i4Myo = parcelRequire("i4Myo");




const $5708614080b3e6d8$var$startingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            4
        ]
    }
};
const $5708614080b3e6d8$var$endingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            8
        ]
    }
};
class $5708614080b3e6d8$export$47a232ed95817c75 {
    createPopperInstance() {
        this.popperInstance = (0, $i4Myo.createPopper)(this.button, this.tooltip, {
            placement: 'top',
            modifiers: [
                $5708614080b3e6d8$var$startingOffset
            ]
        });
    }
    destroy() {
        this.popperInstance?.destroy();
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    hide(immediate = false) {
        clearTimeout(this.currentTimeoutId);
        this.shouldHidePopover = true;
        // Disable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $5708614080b3e6d8$var$startingOffset,
                        {
                            name: 'eventListeners',
                            enabled: false
                        }
                    ]
                }));
            this.tooltip.style.opacity = '0';
            this.isDisplayed = false;
            // If transition animations are disabled immediately hide the popover
            if (this.tooltip.style.transition === 'none') this.tooltip.hidePopover();
        }, immediate ? 0 : this.timeout);
    }
    show() {
        if (this.isDisplayed) return;
        clearTimeout(this.currentTimeoutId);
        this.shouldHidePopover = false;
        // Make the tooltip visible - but hide until
        this.tooltip.style.visibility = 'hidden';
        this.tooltip.showPopover();
        // Update its position
        if (!this.popperInstance) this.createPopperInstance();
        else this.popperInstance.update();
        // Enable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.tooltip.style.opacity = '1';
            this.tooltip.style.visibility = 'visible';
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $5708614080b3e6d8$var$endingOffset,
                        {
                            name: 'eventListeners',
                            enabled: true
                        }
                    ]
                }));
            this.isDisplayed = true;
        }, this.timeout);
    }
    constructor(button, content, /**
   * Id associated to the tooltip - must be unique.
   */ id, timeout = 300){
        this.button = button;
        this.timeout = timeout;
        this.popperInstance = void 0;
        this.listeners = [];
        this.currentTimeoutId = void 0;
        this.shouldHidePopover = false;
        this.tooltip = void 0;
        this.isDisplayed = false;
        const tooltip = document.createElement('span');
        tooltip.role = 'tooltip';
        tooltip.popover = 'hint';
        // Warning: Currently this is used for styling - only works in the block controls package
        tooltip.className = 'blocks-quick-insert-tooltip';
        tooltip.id = id;
        tooltip.textContent = content;
        this.tooltip = tooltip;
        // Button preparation
        button.appendChild(tooltip);
        // Prepare the button to have the popover target and accessibility properties
        button.setAttribute('popovertarget', tooltip.id);
        button.setAttribute('aria-describedby', tooltip.id);
        const showEvents = [
            'mouseenter',
            'focus'
        ];
        const hideEvents = [
            'mouseleave',
            'blur'
        ];
        showEvents.forEach((event)=>{
            this.listeners.push((0, $fFa3V.bind)(button, {
                type: event,
                listener: ()=>this.show()
            }));
        });
        hideEvents.forEach((event)=>{
            this.listeners.push((0, $fFa3V.bind)(button, {
                type: event,
                listener: ()=>this.hide()
            }));
        });
        this.listeners.push((0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        }));
        // Hide the tooltip if the hide transition has completed
        this.tooltip.ontransitionend = ()=>{
            if (this.shouldHidePopover) this.tooltip.hidePopover();
        };
    }
}


// Based on platform/packages/design-system/icon/svgs/utility/add.svg
const $a57211e5c61921fc$var$plusButtonDOM = [
    'http://www.w3.org/2000/svg svg',
    {
        width: '12',
        height: '12',
        fill: 'none',
        viewBox: '0 0 12 12',
        style: 'pointer-events: none;'
    },
    [
        'http://www.w3.org/2000/svg path',
        {
            fill: 'currentcolor',
            'fill-rule': 'evenodd',
            d: 'M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5z',
            'clip-rule': 'evenodd',
            style: 'pointer-events: none;'
        }
    ]
];
const $a57211e5c61921fc$var$vanillaQuickInsert = ({ view: view, getPos: getPos, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache, anchorName: anchorName, rootAnchorName: rootAnchorName, api: api })=>[
        'div',
        {
            style: (0, $24P9d.convertToInlineCss)({
                position: 'absolute',
                ...(0, $f195357aab4cfdf6$export$b3ceb0cbf1056d98)({
                    rootAnchorName: rootAnchorName,
                    anchorName: anchorName,
                    view: view,
                    getPos: getPos,
                    rootNodeType: rootNodeType,
                    macroInteractionUpdates: api?.featureFlags?.sharedState.currentState()?.macroInteractionUpdates ?? false,
                    anchorRectCache: anchorRectCache
                })
            })
        },
        [
            'button',
            {
                class: 'blocks-quick-insert-button',
                'data-testid': 'editor-quick-insert-button'
            },
            $a57211e5c61921fc$var$plusButtonDOM
        ]
    ];
const $a57211e5c61921fc$export$2482d61e053522db = (props)=>{
    const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, $a57211e5c61921fc$var$vanillaQuickInsert(props));
    if (dom instanceof HTMLElement) {
        const button = dom.querySelector('button[data-testid="editor-quick-insert-button"]');
        if (button instanceof HTMLButtonElement) {
            button.onclick = ()=>$a57211e5c61921fc$var$handleQuickInsert(props);
            const tooltip = new (0, $5708614080b3e6d8$export$47a232ed95817c75)(button, props.formatMessage((0, $dwl7L.messages).insert), 'quick-insert-button-tooltip');
            props.cleanupCallbacks.push(()=>{
                tooltip.destroy();
            });
        }
    }
    // Dynamically control the visibility of the node
    let isTypeAheadOpen = props.api.typeAhead?.sharedState.currentState()?.isOpen;
    let isEditing = props.api.blockControls?.sharedState.currentState()?.isEditing;
    const changeDOMVisibility = ()=>{
        if (!(dom instanceof HTMLElement)) return;
        if (isTypeAheadOpen || isEditing) {
            dom.classList.add('blocks-quick-insert-invisible-container');
            dom.classList.remove('blocks-quick-insert-visible-container');
        } else {
            dom.classList.add('blocks-quick-insert-visible-container');
            dom.classList.remove('blocks-quick-insert-invisible-container');
        }
    };
    changeDOMVisibility();
    props.cleanupCallbacks.push(props.api.typeAhead?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        isTypeAheadOpen = nextSharedState?.isOpen;
        changeDOMVisibility();
    }));
    props.cleanupCallbacks.push(props.api.blockControls?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        isEditing = nextSharedState?.isEditing;
        changeDOMVisibility();
    }));
    return dom;
};
const $a57211e5c61921fc$var$TEXT_PARENT_TYPES = [
    'paragraph',
    'heading',
    'blockquote',
    'taskItem',
    'decisionItem'
];
const $a57211e5c61921fc$var$handleQuickInsert = ({ api: api, view: view, getPos: getPos })=>{
    // if the selection is not within the node this decoration is rendered at
    // then insert a newline and trigger quick insert
    const start = getPos();
    if (start !== undefined) {
        // if the selection is not within the node this decoration is rendered at
        // or the node is non-editable, then insert a newline and trigger quick insert
        const isSelectionInsideNode = (0, $7624781dadaf2c82$export$9aa13fc11fb69569)(start, view);
        if (!isSelectionInsideNode || (0, $7624781dadaf2c82$export$907327ee9908a2)(start, view)) api.core.actions.execute((0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(start));
        const { codeBlock: codeBlock } = view.state.schema.nodes;
        const { selection: selection } = view.state;
        const codeBlockParentNode = (0, $8m4tT.findParentNodeOfType)(codeBlock)(selection);
        if (codeBlockParentNode) // Slash command is not meant to be triggered inside code block, hence always insert slash in a new line following
        api.core.actions.execute((0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(codeBlockParentNode.pos));
        else if (isSelectionInsideNode) {
            // text or element with be deselected and the / added immediately after the paragraph
            // unless the selection is empty
            const currentSelection = view.state.selection;
            if ((0, $7624781dadaf2c82$export$ec6e1e8159855f97)(view) && currentSelection.from !== currentSelection.to) {
                const currentParagraphNode = (0, $8m4tT.findParentNode)((node)=>$a57211e5c61921fc$var$TEXT_PARENT_TYPES.includes(node.type.name))(currentSelection);
                if (currentParagraphNode) {
                    const newPos = //if the current selection is selected from right to left, then set the selection to the start of the paragraph
                    currentSelection.anchor === currentSelection.to ? currentParagraphNode.pos : currentParagraphNode.pos + currentParagraphNode.node.nodeSize - 1;
                    api.core.actions.execute(({ tr: tr })=>{
                        tr.setSelection((0, $ks2lK.TextSelection).create(view.state.selection.$from.doc, newPos));
                        return tr;
                    });
                }
            }
            if ((0, $7624781dadaf2c82$export$714e822c87fefc18)(view)) {
                // if the nested selected node is non-editable, then insert a newline below the selected node
                if ((0, $7624781dadaf2c82$export$907327ee9908a2)(view.state.selection.from, view)) api.core.actions.execute((0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(view.state.selection.from));
                else // otherwise need to force the selection to be at the start of the node, because
                // prosemirror is keeping it as NodeSelection for nested nodes. Do this to keep it
                // consistent NodeSelection for root level nodes.
                api.core.actions.execute(({ tr: tr })=>{
                    (0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(view.state.selection.from)({
                        tr: tr
                    });
                    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, view.state.selection.from));
                    return tr;
                });
            }
            if (currentSelection instanceof (0, $7XFGZ.CellSelection)) {
                // find the last inline position in the selection
                const lastInlinePosition = (0, $ks2lK.TextSelection).near(view.state.selection.$to, -1);
                lastInlinePosition && api.core.actions.execute(({ tr: tr })=>{
                    if (!(lastInlinePosition instanceof (0, $ks2lK.TextSelection))) {
                        // this will create a new line after the node
                        (0, $80f7124e6b95f642$export$3ca0fafcb5f79c56)(lastInlinePosition.from)({
                            tr: tr
                        });
                        // this will find the next valid text position after the node
                        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, lastInlinePosition.to));
                    } else tr.setSelection(lastInlinePosition);
                    return tr;
                });
            }
        }
    }
    api.quickInsert?.actions.openTypeAhead('blockControl', true);
};


const $4990d45fb705f5de$var$TYPE_QUICK_INSERT = 'INSERT_BUTTON';
const $4990d45fb705f5de$export$a6ab3402831bd7d8 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $4990d45fb705f5de$var$TYPE_QUICK_INSERT);
};
const $4990d45fb705f5de$export$ab399427af69a61 = ({ api: api, formatMessage: formatMessage, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    const cleanupCallbacks = [];
    const widgetSpec = (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) ? {
        side: -2,
        type: $4990d45fb705f5de$var$TYPE_QUICK_INSERT,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $271e6ebabf680389$export$73aa3a42f47c0775)(editorState, rootPos),
        destroy: (_)=>{
            if ((0, $dh538.fg)('platform_editor_fix_widget_destroy')) nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    } : {
        side: -2,
        type: $4990d45fb705f5de$var$TYPE_QUICK_INSERT,
        destroy: (_)=>{
            if ((0, $dh538.fg)('platform_editor_fix_widget_destroy')) nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    };
    return (0, $ftzrq.Decoration).widget(rootPos, (view, getPos)=>{
        const element = document.createElement('span');
        // inline decoration causes cursor disappear when focusing editor at the first line (e.g. press Tab when title is focused)
        element.style.display = 'block';
        if ((0, $1oCLl.expValEquals)('platform_editor_quick_insert_image_wrap_right_fix', 'isEnabled', true)) // make sure it does not interfere with elements floating next to each other e.g. paragraph next to image with wrap-right
        element.style.clear = 'unset';
        element.contentEditable = 'false';
        element.setAttribute('data-blocks-quick-insert-container', 'true');
        element.setAttribute('data-testid', 'block-ctrl-quick-insert-button');
        if ((0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true, {
            exposure: true
        })) {
            const vanillaElement = (0, $a57211e5c61921fc$export$2482d61e053522db)({
                formatMessage: formatMessage,
                api: api,
                view: view,
                getPos: getPos,
                cleanupCallbacks: cleanupCallbacks,
                rootAnchorName: rootAnchorName ?? nodeType,
                anchorName: anchorName,
                rootNodeType: rootNodeType ?? nodeType,
                anchorRectCache: anchorRectCache
            });
            element.appendChild(vanillaElement);
            return element;
        }
        nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $cbf1f72785039644$export$6ffb15bf86dea6dd), {
                api: api,
                getPos: getPos,
                formatMessage: formatMessage,
                view: view,
                nodeType: nodeType,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, widgetSpec);
};











const $d88d557fffb2fc39$export$b4a93e0b711d8f7 = (api)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        if (!view.editable) {
            const targetPos = view.posAtDOM(event.target, 0);
            // always fetch top level position for mouseDown to avoid drag handle positions being incorrect
            const rootPos = view.state.doc.resolve(targetPos).before(1);
            const rootNode = view.state.doc.nodeAt(rootPos);
            if (!rootNode) return false;
            if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const anchorName = api?.core.actions.getAnchorIdForNode(rootNode, rootPos);
                // don't show the handles if we can't find an anchor
                if (!anchorName) return false;
                api?.core.actions.execute(api?.blockControls.commands.showDragHandleAt(rootPos, anchorName, rootNode.type.name ?? '', undefined, rootPos, anchorName, rootNode.type.name ?? ''));
            } else api?.core.actions.execute(api?.blockControls.commands.showDragHandleAt(rootPos, '', rootNode.type.name ?? '', undefined, rootPos, '', rootNode.type.name ?? ''));
        } else {
            const isDragHandle = event.target.closest((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? (0, $Yqd3z.DRAG_HANDLE_SELECTOR) : '[data-editor-block-ctrl-drag-handle]') !== null;
            api?.core.actions.execute(({ tr: tr })=>{
                api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle)({
                    tr: tr
                });
                /**
				 * When block menu is enabled, reset intent back to 'default' as editor-plugin-block-menu sets the user intent to 'blockMenuOpen', and setting here
				 * causes flickering as this runs before editor-plugin-block-menu.
				 */ if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) // if target is drag handle, block menu will be opened
                {
                    if (!isDragHandle) api?.userIntent?.commands.setCurrentUserIntent('default')({
                        tr: tr
                    });
                } else api.userIntent?.commands.setCurrentUserIntent(isDragHandle ? 'dragHandleSelected' : 'default')({
                    tr: tr
                });
                return tr;
            });
        }
        return false;
    };























const $326a8fb54153aacd$var$isEmptyNestedParagraphOrHeading = (target)=>{
    if (target instanceof HTMLHeadingElement || target instanceof HTMLParagraphElement) return !target.parentElement?.classList.contains('ProseMirror') && target.textContent === '';
    return false;
};
const $326a8fb54153aacd$var$getNodeSelector = (ignoreNodes, ignoreNodeDescendants)=>{
    const baseSelector = `[${(0, $d89c90893897930c$export$ea34df48337a3b78)}]`;
    if (ignoreNodes.length === 0 && ignoreNodeDescendants.length === 0) return baseSelector;
    const ignoreNodeSelectorList = ignoreNodes.map((node)=>`[data-prosemirror-node-name="${node}"]`);
    const ignoreNodeDescendantsSelectorList = ignoreNodeDescendants.map((node)=>{
        if (node === 'table') // Special case for table to exclude its direct descendants
        return [
            `[data-prosemirror-node-name="tableCell"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableCell"] > *:not([data-node-anchor]) > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > *:not([data-node-anchor]) > [data-node-anchor]`
        ];
        return `[data-prosemirror-node-name="${node}"] [data-node-anchor]`;
    });
    const ignoreSelector = [
        ...ignoreNodeSelectorList,
        ...ignoreNodeDescendantsSelectorList.flat(),
        '[data-prosemirror-node-inline="true"]'
    ].join(', ');
    return `${baseSelector}:not(${ignoreSelector})`;
};
const $326a8fb54153aacd$var$getDefaultNodeSelector = (0, $2XqLN.default)(()=>{
    // we don't show handler for node nested in table
    return $326a8fb54153aacd$var$getNodeSelector([
        ...(0, $8653f788c2b076b7$export$4b59c90449151b37),
        'media'
    ], [
        ...(0, $8653f788c2b076b7$export$9cba0273af9f9727),
        'table'
    ]);
});
const $326a8fb54153aacd$export$321c2da35903b013 = (view, event, api)=>{
    const { isDragging: isDragging, activeNode: activeNode, isMenuOpen: isMenuOpen, menuTriggerBy: originalAnchorName, blockMenuOptions: blockMenuOptions } = api?.blockControls?.sharedState.currentState() || {};
    const { editorDisabled: editorDisabled } = api?.editorDisabled?.sharedState.currentState() || {
        editorDisabled: false
    };
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // We shouldn't be firing mouse over transactions when the editor is disabled
    if (editorDisabled) return false;
    // If the editor view is not in focus when the block menu is open, do not update the drag handle
    if (!view.hasFocus() && isMenuOpen && (0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) return false;
    // Most mouseover events don't fire during drag but some can slip through
    // when the drag begins. This prevents those.
    if (isDragging) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isNativeAnchorSupported = (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    if (target?.classList?.contains('ProseMirror')) return false;
    let rootElement = target?.closest(isNativeAnchorSupported ? $326a8fb54153aacd$var$getDefaultNodeSelector() : `[data-drag-handler-anchor-name]`);
    if (rootElement) {
        // We want to exlude handles from showing for empty paragraph and heading nodes
        if ($326a8fb54153aacd$var$isEmptyNestedParagraphOrHeading(rootElement)) return false;
        if (rootElement.getAttribute((0, $d89c90893897930c$export$916bc5085eed228a)()) === 'media' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && !isNativeAnchorSupported) {
            rootElement = rootElement.closest(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}][${(0, $d89c90893897930c$export$916bc5085eed228a)()}="mediaSingle"]`);
            if (!rootElement) return false;
        }
        const parentElement = rootElement.parentElement?.closest(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}]`);
        const parentElementType = isNativeAnchorSupported ? (0, $d89c90893897930c$export$374251d21964e516)(parentElement) : parentElement?.getAttribute('data-drag-handler-node-type');
        if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
            // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
            if (parentElement && parentElementType === 'table') rootElement = parentElement;
            else if (parentElement && parentElementType === 'tableRow') {
                const grandparentElement = parentElement?.parentElement?.closest(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}]`);
                const grandparentElementType = isNativeAnchorSupported ? (0, $d89c90893897930c$export$374251d21964e516)(grandparentElement) : grandparentElement?.getAttribute('data-drag-handler-node-type');
                if (grandparentElement && grandparentElementType === 'table') rootElement = grandparentElement;
            }
        } else // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
        if (parentElement && parentElementType === 'table') rootElement = parentElement;
        let anchorName;
        if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            anchorName = rootElement.getAttribute((0, $d89c90893897930c$export$684dbfb461b166c3)());
            // don't show handles if we can't find an anchor
            if (!anchorName) return false;
        } else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        anchorName = rootElement.getAttribute((0, $d89c90893897930c$export$684dbfb461b166c3)());
        // No need to update handle position if its already there
        if (activeNode?.anchorName === anchorName) return false;
        // We want to exlude handles from showing for wrapped nodes
        // TODO: ED-26959 - We should be able remove these check if we decided to
        // go we not decoration for wrapped image solution.
        if ([
            'wrap-right',
            'wrap-left'
        ].includes(rootElement.getAttribute('layout') || '')) return false;
        const parentRootElement = rootElement.parentElement;
        let pos;
        if (parentRootElement) {
            const childNodes = Array.from(parentRootElement.childNodes);
            const index = childNodes.indexOf(rootElement);
            pos = view.posAtDOM(parentRootElement, index);
            // We want to exlude handles showing for first element in a Panel, ignoring widgets like gapcursor
            const firstChildIsWidget = parentRootElement?.children[0]?.classList.contains('ProseMirror-widget');
            if (parentElement && parentElementType === 'panel' && !parentElement.classList.contains('ak-editor-panel__no-icon') && (index === 0 || firstChildIsWidget && index === 1)) return false;
        } else pos = view.posAtDOM(rootElement, 0);
        if (parentRootElement && parentRootElement.getAttribute('data-layout-section') === 'true' && parentRootElement.querySelectorAll('[data-layout-column]').length === 1 && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) // Don't show drag handle for layout column in a single column layout
        return false;
        const targetPos = view.state.doc.resolve(pos).pos;
        let rootAnchorName;
        let rootNodeType;
        let rootPos;
        // platform_editor_controls note: enables quick insert
        if (toolbarFlagsEnabled) {
            rootPos = view.state.doc.resolve(pos).before(1);
            if (targetPos !== rootPos) {
                const rootDOM = view.nodeDOM(rootPos);
                if (rootDOM instanceof HTMLElement) {
                    rootAnchorName = rootDOM.getAttribute((0, $d89c90893897930c$export$684dbfb461b166c3)()) ?? undefined;
                    rootNodeType = isNativeAnchorSupported ? (0, $d89c90893897930c$export$374251d21964e516)(rootDOM) : rootDOM.getAttribute('data-drag-handler-node-type');
                }
            }
        }
        const nodeType = isNativeAnchorSupported ? (0, $d89c90893897930c$export$374251d21964e516)(rootElement) : rootElement.getAttribute('data-drag-handler-node-type');
        if (nodeType) {
            // platform_editor_controls note: enables quick insert
            if (toolbarFlagsEnabled) {
                if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
                    const preservedSelection = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(view.state)?.preservedSelection;
                    const selection = preservedSelection || view.state.selection;
                    const isMultipleSelected = selection && (0, $l6okE.isMultiBlockSelection)(selection);
                    // Only execute when selection is not a multi-selection, block menu is open, and menu is opened via keyboard
                    // as when it is a multi-selection, the showDragHandleAt command interfere with selection
                    // sometimes makes the multi-selection not continous after block menu is opened with keyboard
                    if (!(isMultipleSelected && isMenuOpen && blockMenuOptions?.openedViaKeyboard)) api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType, undefined, rootPos ?? targetPos, rootAnchorName ?? anchorName, rootNodeType ?? nodeType));
                } else api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType, undefined, rootPos ?? targetPos, rootAnchorName ?? anchorName, rootNodeType ?? nodeType));
            } else api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType));
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
                if (isMenuOpen && originalAnchorName && api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen') api?.core?.actions.execute(api?.blockControls?.commands.toggleBlockMenu());
            }
        }
    }
};






var $ah4M9 = parcelRequire("ah4M9");


var $dus6D = parcelRequire("dus6D");





var $adayn = parcelRequire("adayn");










var $hcbpx = parcelRequire("hcbpx");




















var $id9O1 = parcelRequire("id9O1");

var $bMyNT = parcelRequire("bMyNT");

var $iYC9s = parcelRequire("iYC9s");


















const $b5c2a732510c94ee$export$35954ff4e514ba11 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const parentNodeOfSpecificTypes = (0, $8m4tT.findParentNodeOfType)([
            schema.nodes.bulletList,
            schema.nodes.orderedList,
            schema.nodes.blockquote,
            schema.nodes.taskList,
            schema.nodes.decisionList
        ])(selection);
        if (parentNodeOfSpecificTypes) {
            const parentNodeType = parentNodeOfSpecificTypes.node.type.name;
            nestedNodePos = [
                'bulletList',
                'orderedList'
            ].includes(parentNodeType) ? $pos.before($pos.depth - 1) : [
                'blockquote',
                'taskList',
                'decisionList'
            ].includes(parentNodeType) ? $pos.before() : nestedNodePos;
        }
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $b5c2a732510c94ee$export$ac406f4d57a10c33 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const { bulletList: bulletList, orderedList: orderedList, taskList: taskList, decisionList: decisionList, caption: caption } = schema.nodes;
        const isInList = (0, $8m4tT.findParentNodeOfType)([
            bulletList,
            orderedList,
            taskList
        ])(selection);
        const isInNodeWithoutDragHandle = (0, $8m4tT.findParentNodeOfType)([
            caption,
            decisionList
        ])(selection);
        if (isInList) // Only show drag handle at outermost list parent
        nestedNodePos = $b5c2a732510c94ee$var$getOutermostListPos($pos, resolve);
        else if (isInNodeWithoutDragHandle) // return the position of their parent if there should be no drag handle before the node
        nestedNodePos = $pos.before();
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $b5c2a732510c94ee$var$getOutermostListPos = ($pos, resolve)=>{
    if ($pos.depth === 0) return $pos.pos;
    const parentPos = $pos.before();
    const parentNode = $pos.parent;
    if (parentNode && [
        'bulletList',
        'listItem',
        'orderedList',
        'taskList',
        'taskItem'
    ].includes(parentNode.type.name)) return $b5c2a732510c94ee$var$getOutermostListPos(resolve(parentPos), resolve);
    return $pos.pos;
};












const $6940983cd14d3baa$export$2b4dd9f6b8f819da = (fragment, type)=>fragment.childCount === 1 && fragment.firstChild?.type.name === type;
const $6940983cd14d3baa$export$8cb5c38ddf4d519f = (fragment, type)=>{
    for(let i = 0; i < fragment.childCount; i++){
        const child = fragment.child(i);
        if (child.type.name === type) return true;
    }
    return false;
};




const $31a8295f9374d28a$export$6688b13ec132acdf = (tr, layoutNode, layoutNodePos, childCount)=>{
    const newColumnWidth = (0, $30636d6b7963f251$export$d77e6458bbcae98b)[childCount];
    if (newColumnWidth) layoutNode.content.forEach((node, offset)=>{
        if (node.type.name === 'layoutColumn') tr.setNodeAttribute(layoutNodePos + offset + 1, 'width', newColumnWidth);
    });
    return {
        newColumnWidth: newColumnWidth,
        tr: tr
    };
};


const $ea3d65f7aba7472e$export$29bd206d467fd44 = (tr, $from, to)=>{
    let sourceContent = $from.nodeAfter;
    let isLayoutColumn = sourceContent?.type.name === 'layoutColumn';
    let sourceNodeEndPos = $from.pos + (sourceContent?.nodeSize || 1);
    if ((0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) {
        sourceContent = tr.doc.slice($from.pos, to).content;
        isLayoutColumn = (0, $6940983cd14d3baa$export$2b4dd9f6b8f819da)(sourceContent, 'layoutColumn');
        sourceNodeEndPos = to === undefined ? $from.pos + sourceContent.size : to;
    }
    if (!sourceContent) return tr;
    /**
	 * This logic is used to handle the case when a user tries to delete a layout column
	 * that contains only 2 child node, and single column layouts are not enabled.
	 * In this case, we delete the layout column and replace it with its content.
	 */ if (isLayoutColumn && !(0, $iu6m9.editorExperiment)('single_column_layouts', true)) {
        const sourceParent = $from.parent;
        if (sourceParent.childCount === (0, $38ae61d92a71d752$export$8a51600ccf088851)) {
            // Only delete the layout content, but keep the layout column itself
            // This logic should be remove when we clean up the code for single column layouts.
            // since this step has no effect on the layout column, because the parent node is removed in the later step.
            tr.delete($from.pos + 1, sourceNodeEndPos - 1);
            // This check should be remove when clean up the code for single column layouts.
            // since it has been checked in the previous step.
            if (sourceParent.childCount === 2) {
                const layoutContentFragment = $from.parentOffset === 0 ? (0, $5SAOw.Fragment).from($from.parent.lastChild?.content) : (0, $5SAOw.Fragment).from($from.parent.firstChild?.content);
                const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>{
                    return node.type.name === 'layoutSection';
                });
                if (parent && layoutContentFragment) {
                    const layoutSectionPos = tr.mapping.map(parent.pos);
                    // get the updated layout node size
                    const layoutSectionNodeSize = tr.doc.resolve(layoutSectionPos).nodeAfter?.nodeSize || 0;
                    tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment);
                }
            }
            return tr;
        } else (0, $31a8295f9374d28a$export$6688b13ec132acdf)(tr, $from.parent, $from.before($from.depth), sourceParent.childCount - 1);
    }
    tr.delete($from.pos, sourceNodeEndPos);
    return tr;
};

















const $fb7c69702c6d579c$export$c57c553e4ac98a48 = (selection)=>{
    // Special case: if a table is selected, we want to move the entire table node
    const tableInfo = (0, $id9O1.findTable)(selection);
    if (tableInfo && (0, $iYC9s.isTableSelected)(selection)) {
        const tablePos = tableInfo.pos;
        const tableTo = tablePos + tableInfo.node.nodeSize;
        return {
            from: tablePos,
            to: tableTo
        };
    }
    // Special case: if a media node (file) is selected, we need to get the parent mediaGroup
    // This handles the case where clicking on a file creates a NodeSelection of the media node
    // but we want to move the entire mediaGroup that wraps it
    if (selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file' && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
        // The media node is wrapped in a mediaGroup, so we need to get the parent position
        const mediaGroupPos = selection.$from.pos - 1;
        const mediaGroupNode = selection.$from.doc.nodeAt(mediaGroupPos);
        if (mediaGroupNode && mediaGroupNode.type.name === 'mediaGroup') return {
            from: mediaGroupPos,
            to: mediaGroupPos + mediaGroupNode.nodeSize
        };
    }
    // Use createPreservedSelection to get properly expanded block boundaries
    const preservedSelection = (0, $d37e2d7c197cf61b$export$fa43757966d274e3)(selection.$from, selection.$to);
    if (!preservedSelection) return undefined;
    return {
        from: preservedSelection.from,
        to: preservedSelection.to
    };
};
const $fb7c69702c6d579c$export$6e259a78a1c38d78 = ($currentNodePos, currentNodePos)=>{
    const nodeIndex = $currentNodePos.index();
    const nodeBefore = $currentNodePos.depth > 1 && nodeIndex === 0 ? $currentNodePos.node($currentNodePos.depth) : $currentNodePos.nodeBefore;
    if (nodeBefore?.type.name === 'layoutColumn' && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) return -1;
    return nodeBefore ? currentNodePos - nodeBefore.nodeSize : -1;
};
const $fb7c69702c6d579c$export$3545fa32cdadf3ca = ({ $currentNodePos: $currentNodePos, nodeAfterPos: nodeAfterPos, tr: tr })=>{
    const endOfDoc = $currentNodePos.end();
    if (nodeAfterPos > endOfDoc) return -1;
    const nodeAfter = tr.doc.nodeAt(nodeAfterPos);
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
        const nodeAtCurrentPos = tr.doc.nodeAt($currentNodePos.pos);
        // if move empty line down to another empty line, move to the position of the next empty line
        if (nodeAtCurrentPos?.content.size === 0 && nodeAtCurrentPos.type.name !== 'extension' && nodeAfter?.content.size === 0 && nodeAfter.type.name !== 'extension') return nodeAfterPos;
    }
    // if not the last node, move to the end of the next node
    return nodeAfter ? nodeAfterPos + nodeAfter.nodeSize : -1;
};
const $fb7c69702c6d579c$export$c6093962982030d2 = ({ currentNodePos: currentNodePos, moveToPos: moveToPos, tr: tr })=>{
    // only move the node if the destination is at the same depth, not support moving a nested node to a parent node
    return moveToPos > -1 && tr.doc.resolve(currentNodePos).depth === tr.doc.resolve(moveToPos).depth;
};
const $fb7c69702c6d579c$export$cc4db90b9d5a445a = (tr)=>{
    const nodeBounds = $fb7c69702c6d579c$export$c57c553e4ac98a48(tr.selection);
    if (!nodeBounds || nodeBounds.from <= -1) return {
        moveUp: false,
        moveDown: false
    };
    const currentNodePos = nodeBounds.from;
    const $currentNodePos = tr.doc.resolve(currentNodePos);
    const nodeAfterPos = nodeBounds.to;
    const moveUpPos = $fb7c69702c6d579c$export$6e259a78a1c38d78($currentNodePos, currentNodePos);
    const moveDownPos = $fb7c69702c6d579c$export$3545fa32cdadf3ca({
        $currentNodePos: $currentNodePos,
        nodeAfterPos: nodeAfterPos,
        tr: tr
    });
    return {
        moveUp: $fb7c69702c6d579c$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveUpPos,
            tr: tr
        }),
        moveDown: $fb7c69702c6d579c$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveDownPos,
            tr: tr
        })
    };
};


/**
 * This function transforms the slice to move
 * @param nodeCopy The slice contains the node to be moved
 * @param destType The type of the destiation node
 * @returns transformed slice or null if unable to
 */ function $5d42aac4ae65f87b$var$transformSourceSlice(nodeCopy, destType) {
    const srcNode = nodeCopy.content.firstChild;
    const schema = srcNode?.type.schema;
    if (!schema) return nodeCopy;
    const { doc: doc, layoutColumn: layoutColumn } = schema.nodes;
    const destTypeInTable = (0, $d389fba940977935$export$199dae4875feadcd)(destType);
    const destTypeInDocOrLayoutCol = [
        doc,
        layoutColumn
    ].includes(destType);
    // No need to loop over slice content if destination requires no transformations
    if (!destTypeInTable && !destTypeInDocOrLayoutCol) return nodeCopy;
    let containsExpand = false;
    let containsNestedExpand = false;
    for(let i = 0; i < nodeCopy.content.childCount; i++){
        const node = nodeCopy.content.child(i);
        if (node.type === schema.nodes.expand) containsExpand = true;
        else if (node.type === schema.nodes.nestedExpand) containsNestedExpand = true;
        if (containsExpand && containsNestedExpand) break;
    }
    if (containsExpand && destTypeInTable) return (0, $d389fba940977935$export$447e90e618548243)(nodeCopy);
    else if (containsNestedExpand && destTypeInDocOrLayoutCol) return (0, $hcbpx.transformSliceNestedExpandToExpand)(nodeCopy, schema);
    return nodeCopy;
}
const $5d42aac4ae65f87b$var$nodesSupportDragLayoutColumnInto = [
    'tableCell',
    'tableHeader',
    'panel',
    'expand',
    'nestedExpand'
];
const $5d42aac4ae65f87b$var$isDragLayoutColumnIntoSupportedNodes = ($from, $to)=>{
    const isTopLevel = $to.depth === 0;
    const isDragIntoNodes = $5d42aac4ae65f87b$var$nodesSupportDragLayoutColumnInto.includes($to.parent.type.name);
    const supportedCondition = isDragIntoNodes || isTopLevel;
    return $from.nodeAfter?.type.name === 'layoutColumn' && $from.parent.type.name === 'layoutSection' && supportedCondition;
};
/**
 *
 * @returns the start position of a node if the node can be moved, otherwise -1
 */ const $5d42aac4ae65f87b$var$getCurrentNodePos = (state)=>{
    const { selection: selection } = state;
    let currentNodePos = -1;
    // There are 3 cases when a node can be moved
    const focusedHandle = $5d42aac4ae65f87b$var$getFocusedHandle(state);
    if (focusedHandle) // 1. drag handle of the node is focused
    currentNodePos = focusedHandle.pos;
    else if ((0, $bMyNT.isInTable)(state)) {
        if ((0, $iYC9s.isTableSelected)(selection)) // We only move table node if it's fully selected
        // to avoid shortcut collision with table drag and drop
        currentNodePos = (0, $id9O1.findTable)(selection)?.pos ?? currentNodePos;
    } else if (!(state.selection instanceof (0, $adhil.GapCursorSelection))) {
        // 2. caret cursor is inside the node
        // 3. the start of the selection is inside the node
        currentNodePos = selection.$from.before(1);
        if (selection.$from.depth > 0) currentNodePos = (0, $b5c2a732510c94ee$export$35954ff4e514ba11)({
            selection: selection,
            schema: state.schema,
            resolve: state.doc.resolve.bind(state.doc)
        });
    }
    return currentNodePos;
};
const $5d42aac4ae65f87b$var$getFocusedHandle = (state)=>{
    const { activeNode: activeNode } = (0, $253f56923cf8d759$export$df61b30b684217c0).getState(state) || {};
    return activeNode && activeNode.handleOptions?.isFocused ? activeNode : undefined;
};
const $5d42aac4ae65f87b$export$3438b98b9a6e008b = (api, direction, formatMessage)=>{
    return (state)=>{
        const { selection: selection } = state;
        const isParentNodeOfTypeLayout = !!(0, $8m4tT.findParentNodeOfType)([
            state.schema.nodes.layoutSection
        ])(state.selection);
        const isMultiSelectEnabled = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
        const expandedSelection = (0, $l6okE.expandSelectionBounds)(selection.$anchor, selection.$head);
        const expandedAnchor = expandedSelection.$anchor.pos;
        const expandedHead = expandedSelection.$head.pos;
        let hoistedPos;
        const from = Math.min(expandedAnchor, expandedHead);
        // Nodes like lists nest within themselves, we need to find the top most position
        if (isParentNodeOfTypeLayout) {
            const LAYOUT_COL_DEPTH = 3;
            hoistedPos = state.doc.resolve(from).before(LAYOUT_COL_DEPTH);
        }
        const currentNodePos = isMultiSelectEnabled && !$5d42aac4ae65f87b$var$getFocusedHandle(state) && !selection.empty ? hoistedPos ?? from : $5d42aac4ae65f87b$var$getCurrentNodePos(state);
        if (currentNodePos > -1) {
            const $currentNodePos = state.doc.resolve(currentNodePos);
            const nodeAfterPos = isMultiSelectEnabled && !$5d42aac4ae65f87b$var$getFocusedHandle(state) ? Math.max(expandedAnchor, expandedHead) : $currentNodePos.posAtIndex($currentNodePos.index() + 1);
            const isTopLevelNode = $currentNodePos.depth === 0;
            let moveToPos = -1;
            const isLayoutColumnSelected = selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'layoutColumn';
            if (direction === (0, $ah4M9.DIRECTION).LEFT) {
                if (isTopLevelNode && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
                    const nodeBefore = $currentNodePos.nodeBefore;
                    if (nodeBefore) moveToPos = currentNodePos - nodeBefore.nodeSize;
                    if (moveToPos < 0) return false;
                    api?.core?.actions.execute(({ tr: tr })=>{
                        api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                            moveToEnd: true,
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $a673071a38c5eb36$export$fc81c36e83ce2f6b)(tr);
                        const mappedTo = insertColumnStep?.from;
                        (0, $a673071a38c5eb36$export$2e8776145e31b87)(tr, mappedTo, true);
                        return tr;
                    });
                    api?.core?.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    moveToPos = selection.from - ($currentNodePos.nodeBefore?.nodeSize || 1);
                    api?.core?.actions.execute(api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    // get the previous layoutSection node
                    const index = $currentNodePos.index($currentNodePos.depth - 1);
                    const grandParent = $currentNodePos.node($currentNodePos.depth - 1);
                    const previousNode = grandParent ? grandParent.maybeChild(index - 1) : null;
                    moveToPos = $currentNodePos.start() - (previousNode?.nodeSize || 1);
                }
            } else if (direction === (0, $ah4M9.DIRECTION).RIGHT) {
                if (isTopLevelNode && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
                    const endOfDoc = $currentNodePos.end();
                    moveToPos = $currentNodePos.posAtIndex($currentNodePos.index() + 1);
                    if (moveToPos >= endOfDoc) return false;
                    api?.core?.actions.execute(({ tr: tr })=>{
                        api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $a673071a38c5eb36$export$fc81c36e83ce2f6b)(tr);
                        const mappedTo = insertColumnStep?.from;
                        (0, $a673071a38c5eb36$export$2e8776145e31b87)(tr, mappedTo);
                        return tr;
                    });
                    api?.core?.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    const index = $currentNodePos.index($currentNodePos.depth);
                    const parent = $currentNodePos.node($currentNodePos.depth);
                    // get the next layoutColumn node
                    const nextNode = parent ? parent.maybeChild(index + 1) : null;
                    // if the current node is the last node, don't do anything
                    if (index >= parent.childCount - 1) // prevent event propagation to avoid moving the cursor and still select the node
                    return true;
                    const moveToEnd = index === parent.childCount - 2;
                    moveToPos = moveToEnd ? $currentNodePos.before() : selection.to + (nextNode?.nodeSize || 1);
                    api?.core?.actions.execute(api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                        moveToEnd: moveToEnd,
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    moveToPos = $currentNodePos.after($currentNodePos.depth) + 1;
                }
            } else if (direction === (0, $ah4M9.DIRECTION).UP) {
                if (isLayoutColumnSelected) moveToPos = $currentNodePos.start() - 1;
                else moveToPos = (0, $fb7c69702c6d579c$export$6e259a78a1c38d78)($currentNodePos, currentNodePos);
            } else {
                const endOfDoc = $currentNodePos.end();
                if (nodeAfterPos > endOfDoc) return false;
                if (isLayoutColumnSelected) moveToPos = state.selection.$from.end() + 1;
                else moveToPos = (0, $fb7c69702c6d579c$export$3545fa32cdadf3ca)({
                    $currentNodePos: $currentNodePos,
                    nodeAfterPos: nodeAfterPos,
                    tr: state.tr
                });
            }
            const nodeType = state.doc.nodeAt(currentNodePos)?.type.name;
            let shouldMoveNode = false;
            if (moveToPos > -1) {
                const isDestDepthSameAsSource = $currentNodePos.depth === state.doc.resolve(moveToPos).depth;
                const isSourceLayoutColumn = nodeType === 'layoutColumn';
                shouldMoveNode = isDestDepthSameAsSource || isSourceLayoutColumn;
            }
            const { $anchor: $newAnchor, $head: $newHead } = (0, $l6okE.expandSelectionBounds)($currentNodePos, selection.$to);
            if (shouldMoveNode) {
                api?.core?.actions.execute(({ tr: tr })=>{
                    api?.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    $5d42aac4ae65f87b$export$83751492c88cf2ca(api)(currentNodePos, moveToPos, (0, $d925B.INPUT_METHOD).SHORTCUT, formatMessage)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            } else if (nodeType && !isMultiSelectEnabled) {
                // If the node is first/last one, only select the node
                api?.core?.actions.execute(({ tr: tr })=>{
                    (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, currentNodePos, nodeType, api);
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            } else if (isMultiSelectEnabled) {
                api?.core?.actions.execute(({ tr: tr })=>{
                    api?.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            }
        }
        return false;
    };
};
const $5d42aac4ae65f87b$export$83751492c88cf2ca = (api)=>(start, to, inputMethod = (0, $d925B.INPUT_METHOD).DRAG_AND_DROP, formatMessage)=>({ tr: tr })=>{
            if (!api || start < 0 || to < 0) return tr;
            const handleNode = tr.doc.nodeAt(start);
            if (!handleNode) return tr;
            let sliceFrom = start;
            let sliceTo;
            let sourceNodeTypes, hasSelectedMultipleNodes;
            const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
            if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.setContentMoved()({
                tr: tr
            });
            const preservedSelection = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? api?.blockControls.sharedState.currentState()?.preservedSelection : undefined;
            if (preservedSelection) {
                const $from = tr.doc.resolve(Math.min(start, preservedSelection.from));
                const expandedRange = $from.blockRange(preservedSelection.$to);
                sliceFrom = expandedRange ? expandedRange.start : preservedSelection.from;
                sliceTo = expandedRange ? expandedRange.end : preservedSelection.to;
                const attributes = (0, $c506554d919477c1$export$9f4024dd9bfa7336)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            } else if (isMultiSelect) {
                const slicePosition = (0, $d37e2d7c197cf61b$export$5e3fa240bc795f26)(start, tr, api);
                sliceFrom = slicePosition.from;
                sliceTo = slicePosition.to;
                const attributes = (0, $c506554d919477c1$export$9f4024dd9bfa7336)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            } else {
                const size = handleNode?.nodeSize ?? 1;
                sliceTo = sliceFrom + size;
            }
            const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
            const $to = tr.doc.resolve(to);
            const $handlePos = tr.doc.resolve(start);
            const nodeCopy = tr.doc.slice(sliceFrom, sliceTo, false); // cut the content
            const destNode = $to.node();
            const destType = destNode.type;
            const destParent = $to.node($to.depth);
            const sourceNode = $handlePos.nodeAfter;
            //TODO: ED-26959 - Does this need to be updated with new selection logic above? ^
            // Move a layout column to top level, or table cell, or panel, or expand, only moves the content into them
            if (sourceNode && $5d42aac4ae65f87b$var$isDragLayoutColumnIntoSupportedNodes($handlePos, $to)) {
                // need update after we support single column layout.
                const layoutColumnContent = sourceNode.content;
                let fragment;
                // if drop into table, and layout column contains expand, transform it to nestedExpand
                if ([
                    'tableCell',
                    'tableHeader'
                ].includes($to.parent.type.name)) {
                    const contentContainsExpand = (0, $8m4tT.findChildrenByType)(sourceNode, expand).length > 0;
                    fragment = contentContainsExpand ? (0, $d389fba940977935$export$ca1d8e12fb5b3277)((0, $5SAOw.Fragment).from(layoutColumnContent)) : (0, $5SAOw.Fragment).from(layoutColumnContent);
                    if (!fragment) return tr;
                } else fragment = (0, $5SAOw.Fragment).from(layoutColumnContent);
                (0, $ea3d65f7aba7472e$export$29bd206d467fd44)(tr, $handlePos, $handlePos.pos + sourceNode.nodeSize);
                const mappedTo = tr.mapping.map(to);
                tr.insert(mappedTo, fragment).setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(mappedTo))).scrollIntoView();
                return tr;
            }
            if (!(0, $d389fba940977935$export$918b4fd27bccdab5)(destParent, $to.index(), $handlePos.node().child($handlePos.index()), $to)) return tr;
            let convertedNodeSlice = $5d42aac4ae65f87b$var$transformSourceSlice(nodeCopy, destType);
            let convertedNode = convertedNodeSlice?.content;
            if (!convertedNode) return tr;
            // Currently we don't support breakout mark for children nodes of bodiedSyncBlock node
            // Hence strip out the mark for now
            if (destNode.type.name === 'bodiedSyncBlock' && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
                const nodes = [];
                convertedNodeSlice?.content.forEach((node)=>{
                    nodes.push(node.mark(node.marks.filter((mark)=>mark.type.name !== 'breakout')));
                });
                convertedNodeSlice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0);
                convertedNode = convertedNodeSlice.content;
            }
            // delete the content from the original position
            tr.delete(sliceFrom, sliceTo);
            const mappedTo = tr.mapping.map(to);
            const isDestNestedLoneEmptyParagraph = destParent.type.name !== 'doc' && destParent.childCount === 1 && (0, $l9G9n.isEmptyParagraph)($to.nodeAfter);
            if (convertedNodeSlice && isDestNestedLoneEmptyParagraph) // if only a single empty paragraph within container, replace it
            tr.replace(mappedTo, mappedTo + 1, convertedNodeSlice);
            else // otherwise just insert the content at the new position
            tr.insert(mappedTo, convertedNode);
            const sliceSize = sliceTo - sliceFrom;
            if (inputMethod === (0, $d925B.INPUT_METHOD).DRAG_AND_DROP) tr = (0, $b9aa051abc8155ab$export$4b5c09668d5b4e01)(tr, mappedTo, api);
            else if (preservedSelection) {
                const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
                const nodeMovedOffset = mappedTo - sliceFrom;
                tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                    ...currMeta,
                    preservedSelectionMapping: new (0, $aXG5V.Mapping)([
                        new (0, $aXG5V.StepMap)([
                            0,
                            0,
                            nodeMovedOffset
                        ])
                    ])
                });
            } else if (isMultiSelect) tr = api?.blockControls.commands.setMultiSelectPositions(mappedTo, mappedTo + sliceSize)({
                tr: tr
            }) ?? tr;
            else tr = (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, mappedTo, handleNode.type.name, api);
            const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
            tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                ...currMeta,
                nodeMoved: true
            });
            if (// when move node via block menu, we need to keep the focus on block menu popup, so don't move focus to editor in this scenario
            !(inputMethod === (0, $d925B.INPUT_METHOD).BLOCK_MENU && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true))) api?.core.actions.focus();
            const $mappedTo = tr.doc.resolve(mappedTo);
            const expandAncestor = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($to, [
                expand,
                nestedExpand
            ]);
            if (expandAncestor) {
                const wasExpandExpanded = (0, $adayn.expandedState).get(expandAncestor.node);
                const updatedExpandAncestor = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($mappedTo, [
                    expand,
                    nestedExpand
                ]);
                if (wasExpandExpanded !== undefined && updatedExpandAncestor) (0, $adayn.expandedState).set(updatedExpandAncestor.node, wasExpandExpanded);
            }
            if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) (0, $c506554d919477c1$export$991fd708287269fd)(tr, inputMethod, $handlePos.depth, handleNode.type.name, $mappedTo?.depth, $mappedTo?.parent.type.name, $handlePos.sameParent($mappedTo), api, sourceNodeTypes, hasSelectedMultipleNodes);
            else api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).MOVED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: $handlePos.depth,
                    nodeType: handleNode.type.name,
                    destinationNodeDepth: $mappedTo?.depth,
                    destinationNodeType: $mappedTo?.parent.type.name,
                    inputMethod: inputMethod,
                    ...isMultiSelect && {
                        sourceNodeTypes: sourceNodeTypes,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    }
                }
            })(tr);
            const movedMessage = to > sliceFrom ? (0, $dwl7L.messages).movedDown : (0, $dwl7L.messages).movedup;
            api?.accessibilityUtils?.actions.ariaNotify(formatMessage ? formatMessage(movedMessage) : movedMessage.defaultMessage, {
                priority: 'important'
            });
            return tr;
        };












const $d77b48bf18c5b4f8$var$findParentPosForHandle = (state)=>{
    const { selection: { $from: $from } } = state;
    const { activeNode: activeNode } = (0, $253f56923cf8d759$export$df61b30b684217c0).getState(state) || {};
    // if a node handle is already focused, return the parent pos of that node (with focused handle)
    if (activeNode && activeNode.handleOptions?.isFocused) {
        const $activeNodePos = state.doc.resolve(activeNode.pos);
        // if the handle is at the top level already, do nothing
        if ($activeNodePos.depth === 0) return undefined;
        return $activeNodePos.before();
    }
    // if we are in second level of nested node, we should focus the node at level 1
    if ($from.depth <= 1) return $from.before(1);
    // if we are inside a table, we should focus the table's handle
    const parentTableNode = (0, $8m4tT.findParentNodeOfType)([
        state.schema.nodes.table
    ])(state.selection);
    if (parentTableNode) return parentTableNode.pos;
    // else find closest parent node
    return (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? // as opposed to old approach, node decoration is only added to the node that have drag handle,
    // hence, we need to return the exact position of the node that can have drag handle
    (0, $b5c2a732510c94ee$export$ac406f4d57a10c33)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    }) : (0, $b5c2a732510c94ee$export$35954ff4e514ba11)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    });
};
const $d77b48bf18c5b4f8$var$findNextAnchorDecoration = (state)=>{
    const decorations = (0, $253f56923cf8d759$export$968abecb43309c32)(state);
    if (!decorations) return undefined;
    const nextHandleNodePos = $d77b48bf18c5b4f8$var$findParentPosForHandle(state);
    if (nextHandleNodePos === undefined) return undefined;
    const nextHandleNode = state.doc.nodeAt(nextHandleNodePos);
    let nodeDecorations = nextHandleNode && (0, $8653f788c2b076b7$export$562fc95beb8a58d3)(state, decorations, nextHandleNodePos, nextHandleNodePos + nextHandleNode.nodeSize);
    if (!nodeDecorations || nodeDecorations.length === 0) return undefined;
    // ensure the decoration covers the position of the look up node
    nodeDecorations = nodeDecorations.filter((decoration)=>{
        return decoration.from <= nextHandleNodePos;
    });
    if (nodeDecorations.length === 0) return undefined;
    // sort the decorations by the position of the node
    // so we can find the closest decoration to the node
    nodeDecorations.sort((a, b)=>{
        if (a.from === b.from) return a.to - b.to;
        return b.from - a.from;
    });
    // return the closest decoration to the node
    return nodeDecorations[0];
};
const $d77b48bf18c5b4f8$var$findNextAnchorNode = (view)=>{
    const nextHandleNodePos = $d77b48bf18c5b4f8$var$findParentPosForHandle(view.state);
    if (nextHandleNodePos === undefined) return undefined;
    const dom = view.nodeDOM(nextHandleNodePos);
    if (!(dom instanceof HTMLElement)) return undefined;
    const nodeDOM = dom.closest(`[${(0, $d89c90893897930c$export$ea34df48337a3b78)}]`);
    if (!nodeDOM) return undefined;
    const nodeType = nodeDOM?.getAttribute((0, $d89c90893897930c$export$195bd9e1fd438938));
    const anchorName = nodeDOM?.getAttribute((0, $d89c90893897930c$export$ea34df48337a3b78));
    if (nodeType && anchorName) return {
        pos: nextHandleNodePos,
        nodeType: nodeType,
        anchorName: anchorName
    };
};
const $d77b48bf18c5b4f8$export$c78ece06e89c3c69 = (api)=>(state, _, view)=>{
        if (view && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            const anchorNode = $d77b48bf18c5b4f8$var$findNextAnchorNode(view);
            if (api && anchorNode) {
                const { pos: pos, anchorName: anchorName, nodeType: nodeType } = anchorNode;
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(pos, anchorName, nodeType, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        } else {
            const decoration = $d77b48bf18c5b4f8$var$findNextAnchorDecoration(state);
            if (api && decoration) {
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(decoration.from, decoration.spec.anchorName, decoration.spec.nodeTypeWithLevel, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        }
    };


function $81fcabb5fcc6909d$var$keymapList(api, formatMessage) {
    const keymapList = {};
    if (api) {
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.showElementDragHandle).common, (state, dispatch, view)=>{
            (0, $d77b48bf18c5b4f8$export$c78ece06e89c3c69)(api)(state, dispatch, view);
            //we always want to handle this shortcut to prevent default browser special char insert when option + alphabetical key is used
            return true;
        }, keymapList);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.dragToMoveUp).common, (0, $5d42aac4ae65f87b$export$3438b98b9a6e008b)(api, (0, $ah4M9.DIRECTION).UP, formatMessage), keymapList);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.dragToMoveDown).common, (0, $5d42aac4ae65f87b$export$3438b98b9a6e008b)(api, (0, $ah4M9.DIRECTION).DOWN, formatMessage), keymapList);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.dragToMoveLeft).common, (0, $5d42aac4ae65f87b$export$3438b98b9a6e008b)(api, (0, $ah4M9.DIRECTION).LEFT, formatMessage), keymapList);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.dragToMoveRight).common, (0, $5d42aac4ae65f87b$export$3438b98b9a6e008b)(api, (0, $ah4M9.DIRECTION).RIGHT, formatMessage), keymapList);
    }
    return keymapList;
}
const $81fcabb5fcc6909d$export$2734319938f9e9db = (api, formatMessage)=>(0, $dus6D.keydownHandler)($81fcabb5fcc6909d$var$keymapList(api, formatMessage));










const $8f771171aeccd7a7$export$3e44da64b47beb51 = (s)=>{
    const content = s.slice.content.firstChild;
    return s.from === s.to && s.slice.content.childCount === 1 && !!content && !!content.text;
};
const $8f771171aeccd7a7$export$84cb963246195c8 = (s)=>{
    const content = s.slice.content;
    return s.to === s.from + 1 && content.size === 0;
};
/**
 * Check if content being replaced is replaced with another of the same size
 * This can occur on empty docs and 'backspace' is pressed, the paragraph node is re-drawn
 * @param s
 * @returns True if content being replaced is replaced with another of the same size
 */ const $8f771171aeccd7a7$var$isStepContentReplacedWithAnotherOfSameSize = (s)=>{
    if (s instanceof (0, $aXG5V.ReplaceAroundStep)) {
        const replacedContentSize = s.to - s.from;
        return s.slice.content.size === replacedContentSize;
    }
    return false;
};
const $8f771171aeccd7a7$export$5a67a4a1d2fbf068 = (tr, flags)=>{
    let from;
    let to;
    let numReplaceSteps = 0;
    let isAllText = true;
    let isReplacedWithSameSize = false;
    tr.steps.forEach((s)=>{
        if (s instanceof (0, $aXG5V.ReplaceStep) || s instanceof (0, $aXG5V.ReplaceAroundStep)) {
            if (s instanceof (0, $aXG5V.ReplaceAroundStep) || s instanceof (0, $aXG5V.ReplaceStep) && !$8f771171aeccd7a7$export$3e44da64b47beb51(s) && !$8f771171aeccd7a7$export$84cb963246195c8(s)) isAllText = false;
            // Fixes drag handle and quick insert button overlap issues
            if (flags.toolbarFlagsEnabled) // platform_editor_controls note: fixes drag handle and quick insert button overlap issues
            isReplacedWithSameSize = $8f771171aeccd7a7$var$isStepContentReplacedWithAnotherOfSameSize(s);
            const mappedTo = tr.mapping.map(s.to);
            let $to = s.from + s.slice.size;
            $to = $to > mappedTo ? $to : mappedTo;
            from = from === undefined || from > s.from ? s.from : from;
            to = to === undefined || to < $to ? $to : to;
            numReplaceSteps++;
        }
    });
    if (from === undefined) from = 0;
    if (to === undefined || to > tr.doc.nodeSize - 2) to = tr.doc.nodeSize - 2;
    return {
        from: from,
        to: to,
        numReplaceSteps: numReplaceSteps,
        isAllText: isAllText,
        isReplacedWithSameSize: isReplacedWithSameSize
    };
};


const $253f56923cf8d759$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('blockControls');
const $253f56923cf8d759$var$EDITOR_BLOCKS_DRAG_INIT = 'Editor Blocks Drag Initialization Time';
const $253f56923cf8d759$var$EDITOR_BLOCKS_DROP_INIT = 'Editor Blocks Drop Initialization Time';
const $253f56923cf8d759$var$scheduleCallback = (cb, options)=>{
    return 'requestIdleCallback' in window ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $253f56923cf8d759$var$isHTMLElement = (element)=>{
    return element instanceof HTMLElement;
};
const $253f56923cf8d759$var$destroyFn = (api, editorView)=>{
    const scrollable = document.querySelector('.fabric-editor-popup-scroll-parent');
    const cleanupFn = [];
    if (scrollable) cleanupFn.push((0, $51lK8.autoScrollForElements)({
        element: scrollable
    }));
    let dragInitializationDuration = 0;
    cleanupFn.push((0, $4T4vf.monitorForElements)({
        canMonitor: ({ source: source })=>source.data.type === 'element',
        onDrag: ()=>{
            if ((0, $dh538.fg)('platform_editor_drag_and_drop_perf_analytics')) {
                if ((0, $2T4ch.isMeasuring)($253f56923cf8d759$var$EDITOR_BLOCKS_DRAG_INIT)) (0, $2T4ch.stopMeasure)($253f56923cf8d759$var$EDITOR_BLOCKS_DRAG_INIT, (duration)=>{
                    dragInitializationDuration = duration;
                });
            } else if ((0, $2T4ch.isMeasuring)($253f56923cf8d759$var$EDITOR_BLOCKS_DRAG_INIT)) (0, $2T4ch.stopMeasure)($253f56923cf8d759$var$EDITOR_BLOCKS_DRAG_INIT, (duration, startTime)=>{
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).BLOCKS_DRAG_INIT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodesCount: editorView?.state.doc.nodeSize
                    }
                });
            });
        },
        onDragStart: ()=>{
            if ($253f56923cf8d759$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', 'unset');
        },
        onDrop: ({ location: location, source: source })=>{
            if ($253f56923cf8d759$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', null);
            if ((0, $dh538.fg)('platform_editor_drag_and_drop_perf_analytics')) (0, $2T4ch.startMeasure)($253f56923cf8d759$var$EDITOR_BLOCKS_DROP_INIT);
            if (!api) return;
            api.core?.actions.execute(({ tr: tr })=>{
                const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
                if (isMultiSelect) {
                    const { multiSelectDnD: multiSelectDnD } = api.blockControls?.sharedState.currentState() || {};
                    // Restore the users initial Editor selection when the drop completes
                    if (multiSelectDnD) {
                        // If the TextSelection between the drag start and end has changed, the document has changed, and we should not reapply the last selection
                        const expandedSelectionUnchanged = multiSelectDnD.textAnchor === tr.selection.anchor && multiSelectDnD.textHead === tr.selection.head;
                        if (expandedSelectionUnchanged) {
                            const $anchor = tr.doc.resolve(multiSelectDnD.userAnchor);
                            const $head = tr.doc.resolve(multiSelectDnD.userHead);
                            if ($head.node() === $anchor.node()) {
                                const $from = $anchor.min($head);
                                (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, $from.pos, $from.node().type.name, api);
                            } else tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, multiSelectDnD.userAnchor, multiSelectDnD.userHead));
                        }
                    }
                    api.selection?.commands.clearManualSelection()({
                        tr: tr
                    });
                }
                const { start: start } = source.data;
                // if no drop targets are rendered, assume that drop is invalid
                const lastDragCancelled = location.current.dropTargets.length === 0;
                if (lastDragCancelled) {
                    let nodeTypes, hasSelectedMultipleNodes;
                    if (isMultiSelect) {
                        const position = (0, $d37e2d7c197cf61b$export$5e3fa240bc795f26)(start, tr, api);
                        const attributes = (0, $c506554d919477c1$export$9f4024dd9bfa7336)(tr, position.from, position.to);
                        nodeTypes = attributes.nodeTypes;
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                    }
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const maybeNode = resolvedMovingNode.nodeAfter;
                    api.analytics?.actions.attachAnalyticsEvent({
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        action: (0, $d925B.ACTION).CANCELLED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeType: maybeNode?.type.name || '',
                            ...isMultiSelect && {
                                nodeTypes: nodeTypes,
                                hasSelectedMultipleNodes: hasSelectedMultipleNodes
                            }
                        }
                    })(tr);
                }
                if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api.metrics?.commands.startActiveSessionTimer()({
                    tr: tr
                });
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                    ...tr.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                    isDragging: false,
                    isPMDragging: false,
                    lastDragCancelled: lastDragCancelled
                });
            });
            if ((0, $dh538.fg)('platform_editor_drag_and_drop_perf_analytics')) // wait for the idle callback to ensure that the drag operation has completed
            $253f56923cf8d759$var$scheduleCallback(()=>{
                if ((0, $2T4ch.isMeasuring)($253f56923cf8d759$var$EDITOR_BLOCKS_DROP_INIT)) (0, $2T4ch.stopMeasure)($253f56923cf8d759$var$EDITOR_BLOCKS_DROP_INIT, (duration)=>{
                    const isCancelled = location.current.dropTargets.length === 0;
                    api?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).ENDED,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            dragInitializationDuration: dragInitializationDuration,
                            dropProcessingDuration: duration,
                            isCancelled: isCancelled,
                            nodesCount: editorView?.state.doc.nodeSize
                        }
                    });
                });
            });
        }
    }));
    return (0, $bSjaC.combine)(...cleanupFn);
};
const $253f56923cf8d759$var$initialState = {
    decorations: (0, $ftzrq.DecorationSet).empty,
    activeNode: undefined,
    isDragging: false,
    isMenuOpen: false,
    editorHeight: 0,
    editorWidthLeft: 0,
    editorWidthRight: 0,
    isResizerResizing: false,
    isDocSizeLimitEnabled: null,
    isPMDragging: false,
    multiSelectDnD: undefined,
    lastDragCancelled: false,
    isSelectedViaDragHandle: false
};
const $253f56923cf8d759$export$968abecb43309c32 = (state)=>$253f56923cf8d759$export$df61b30b684217c0.getState(state)?.decorations;
const $253f56923cf8d759$var$getDecorationAtPos = (state, decorations, pos, to)=>{
    // Find the newly minted node decs that touch the active node
    const findNewNodeDecs = (0, $8653f788c2b076b7$export$562fc95beb8a58d3)(state, decorations, (0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) ? pos : pos - 1, to);
    // Find the specific dec that the active node corresponds to
    const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>dec?.from === pos);
    // If multiple decorations at the active node pos, we want the last one
    const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
    return nodeDecAtActivePos;
};
const $253f56923cf8d759$export$5635d7ef4b8fee1c = (api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, anchorRectCache, resizeObserverWidth, pragmaticCleanup)=>{
    let { activeNode: activeNode, decorations: decorations, isResizerResizing: isResizerResizing, multiSelectDnD: multiSelectDnD } = currentState;
    const { editorHeight: editorHeight, editorWidthLeft: editorWidthLeft, editorWidthRight: editorWidthRight, isDragging: isDragging, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, menuTriggerByNode: menuTriggerByNode, blockMenuOptions: blockMenuOptions, isPMDragging: isPMDragging, isShiftDown: isShiftDown, lastDragCancelled: lastDragCancelled, isSelectedViaDragHandle: isSelectedViaDragHandle } = currentState;
    let isActiveNodeDeleted = false;
    const { from: from, to: to, numReplaceSteps: numReplaceSteps, isAllText: isAllText, isReplacedWithSameSize: isReplacedWithSameSize } = (0, $8f771171aeccd7a7$export$5a67a4a1d2fbf068)(tr, flags);
    const meta = tr.getMeta($253f56923cf8d759$export$df61b30b684217c0);
    const hasDocumentSizeBreachedThreshold = api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(newState)?.documentSizeBreachesThreshold;
    if (hasDocumentSizeBreachedThreshold) {
        /**
     * INFO: This if statement is a duplicate of the logic in destroy(). When the threshold is breached and we enter limited mode, we want to trigger the cleanup logic in destroy().
     */ const editorContentArea = document.querySelector('.fabric-editor-popup-scroll-parent');
        if (editorContentArea && resizeObserverWidth) resizeObserverWidth.unobserve(editorContentArea);
        pragmaticCleanup?.();
        return currentState;
    }
    // When steps exist, remap existing decorations, activeNode and multi select positions
    if (tr.docChanged) {
        decorations = decorations.map(tr.mapping, tr.doc);
        // platform_editor_controls note: enables quick insert
        // don't remap activeNode if it's being dragged
        if (!flags.toolbarFlagsEnabled) {
            if (activeNode) {
                const mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
                activeNode = {
                    pos: mappedPos.pos,
                    anchorName: activeNode.anchorName,
                    nodeType: activeNode.nodeType
                };
            }
        } else if (activeNode && meta?.isDragging !== true) {
            let mappedPos;
            const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
            // In safari, when platform_editor_controls is on,
            // sometimes the drag handle for the layout disppears after you click on the handle for a few times
            // Which caused the drag handle onClick event not firing, then block menu wouldn't be opened
            // This is caused by the mappedPos.deletedAfter sometimes returning true in webkit browsers even though the active node still exists
            // This is likely a prosemirror and safari integration bug, but to unblock the issue, we are going to use mappedPos.deleted in safari for now
            if (browser.webkit && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
                mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
            } else {
                mappedPos = tr.mapping.mapResult(activeNode.pos, -1);
                isActiveNodeDeleted = mappedPos.deletedAfter;
            }
            // for editor controls, remap the rootPos as well
            let mappedRootPos;
            if (activeNode.rootPos !== undefined) mappedRootPos = tr.mapping.mapResult(activeNode.rootPos, -1);
            activeNode = {
                pos: mappedPos.pos,
                anchorName: activeNode.anchorName,
                nodeType: activeNode.nodeType,
                rootPos: mappedRootPos?.pos ?? activeNode.rootPos,
                rootAnchorName: activeNode.rootAnchorName,
                rootNodeType: activeNode.rootNodeType
            };
        }
        if (multiSelectDnD && flags.isMultiSelectEnabled) {
            multiSelectDnD.anchor = tr.mapping.map(multiSelectDnD.anchor);
            multiSelectDnD.head = tr.mapping.map(multiSelectDnD.head);
        }
    }
    const resizerMeta = tr.getMeta('is-resizer-resizing');
    isResizerResizing = resizerMeta ?? isResizerResizing;
    const hasJustFinishedResizing = resizerMeta === false;
    multiSelectDnD = meta?.multiSelectDnD ?? multiSelectDnD;
    if (multiSelectDnD && flags.isMultiSelectEnabled) {
        if ((meta?.isDragging ?? isDragging) && (0, $1oCLl.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // When dragging, we want to keep the multiSelectDnD object unless both document and selection
            // has changed, in which case we want to reset it.
            const shouldResetMultiSelectDnD = tr.docChanged && tr.selectionSet && tr.selection.empty;
            multiSelectDnD = shouldResetMultiSelectDnD ? undefined : multiSelectDnD;
        } else multiSelectDnD = meta?.isDragging === false || tr.selection.empty ? undefined : multiSelectDnD;
    }
    const maybeNodeCountChanged = !isAllText && numReplaceSteps > 0;
    let latestActiveNode = meta?.activeNode;
    if (!latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) latestActiveNode = activeNode;
    // Re-create node decorations
    const isDecSetEmpty = decorations === (0, $ftzrq.DecorationSet).empty;
    const isNodeDecsMissing = isDecSetEmpty || maybeNodeCountChanged || (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) && hasJustFinishedResizing;
    const shouldRedrawNodeDecs = !isResizerResizing && (isNodeDecsMissing || meta?.isDragging) && // Skip expensive anchor node decoration recalculations when native anchor support is enabled
    !((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $dh538.fg)('editor_native_anchor_remove_decoration_in_apply'));
    let isActiveNodeModified = false;
    if (api && shouldRedrawNodeDecs) {
        const oldNodeDecs = (0, $8653f788c2b076b7$export$562fc95beb8a58d3)(newState, decorations, from, to);
        decorations = decorations.remove(oldNodeDecs);
        const newNodeDecs = (0, $8653f788c2b076b7$export$a3bb13b1e97d70c7)(newState, isDecSetEmpty ? undefined : from, isDecSetEmpty ? undefined : to);
        decorations = decorations.add(newState.doc, newNodeDecs);
        // platform_editor_controls note: enables quick insert
        if (!flags.toolbarFlagsEnabled) {
            if (latestActiveNode && !isActiveNodeDeleted) {
                // Find the newly minted node decs that touch the active node
                const findNewNodeDecs = (0, $8653f788c2b076b7$export$562fc95beb8a58d3)(newState, decorations, (0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) ? latestActiveNode.pos : latestActiveNode.pos - 1, to);
                // Find the specific dec that the active node corresponds to
                const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>dec?.from === latestActiveNode.pos);
                // If multiple decorations at the active node pos, we want the last one
                const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
                // Update the active node anchor-name and type for accurate positioning
                if (nodeDecAtActivePos) {
                    isActiveNodeModified = true;
                    latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                    latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
                }
            }
        } else if (latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) {
            const nodeDecAtActivePos = $253f56923cf8d759$var$getDecorationAtPos(newState, decorations, latestActiveNode.pos, to);
            const rootNodeDecAtActivePos = $253f56923cf8d759$var$getDecorationAtPos(newState, decorations, latestActiveNode.rootPos, to);
            if (nodeDecAtActivePos || rootNodeDecAtActivePos) isActiveNodeModified = true;
            // Update the active node anchor-name and type for accurate positioning
            if (nodeDecAtActivePos) {
                latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
            }
            if (rootNodeDecAtActivePos) {
                latestActiveNode.rootAnchorName = rootNodeDecAtActivePos.spec.anchorName;
                latestActiveNode.rootNodeType = rootNodeDecAtActivePos.spec.nodeType;
            }
        }
    }
    // Check if editor dimensions have changed
    const editorSizeChanged = meta?.editorHeight !== undefined && meta?.editorHeight !== editorHeight || meta?.editorWidthLeft !== undefined && meta?.editorWidthLeft !== editorWidthLeft || meta?.editorWidthRight !== undefined && meta?.editorWidthRight !== editorWidthRight;
    // Check if there's a new active node, and it differs from the last
    const activeNodeChanged = meta?.activeNode && (meta?.activeNode.pos !== activeNode?.pos && meta?.activeNode.anchorName !== activeNode?.anchorName || meta?.activeNode.handleOptions?.isFocused);
    const rootActiveNodeChanged = meta?.activeNode && meta?.activeNode.rootPos !== activeNode?.rootPos && meta?.activeNode.rootAnchorName !== activeNode?.rootAnchorName;
    // Some browsers don't support anchor positioning, meaning we need to replace the handle when nodes change
    const handleNeedsRedraw = shouldRedrawNodeDecs && !(0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)();
    // Create/recreate handle dec when the active node is missing/changes, or the editor viewport has changed (non-anchor pos workaround)
    const shouldRecreateHandle = latestActiveNode && (activeNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    const shouldRecreateQuickInsertButton = latestActiveNode && (rootActiveNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    // If the active node is missing, we need to remove the handle
    let shouldRemoveHandle = latestActiveNode ? isResizerResizing || isActiveNodeDeleted && !isReplacedWithSameSize || meta?.nodeMoved : true;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) // Remove handle dec when editor is blurred
    shouldRemoveHandle = shouldRemoveHandle || meta?.editorBlurred;
    if (shouldRemoveHandle) {
        const oldHandle = (0, $07725a88f79f2db7$export$3ec2b0df4b056a96)(decorations, activeNode?.pos, activeNode?.pos);
        decorations = decorations.remove(oldHandle);
        // platform_editor_controls note: enables quick insert
        if (flags.toolbarFlagsEnabled) {
            const oldQuickInsertButton = (0, $4990d45fb705f5de$export$a6ab3402831bd7d8)(decorations, activeNode?.rootPos, activeNode?.rootPos);
            decorations = decorations.remove(oldQuickInsertButton);
        }
    } else if (api) {
        if (shouldRecreateHandle) {
            const oldHandle = (0, $07725a88f79f2db7$export$3ec2b0df4b056a96)(decorations, activeNode?.pos, activeNode?.pos);
            decorations = decorations.remove(oldHandle);
            const handleDec = (0, $07725a88f79f2db7$export$38a5c9b9faf26cd8)({
                api: api,
                formatMessage: formatMessage,
                pos: latestActiveNode?.pos,
                anchorName: latestActiveNode?.anchorName,
                nodeType: latestActiveNode?.nodeType,
                handleOptions: latestActiveNode?.handleOptions,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                anchorRectCache: anchorRectCache,
                editorState: newState
            });
            decorations = decorations.add(newState.doc, [
                handleDec
            ]);
        }
        if (shouldRecreateQuickInsertButton && latestActiveNode?.rootPos !== undefined && // platform_editor_controls note: enables quick insert
        flags.toolbarFlagsEnabled) {
            const oldQuickInsertButton = (0, $4990d45fb705f5de$export$a6ab3402831bd7d8)(decorations, activeNode?.rootPos, activeNode?.rootPos);
            decorations = decorations.remove(oldQuickInsertButton);
            const quickInsertButton = (0, $4990d45fb705f5de$export$ab399427af69a61)({
                api: api,
                formatMessage: formatMessage,
                anchorName: latestActiveNode?.anchorName,
                nodeType: latestActiveNode?.nodeType,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                rootPos: latestActiveNode?.rootPos,
                rootAnchorName: latestActiveNode?.rootAnchorName,
                rootNodeType: latestActiveNode?.rootNodeType,
                anchorRectCache: anchorRectCache,
                editorState: newState
            });
            decorations = decorations.add(newState.doc, [
                quickInsertButton
            ]);
        }
    }
    // Drop targets may be missing when the node count is being changed during a drag
    const isDropTargetsMissing = (meta?.isDragging ?? isDragging) && maybeNodeCountChanged && !meta?.nodeMoved;
    // Remove drop target decorations when dragging stops or they need to be redrawn
    if (meta?.isDragging === false || isDropTargetsMissing) {
        const dropTargetDecs = (0, $79ac2953323ad1e7$export$99bd791313c07808)(decorations);
        decorations = decorations.remove(dropTargetDecs);
    }
    let currentActiveDropTargetNode = isDragging ? currentState.activeDropTargetNode : undefined;
    if (api) {
        if ((0, $1oCLl.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // If page is updated while dragging (likely by remote updates), we simply remove the drop targets
            // and add them back when the user interacts with the editor again
            if (isDropTargetsMissing) {
                const oldDropTargetDecs = (0, $79ac2953323ad1e7$export$99bd791313c07808)(decorations);
                decorations = decorations.remove(oldDropTargetDecs);
            }
            if (meta?.activeDropTargetNode) {
                currentActiveDropTargetNode = meta?.activeDropTargetNode;
                const oldDropTargetDecs = (0, $79ac2953323ad1e7$export$99bd791313c07808)(decorations);
                const { decsToAdd: decsToAdd, decsToRemove: decsToRemove } = (0, $db1bc3ef2f702e84$export$181f339130769cb6)(meta.activeDropTargetNode, newState, api, oldDropTargetDecs, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
                decorations = decorations.remove(decsToRemove);
                if (decsToAdd.length > 0) decorations = decorations.add(newState.doc, decsToAdd);
            }
        } else if (meta?.isDragging || isDropTargetsMissing) {
            // Add drop targets when dragging starts or some are missing
            const decs = (0, $79ac2953323ad1e7$export$248c2f3619ca4fdf)(newState, api, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
            decorations = decorations.add(newState.doc, decs);
        }
    }
    const isEmptyDoc = (0, $2pjJ5.isEmptyDocument)(newState.doc);
    if (isEmptyDoc && !(0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
        const hasNodeDecoration = !!(0, $8653f788c2b076b7$export$562fc95beb8a58d3)(newState, decorations).length;
        if (!hasNodeDecoration) decorations = decorations.add(newState.doc, [
            (0, $07725a88f79f2db7$export$613641ee4757989)()
        ]);
    }
    let newActiveNode;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) // remove isEmptyDoc check and let decorations render and determine their own visibility
    newActiveNode = !meta?.activeNode && (0, $07725a88f79f2db7$export$3ec2b0df4b056a96)(decorations, latestActiveNode?.pos, latestActiveNode?.pos).length === 0 ? null : latestActiveNode;
    else newActiveNode = isEmptyDoc || !meta?.activeNode && (0, $07725a88f79f2db7$export$3ec2b0df4b056a96)(decorations, latestActiveNode?.pos, latestActiveNode?.pos).length === 0 ? null : latestActiveNode;
    let isMenuOpenNew = isMenuOpen;
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) {
        if (meta?.closeMenu) isMenuOpenNew = false;
        else if (meta?.toggleMenu) {
            const isSameAnchor = meta?.toggleMenu.anchorName === menuTriggerBy;
            isMenuOpenNew = menuTriggerBy === undefined || isSameAnchor || !isMenuOpen && !isSameAnchor ? !isMenuOpen : isMenuOpen;
        }
    } else if (meta?.toggleMenu) isMenuOpenNew = !isMenuOpen;
    let isSelectedViaDragHandleNew;
    if (flags.toolbarFlagsEnabled && (0, $1oCLl.expValEquals)('platform_editor_controls_block_controls_state_fix', 'isEnabled', true)) isSelectedViaDragHandleNew = meta?.isSelectedViaDragHandle !== undefined ? meta?.isSelectedViaDragHandle : isSelectedViaDragHandle;
    else isSelectedViaDragHandleNew = meta?.isSelectedViaDragHandle !== undefined && flags.toolbarFlagsEnabled && meta?.isSelectedViaDragHandle;
    return {
        decorations: decorations,
        activeNode: newActiveNode,
        activeDropTargetNode: currentActiveDropTargetNode,
        isDragging: meta?.isDragging ?? isDragging,
        isMenuOpen: isMenuOpenNew,
        menuTriggerBy: flags.toolbarFlagsEnabled || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? meta?.toggleMenu?.anchorName || menuTriggerBy : undefined,
        menuTriggerByNode: (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? meta?.toggleMenu?.triggerByNode || menuTriggerByNode : undefined,
        blockMenuOptions: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? {
            canMoveUp: meta?.toggleMenu?.moveUp !== undefined ? meta?.toggleMenu?.moveUp : blockMenuOptions?.canMoveUp,
            canMoveDown: meta?.toggleMenu?.moveDown !== undefined ? meta?.toggleMenu?.moveDown : blockMenuOptions?.canMoveDown,
            openedViaKeyboard: meta?.toggleMenu?.openedViaKeyboard !== undefined ? meta?.toggleMenu?.openedViaKeyboard : blockMenuOptions?.openedViaKeyboard
        } : undefined,
        editorHeight: meta?.editorHeight ?? editorHeight,
        editorWidthLeft: meta?.editorWidthLeft ?? editorWidthLeft,
        editorWidthRight: meta?.editorWidthRight ?? editorWidthRight,
        isResizerResizing: isResizerResizing,
        isDocSizeLimitEnabled: $253f56923cf8d759$var$initialState.isDocSizeLimitEnabled,
        isPMDragging: meta?.isPMDragging ?? isPMDragging,
        multiSelectDnD: multiSelectDnD,
        isShiftDown: meta?.isShiftDown ?? isShiftDown,
        lastDragCancelled: meta?.lastDragCancelled ?? lastDragCancelled,
        isSelectedViaDragHandle: isSelectedViaDragHandleNew
    };
};
const $253f56923cf8d759$export$ae829ec7b2625219 = (api, getIntl, nodeViewPortalProviderAPI)=>{
    const { formatMessage: formatMessage } = getIntl();
    const isAdvancedLayoutEnabled = (0, $iu6m9.editorExperiment)('advanced_layouts', true, {
        exposure: true
    });
    const isMultiSelectEnabled = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true, {
        exposure: true
    });
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const flags = {
        isMultiSelectEnabled: isMultiSelectEnabled,
        toolbarFlagsEnabled: toolbarFlagsEnabled
    };
    let anchorRectCache;
    if (!(0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)()) anchorRectCache = new (0, $b0c29e8b0584a1ce$export$e1d230f644ff05aa)();
    let resizeObserverWidth;
    let pragmaticCleanup = null;
    return new (0, $1S4f7.SafePlugin)({
        key: $253f56923cf8d759$export$df61b30b684217c0,
        state: {
            init () {
                return $253f56923cf8d759$var$initialState;
            },
            apply: (tr, currentState, _, newState)=>$253f56923cf8d759$export$5635d7ef4b8fee1c(api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, anchorRectCache, resizeObserverWidth, pragmaticCleanup)
        },
        props: {
            decorations: (state)=>{
                if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                const isDisabled = api?.editorDisabled?.sharedState.currentState()?.editorDisabled;
                if (isDisabled) return;
                return $253f56923cf8d759$export$df61b30b684217c0.getState(state)?.decorations;
            },
            handleDOMEvents: {
                drop (view, event) {
                    // Prevent native DnD from triggering if we are in drag
                    const { dispatch: dispatch, dragging: dragging, state: state } = view;
                    const tr = state.tr;
                    let pluginState = $253f56923cf8d759$export$df61b30b684217c0.getState(state);
                    const dndDragCancelled = pluginState?.lastDragCancelled;
                    if (pluginState?.isPMDragging || dndDragCancelled && isMultiSelectEnabled) {
                        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        dispatch(tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                            ...tr.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                            isPMDragging: false,
                            lastDragCancelled: false
                        }));
                    }
                    pluginState = $253f56923cf8d759$export$df61b30b684217c0.getState(view.state);
                    if (!(event.target instanceof HTMLElement) || !pluginState?.activeNode) return false;
                    // Currently we can only drag one node at a time
                    // so we only need to check first child
                    const draggable = dragging?.slice.content.firstChild;
                    if (dndDragCancelled && isMultiSelectEnabled || draggable?.type.name === 'layoutColumn') {
                        // we prevent native DnD for layoutColumn to prevent single column layout.
                        event.preventDefault();
                        return false;
                    }
                    const nodeElement = event.target?.closest?.(`[${(0, $d89c90893897930c$export$684dbfb461b166c3)()}]`);
                    if (!nodeElement) return false;
                    // TODO: ED-26959 - Review usage of posAtDOM here
                    const domPos = Math.max(view.posAtDOM(nodeElement, 0) - 1, 0);
                    const nodeTarget = state.doc.nodeAt(domPos);
                    const isSameNode = !!(nodeTarget && draggable?.eq(nodeTarget));
                    if (isSameNode) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                dragenter (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if ($253f56923cf8d759$var$isHTMLElement(event.target) && (0, $1oCLl.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
                        const targetElement = event.target.closest('[data-prosemirror-node-name]');
                        if (targetElement) {
                            const nodeTypeName = targetElement?.getAttribute('data-prosemirror-node-name');
                            const pos = view.posAtDOM(targetElement, -1);
                            const currentActiveDropTargetNode = api?.blockControls.sharedState.currentState()?.activeDropTargetNode;
                            if (currentActiveDropTargetNode?.pos !== pos || currentActiveDropTargetNode?.nodeTypeName !== nodeTypeName) {
                                const activeDropTargetNode = {
                                    pos: pos,
                                    nodeTypeName: nodeTypeName
                                };
                                view.dispatch(view.state.tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                                    activeDropTargetNode: activeDropTargetNode
                                }));
                            }
                        }
                    } else if (isAdvancedLayoutEnabled) {
                        if ($253f56923cf8d759$var$isHTMLElement(event.target)) {
                            const closestParentElement = event.target.closest('[data-drag-handler-anchor-depth="0"]');
                            if (closestParentElement) {
                                const currentAnchor = closestParentElement.getAttribute((0, $d89c90893897930c$export$684dbfb461b166c3)());
                                if (currentAnchor) (0, $e89e2e6fe979fcda$export$73b394ea452decfd).emit(currentAnchor);
                            }
                        }
                    }
                },
                dragstart (view) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    (0, $2T4ch.startMeasure)($253f56923cf8d759$var$EDITOR_BLOCKS_DRAG_INIT);
                    if (isAdvancedLayoutEnabled) (0, $e89e2e6fe979fcda$export$73b394ea452decfd).reset();
                    if ((0, $1oCLl.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) anchorRectCache?.clear();
                    anchorRectCache?.setEditorView(view);
                    view.dispatch(view.state.tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                        isPMDragging: true
                    }));
                },
                dragend (view) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    const { state: state, dispatch: dispatch } = view;
                    if ($253f56923cf8d759$export$df61b30b684217c0.getState(state)?.isPMDragging) {
                        const tr = state.tr;
                        tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                            ...state.tr.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                            isPMDragging: false
                        });
                        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        dispatch(tr);
                    }
                },
                mouseover: (view, event)=>{
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    // another layer of protection to prevent handling mouseover
                    // when native anchor with dnd is enabled in limited mode
                    // in case there are descripancies between getNodeIdProvider limited mode state
                    if ((0, $b7atO.getNodeIdProvider)(view)?.isLimitedMode() && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_native_anchor_patch_2')) return;
                    (0, $326a8fb54153aacd$export$321c2da35903b013)(view, event, api);
                    return false;
                },
                mousedown: (view, event)=>{
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $d88d557fffb2fc39$export$b4a93e0b711d8f7)(api)(view, event) : undefined;
                },
                keydown (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if (isMultiSelectEnabled) {
                        if (event.shiftKey && event.ctrlKey) //prevent holding down key combo from firing repeatedly
                        {
                            if (!event.repeat && (0, $81fcabb5fcc6909d$export$2734319938f9e9db)(api, formatMessage)(view, event)) {
                                event.preventDefault();
                                return true;
                            }
                        }
                        if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLElement && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                            const isDragHandle = event.target.closest((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? (0, $Yqd3z.DRAG_HANDLE_SELECTOR) : '[data-editor-block-ctrl-drag-handle="true"]') !== null;
                            api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle));
                        }
                        if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowDown' || event.key === 'ArrowUp') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                            const isBlockMenuOpen = api?.blockControls.sharedState.currentState()?.isMenuOpen && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true);
                            // when block menu is just open, and we press arrow keys, we want to use the arrow keys to navigate the block menu
                            // in this scenario, isSelectedViaDragHandle should not be set to false
                            if (api?.blockControls.sharedState.currentState()?.isSelectedViaDragHandle && !isBlockMenuOpen) api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(false));
                        }
                        if (!event.repeat && event.shiftKey && (0, $dh538.fg)('platform_editor_elements_dnd_shift_click_select')) view.dispatch(view.state.tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                            ...view.state.tr.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                            isShiftDown: true
                        }));
                        return false;
                    } else {
                        if (event.shiftKey && event.ctrlKey) //prevent holding down key combo from firing repeatedly
                        {
                            if (!event.repeat && (0, $81fcabb5fcc6909d$export$2734319938f9e9db)(api, formatMessage)(view, event)) {
                                event.preventDefault();
                                return true;
                            }
                        }
                        if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLElement && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                            const isDragHandle = event.target.closest((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? (0, $Yqd3z.DRAG_HANDLE_SELECTOR) : '[data-editor-block-ctrl-drag-handle="true"]') !== null;
                            api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle));
                        }
                        if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowDown' || event.key === 'ArrowUp') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                            const isBlockMenuOpen = api?.blockControls.sharedState.currentState()?.isMenuOpen && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true);
                            // when block menu is just open, and we press arrow keys, we want to use the arrow keys to navigate the block menu
                            // in this scenario, isSelectedViaDragHandle should not be set to false
                            if (api?.blockControls.sharedState.currentState()?.isSelectedViaDragHandle && !isBlockMenuOpen) api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(false));
                        }
                    }
                },
                keyup (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if (!event.repeat && event.key === 'Shift') view.dispatch(view.state.tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                        isShiftDown: false
                    }));
                },
                blur (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isChildOfEditor = event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest(`#${(0, $f9zLy.EDIT_AREA_ID)}`) !== null;
                        // don't do anything if the event relatedTarget (the element receiving focus) is a child of the editor
                        // or if the editor has focus
                        if (isChildOfEditor || view.hasFocus()) return false;
                        api?.core?.actions.execute(({ tr: tr })=>{
                            const currMeta = tr.getMeta($253f56923cf8d759$export$df61b30b684217c0);
                            tr.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                                ...currMeta,
                                editorBlurred: true
                            });
                            return tr;
                        });
                        return false;
                    }
                }
            }
        },
        view: (editorView)=>{
            const dom = editorView.dom;
            const editorContentArea = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
            // Use ResizeObserver to observe resizer (scroll-parent typically grows when resizing) and editor width changes
            resizeObserverWidth = new ResizeObserver((0, $2P8Ax.default)((entries)=>{
                const pluginState = $253f56923cf8d759$export$df61b30b684217c0.getState(editorView.state);
                if (!pluginState?.isDragging) {
                    const isResizerResizing = !!dom.querySelector('.is-resizing');
                    const transaction = editorView.state.tr;
                    if (pluginState?.isResizerResizing !== isResizerResizing) transaction.setMeta('is-resizer-resizing', isResizerResizing);
                    if (!isResizerResizing) {
                        const editorContentArea = entries[0].target;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthRight = editorContentArea.getBoundingClientRect().right;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthLeft = editorContentArea.getBoundingClientRect().left;
                        transaction.setMeta($253f56923cf8d759$export$df61b30b684217c0, {
                            ...transaction.getMeta($253f56923cf8d759$export$df61b30b684217c0),
                            editorWidthLeft: editorWidthLeft,
                            editorWidthRight: editorWidthRight
                        });
                    }
                    editorView.dispatch(transaction);
                }
            }));
            const shouldObserve = (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_native_anchor_patch_1') ? !(0, $b0c29e8b0584a1ce$export$2073a24f9367a16f)() : true;
            if (editorContentArea && shouldObserve) resizeObserverWidth.observe(editorContentArea);
            // Start pragmatic monitors
            pragmaticCleanup = $253f56923cf8d759$var$destroyFn(api, editorView);
            return {
                destroy () {
                    if (editorContentArea) resizeObserverWidth.unobserve(editorContentArea);
                    pragmaticCleanup?.();
                }
            };
        }
    });
};
const $253f56923cf8d759$export$e75bc9902db1596f = (tr)=>{
    return tr.getMeta($253f56923cf8d759$export$df61b30b684217c0);
};


const $4556138d8af21794$export$e21678cf246ba963 = (mapping)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
        return tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
            ...currMeta,
            preservedSelectionMapping: mapping
        });
    };
















const $90cb2fa8cd454b54$var$getSelectionToIndex = (fromIndex, $to, depth)=>{
    const toIndex = $to.index(depth);
    const toIndexAfter = $to.indexAfter(depth);
    // If $to is at the start of a node (indexAfter === index), don't include that node
    // This occurs when the preserved selection is outside of inline positions at node boundaries
    if (toIndexAfter === toIndex && toIndex > fromIndex) return toIndex - 1;
    return toIndex;
};
const $90cb2fa8cd454b54$export$86c511a177340b22 = (api, direction)=>{
    return ({ tr: tr })=>{
        if (!(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) return tr;
        const preservedSelection = api?.blockControls.sharedState.currentState()?.preservedSelection;
        const selection = preservedSelection ?? tr.selection;
        // Use getNodeBoundsFromSelection to get the proper block boundaries
        const nodeBounds = (0, $fb7c69702c6d579c$export$c57c553e4ac98a48)(selection);
        if (!nodeBounds) return tr;
        const currentNodePos = nodeBounds.from;
        const { $from: $from, $to: $to } = selection;
        const depth = tr.doc.resolve(currentNodePos).depth;
        const fromIndex = $from.index(depth);
        let trAfterNodeMove = tr;
        if (direction === (0, $ah4M9.DIRECTION).UP) {
            if (fromIndex > 0) {
                const moveToPos = $from.posAtIndex(fromIndex - 1, depth);
                trAfterNodeMove = (0, $5d42aac4ae65f87b$export$83751492c88cf2ca)(api)(currentNodePos, moveToPos, (0, $d925B.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        } else {
            // selectionToIndex is the index of the last node in the selection
            const selectionToIndex = $90cb2fa8cd454b54$var$getSelectionToIndex(fromIndex, $to, depth);
            // Adding 2 so we jump over the next node to the position after it
            const moveToIndex = selectionToIndex + 2;
            if (moveToIndex <= $to.node(depth).childCount) {
                const moveToPos = $to.posAtIndex(moveToIndex, depth);
                trAfterNodeMove = (0, $5d42aac4ae65f87b$export$83751492c88cf2ca)(api)(currentNodePos, moveToPos, (0, $d925B.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        }
        // map selection
        const mappedSelection = (0, $d37e2d7c197cf61b$export$e21678cf246ba963)(selection, trAfterNodeMove);
        if (mappedSelection) trAfterNodeMove.setSelection(mappedSelection);
        //recalculate canMoveUp and canMoveDown
        const { moveUp: moveUp, moveDown: moveDown } = (0, $fb7c69702c6d579c$export$cc4db90b9d5a445a)(trAfterNodeMove);
        const currentMeta = trAfterNodeMove.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
        const newMeta = {
            ...currentMeta,
            toggleMenu: {
                moveUp: moveUp,
                moveDown: moveDown
            }
        };
        return trAfterNodeMove.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), newMeta);
    };
};






var $hWRJP = parcelRequire("hWRJP");























const $098bb390c9d6cf1a$var$createNewLayout = (schema, layoutContents)=>{
    if (layoutContents.length === 0 || layoutContents.length > (0, $38ae61d92a71d752$export$b8ad888c900fcbc2)()) return null;
    const width = (0, $30636d6b7963f251$export$d77e6458bbcae98b)[layoutContents.length];
    if (!width) return null;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes || {};
    try {
        const layoutContent = (0, $5SAOw.Fragment).fromArray(layoutContents.map((layoutContent)=>{
            return layoutColumn.createChecked({
                width: width
            }, layoutContent);
        }));
        const layoutSectionNode = layoutSection.createChecked(undefined, layoutContent);
        return layoutSectionNode;
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    return null;
};
const $098bb390c9d6cf1a$var$moveToExistingLayout = (toLayout, toLayoutPos, sourceContent, from, to, tr, $originalFrom, $originalTo, api, selectMovedNode)=>{
    const isSameLayout = (0, $d389fba940977935$export$9d5fcdcf2394fab8)($originalFrom, $originalTo);
    let sourceContentEndPos = -1;
    const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    let sourceNodeTypes, hasSelectedMultipleNodes;
    if (isMultiSelect) {
        if (sourceContent instanceof (0, $5SAOw.Fragment)) {
            sourceContentEndPos = from + sourceContent.size;
            const attributes = (0, $c506554d919477c1$export$9f4024dd9bfa7336)(tr, from, sourceContentEndPos);
            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
            sourceNodeTypes = attributes.nodeTypes;
        }
    } else if (sourceContent instanceof (0, $5SAOw.Node)) sourceContentEndPos = from + sourceContent.nodeSize;
    if (sourceContentEndPos === -1) return tr;
    if (isSameLayout) {
        // reorder columns
        tr.delete(from, sourceContentEndPos);
        const mappedTo = tr.mapping.map(to);
        tr.insert(mappedTo, sourceContent);
        if (selectMovedNode) tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(mappedTo))).scrollIntoView();
        (0, $c506554d919477c1$export$991fd708287269fd)(tr, (0, $d925B.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, $originalFrom.nodeAfter?.type.name || '', 1, 'layoutSection', true, api, sourceNodeTypes, hasSelectedMultipleNodes);
    } else if (toLayout.childCount < (0, $38ae61d92a71d752$export$b8ad888c900fcbc2)()) {
        (0, $ea3d65f7aba7472e$export$29bd206d467fd44)(tr, tr.doc.resolve(from), sourceContentEndPos);
        $098bb390c9d6cf1a$var$insertToDestinationNoWidthUpdate(tr, tr.mapping.map(to), sourceContent);
        (0, $c506554d919477c1$export$991fd708287269fd)(tr, (0, $d925B.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, $originalFrom.nodeAfter?.type.name || '', 1, 'layoutSection', false, api, sourceNodeTypes, hasSelectedMultipleNodes);
    }
    return tr;
};
/**
 * This function is similar to insertToDestination
 * But without update width step, mainly rely on the append transaction from layout.
 * @param tr
 * @param to
 * @param sourceNode
 * @returns
 */ const $098bb390c9d6cf1a$var$insertToDestinationNoWidthUpdate = (tr, to, sourceContent)=>{
    const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
    let content = null;
    try {
        if ((0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) {
            if (sourceContent instanceof (0, $5SAOw.Fragment)) {
                const sourceFragment = sourceContent;
                content = layoutColumn.createChecked({
                    width: 0
                }, (0, $6940983cd14d3baa$export$2b4dd9f6b8f819da)(sourceFragment, 'layoutColumn') ? sourceFragment.firstChild?.content : sourceFragment);
            }
        } else if (sourceContent instanceof (0, $5SAOw.Node)) {
            const sourceNode = sourceContent;
            content = layoutColumn.createChecked({
                width: 0
            }, sourceNode.type.name === 'layoutColumn' ? sourceNode.content : sourceNode);
        }
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    if (content) tr.insert(to, content);
    return tr;
};
/**
 * Check if the node at `from` can be moved to node at `to` to create/expand a layout.
 * Returns the source and destination nodes and positions if it's a valid move, otherwise, undefined
 */ const $098bb390c9d6cf1a$var$canMoveToLayout = (api, from, to, tr, moveNodeAtCursorPos)=>{
    if (from === to) return;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn, doc: doc } = tr.doc.type.schema.nodes || {};
    // layout plugin does not exist
    if (!layoutSection || !layoutColumn) return;
    const $to = tr.doc.resolve(to);
    // drop at invalid position, not top level, or not a layout column
    if (!$to.nodeAfter || ![
        doc,
        layoutSection
    ].includes($to.parent.type)) return;
    const $from = tr.doc.resolve(from);
    const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    // invalid from position or dragging a layout
    if (!$from.nodeAfter || $from.nodeAfter.type === layoutSection) return;
    let sourceContent = $from.nodeAfter;
    let sourceFrom = from;
    let sourceTo = from + sourceContent.nodeSize;
    if (isMultiSelect && !moveNodeAtCursorPos) {
        const { anchor: anchor, head: head } = (0, $d37e2d7c197cf61b$export$4e8a3dde481e0452)(api, from);
        if (anchor !== undefined && head !== undefined) {
            sourceFrom = Math.min(anchor, head);
            sourceTo = Math.max(anchor, head);
            sourceContent = tr.doc.slice(sourceFrom, sourceTo).content;
            // TODO: ED-26959 - this might become expensive for large content, consider removing it if check has been done beforehand
            if ((0, $6940983cd14d3baa$export$8cb5c38ddf4d519f)(sourceContent, 'layoutSection')) return;
        } else sourceContent = (0, $5SAOw.Fragment).from($from.nodeAfter);
    }
    const toNode = $to.nodeAfter;
    return {
        toNode: toNode,
        $to: $to,
        sourceContent: sourceContent,
        $sourceFrom: tr.doc.resolve(sourceFrom),
        sourceTo: sourceTo
    };
};
const $098bb390c9d6cf1a$var$removeBreakoutMarks = (tr, $from, to)=>{
    let fromContentWithoutBreakout = $from.nodeAfter;
    const { breakout: breakout } = tr.doc.type.schema.marks || {};
    if ((0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) {
        tr.doc.nodesBetween($from.pos, to, (node, pos, parent)=>{
            // should never remove breakout from previous layoutSection
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if (node.type.name === 'layoutSection') return false;
            }
            // breakout doesn't exist on nested nodes
            if (parent?.type.name === 'doc' && node.marks.some((m)=>m.type === breakout)) tr.removeNodeMark(pos, breakout);
            // descending is not needed as  breakout doesn't exist on nested nodes
            return false;
        });
        // resolve again the source content after node updated (remove breakout marks)
        fromContentWithoutBreakout = tr.doc.slice($from.pos, to).content;
    } else if (breakout && $from.nodeAfter && $from.nodeAfter.marks.some((m)=>m.type === breakout)) {
        tr.removeNodeMark($from.pos, breakout);
        // resolve again the source node after node updated (remove breakout marks)
        fromContentWithoutBreakout = tr.doc.resolve($from.pos).nodeAfter;
    }
    return fromContentWithoutBreakout;
};
const $098bb390c9d6cf1a$var$getBreakoutMode = (content, breakout)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) {
        if (content instanceof (0, $5SAOw.Node)) return content.marks.find((m)=>m.type === breakout)?.attrs.mode;
        else if (content instanceof (0, $5SAOw.Fragment)) {
            // Find the first breakout mode in the fragment
            let firstBreakoutMode;
            for(let i = 0; i < content.childCount; i++){
                const child = content.child(i);
                const breakoutMark = child.marks.find((m)=>m.type === breakout);
                if (breakoutMark) {
                    firstBreakoutMode = breakoutMark.attrs.mode;
                    break;
                }
            }
            return firstBreakoutMode;
        }
    } else {
        // Without multi-select support, we can assume source content is of type PMNode
        if (content instanceof (0, $5SAOw.Node)) return content.marks.find((m)=>m.type === breakout)?.attrs.mode;
    }
};
const $098bb390c9d6cf1a$var$getBreakoutModeAndWidth = (content, breakout)=>{
    const findBreakoutMark = (node)=>node.marks.find((m)=>m.type === breakout);
    const extractBreakoutAttributes = (mark)=>mark ? {
            breakoutMode: mark.attrs.mode,
            breakoutWidth: mark.attrs.width
        } : null;
    if ((0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) {
        if (content instanceof (0, $5SAOw.Node)) return extractBreakoutAttributes(findBreakoutMark(content));
        else if (content instanceof (0, $5SAOw.Fragment)) // Find the first breakout mode in the fragment
        for(let i = 0; i < content.childCount; i++){
            const child = content.child(i);
            const breakoutMark = findBreakoutMark(child);
            if (breakoutMark) return extractBreakoutAttributes(breakoutMark);
        }
    } else {
        // Without multi-select support, we can assume source content is of type PMNode
        if (content instanceof (0, $5SAOw.Node)) return extractBreakoutAttributes(findBreakoutMark(content));
    }
    return null;
};
const $098bb390c9d6cf1a$export$6e686efeb3f3578c = (api)=>(from, to, options)=>({ tr: tr })=>{
            if (!api) return tr;
            const canMove = $098bb390c9d6cf1a$var$canMoveToLayout(api, from, to, tr, options?.moveNodeAtCursorPos);
            if (!canMove) return tr;
            const { toNode: toNode, $to: $to, sourceContent: sourceContent, $sourceFrom: $sourceFrom, sourceTo: sourceTo } = canMove;
            const { layoutSection: layoutSection, layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
            const { breakout: breakout } = tr.doc.type.schema.marks || {};
            // get breakout mode from destination node,
            // if not found, get from source node,
            let breakoutMode;
            let breakoutWidth;
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) ({ breakoutMode: breakoutMode, breakoutWidth: breakoutWidth } = $098bb390c9d6cf1a$var$getBreakoutModeAndWidth(toNode, breakout) || $098bb390c9d6cf1a$var$getBreakoutModeAndWidth(sourceContent, breakout) || {});
            else breakoutMode = $098bb390c9d6cf1a$var$getBreakoutMode(toNode, breakout) || $098bb390c9d6cf1a$var$getBreakoutMode(sourceContent, breakout);
            // we don't want to remove marks when moving/re-ordering layoutSection
            const shouldRemoveMarks = !($sourceFrom.node().type === layoutSection && (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true));
            const fromContentBeforeBreakoutMarksRemoved = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true) ? tr.doc.slice($sourceFrom.pos, sourceTo).content : $sourceFrom.nodeAfter;
            // remove breakout from source content
            let fromContentWithoutBreakout = shouldRemoveMarks ? $098bb390c9d6cf1a$var$removeBreakoutMarks(tr, $sourceFrom, sourceTo) : fromContentBeforeBreakoutMarksRemoved;
            if (!fromContentWithoutBreakout) return tr;
            if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.setContentMoved()({
                tr: tr
            });
            const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
            if (toNode.type === layoutSection) {
                const toPos = options?.moveToEnd ? to + toNode.nodeSize - 1 : to + 1;
                return $098bb390c9d6cf1a$var$moveToExistingLayout(toNode, to, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options?.selectMovedNode);
            } else if (toNode.type === layoutColumn) {
                const toLayout = $to.parent;
                const toLayoutPos = to - $to.parentOffset - 1;
                const toPos = options?.moveToEnd ? to + toNode.nodeSize : to;
                return $098bb390c9d6cf1a$var$moveToExistingLayout(toLayout, toLayoutPos, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options?.selectMovedNode);
            } else {
                let toNodeWithoutBreakout = toNode;
                // remove breakout from node;
                if (breakout && $to.nodeAfter && $to.nodeAfter.marks.some((m)=>m.type === breakout)) {
                    tr.removeNodeMark(to, breakout);
                    // resolve again the source node after node updated (remove breakout marks)
                    toNodeWithoutBreakout = tr.doc.resolve(to).nodeAfter || toNode;
                }
                if (isMultiSelect) {
                    if ((0, $6940983cd14d3baa$export$2b4dd9f6b8f819da)(fromContentWithoutBreakout, 'layoutColumn') && fromContentWithoutBreakout.firstChild) fromContentWithoutBreakout = fromContentWithoutBreakout.firstChild.content;
                } else if (fromContentWithoutBreakout instanceof (0, $5SAOw.Node) && fromContentWithoutBreakout.type.name === 'layoutColumn') fromContentWithoutBreakout = fromContentWithoutBreakout.content;
                const layoutContents = options?.moveToEnd ? [
                    toNodeWithoutBreakout,
                    fromContentWithoutBreakout
                ] : [
                    fromContentWithoutBreakout,
                    toNodeWithoutBreakout
                ];
                const newLayout = $098bb390c9d6cf1a$var$createNewLayout(tr.doc.type.schema, layoutContents);
                if (newLayout) {
                    let sourceNodeTypes, hasSelectedMultipleNodes;
                    if (isMultiSelect) {
                        const attributes = (0, $c506554d919477c1$export$9f4024dd9bfa7336)(tr, $sourceFrom.pos, sourceTo);
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        sourceNodeTypes = attributes.nodeTypes;
                    }
                    tr = (0, $ea3d65f7aba7472e$export$29bd206d467fd44)(tr, $sourceFrom, sourceTo);
                    const mappedTo = tr.mapping.map(to);
                    tr.delete(mappedTo, mappedTo + toNodeWithoutBreakout.nodeSize).insert(mappedTo, newLayout);
                    if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode,
                            width: breakoutWidth
                        })
                    ]);
                    else breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode
                        })
                    ]);
                    if ((0, $dh538.fg)('platform_editor_column_count_analytics')) // layout created via drag and drop will always be 2 columns
                    (0, $c506554d919477c1$export$9d441c3a20655711)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes, 2);
                    else (0, $c506554d919477c1$export$9d441c3a20655711)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes);
                }
                return tr;
            }
        };


















const $cc185418919b2c56$export$fd198b85b7fd4b80 = new (0, $ks2lK.PluginKey)('firstNodeDec');
const $cc185418919b2c56$var$createFirstNodeDecSet = (state)=>{
    const firstNode = state.doc.firstChild;
    if (!firstNode) return (0, $ftzrq.DecorationSet).empty;
    const firstNodeDecoration = (0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? (0, $ftzrq.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0;',
        class: 'first-node-in-document'
    }) : (0, $ftzrq.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0'
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, [
        firstNodeDecoration
    ]);
};
const $cc185418919b2c56$export$4a529dfc67d1b47b = ()=>new (0, $1S4f7.SafePlugin)({
        key: $cc185418919b2c56$export$fd198b85b7fd4b80,
        state: {
            init (_, state) {
                return $cc185418919b2c56$var$createFirstNodeDecSet(state);
            },
            apply (tr, currentState, _, newState) {
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
                // Reapply decorations if there are any steps that modify the document
                if (isDocChanged) return $cc185418919b2c56$var$createFirstNodeDecSet(newState);
                return currentState;
            }
        },
        props: {
            decorations (state) {
                return $cc185418919b2c56$export$fd198b85b7fd4b80.getState(state);
            }
        }
    });















const $a8eaec2f17a6d5fa$export$2e0e85f705dfca46 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $e895db8dd5f4f3b6$export$d14f503a2a677768), {
        type: 'stopEditing'
    }));
};
const $a8eaec2f17a6d5fa$export$67bd57d439e8e4eb = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $e895db8dd5f4f3b6$export$d14f503a2a677768), {
        type: 'startEditing'
    }));
};
const $a8eaec2f17a6d5fa$export$62b9e387feb21f54 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $e895db8dd5f4f3b6$export$d14f503a2a677768), {
        type: 'mouseLeave'
    }));
};
const $a8eaec2f17a6d5fa$export$681e7b82bbbeba93 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $e895db8dd5f4f3b6$export$d14f503a2a677768), {
        type: 'mouseEnter'
    }));
};



const $1b142cf61721d4dd$export$bab59f27a7347e45 = (view, event)=>{
    // Check if this is a keyboard shortcut (Ctrl/Cmd + key)
    const isShortcut = event.ctrlKey || event.metaKey || event.altKey;
    if (isShortcut) return false;
    // Only consider actual typing keys (not shortcuts)
    // We need to check if it's a single character key or a deletion key
    // and ensure it's not part of a shortcut
    const isTypingKey = // Single character keys (letters, numbers, symbols)
    event.key.length === 1 || event.key === 'Backspace' || event.key === 'Delete' || event.key === ' ' || event.key === 'Enter';
    if (!isTypingKey) return false;
    const state = (0, $e895db8dd5f4f3b6$export$27d80eabdcbf88a5)(view.state);
    // if user hasnt started typing yet, start timer
    if (!state?.isEditing) (0, $a8eaec2f17a6d5fa$export$67bd57d439e8e4eb)(view);
    return false;
};




const $a3b45362c341bd88$export$3248c033e90a4ba0 = (view)=>{
    const state = (0, $e895db8dd5f4f3b6$export$27d80eabdcbf88a5)(view.state);
    // if user has stopped editing and moved their mouse, show block controls again
    if (state?.isEditing) (0, $a8eaec2f17a6d5fa$export$2e0e85f705dfca46)(view);
    return false;
};
const $a3b45362c341bd88$export$fcff8e67f71577c3 = (view)=>{
    (0, $a8eaec2f17a6d5fa$export$62b9e387feb21f54)(view);
    return false;
};
const $a3b45362c341bd88$export$2560ef85393729a7 = (view)=>{
    (0, $a8eaec2f17a6d5fa$export$681e7b82bbbeba93)(view);
    return false;
};


const $e895db8dd5f4f3b6$export$d14f503a2a677768 = new (0, $ks2lK.PluginKey)('interactionTrackingPlugin');
const $e895db8dd5f4f3b6$export$66f3b9297f4ee65b = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $e895db8dd5f4f3b6$export$d14f503a2a677768,
        state: {
            init () {
                const state = {
                    isEditing: false
                };
                if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) state.isMouseOut = false;
                return state;
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($e895db8dd5f4f3b6$export$d14f503a2a677768);
                const newState = {};
                switch(meta?.type){
                    case 'startEditing':
                        newState.isEditing = true;
                        break;
                    case 'stopEditing':
                        newState.isEditing = false;
                        break;
                    case 'mouseLeave':
                        newState.isMouseOut = true;
                        break;
                    case 'mouseEnter':
                        newState.isMouseOut = false;
                        break;
                }
                return {
                    ...pluginState,
                    ...newState
                };
            }
        },
        props: {
            handleKeyDown: $1b142cf61721d4dd$export$bab59f27a7347e45,
            handleDOMEvents: {
                mousemove: (0, $a3b45362c341bd88$export$3248c033e90a4ba0)
            }
        },
        view: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
            const editorContentArea = view.dom.closest('.ak-editor-content-area');
            let unbindMouseEnter;
            let unbindMouseLeave;
            if (editorContentArea) {
                unbindMouseEnter = (0, $fFa3V.bind)(editorContentArea, {
                    type: 'mouseenter',
                    listener: ()=>{
                        (0, $a3b45362c341bd88$export$2560ef85393729a7)(view);
                    }
                });
                unbindMouseLeave = (0, $fFa3V.bind)(editorContentArea, {
                    type: 'mouseleave',
                    listener: ()=>{
                        (0, $a3b45362c341bd88$export$fcff8e67f71577c3)(view);
                    }
                });
            }
            return {
                destroy: ()=>{
                    unbindMouseEnter?.();
                    unbindMouseLeave?.();
                }
            };
        } : undefined
    });
};
const $e895db8dd5f4f3b6$export$27d80eabdcbf88a5 = (state)=>{
    return $e895db8dd5f4f3b6$export$d14f503a2a677768.getState(state);
};



















const $1fa409124f22fb7b$export$a61ec0b8c52b12b5 = (transactions)=>{
    return transactions.some((tr)=>tr.getMeta('pointer') && tr.selectionSet);
};
const $1fa409124f22fb7b$export$176558ea818a3e54 = (tr)=>{
    return tr.getMeta((0, $fd0b1a7899796485$export$4d3f50627e188696));
};
const $1fa409124f22fb7b$export$36518d6d9145806a = (a, b)=>{
    return !a && !b || !!a && !!b && a.eq(b);
};
const $1fa409124f22fb7b$export$e6bc8ad830dbda92 = (selection)=>{
    const domSelection = window.getSelection();
    const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
    const isOutOfSync = domRange && (selection.from !== domRange.startOffset || selection.to !== domRange.endOffset);
    if (isOutOfSync) {
        // Force the DOM selection to refresh, setting it to the same range
        // This will trigger ProseMirror to re-apply its selection logic based on the current state
        domSelection.removeAllRanges();
        domSelection.addRange(domRange);
    }
};


const $2f74980d0c2c3805$export$36720c70349457f = (api)=>()=>{
        return new (0, $1S4f7.SafePlugin)({
            key: (0, $fd0b1a7899796485$export$4d3f50627e188696),
            state: {
                init () {
                    return {
                        preservedSelection: undefined
                    };
                },
                apply (tr, pluginState) {
                    const meta = (0, $1fa409124f22fb7b$export$176558ea818a3e54)(tr);
                    const newState = {
                        ...pluginState
                    };
                    if (meta?.type === 'startPreserving') newState.preservedSelection = (0, $d37e2d7c197cf61b$export$fa43757966d274e3)(tr.doc.resolve(tr.selection.from), tr.doc.resolve(tr.selection.to));
                    else if (meta?.type === 'stopPreserving') newState.preservedSelection = undefined;
                    else if (newState.preservedSelection && tr.docChanged) newState.preservedSelection = (0, $d37e2d7c197cf61b$export$e21678cf246ba963)(newState.preservedSelection, tr);
                    if (!(0, $1fa409124f22fb7b$export$36518d6d9145806a)(newState.preservedSelection, pluginState.preservedSelection)) {
                        if (newState.preservedSelection) api?.core.actions.execute(api?.selection?.commands?.setBlockSelection(newState.preservedSelection));
                        else api?.core.actions.execute(api?.selection?.commands?.clearBlockSelection());
                    }
                    return newState;
                }
            },
            appendTransaction (transactions, _oldState, newState) {
                const pluginState = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(newState);
                const preservedSel = pluginState?.preservedSelection;
                const stateSel = newState.selection;
                if (!preservedSel) return null;
                // Auto-stop if user explicitly changes selection
                if ((0, $1fa409124f22fb7b$export$a61ec0b8c52b12b5)(transactions)) return (0, $ad55c0625fa8df26$export$7ee148889ab74bda)({
                    tr: newState.tr
                });
                const selectionUnchanged = stateSel.from === preservedSel.from && stateSel.to === preservedSel.to;
                const selectionInvalid = preservedSel.from < 0 || preservedSel.to > newState.doc.content.size;
                if (selectionUnchanged || selectionInvalid) return null;
                const newSelection = (0, $d37e2d7c197cf61b$export$fa43757966d274e3)(newState.doc.resolve(preservedSel.from), newState.doc.resolve(preservedSel.to));
                // If selection becomes invalid, stop preserving
                if (!newSelection) return (0, $ad55c0625fa8df26$export$7ee148889ab74bda)({
                    tr: newState.tr
                });
                return newState.tr.setSelection(newSelection);
            },
            view (initialView) {
                let view = initialView;
                const unbindDocumentMouseDown = (0, $fFa3V.bind)(document, {
                    type: 'mousedown',
                    listener: (e)=>{
                        if (!(e.target instanceof HTMLElement)) return;
                        const { preservedSelection: preservedSelection } = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(view.state) || {};
                        // If there is no current preserved selection or the editor is not focused, do nothing
                        if (!preservedSelection) return;
                        const clickedDragHandle = !!e.target.closest((0, $Yqd3z.DRAG_HANDLE_SELECTOR));
                        // When mouse down on a drag handle we continue preserving the selection
                        if (clickedDragHandle) return;
                        const clickedOutsideEditor = !e.target.closest('.ProseMirror');
                        // When mouse down outside the editor continue to preserve the selection
                        if (clickedOutsideEditor) return;
                        // Otherwise mouse down anywhere else in the editor stops preserving the selection
                        const tr = view.state.tr;
                        (0, $ad55c0625fa8df26$export$7ee148889ab74bda)({
                            tr: tr
                        });
                        view.dispatch(tr);
                    },
                    // Use capture phase to stop preservation before appendTransaction runs,
                    // preventing unwanted selection restoration when the user clicks into the editor.
                    options: {
                        capture: true
                    }
                });
                return {
                    update (updateView, prevState) {
                        view = updateView;
                        const prevPreservedSelection = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(prevState)?.preservedSelection;
                        const currPreservedSelection = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(view.state)?.preservedSelection;
                        const prevActiveNode = (0, $253f56923cf8d759$export$df61b30b684217c0).getState(prevState)?.activeNode;
                        const currActiveNode = (0, $253f56923cf8d759$export$df61b30b684217c0).getState(view.state)?.activeNode;
                        if (currPreservedSelection && view.hasFocus() && (!(0, $1fa409124f22fb7b$export$36518d6d9145806a)(prevPreservedSelection, currPreservedSelection) || prevActiveNode !== currActiveNode)) (0, $1fa409124f22fb7b$export$e6bc8ad830dbda92)(view.state.selection);
                    },
                    destroy () {
                        unbindDocumentMouseDown();
                    }
                };
            },
            props: {
                handleKeyDown: (view, event)=>{
                    const { preservedSelection: preservedSelection } = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(view.state) || {};
                    // If there is no current preserved selection, do nothing
                    if (!preservedSelection) return false;
                    api?.core?.actions.execute(api?.blockControls?.commands?.handleKeyDownWithPreservedSelection(event));
                    // While preserving selection, if user presses delete/backspace, prevent event from being
                    // handled by ProseMirror natively so that we can apply logic using the preserved selection.
                    return [
                        'backspace',
                        'delete'
                    ].includes(event.key.toLowerCase());
                }
            }
        });
    };



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $04H9b = parcelRequire("04H9b");












var $TfRUG = parcelRequire("TfRUG");















function $b7423bc100799df8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This anchor element selector disregards anchors that are solely utilized for size measurements,
 * including those within table rows and media.
 */ const $b7423bc100799df8$var$dragHandlerAnchorSelector = '[data-drag-handler-anchor-name]:not([data-drag-handler-node-type="tableRow"], [data-drag-handler-node-type="media"])';
/**
 * Disregards anchors that can not have handles next to them, and so shouldn't have an extended hover zone
 */ const $b7423bc100799df8$var$dragHandlerAnchorSelectorNext = `[${(0, $d89c90893897930c$export$ea34df48337a3b78)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"])`;
const $b7423bc100799df8$var$gutterPaddingWidth = ()=>(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? `${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px` : '100%';
const $b7423bc100799df8$var$gutterPaddingLeft = ()=>(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? `-${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px` : '-100px';
const $b7423bc100799df8$var$extendedHoverZone = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.block-ctrl-drag-preview ${$b7423bc100799df8$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $30636d6b7963f251$export$f0af6742db040d57)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $30636d6b7963f251$export$f0af6742db040d57)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& [data-drag-handler-anchor-depth="0"]${$b7423bc100799df8$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $b7423bc100799df8$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $b7423bc100799df8$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$b7423bc100799df8$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // hover zone for layout column should be placed near the top of the column (where drag handle is)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&& [data-drag-handler-anchor-name][data-layout-column]::after': {
                content: '""',
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                top: `${-(0, $Yqd3z.DRAG_HANDLE_WIDTH) / 2}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                height: `${(0, $Yqd3z.DRAG_HANDLE_WIDTH)}px`,
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        //eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-blocks-drag-handle-container="true"] + [data-drag-handler-anchor-depth="0"]::after': {
            display: 'none'
        }
    });
const $b7423bc100799df8$var$extendedHoverZoneNext = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.block-ctrl-drag-preview ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $30636d6b7963f251$export$f0af6742db040d57)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $30636d6b7963f251$export$f0af6742db040d57)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // Top level depth hover zone should extend to gutter padding area
            // we select the top level by using NOT nested anchor selector
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}:not([${0, $d89c90893897930c$export$ea34df48337a3b78}] [${0, $d89c90893897930c$export$ea34df48337a3b78}])::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $b7423bc100799df8$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $b7423bc100799df8$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`[data-blocks-drag-handle-container="true"] + ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}:not([${0, $d89c90893897930c$export$ea34df48337a3b78}] [${0, $d89c90893897930c$export$ea34df48337a3b78}])::after`]: {
            display: 'none'
        }
    });
const $b7423bc100799df8$var$layoutColumnExtendedHoverZone = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // hover zone for layout column should be placed near the top of the column (where drag handle is)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}[data-layout-column]::after`]: {
            content: '""',
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            top: `${-(0, $Yqd3z.DRAG_HANDLE_WIDTH) / 2}px`,
            left: 0,
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $Yqd3z.DRAG_HANDLE_WIDTH)}px`,
            cursor: 'default',
            zIndex: 1
        }
    }
});
const $b7423bc100799df8$var$layoutColumnWithoutHoverZone = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // when advanced_layouts is off, layout columns should not have hover zones, because there aren't any drag handles for layout columns
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}[data-layout-column]::after`]: {
            display: 'none'
        }
    }
});
const $b7423bc100799df8$var$extendHoverZoneReduced = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$b7423bc100799df8$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $aFUXX.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $aFUXX.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $b7423bc100799df8$var$extendHoverZoneReducedNext = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`> ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $aFUXX.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $aFUXX.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $b7423bc100799df8$var$extendedDragZone = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$b7423bc100799df8$var$dragHandlerAnchorSelector}::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $b7423bc100799df8$var$extendedDragZoneNext = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}:not([${0, $d89c90893897930c$export$ea34df48337a3b78}] [${0, $d89c90893897930c$export$ea34df48337a3b78}])::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $b7423bc100799df8$var$paragraphWithTrailingBreakAsOnlyChild = '+ :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $b7423bc100799df8$var$indentatedParagraphWithTrailingBreakAsOnlyChild = '+ div.fabric-editor-indentation-mark > :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $b7423bc100799df8$var$paragraphWithPlaceholder = '+ p > .placeholder-decoration';
const $b7423bc100799df8$var$dragHandleContainer = '.ProseMirror-widget[data-blocks-drag-handle-container="true"]';
const $b7423bc100799df8$var$dragHandleSelector = 'button[data-testid="block-ctrl-drag-handle"]';
const $b7423bc100799df8$var$dropTargetContainer = '.ProseMirror-widget[data-blocks-drop-target-container="true"]';
const $b7423bc100799df8$var$dividerBodiedInCustomPanelWithNoIconSelector = '[data-panel-type].ak-editor-panel__no-icon .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + hr, [data-panel-type] hr:first-child';
const $b7423bc100799df8$var$withInlineNodeStyleSelectors = [
    `${$b7423bc100799df8$var$dragHandleContainer}:has(${$b7423bc100799df8$var$paragraphWithTrailingBreakAsOnlyChild}) ${$b7423bc100799df8$var$dragHandleSelector}`,
    `${$b7423bc100799df8$var$dragHandleContainer}:has(${$b7423bc100799df8$var$indentatedParagraphWithTrailingBreakAsOnlyChild}) ${$b7423bc100799df8$var$dragHandleSelector}`,
    `${$b7423bc100799df8$var$dragHandleContainer}:has(${$b7423bc100799df8$var$paragraphWithPlaceholder}) ${$b7423bc100799df8$var$dragHandleSelector}`
].join(', ');
const $b7423bc100799df8$var$withFormatInLayoutStyleFixSelectors = [
    `${$b7423bc100799df8$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$b7423bc100799df8$var$dragHandleContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$b7423bc100799df8$var$dragHandleContainer}:first-child + ${$b7423bc100799df8$var$dropTargetContainer} + .fabric-editor-indentation-mark > p:first-child`,
    `${$b7423bc100799df8$var$dragHandleContainer}:first-child + ${$b7423bc100799df8$var$dropTargetContainer} + .fabric-editor-alignment > p:first-child`,
    `${$b7423bc100799df8$var$dropTargetContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$b7423bc100799df8$var$dropTargetContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$b7423bc100799df8$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`
].join(', ');
/**
 * Please do not change change transform to display:none, or visibility:hidden
 * Otherwise it might break composition input for Chrome
 * https://product-fabric.atlassian.net/browse/ED-24136
 */ const $b7423bc100799df8$var$withInlineNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$b7423bc100799df8$var$withInlineNodeStyleSelectors]: {
        transform: 'scale(0)'
    }
});
const $b7423bc100799df8$var$legacyBreakoutWideLayoutStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '.ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
        '@media (width>=1280px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
        }
    }
});
const $b7423bc100799df8$var$globalDnDStyle = {
    name: "rngdgu",
    styles: ".ProseMirror{[data-layout-content]{user-drag:none;}}"
};
var $b7423bc100799df8$var$_ref = {
    name: "6tfzz7",
    styles: ".ProseMirror-widget:first-child + *:not([data-panel-type], .code-block, [data-node-type=\"nestedExpand\"], [data-node-type=\"expand\"], [data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]){margin-top:0 !important;}"
};
const $b7423bc100799df8$var$globalStyles = ()=>$b7423bc100799df8$var$_ref;
const $b7423bc100799df8$var$quickInsertStyles = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-button': {
            backgroundColor: 'transparent',
            top: `var(--top-override,8px)`,
            position: 'sticky',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            border: 'none',
            borderRadius: "var(--ds-radius-full, 9999px)",
            zIndex: (0, $dTk3A.layers).card(),
            outline: 'none',
            cursor: 'pointer',
            color: "var(--ds-icon-subtle, #505258)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            '--top-override': `${(0, $1zav4.tableControlsSpacing)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            '--top-override': `${(0, $1zav4.tableControlsSpacing)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-button:hover': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-button:active': {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-button:focus': {
            outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-visible-container': {
            transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out',
            opacity: 1,
            visibility: 'visible'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-invisible-container': {
            transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out',
            opacity: 0,
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.blocks-quick-insert-tooltip': {
            zIndex: (0, $dTk3A.layers).tooltip(),
            borderRadius: "var(--ds-radius-small, 4px)",
            padding: `${"var(--ds-space-050, 4px)"} 0`,
            boxSizing: 'border-box',
            maxWidth: '240px',
            backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            insetBlockStart: "var(--ds-space-0, 0px)",
            insetInlineStart: "var(--ds-space-0, 0px)",
            overflowWrap: 'break-word',
            paddingBlockEnd: "var(--ds-space-025, 2px)",
            paddingBlockStart: "var(--ds-space-025, 2px)",
            paddingInlineEnd: "var(--ds-space-075, 6px)",
            paddingInlineStart: "var(--ds-space-075, 6px)",
            wordWrap: 'break-word',
            pointerEvents: 'none',
            userSelect: 'none',
            // Based on: platform/packages/design-system/motion/src/entering/keyframes-motion.tsx
            transition: 'opacity .1s ease-in-out, transform .1s ease-in-out, visibility .1s ease-in-out',
            '@media (prefers-reduced-motion: reduce)': {
                transition: 'none'
            }
        }
    });
const $b7423bc100799df8$var$topLevelNodeMarginStyles = {
    name: "13jrzwf",
    styles: ".ProseMirror{> .ProseMirror-widget:first-child + .ProseMirror-gapcursor + *:not([data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]), > .ProseMirror-widget:first-child + *:not([data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]){margin-top:0 !important;}}"
};
const $b7423bc100799df8$var$withDividerInPanelStyleFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$b7423bc100799df8$var$dividerBodiedInCustomPanelWithNoIconSelector}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $b7423bc100799df8$var$withDeleteLinesStyleFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`p[data-drag-handler-anchor-name] ${$b7423bc100799df8$var$dragHandleContainer}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        display: 'none !important'
    }
});
// Image dnd is broken in Firefox due to a previous fix for image caption https://product-fabric.atlassian.net/browse/ED-14034
// We could remove this fix if the previous issue is invalid
const $b7423bc100799df8$var$withMediaSingleStyleFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    ['.ProseMirror.ua-firefox .mediaSingleView-content-wrap[data-drag-handler-node-type="mediaSingle"][data-drag-handler-anchor-name], .ProseMirror.ua-firefox [data-drag-handler-anchor-name][data-drag-handler-node-type] .mediaSingleView-content-wrap']: {
        userSelect: 'auto',
        cursor: 'pointer'
    }
});
const $b7423bc100799df8$var$withFormatInLayoutStyleFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$b7423bc100799df8$var$withFormatInLayoutStyleFixSelectors}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $b7423bc100799df8$var$headingWithIndentationInLayoutStyleFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$b7423bc100799df8$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $b7423bc100799df8$var$withRelativePosStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelector}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelector}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $TfRUG.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $b7423bc100799df8$var$withRelativePosStyleNext = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$b7423bc100799df8$var$dragHandlerAnchorSelectorNext}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $TfRUG.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $b7423bc100799df8$var$withAnchorNameZindexStyle = {
    name: "okzdt4",
    styles: ".ProseMirror{&& [data-drag-handler-anchor-depth=\"0\"][data-drag-handler-anchor-name]{z-index:1;}}"
};
const $b7423bc100799df8$var$withAnchorNameZindexStyleNext = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& [${0, $d89c90893897930c$export$ea34df48337a3b78}]:not([${0, $d89c90893897930c$export$ea34df48337a3b78}] [${0, $d89c90893897930c$export$ea34df48337a3b78}])`]: {
            zIndex: 1
        }
    }
});
// This style is used to define width for block card (with datasource) that does not have layout
// In full-width editor, block card has width of full-width layout
// In fixed-width editor, block card has width of wide layout
const $b7423bc100799df8$var$blockCardWithoutLayout = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-content-area.fabric-editor--full-width-mode .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor-block-card-width': `min(calc(100cqw - ${(0, $aFUXX.akEditorBreakoutPadding)}px), 1800px)`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        '--ak-editor-block-card-width': 'max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))'
    }
});
const $b7423bc100799df8$var$nextAnchorSelector = [
    '&[data-node-anchor]',
    // adjacent sibling with anchor
    '&:not([data-node-anchor]) [data-node-anchor]:first-of-type',
    // first nested anchor inside adjacent sibling
    '&.ProseMirror-widget + [data-node-anchor]',
    // adjacent sibling with anchor (when next to a widget like gap cursor)
    '&.ProseMirror-widget + :not([data-node-anchor]) [data-node-anchor]:first-of-type' // first nested anchor inside adjacent sibling (when next to a widget like gap cursor)
].join(', ');
const $b7423bc100799df8$var$dragHandlerAnchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-decorator-widget"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$b7423bc100799df8$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $04H9b.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-quick-insert-button"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$b7423bc100799df8$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $04H9b.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        }
    }
});
// Styles applied to nodes with anchors when dragging
const $b7423bc100799df8$var$dragAnchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:not([data-node-anchor] [data-node-anchor])': {
            // all top level nodes with anchor
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $04H9b.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:has([data-blocks-drop-target-container]) [data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $04H9b.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-name="media"][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $04H9b.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // first table row to avoid multiple anchors in table
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-prosemirror-node-name="table"] [data-prosemirror-node-name="tableRow"][data-node-anchor]:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $04H9b.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
const $b7423bc100799df8$export$cc5403d58ddfa812 = ({ api: api })=>{
    const isDragging = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockControls.isDragging', {
        disabled: !(0, $1oCLl.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)
    });
    const shouldRenderAnchors = (0, $04H9b.isCSSAnchorSupported)() && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: [
            $b7423bc100799df8$var$globalStyles(),
            $b7423bc100799df8$var$globalDnDStyle,
            (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $b7423bc100799df8$var$extendedHoverZoneNext() : $b7423bc100799df8$var$extendedHoverZone(),
            isDragging && ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $b7423bc100799df8$var$extendedDragZoneNext : $b7423bc100799df8$var$extendedDragZone),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $b7423bc100799df8$var$extendHoverZoneReducedNext : $b7423bc100799df8$var$extendHoverZoneReduced : undefined,
            // platform_editor_controls note: this allows drag handles to render on empty lines
            toolbarFlagsEnabled ? undefined : $b7423bc100799df8$var$withInlineNodeStyle,
            (0, $iu6m9.editorExperiment)('platform_editor_block_control_optimise_render', true) ? $b7423bc100799df8$var$quickInsertStyles : undefined,
            $b7423bc100799df8$var$withDeleteLinesStyleFix,
            $b7423bc100799df8$var$withMediaSingleStyleFix,
            $b7423bc100799df8$var$legacyBreakoutWideLayoutStyle,
            $b7423bc100799df8$var$headingWithIndentationInLayoutStyleFix,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $b7423bc100799df8$var$blockCardWithoutLayout : undefined,
            $b7423bc100799df8$var$withDividerInPanelStyleFix,
            $b7423bc100799df8$var$withFormatInLayoutStyleFix,
            (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $b7423bc100799df8$var$withRelativePosStyleNext : $b7423bc100799df8$var$withRelativePosStyle,
            $b7423bc100799df8$var$topLevelNodeMarginStyles,
            (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $b7423bc100799df8$var$withAnchorNameZindexStyleNext : $b7423bc100799df8$var$withAnchorNameZindexStyle,
            (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $1oCLl.expValEquals)('advanced_layouts', 'isEnabled', true) ? $b7423bc100799df8$var$layoutColumnExtendedHoverZone : $b7423bc100799df8$var$layoutColumnWithoutHoverZone,
            shouldRenderAnchors && (isDragging ? $b7423bc100799df8$var$dragAnchorStyles : $b7423bc100799df8$var$dragHandlerAnchorStyles)
        ]
    });
};


const $3bece6cbff65939d$export$7a291905586a23d3 = ({ api: api })=>({
        name: 'blockControls',
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'blockControlsPmPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $253f56923cf8d759$export$ae829ec7b2625219)(api, getIntl, nodeViewPortalProviderAPI)
                }
            ];
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) pmPlugins.push({
                name: 'blockControlsInteractionTrackingPlugin',
                plugin: (0, $e895db8dd5f4f3b6$export$66f3b9297f4ee65b)
            });
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) pmPlugins.push({
                name: 'blockControlsSelectionPreservationPlugin',
                plugin: (0, $2f74980d0c2c3805$export$36720c70349457f)(api)
            });
            // platform_editor_controls note: quick insert rendering fixes
            if ((0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) pmPlugins.push({
                name: 'firstNodeDec',
                plugin: (0, $cc185418919b2c56$export$4a529dfc67d1b47b)
            });
            return pmPlugins;
        },
        commands: {
            moveNode: (0, $5d42aac4ae65f87b$export$83751492c88cf2ca)(api),
            moveToLayout: (0, $098bb390c9d6cf1a$export$6e686efeb3f3578c)(api),
            showDragHandleAt: (pos, anchorName, nodeType, handleOptions, rootPos, rootAnchorName, rootNodeType)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
                    tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                        ...currMeta,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType,
                            handleOptions: handleOptions,
                            rootPos: rootPos,
                            rootAnchorName: rootAnchorName,
                            rootNodeType: rootNodeType
                        }
                    });
                    return tr;
                },
            toggleBlockMenu: (options)=>({ tr: tr })=>{
                    if (!(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) return tr;
                    const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
                    const currentUserIntent = api?.userIntent?.sharedState.currentState()?.currentUserIntent;
                    const isMenuCurrentlyOpen = api?.blockControls?.sharedState.currentState()?.isMenuOpen;
                    if (options?.closeMenu) {
                        tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                            ...currMeta,
                            closeMenu: true
                        });
                        if (currentUserIntent === 'blockMenuOpen') api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        return tr;
                    }
                    // Do not open menu on layoutColumn and close opened menu when layoutColumn drag handle is clicked
                    if (options?.anchorName?.includes('layoutColumn')) {
                        if (currentUserIntent === 'blockMenuOpen') api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                            ...currMeta,
                            closeMenu: true
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        return tr;
                    }
                    let toggleMenuMeta = {
                        anchorName: options?.anchorName,
                        triggerByNode: options?.triggerByNode
                    };
                    const menuTriggerBy = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
                    if (options?.anchorName) {
                        const { moveUp: moveUp, moveDown: moveDown } = (0, $fb7c69702c6d579c$export$cc4db90b9d5a445a)(tr);
                        toggleMenuMeta = {
                            ...toggleMenuMeta,
                            moveUp: moveUp,
                            moveDown: moveDown,
                            openedViaKeyboard: options?.openedViaKeyboard
                        };
                    }
                    tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                        ...currMeta,
                        toggleMenu: toggleMenuMeta
                    });
                    if ((menuTriggerBy === undefined || !!menuTriggerBy && menuTriggerBy === options?.anchorName) && currentUserIntent === 'blockMenuOpen') {
                        const state = api?.blockControls.sharedState.currentState();
                        if (state?.isSelectedViaDragHandle) api?.userIntent?.commands.setCurrentUserIntent('dragHandleSelected')({
                            tr: tr
                        });
                        else // Toggled from drag handle
                        api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        // When closing the menu, restart the active session timer
                        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                    } else if (!isMenuCurrentlyOpen) // When opening the menu, pause the active session timer
                    {
                        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                            shouldStartTimer: false,
                            shouldPersistActiveSession: true
                        })({
                            tr: tr
                        });
                    }
                    return tr;
                },
            setNodeDragged: (getPos, anchorName, nodeType)=>({ tr: tr })=>{
                    const pos = getPos();
                    if (pos === undefined) return tr;
                    const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
                    tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                        ...currMeta,
                        isDragging: true,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType
                        }
                    });
                    if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                        shouldStartTimer: false,
                        shouldPersistActiveSession: true
                    })({
                        tr: tr
                    });
                    api?.userIntent?.commands.setCurrentUserIntent('dragging')({
                        tr: tr
                    });
                    return tr;
                },
            setMultiSelectPositions: (anchor, head)=>({ tr: tr })=>{
                    const { anchor: userAnchor, head: userHead } = tr.selection;
                    let $expandedAnchor, $expandedHead;
                    if (anchor !== undefined && head !== undefined) {
                        $expandedAnchor = tr.doc.resolve(anchor);
                        $expandedHead = tr.doc.resolve(head);
                    } else {
                        const expandedSelection = (0, $l6okE.expandSelectionBounds)(tr.selection.$anchor, tr.selection.$head);
                        $expandedAnchor = expandedSelection.$anchor;
                        $expandedHead = expandedSelection.$head;
                    }
                    api?.selection?.commands.setManualSelection($expandedAnchor.pos, $expandedHead.pos)({
                        tr: tr
                    });
                    const $from = $expandedAnchor.min($expandedHead);
                    const $to = $expandedAnchor.max($expandedHead);
                    let expandedNormalisedSel;
                    if ($from.nodeAfter === $to.nodeBefore) {
                        (0, $b9aa051abc8155ab$export$cbcb4f775d907a9e)(tr, $from.pos, $expandedAnchor.node().type.name, api);
                        expandedNormalisedSel = tr.selection;
                    } else if ($to.nodeBefore?.type.name === 'mediaSingle' || $from.nodeAfter?.type.name === 'mediaSingle') {
                        expandedNormalisedSel = new (0, $ks2lK.TextSelection)($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    } else {
                        // this is to normalise the selection's boundaries to inline positions, preventing it from collapsing
                        expandedNormalisedSel = (0, $ks2lK.TextSelection).between($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    }
                    const multiSelectDnD = {
                        anchor: $expandedAnchor.pos,
                        head: $expandedHead.pos,
                        textAnchor: expandedNormalisedSel.anchor,
                        textHead: expandedNormalisedSel.head,
                        userAnchor: userAnchor,
                        userHead: userHead
                    };
                    const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
                    tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                        ...currMeta,
                        multiSelectDnD: multiSelectDnD
                    });
                    return tr;
                },
            setSelectedViaDragHandle: (isSelectedViaDragHandle)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $253f56923cf8d759$export$df61b30b684217c0));
                    return tr.setMeta((0, $253f56923cf8d759$export$df61b30b684217c0), {
                        ...currMeta,
                        isSelectedViaDragHandle: isSelectedViaDragHandle
                    });
                },
            mapPreservedSelection: (mapping)=>(0, $4556138d8af21794$export$e21678cf246ba963)(mapping),
            moveNodeWithBlockMenu: (direction)=>(0, $90cb2fa8cd454b54$export$86c511a177340b22)(api, direction),
            handleKeyDownWithPreservedSelection: (0, $60e9e01ab3795199$export$f38920f5272efc06)(api),
            startPreservingSelection: ()=>(0, $ad55c0625fa8df26$export$4c9c90f81bda40ce),
            stopPreservingSelection: ()=>(0, $ad55c0625fa8df26$export$7ee148889ab74bda)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const sharedState = {
                isMenuOpen: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.isMenuOpen ?? false,
                menuTriggerBy: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.menuTriggerBy ?? undefined,
                menuTriggerByNode: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.menuTriggerByNode ?? undefined,
                blockMenuOptions: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.blockMenuOptions ?? undefined,
                activeNode: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.activeNode ?? undefined,
                activeDropTargetNode: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.activeDropTargetNode ?? undefined,
                isDragging: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.isDragging ?? false,
                isPMDragging: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.isPMDragging ?? false,
                multiSelectDnD: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.multiSelectDnD ?? undefined,
                isShiftDown: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.isShiftDown ?? undefined,
                lastDragCancelled: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.lastDragCancelled ?? false,
                isEditing: (0, $e895db8dd5f4f3b6$export$d14f503a2a677768).getState(editorState)?.isEditing,
                isSelectedViaDragHandle: (0, $253f56923cf8d759$export$df61b30b684217c0).getState(editorState)?.isSelectedViaDragHandle ?? false
            };
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) sharedState.isMouseOut = (0, $e895db8dd5f4f3b6$export$d14f503a2a677768).getState(editorState)?.isMouseOut ?? false;
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) sharedState.preservedSelection = (0, $fd0b1a7899796485$export$4d3f50627e188696).getState(editorState)?.preservedSelection;
            return sharedState;
        },
        contentComponent () {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b7423bc100799df8$export$cc5403d58ddfa812), {
                api: api
            });
        }
    });
module.exports["blockControlsPlugin"] = $3bece6cbff65939d$export$7a291905586a23d3;

});

parcelRegister("Yqd3z", function(module, exports) {
const $e7fc4d15e5a27605$export$21d634b1d5d9bee3 = '[data-editor-block-ctrl-drag-handle]';
const $e7fc4d15e5a27605$export$8e6a2e69f746ce30 = 12;
module.exports["DRAG_HANDLE_SELECTOR"] = $e7fc4d15e5a27605$export$21d634b1d5d9bee3;
module.exports["DRAG_HANDLE_WIDTH"] = $e7fc4d15e5a27605$export$8e6a2e69f746ce30;

});

parcelRegister("7f6xB", function(module, exports) {
/* HeadingLinksStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64491970f5adad44$var$wrapperStyles = null;
const $64491970f5adad44$export$b5a9f673a8d428df = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1tk1glyw _p7zlh2mm _wx3btlke _1cuh7vkz _1cgp1h22 _ubne14id _1gl21nu9 _12nk1nu9 _4v031nu9 _12fa1nu9 _syhn1nu9 _1r3i1nu9 _193y14id _13i6stnw _1sfutlke _w25x1qgb _rtxh92b3 _1gjm1ssu _99kk15i3 _12r2gktf _dv30gktf _10lodlk8 _1atodlk8"
        ])
    }, children);
};
module.exports["HeadingLinksStyleWrapper"] = $64491970f5adad44$export$b5a9f673a8d428df;

});

parcelRegister("6gbpH", function(module, exports) {
/* HubEditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $biMIt = parcelRequire("biMIt");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
const $47430e4f2bc1319c$var$HubEditorWrapperStyle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19121cl4 _piutysee _mnh0vuon _duwl16wv _zpcaihuw _1lp21h6o _14lf1wug _1tvp1i3y _d4p1xy5q _wpot1ejb _1bl4idpf _apxy1b66",
            __cmplp.className
        ])
    });
});
const $47430e4f2bc1319c$export$ce728530374e0386 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biMIt.AudienceSegmentationContextProvider), {
        isCompanyHub: true,
        shouldFetchUserGroups: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($47430e4f2bc1319c$var$HubEditorWrapperStyle, null, children));
};
module.exports["HubEditorWrapper"] = $47430e4f2bc1319c$export$ce728530374e0386;

});

parcelRegister("5y9PZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $50c349295b2bf74d$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('offlineMode');
const $50c349295b2bf74d$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $50c349295b2bf74d$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    browserState: 'online',
                    externalState: undefined
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($50c349295b2bf74d$export$df61b30b684217c0);
                if (meta) {
                    const { externalState: externalState, browserState: browserState } = meta;
                    return {
                        browserState: browserState ?? pluginState?.browserState,
                        externalState: externalState === null ? undefined : externalState ?? pluginState?.externalState
                    };
                }
                return pluginState;
            }
        }
    });
};


const $cc93caaff25557e0$export$aa1854019a007ea9 = ()=>{
    let previousMode;
    return {
        name: 'connectivity',
        getSharedState (editorState) {
            if (!editorState) return {
                mode: 'online'
            };
            const pluginState = (0, $50c349295b2bf74d$export$df61b30b684217c0).getState(editorState);
            return {
                mode: pluginState?.externalState ?? pluginState?.browserState ?? 'online'
            };
        },
        commands: {
            setMode: (mode)=>({ tr: tr })=>{
                    // Leave early if the mode has not changed
                    if (mode === previousMode) return null;
                    previousMode = mode;
                    return tr.setMeta((0, $50c349295b2bf74d$export$df61b30b684217c0), {
                        externalState: mode
                    });
                }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'connectivity',
                    plugin: (0, $50c349295b2bf74d$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $42omo.useEffect)(()=>{
                const dispatch = (value)=>{
                    const { dispatch: dispatch, state: { tr: tr } } = editorView;
                    dispatch(tr.setMeta((0, $50c349295b2bf74d$export$df61b30b684217c0), {
                        browserState: value
                    }));
                };
                const handleOnline = ()=>dispatch('online');
                const handleOffline = ()=>dispatch('offline');
                if (window.navigator.onLine === false) dispatch('offline');
                const cleanupOnlineListener = (0, $fFa3V.bind)(window, {
                    type: 'online',
                    listener: handleOnline
                });
                const cleanupOfflineListener = (0, $fFa3V.bind)(window, {
                    type: 'offline',
                    listener: handleOffline
                });
                return ()=>{
                    cleanupOnlineListener();
                    cleanupOfflineListener();
                };
            }, [
                editorView
            ]);
        }
    };
};
module.exports["connectivityPlugin"] = $cc93caaff25557e0$export$aa1854019a007ea9;

});

parcelRegister("3mcWz", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $6329756d44e49f4d$var$viewModePluginKey = new (0, $ks2lK.PluginKey)('editorViewMode');
const $6329756d44e49f4d$var$createPlugin = ({ initialMode: initialMode })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $6329756d44e49f4d$var$viewModePluginKey,
        state: {
            init: ()=>({
                    mode: initialMode ?? 'edit'
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($6329756d44e49f4d$var$viewModePluginKey);
                if (meta) return meta;
                return pluginState;
            }
        },
        props: {
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // We will fast-follow to consolidate the logic with `editor-disabled` so we don't
            // need this workaround.
            // @ts-expect-error
            editable: (state)=>{
                const mode = $6329756d44e49f4d$var$viewModePluginKey.getState(state)?.mode;
                return mode === 'view' ? false : undefined;
            }
        }
    });
};
const $6329756d44e49f4d$export$cc1df4562f7c69ec = ({ config: options, api: api })=>{
    return {
        name: 'editorViewMode',
        getSharedState (editorState) {
            if (!editorState) return {
                mode: options?.mode === 'view' ? 'view' : 'edit'
            }; // Skipping type safety for the deprecated mode property
            return {
                mode: $6329756d44e49f4d$var$viewModePluginKey.getState(editorState)?.mode ?? 'edit'
            }; // Skipping type safety for the deprecated mode property
        },
        commands: {
            updateViewMode: (mode)=>({ tr: tr })=>{
                    return tr.setMeta($6329756d44e49f4d$var$viewModePluginKey, {
                        mode: mode
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewMode',
                    plugin: ()=>$6329756d44e49f4d$var$createPlugin({
                            initialMode: options?.mode
                        })
                }
            ];
        }
    };
};
module.exports["editorViewModePlugin"] = $6329756d44e49f4d$export$cc1df4562f7c69ec;

});

parcelRegister("8ABVP", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $ks2lK = parcelRequire("ks2lK");

const $298a1bda4aacca07$export$236b6da1fbb1c083 = new (0, $ks2lK.PluginKey)('engagementPlatformPmPlugin');


const $2e8e057ed3cb7c5c$export$a47559fd89434a3 = (command)=>({ tr: tr })=>{
        const currentMeta = tr.getMeta((0, $298a1bda4aacca07$export$236b6da1fbb1c083)) ?? {
            commands: []
        };
        const newMeta = {
            ...currentMeta,
            commands: [
                ...currentMeta.commands,
                command
            ]
        };
        return tr.setMeta((0, $298a1bda4aacca07$export$236b6da1fbb1c083), newMeta);
    };


function $7c350c4caf0125ae$export$7a77c9a7b182680b(api, coordinationClient) {
    return (messageId, variationId)=>{
        if (!api) return Promise.resolve(false);
        // If the message is already started (even with `false` state), return the state
        const messageStates = api.engagementPlatform.sharedState.currentState()?.messageStates ?? {};
        const messageState = messageStates[messageId];
        if (messageState !== undefined) return Promise.resolve(messageState);
        // If there is already a start message promise, return it to prevent multiple start requests
        const startMessagePromises = api.engagementPlatform.sharedState.currentState()?.startMessagePromises ?? {};
        const startMessagePromise = startMessagePromises[messageId];
        if (startMessagePromise) return startMessagePromise;
        const newStartedMessagePromise = coordinationClient.start(messageId, variationId).then((isStarted)=>{
            // Update the message state in the shared state
            api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setMessageState',
                messageId: messageId,
                state: isStarted
            }));
            return isStarted;
        }).catch((error)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ENGAGEMENT_PLATFORM,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error instanceof Error ? error.message : `${error}`,
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            });
            return false;
        }).finally(()=>{
            // Remove the promise from the state after it has been resolved
            api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setStartMessagePromise',
                messageId: messageId,
                promise: undefined
            }));
        });
        // Store the promise in the shared state to prevent multiple start requests for the same message
        api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
            type: 'setStartMessagePromise',
            messageId: messageId,
            promise: newStartedMessagePromise
        }));
        return newStartedMessagePromise;
    };
}






function $ed55e7927e87749f$export$159ff839f1f095d2(api, coordinationClient) {
    return (messageId)=>{
        if (!api) return Promise.resolve(false);
        // If the message is already stopped, return `true`
        const messageStates = api.engagementPlatform.sharedState.currentState()?.messageStates ?? {};
        const isActive = messageStates[messageId];
        if (isActive === false) return Promise.resolve(true);
        // If there is already a stop message promise, return it to prevent multiple stop requests
        const stopMessagePromises = api.engagementPlatform.sharedState.currentState()?.stopMessagePromises ?? {};
        const stopMessagePromise = stopMessagePromises[messageId];
        if (stopMessagePromise) return stopMessagePromise;
        const newStopMessagePromise = coordinationClient.stop(messageId).then((isStopped)=>{
            // Update the message state in the shared state
            if (isStopped) api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setMessageState',
                messageId: messageId,
                state: false
            }));
            return isStopped;
        }).catch((error)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ENGAGEMENT_PLATFORM,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error instanceof Error ? error.message : `${error}`,
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            });
            return false;
        }).finally(()=>{
            // Remove the promise from the state after it has been resolved
            api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setStopMessagePromise',
                messageId: messageId,
                promise: undefined
            }));
        });
        // Store the promise in the shared state to prevent multiple stop requests for the same message
        api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
            type: 'setStopMessagePromise',
            messageId: messageId,
            promise: newStopMessagePromise
        }));
        return newStopMessagePromise;
    };
}



var $1S4f7 = parcelRequire("1S4f7");


const $0b6c8236b05396f7$export$33825561da15aa81 = (pluginConfig)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $298a1bda4aacca07$export$236b6da1fbb1c083),
        state: {
            init: ()=>{
                return {
                    messageStates: {},
                    startMessagePromises: {},
                    stopMessagePromises: {},
                    epComponents: pluginConfig.epComponents,
                    epHooks: pluginConfig.epHooks,
                    coordinationClient: pluginConfig.coordinationClient
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $298a1bda4aacca07$export$236b6da1fbb1c083));
                if (!meta) return pluginState;
                let state = {
                    ...pluginState
                };
                for (const command of meta.commands)switch(command.type){
                    case 'setMessageState':
                        state = {
                            ...state,
                            messageStates: {
                                ...state.messageStates,
                                [command.messageId]: command.state
                            }
                        };
                        break;
                    case 'setStartMessagePromise':
                        if (command.promise !== undefined) {
                            state = {
                                ...state,
                                startMessagePromises: {
                                    ...state.startMessagePromises,
                                    [command.messageId]: command.promise
                                }
                            };
                            break;
                        } else {
                            // If the promise is undefined, remove it from the state
                            const { [command.messageId]: _, ...startMessagePromises } = state.startMessagePromises;
                            state = {
                                ...state,
                                startMessagePromises: startMessagePromises
                            };
                        }
                        break;
                    case 'setStopMessagePromise':
                        if (command.promise !== undefined) {
                            state = {
                                ...state,
                                stopMessagePromises: {
                                    ...state.stopMessagePromises,
                                    [command.messageId]: command.promise
                                }
                            };
                            break;
                        } else {
                            // If the promise is undefined, remove it from the state
                            const { [command.messageId]: _, ...stopMessagePromises } = state.stopMessagePromises;
                            state = {
                                ...state,
                                stopMessagePromises: stopMessagePromises
                            };
                        }
                        break;
                }
                return state;
            }
        }
    });
};



const $3e71787c42cfad4f$export$5dda357eeee894b1 = ({ config: config, api: api })=>{
    return {
        name: 'engagementPlatform',
        actions: {
            startMessage: (0, $7c350c4caf0125ae$export$7a77c9a7b182680b)(api, config.coordinationClient),
            stopMessage: (0, $ed55e7927e87749f$export$159ff839f1f095d2)(api, config.coordinationClient)
        },
        pmPlugins () {
            return [
                {
                    name: 'engagementPlatformPmPlugin',
                    plugin: ()=>(0, $0b6c8236b05396f7$export$33825561da15aa81)(config)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $298a1bda4aacca07$export$236b6da1fbb1c083).getState(editorState);
        }
    };
};
module.exports["engagementPlatformPlugin"] = $3e71787c42cfad4f$export$5dda357eeee894b1;

});

parcelRegister("dH9DB", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $fFa3V = parcelRequire("fFa3V");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");




const $8f91eb19a5c08ca3$var$ACTIVE_SESSION_IDLE_TIME = 5000;
class $8f91eb19a5c08ca3$export$533c4bb863159234 {
    constructor(api){
        this.timerId = void 0;
        this.api = void 0;
        this.startTimer = ()=>{
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = window.setTimeout(()=>{
                if (this.api) this.api.core.actions.execute(this.api.metrics?.commands.stopActiveSession());
                this.cleanupTimer();
            }, $8f91eb19a5c08ca3$var$ACTIVE_SESSION_IDLE_TIME);
        };
        this.cleanupTimer = ()=>{
            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
        };
        this.timerId = null;
        this.api = api;
    }
}



var $d925B = parcelRequire("d925B");

function $1d3b27eba4f8242a$var$countNodesByType(fragment) {
    const counts = {};
    fragment.forEach((node)=>{
        counts[node.type.name] = (counts[node.type.name] || 0) + 1;
    });
    return counts;
}
const $1d3b27eba4f8242a$export$19c1cd683a3a7719 = ({ currentContent: currentContent, pluginState: pluginState })=>{
    if (pluginState?.initialContent) {
        const initialCounts = $1d3b27eba4f8242a$var$countNodesByType(pluginState.initialContent);
        const currentCounts = $1d3b27eba4f8242a$var$countNodesByType(currentContent);
        const netChanges = Object.keys({
            ...initialCounts,
            ...currentCounts
        }).filter((value)=>![
                'paragraph',
                'heading'
            ].includes(value)).reduce((changes, nodeType)=>{
            const change = (currentCounts[nodeType] || 0) - (initialCounts[nodeType] || 0);
            if (change !== 0) changes[nodeType] = change;
            return changes;
        }, {});
        return netChanges;
    }
    return {};
};


const $ce6be75fb626e89b$export$4feda93c1c6b2d80 = ({ currentContent: currentContent, pluginState: pluginState, toolbarDocking: toolbarDocking })=>{
    const nodeChanges = (0, $1d3b27eba4f8242a$export$19c1cd683a3a7719)({
        currentContent: currentContent,
        pluginState: pluginState
    });
    const getActionCountByTypeSum = ()=>{
        let actionCountByTypeSum = 0;
        Object.entries(pluginState.actionTypeCount).forEach(([_actionType, count])=>{
            actionCountByTypeSum += count;
        });
        return pluginState.totalActionCount - actionCountByTypeSum;
    };
    let nodeInsertionCount = 0;
    let nodeDeletionCount = 0;
    Object.entries(nodeChanges).forEach(([_, change])=>{
        if (change > 0) nodeInsertionCount += change;
        else if (change < 0) nodeDeletionCount += Math.abs(change);
    });
    return {
        action: (0, $d925B.ACTION).ENDED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ACTIVITY_SESSION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ACTIVITY,
        attributes: {
            efficiency: {
                totalActiveTime: pluginState.activeSessionTime / 1000,
                totalActionCount: pluginState.totalActionCount,
                actionByTypeCount: {
                    ...pluginState.actionTypeCount ?? {},
                    nodeDeletionCount: nodeDeletionCount,
                    nodeInsertionCount: nodeInsertionCount,
                    other: getActionCountByTypeSum()
                }
            },
            effectiveness: {
                undoCount: pluginState.actionTypeCount.undoCount,
                repeatedActionCount: pluginState.repeatedActionCount,
                safeInsertCount: pluginState.safeInsertCount
            },
            contentSizeChanged: pluginState.contentSizeChanged,
            toolbarDocking: toolbarDocking
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};



var $aXG5V = parcelRequire("aXG5V");


var $00c3987b79c8d52d$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["TEXT_INPUT"] = "textInput";
    ActionType["EMPTY_LINE_ADDED_OR_DELETED"] = "emptyLineAddedOrDeleted";
    ActionType["INSERTED_FROM_TYPE_AHEAD"] = "insertedFromTypeAhead";
    ActionType["INSERTING_NEW_LIST_TYPE_NODE"] = "insertingNewListTypeNode";
    ActionType["UPDATING_NEW_LIST_TYPE_ITEM"] = "updatingNewListItem";
    ActionType["ADDING_LINK"] = "addingLink";
    ActionType["UPDATING_STATUS"] = "updatingStatus";
    ActionType["CHANGING_MARK"] = "changingMark";
    ActionType["CHANGING_ATTRS"] = "changingAttrs";
    ActionType["MOVING_CONTENT"] = "contentMoved";
    ActionType["PASTING_CONTENT"] = "contentPasted";
    ActionType["DELETING_CONTENT"] = "deletingContent";
    ActionType["SAFE_INSERT"] = "safeInsert";
    ActionType["UNDO"] = "undo";
    return ActionType;
}({});


const $781c8d2cd5f6b12a$var$UI_EVENT = 'uiEvent';
const $781c8d2cd5f6b12a$var$PASTE_EVENT = 'paste';
const $781c8d2cd5f6b12a$export$dd95ad7faeb49efb = (tr)=>{
    const isContentMoved = tr.getMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b))?.contentMoved;
    const isContentPasted = tr.getMeta($781c8d2cd5f6b12a$var$UI_EVENT) === $781c8d2cd5f6b12a$var$PASTE_EVENT;
    if (isContentMoved) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).MOVING_CONTENT
    };
    if (isContentPasted) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).PASTING_CONTENT
    };
    return undefined;
};



const $58e217490bfea9c2$export$37e6d8d5ff035b23 = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const isDeletingContent = to !== from && content.childCount === 0;
    if (!isDeletingContent) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).DELETING_CONTENT
    };
};



const $c8e6cc7ad83c39fa$export$3b8bead5689e4d0b = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const isEmptyLineDeleted = to - from === 2 && content.size === 0;
    if (isEmptyLineDeleted) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
    };
    let isEmptyLineAdded = false;
    content.forEach((node)=>{
        isEmptyLineAdded = node.type.name === 'paragraph' && node.content.size === 0;
    });
    if (!isEmptyLineAdded) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
    };
};



const $c182a1d183e1eae0$export$3dd64ceb881e5e4e = (step)=>{
    const { slice: { content: content } } = step;
    const childCount = content.childCount;
    if (childCount < 1) return undefined;
    for (const node of content.content){
        const isListTypeNode = [
            'decisionList',
            'decisionItem',
            'bulletList',
            'listItem',
            'orderedList',
            'taskList',
            'taskItem'
        ].includes(node.type.name);
        if (isListTypeNode) return childCount === 1 ? {
            type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).INSERTING_NEW_LIST_TYPE_NODE
        } : {
            type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM
        };
    }
    return undefined;
};






const $426d5487c4115f22$export$c93a5d700df353f0 = (step)=>{
    if (!(step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep))) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_MARK
    };
};



const $69ed531524cec504$var$compareAttributes = (prevAttr, newAttr)=>{
    const allKeys = new Set([
        ...Object.keys(prevAttr),
        ...Object.keys(newAttr)
    ]);
    for (const key of allKeys){
        const prevValue = prevAttr[key];
        const newValue = newAttr[key];
        if (prevValue !== newValue && key !== 'localId') return key;
    }
    return undefined;
};
const $69ed531524cec504$var$compareMarks = (prevMarks, newMarks)=>{
    if (!prevMarks && !newMarks) return undefined;
    const previousMarksArr = new Map(prevMarks.map((mark)=>[
            mark.type.name,
            mark.attrs
        ]));
    const newMarksArr = new Map(newMarks.map((mark)=>[
            mark.type.name,
            mark.attrs
        ]));
    const allMarks = new Set([
        ...previousMarksArr.keys(),
        ...newMarksArr.keys()
    ]);
    for (const key of allMarks){
        const previousValue = previousMarksArr.get(key);
        const newValue = newMarksArr.get(key);
        if (JSON.stringify(previousValue) !== JSON.stringify(newValue)) return key;
    }
    return undefined;
};
const $69ed531524cec504$export$460c78c4e7d0df18 = (tr, step)=>{
    const { slice: slice, from: from, to: to } = step;
    const oldNode = tr.docs[0].nodeAt(from);
    const newNode = slice.content.firstChild;
    if (!oldNode || !newNode) return undefined;
    if (oldNode.type.name !== newNode.type.name) return undefined;
    // We need to compare the attributes of the node
    const changedAttr = $69ed531524cec504$var$compareAttributes(oldNode.attrs, newNode.attrs);
    if (changedAttr) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: changedAttr,
            from: from,
            to: to
        }
    };
    // For some changes, we need to compare the marks of the node
    // e.g. Media Border, Links
    const changedMarks = $69ed531524cec504$var$compareMarks(oldNode.marks, newNode.marks);
    if (changedMarks) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: changedMarks,
            from: from,
            to: to
        }
    };
    return undefined;
};



const $5ecfe415ab8e1348$export$dfe6977d1be089c2 = (step)=>{
    const { slice: slice } = step;
    const firstChild = slice.content.firstChild;
    if (!firstChild) return undefined;
    // Get statusId so that we can track whether edits are performed on same status node
    return firstChild.type.name === 'status' ? {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS,
        extraData: {
            statusId: firstChild.attrs.localId
        }
    } : undefined;
};



var $7Mtx3 = parcelRequire("7Mtx3");





const $a3d93f3aadbab099$export$99fad7bb37d9329a = (tr)=>{
    const COL_WIDTH_ATTR = 'colwidth';
    const steps = tr.steps;
    // Find the step that is changing the column width
    const resizingColumnStep = steps.find((step)=>step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $7Mtx3.BatchAttrsStep));
    if (!resizingColumnStep) return undefined;
    let pos;
    // Find the position of the first column in the step that is being resized
    if (resizingColumnStep instanceof (0, $7Mtx3.BatchAttrsStep)) {
        if (resizingColumnStep.data.length === 0) return undefined;
        const { attrs: attrs, nodeType: nodeType, position: position } = resizingColumnStep.data[0];
        if ([
            'tableHeader',
            'tableCell'
        ].includes(nodeType) && attrs?.[COL_WIDTH_ATTR]) pos = position;
    } else if (resizingColumnStep instanceof (0, $aXG5V.AttrStep) && resizingColumnStep.attr === COL_WIDTH_ATTR) pos = resizingColumnStep.pos;
    if (!pos) return undefined;
    // Find the range of the table that is being resized
    const $pos = tr.doc.resolve(pos);
    const blockRange = $pos.blockRange();
    if (!blockRange) return undefined;
    const from = blockRange.start;
    const to = from + blockRange.parent.content.size;
    // Use to and from position of table to check whether column width of same table is being resized
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: COL_WIDTH_ATTR,
            from: from,
            to: to
        }
    };
};



const $c00be276ac262a0f$export$1a2f61e1ac72166a = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const node = content.firstChild;
    const isAddingCharacter = from === to && content.childCount === 1 && !!node && !!node.text && node.text.length === 1;
    const isDeletingCharacter = to - from === 1 && content.childCount === 0;
    const isTextInput = isAddingCharacter || isDeletingCharacter;
    if (!isTextInput) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT
    };
};


const $a51de28a7810fdcf$export$ea477ab911425d3e = (tr)=>{
    const stepsLength = tr.steps.length;
    if (stepsLength <= 0) return undefined;
    const contentPastedOrMoved = (0, $781c8d2cd5f6b12a$export$dd95ad7faeb49efb)(tr);
    if (contentPastedOrMoved) return contentPastedOrMoved;
    // Resized column data is either AttrStep or BatchAttrsStep, so we want to check it first
    const resizedColumnData = (0, $a3d93f3aadbab099$export$99fad7bb37d9329a)(tr);
    if (resizedColumnData) return resizedColumnData;
    // Since we are looking at editor actions, we want to look at the first step only
    const [firstStep] = tr.steps;
    const isReplaceStep = firstStep instanceof (0, $aXG5V.ReplaceStep);
    const isReplaceAroundStep = firstStep instanceof (0, $aXG5V.ReplaceAroundStep);
    // Check if mark is added or removed, this is for text formatting changes
    const marksChanged = (0, $426d5487c4115f22$export$c93a5d700df353f0)(firstStep);
    if (marksChanged) return marksChanged;
    // Return early if it's not a replace step or replace around step as following checks are for these steps only
    if (!(isReplaceStep || isReplaceAroundStep)) return undefined;
    if (isReplaceStep) {
        // Check if tr is text input as we want to ignore continuous typing actions
        const textInput = (0, $c00be276ac262a0f$export$1a2f61e1ac72166a)(firstStep);
        if (textInput) return textInput;
        // Check if tr is adding/ removing empty lines as we want to ignore continuous typing actions
        const emptyLineAddedOrDeleted = (0, $c8e6cc7ad83c39fa$export$3b8bead5689e4d0b)(firstStep);
        if (emptyLineAddedOrDeleted) return emptyLineAddedOrDeleted;
        //Check if tr is removing content
        const isDeletingContent = (0, $58e217490bfea9c2$export$37e6d8d5ff035b23)(firstStep);
        if (isDeletingContent) return isDeletingContent;
        // Status nodes save status content in attributes and a new transaction is fired each keypress
        // Check if tr is updating status so we can handle actionCount correctly
        const status = (0, $5ecfe415ab8e1348$export$dfe6977d1be089c2)(firstStep);
        if (status) return status;
    }
    // Check if tr is updating list type node because we want to ignore continuous typing actions and adding new list items
    const updatingListTypeNode = (0, $c182a1d183e1eae0$export$3dd64ceb881e5e4e)(firstStep);
    if (updatingListTypeNode) return updatingListTypeNode;
    // Check if tr is updating node attributes so we can track nodeAttributeChangeCount
    const nodeAttributeChange = (0, $69ed531524cec504$export$460c78c4e7d0df18)(tr, firstStep);
    if (nodeAttributeChange) return nodeAttributeChange;
    return undefined;
};






const $4b11a2a6f46f529e$export$8e97e3f7bfe68ba6 = (tr)=>{
    if (tr.getMeta('undoRedoPlugin$') === undefined) return false;
    let hasNonTextChange = false;
    tr.steps.forEach((step)=>{
        if (step instanceof (0, $aXG5V.ReplaceStep)) {
            const { slice: slice } = step;
            if (slice.content) slice.content.forEach((node)=>{
                if (node.type.name !== 'text') hasNonTextChange = true;
            });
        } else hasNonTextChange = true;
    });
    return hasNonTextChange;
};





const $f03e13d311a61bf0$export$70c169bac24eb87d = (tr, insertPos, trType)=>{
    // Exclude the cases where trType is defined, as it is a specific action
    // that should not be considered for safe insert actions
    if (trType) return false;
    if (insertPos > tr.doc.content.size) return false;
    const [firstStep] = tr.steps;
    if (!(firstStep instanceof (0, $aXG5V.ReplaceStep))) return false;
    const firstStepPos = firstStep.from;
    if (firstStepPos === insertPos) return false;
    const $firstStepPos = tr.doc.resolve(firstStepPos);
    if ($firstStepPos.node().type.name === 'paragraph') return false;
    const firstStepParentNodeType = $firstStepPos.node($firstStepPos.depth)?.type.name;
    const $insertPos = tr.doc.resolve(insertPos);
    const parentNodeType = $insertPos.node($insertPos.depth - 1)?.type.name;
    return parentNodeType !== firstStepParentNodeType;
};


const $ab40e8b2935f417b$var$textInputActions = [
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT,
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
];
const $ab40e8b2935f417b$var$listActions = [
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM,
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).INSERTING_NEW_LIST_TYPE_NODE
];
const $ab40e8b2935f417b$var$continuousActions = [
    ...$ab40e8b2935f417b$var$textInputActions,
    ...$ab40e8b2935f417b$var$listActions,
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS
];
const $ab40e8b2935f417b$var$checkIsDesiredAction = (trType, desiredActions)=>{
    return trType && desiredActions.includes(trType.type);
};
const $ab40e8b2935f417b$var$getNewActionTypeCount = (shouldIncrement, currentCount)=>{
    return shouldIncrement ? currentCount + 1 : currentCount;
};
const $ab40e8b2935f417b$export$e128bc0c2209d622 = ({ now: now, intentToStartEditTime: intentToStartEditTime, shouldPersistActiveSession: shouldPersistActiveSession, tr: tr, pluginState: pluginState, oldState: oldState, newState: newState })=>{
    const { actionTypeCount: actionTypeCount, timeOfLastTextInput: timeOfLastTextInput, totalActionCount: totalActionCount, previousTrType: previousTrType, safeInsertCount: safeInsertCount, contentSizeChanged: contentSizeChanged } = pluginState;
    const newPluginState = {
        ...pluginState,
        activeSessionTime: now - intentToStartEditTime,
        contentSizeChanged: contentSizeChanged + Math.abs(newState.doc.content.size - oldState.doc.content.size),
        intentToStartEditTime: intentToStartEditTime,
        shouldPersistActiveSession: shouldPersistActiveSession
    };
    const trType = (0, $a51de28a7810fdcf$export$ea477ab911425d3e)(tr);
    const newSafeInsertCount = $ab40e8b2935f417b$var$getNewActionTypeCount((0, $f03e13d311a61bf0$export$70c169bac24eb87d)(tr, oldState.tr.selection.from, trType?.type), safeInsertCount);
    const newUndoCount = $ab40e8b2935f417b$var$getNewActionTypeCount((0, $4b11a2a6f46f529e$export$8e97e3f7bfe68ba6)(tr), actionTypeCount.undoCount);
    if (!trType) return {
        ...newPluginState,
        totalActionCount: totalActionCount + 1,
        timeOfLastTextInput: undefined,
        actionTypeCount: {
            ...actionTypeCount,
            undoCount: newUndoCount
        },
        previousTrType: trType,
        safeInsertCount: newSafeInsertCount
    };
    // Below are conditions for special cases which should not increase action count if the previous action was the same or was textInput
    // Check if tr is updating the same status node
    const isNotNewStatus = trType.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS && previousTrType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS && trType?.extraData?.statusId === previousTrType?.extraData?.statusId;
    // Check if tr is adding text after adding a list node
    const isAddingTextToListNode = trType.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT && $ab40e8b2935f417b$var$checkIsDesiredAction(previousTrType, $ab40e8b2935f417b$var$listActions);
    // Check if tr is adding new list item after text input
    const isAddingNewListItemAfterTextInput = previousTrType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT && trType.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM;
    // Check if tr is textInput
    const isTextInput = $ab40e8b2935f417b$var$textInputActions.includes(trType.type);
    // Don't increment action count if tr is text input, not a new status, adding text to list node or adding new list item if timeOfLastTextInput is set
    const shouldNotIncrementActionCount = timeOfLastTextInput && (isTextInput || isNotNewStatus || isAddingTextToListNode || isAddingNewListItemAfterTextInput);
    const newTotalActionCount = $ab40e8b2935f417b$var$getNewActionTypeCount(!shouldNotIncrementActionCount, totalActionCount);
    // Increment textInputCount if tr is text input and previous action was not text input or list action
    const newTextInputCount = $ab40e8b2935f417b$var$getNewActionTypeCount(isTextInput && !(timeOfLastTextInput && $ab40e8b2935f417b$var$checkIsDesiredAction(previousTrType, [
        ...$ab40e8b2935f417b$var$textInputActions,
        ...$ab40e8b2935f417b$var$listActions
    ])), actionTypeCount.textInputCount);
    const newNodeAttrCount = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS, actionTypeCount.nodeAttributeChangeCount);
    const isRepeatedAttrAction = trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS && previousTrType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS && trType.extraData.attr === previousTrType.extraData.attr && trType.extraData.from === previousTrType.extraData.from && trType.extraData.to === previousTrType.extraData.to;
    const newRepeatedActionCount = $ab40e8b2935f417b$var$getNewActionTypeCount(isRepeatedAttrAction, pluginState.repeatedActionCount);
    const contentMoved = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).MOVING_CONTENT, actionTypeCount.contentMovedCount);
    const newMarkChangeCount = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_MARK, actionTypeCount.markChangeCount);
    const newContentDeletedCount = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).DELETING_CONTENT, actionTypeCount.contentDeletedCount);
    // timeOfLastTextInput should be set if tr includes continuous text input on the same node
    const shouldSetTimeOfLastTextInput = $ab40e8b2935f417b$var$continuousActions.includes(trType.type) || isNotNewStatus;
    return {
        ...newPluginState,
        totalActionCount: newTotalActionCount,
        timeOfLastTextInput: shouldSetTimeOfLastTextInput ? now : undefined,
        actionTypeCount: {
            ...actionTypeCount,
            textInputCount: newTextInputCount,
            undoCount: newUndoCount,
            nodeAttributeChangeCount: newNodeAttrCount,
            contentMovedCount: contentMoved,
            markChangeCount: newMarkChangeCount,
            contentDeletedCount: newContentDeletedCount
        },
        previousTrType: trType,
        repeatedActionCount: newRepeatedActionCount,
        safeInsertCount: newSafeInsertCount
    };
};








const $49f426e5228e5ede$export$d18f9a4086c7ba4 = (tr)=>tr.steps.length > 0 && tr.steps?.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep) || step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $aXG5V.RemoveMarkStep) || step instanceof (0, $7Mtx3.BatchAttrsStep));



var $cuprm = parcelRequire("cuprm");

var $8EkET = parcelRequire("8EkET");




const $c9df803a4bd88351$var$isResolvingLink = (tr)=>{
    // When links are added, there are two transactions that are fired and we want to ignore the last one where the link is resolved
    const linkStep = tr.steps.find((step)=>step instanceof (0, $8EkET.LinkMetaStep));
    const hasReplaceStep = tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep));
    return Boolean(hasReplaceStep && linkStep instanceof (0, $8EkET.LinkMetaStep) && linkStep.getMetadata()?.cardAction === 'RESOLVE');
};
const $c9df803a4bd88351$var$checkTypeAheadStepStage = (tr)=>{
    // When nodes are inserted from typeahead, there are multiple transactions that are fired that changes the document
    // We want to ignore all but the last transaction where the node is inserted
    if (tr.getMeta('typeAheadPlugin$')?.action === 'INSERT_RAW_QUERY') return 'INSERT_RAW_QUERY';
    if (!tr.getMeta('appendedTransaction')) return false;
    const insertTypeAheadStep = tr.steps.find((step)=>step instanceof (0, $cuprm.InsertTypeAheadStep));
    const replaceStep = tr.steps.find((step)=>step instanceof (0, $aXG5V.ReplaceStep));
    if (!insertTypeAheadStep || !replaceStep) return false;
    return insertTypeAheadStep instanceof (0, $cuprm.InsertTypeAheadStep) && insertTypeAheadStep.stage;
};
const $c9df803a4bd88351$export$54b973d42577e602 = (tr)=>{
    if ($c9df803a4bd88351$var$isResolvingLink(tr)) return true;
    const typeAheadStepStage = $c9df803a4bd88351$var$checkTypeAheadStepStage(tr);
    if (typeAheadStepStage) return typeAheadStepStage !== 'INSERTING_ITEM';
    else // Ignore all appended transactions apart from when typeahead is inserting an item
    return tr.getMeta('appendedTransaction');
};


const $80fe32b43f4a18a7$export$25eda213007f3f3b = new (0, $ks2lK.PluginKey)('metricsPlugin');
const $80fe32b43f4a18a7$export$730217bf68c4a14 = {
    intentToStartEditTime: undefined,
    lastSelection: undefined,
    activeSessionTime: 0,
    totalActionCount: 0,
    contentSizeChanged: 0,
    shouldPersistActiveSession: undefined,
    timeOfLastTextInput: undefined,
    initialContent: undefined,
    actionTypeCount: {
        textInputCount: 0,
        nodeInsertionCount: 0,
        nodeAttributeChangeCount: 0,
        contentMovedCount: 0,
        nodeDeletionCount: 0,
        undoCount: 0,
        markChangeCount: 0,
        contentDeletedCount: 0
    },
    repeatedActionCount: 0,
    safeInsertCount: 0
};
const $80fe32b43f4a18a7$export$ae829ec7b2625219 = (api, userPreferencesProvider)=>{
    const timer = new (0, $8f91eb19a5c08ca3$export$533c4bb863159234)(api);
    return new (0, $1S4f7.SafePlugin)({
        key: $80fe32b43f4a18a7$export$25eda213007f3f3b,
        state: {
            init: (_, state)=>{
                return {
                    ...$80fe32b43f4a18a7$export$730217bf68c4a14,
                    initialContent: state.doc.content
                };
            },
            // eslint-disable-next-line @typescript-eslint/max-params
            apply (tr, pluginState, oldState, newState) {
                // Return if transaction is remote or replaceDocument is set
                if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument')) return pluginState;
                const meta = tr.getMeta($80fe32b43f4a18a7$export$25eda213007f3f3b);
                // If the active session is stopped, reset the plugin state, and set initialContent to new doc content
                if (meta && meta.stopActiveSession) return {
                    ...$80fe32b43f4a18a7$export$730217bf68c4a14,
                    initialContent: newState.doc.content
                };
                const shouldPersistActiveSession = meta?.shouldPersistActiveSession ?? pluginState.shouldPersistActiveSession;
                const hasDocChanges = (0, $49f426e5228e5ede$export$d18f9a4086c7ba4)(tr);
                let intentToStartEditTime = meta?.intentToStartEditTime || pluginState.intentToStartEditTime;
                const now = performance.now();
                // If there is no intentToStartEditTime and there are no doc changes, return the plugin state
                if (!intentToStartEditTime && !hasDocChanges && !tr.storedMarksSet) return {
                    ...pluginState,
                    shouldPersistActiveSession: shouldPersistActiveSession
                };
                // Set intentToStartEditTime if it is not set and there are doc changes or marks are set
                if (!intentToStartEditTime && (hasDocChanges || tr.storedMarksSet)) intentToStartEditTime = now;
                // Start active session timer if intentToStartEditTime is defined, shouldStartTimer is true and shouldPersistActiveSession is false
                // shouldPersistActiveSession is true when dragging block controls and when insert menu is open as user is interacting with the editor without making doc changes
                // Timer should start when menu closes or dragging stops
                if (intentToStartEditTime && meta?.shouldStartTimer && !shouldPersistActiveSession) timer.startTimer();
                if (hasDocChanges) {
                    timer.startTimer();
                    if ((0, $c9df803a4bd88351$export$54b973d42577e602)(tr)) return {
                        ...pluginState,
                        shouldPersistActiveSession: shouldPersistActiveSession
                    };
                    const newPluginState = (0, $ab40e8b2935f417b$export$e128bc0c2209d622)({
                        now: now,
                        intentToStartEditTime: intentToStartEditTime,
                        shouldPersistActiveSession: shouldPersistActiveSession,
                        tr: tr,
                        pluginState: pluginState,
                        oldState: oldState,
                        newState: newState
                    });
                    return newPluginState;
                }
                return {
                    ...pluginState,
                    lastSelection: meta?.newSelection || pluginState.lastSelection,
                    intentToStartEditTime: intentToStartEditTime,
                    shouldPersistActiveSession: shouldPersistActiveSession
                };
            }
        },
        view (view) {
            const fireAnalyticsEvent = ()=>{
                const pluginState = $80fe32b43f4a18a7$export$25eda213007f3f3b.getState(view.state);
                if (!pluginState) return;
                let toolbarDocking;
                if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) toolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                const payloadToSend = (0, $ce6be75fb626e89b$export$4feda93c1c6b2d80)({
                    currentContent: view.state.doc.content,
                    pluginState: pluginState,
                    toolbarDocking: toolbarDocking || undefined
                });
                if (pluginState && pluginState.totalActionCount > 0 && pluginState.activeSessionTime > 0) api?.analytics?.actions?.fireAnalyticsEvent(payloadToSend, undefined, {
                    immediate: true
                });
            };
            const unbindBeforeUnload = (0, $fFa3V.bind)(window, {
                type: 'beforeunload',
                listener: ()=>{
                    fireAnalyticsEvent();
                }
            });
            return {
                destroy () {
                    fireAnalyticsEvent();
                    timer.cleanupTimer();
                    unbindBeforeUnload();
                }
            };
        },
        props: {
            handleDOMEvents: {
                click: (view)=>{
                    const newSelection = view.state.tr.selection;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (pluginState?.lastSelection?.from !== newSelection.from && pluginState?.lastSelection?.to !== newSelection.to) api?.core.actions.execute(api?.metrics.commands.handleIntentToStartEdit({
                        newSelection: newSelection
                    }));
                    return false;
                }
            }
        }
    });
};



const $8d1bee59aa63c32d$export$3353f6727450fd85 = ({ config: config, api: api })=>({
        name: 'metrics',
        pmPlugins () {
            return [
                {
                    name: 'metrics',
                    plugin: ()=>(0, $80fe32b43f4a18a7$export$ae829ec7b2625219)(api, config?.userPreferencesProvider)
                }
            ];
        },
        commands: {
            setContentMoved: ()=>({ tr: tr })=>{
                    return tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        contentMoved: true
                    });
                },
            startActiveSessionTimer: ()=>({ tr: tr })=>{
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (!pluginState?.intentToStartEditTime) return tr;
                    return tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        shouldStartTimer: true,
                        shouldPersistActiveSession: false
                    });
                },
            stopActiveSession: ()=>({ tr: tr })=>{
                    if (!api) return tr;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (pluginState?.shouldPersistActiveSession) return tr;
                    if (pluginState && pluginState.totalActionCount > 0 && pluginState.activeSessionTime > 0) {
                        let toolbarDocking;
                        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) toolbarDocking = toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : config?.userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                        const payloadToSend = (0, $ce6be75fb626e89b$export$4feda93c1c6b2d80)({
                            currentContent: tr.doc.content,
                            pluginState: pluginState,
                            toolbarDocking: toolbarDocking || undefined
                        });
                        api?.analytics?.actions.attachAnalyticsEvent(payloadToSend)(tr);
                    }
                    tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        stopActiveSession: true
                    });
                    tr.setMeta('scrollIntoView', false);
                    tr.setMeta('addToHistory', false);
                    return tr;
                },
            handleIntentToStartEdit: ({ newSelection: newSelection, shouldStartTimer: shouldStartTimer = true, shouldPersistActiveSession: shouldPersistActiveSession })=>({ tr: tr })=>{
                    if (!api) return tr;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (shouldPersistActiveSession && pluginState?.intentToStartEditTime) return tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        shouldPersistActiveSession: shouldPersistActiveSession
                    });
                    if (!pluginState || pluginState.intentToStartEditTime) return tr;
                    tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        intentToStartEditTime: performance.now(),
                        shouldStartTimer: shouldStartTimer,
                        newSelection: newSelection,
                        shouldPersistActiveSession: shouldPersistActiveSession
                    });
                    return tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return 0, $80fe32b43f4a18a7$export$730217bf68c4a14;
            return (0, $80fe32b43f4a18a7$export$25eda213007f3f3b).getState(editorState);
        }
    });
module.exports["metricsPlugin"] = $8d1bee59aa63c32d$export$3353f6727450fd85;

});

parcelRegister("kcvNv", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $ajtqX = parcelRequire("ajtqX");


var $1S4f7 = parcelRequire("1S4f7");


var $d925B = parcelRequire("d925B");

const $b7f2ebaf15dc8b31$export$ccab2b64c5d440 = (sessionStepMetrics)=>{
    return {
        action: (0, $d925B.ACTION).NCS_SESSION_STEP_METRICS,
        actionSubject: (0, $d925B.ACTION_SUBJECT).COLLAB,
        attributes: sessionStepMetrics,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};



var $25jxS = parcelRequire("25jxS");


var $kt8c2 = parcelRequire("kt8c2");


/**
 * Calculates the 90th percentile value from an array of step sizes.
 * @param stepSizeSumFor90 - An array of step sizes to calculate the 90th percentile value.
 * @returns
 */ const $2f4118c9c86a9112$export$6a22bffac697349 = (stepSizeSumFor90)=>{
    if (!stepSizeSumFor90 || stepSizeSumFor90?.length === 0) return 0;
    const sortedSteps = stepSizeSumFor90.sort((a, b)=>a - b);
    const p90Index = Math.ceil(0.9 * sortedSteps.length) - 1;
    return sortedSteps[p90Index] || 0;
};


const $29f56673b0f31509$var$storageClient = new (0, $kt8c2.default)((0, $25jxS.NCS_STORAGE).NCS_STORAGE_CLIENT_KEY);
/**
 * This function transforms the NCS session step metrics
 * into a format suitable for analytics events.
 * @param metrics - The NCS session step metrics to be transformed.
 */ const $29f56673b0f31509$var$transformSessionStepMetrics = (metrics)=>{
    return {
        ncsSessionId: metrics.ncsSessionId,
        totalStepSize: metrics.totalStepSize,
        numberOfSteps: metrics.numberOfSteps,
        maxStepSize: metrics.maxStepSize,
        p90StepSize: (0, $2f4118c9c86a9112$export$6a22bffac697349)(metrics.stepSizeSumForP90)
    };
};
const $29f56673b0f31509$export$4fe9abcf7996805c = (sessionId)=>{
    if (!sessionId) return;
    const ncsSessionStepMetrics = JSON.parse($29f56673b0f31509$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    const current = ncsSessionStepMetrics[sessionId];
    if (current) return $29f56673b0f31509$var$transformSessionStepMetrics(current);
    return undefined;
};
const $29f56673b0f31509$export$640e7406945bdef4 = (sessionId)=>{
    if (!sessionId) return;
    // Clear the current NCS session step metrics from storage
    const ncsSessionStepMetrics = JSON.parse($29f56673b0f31509$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    if (ncsSessionStepMetrics[sessionId]) {
        delete ncsSessionStepMetrics[sessionId];
        if (Object.keys(ncsSessionStepMetrics).length === 0) $29f56673b0f31509$var$storageClient.removeItem((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS);
        else $29f56673b0f31509$var$storageClient.setItemWithExpiry((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS, JSON.stringify(ncsSessionStepMetrics));
    }
    // Clear the active session from storage
    $29f56673b0f31509$export$54d394eae73ee0f9(sessionId);
};
const $29f56673b0f31509$export$54d394eae73ee0f9 = (sessionId)=>{
    if (!sessionId) return;
    const activeSessions = JSON.parse($29f56673b0f31509$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS) || '{}');
    if (activeSessions[sessionId]) {
        delete activeSessions[sessionId];
        if (Object.keys(activeSessions).length === 0) $29f56673b0f31509$var$storageClient.removeItem((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS);
        else $29f56673b0f31509$var$storageClient.setItemWithExpiry((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS, JSON.stringify(activeSessions));
    }
};
const $29f56673b0f31509$export$b9ad7e6f409a8c9b = (api)=>{
    const ncsSessionStepMetrics = JSON.parse($29f56673b0f31509$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    const activeNcsSessions = JSON.parse($29f56673b0f31509$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS) || '{}');
    Object.keys(ncsSessionStepMetrics).forEach((id)=>{
        if (!activeNcsSessions[id]) {
            const metrics = $29f56673b0f31509$var$transformSessionStepMetrics(ncsSessionStepMetrics[id]);
            if (metrics) {
                const payload = (0, $b7f2ebaf15dc8b31$export$ccab2b64c5d440)(metrics);
                api?.analytics?.actions?.fireAnalyticsEvent(payload);
                $29f56673b0f31509$export$640e7406945bdef4(id);
            }
        }
    });
};


const $76ea322f0da7e317$export$209ae7648d2a7a31 = ({ api: api })=>{
    let sessionId;
    let createAnalyticsEvent;
    return {
        name: 'ncsStepMetrics',
        pmPlugins () {
            return [
                {
                    name: 'ncsStepMetricsPlugin',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            view: ()=>{
                                api?.collabEdit?.sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
                                    if (nextSharedState.sessionId !== undefined && sessionId !== nextSharedState.sessionId) {
                                        sessionId = nextSharedState.sessionId;
                                        (0, $29f56673b0f31509$export$b9ad7e6f409a8c9b)(api);
                                    }
                                });
                                const unsubscribeAnalytics = api?.analytics?.sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
                                    if (nextSharedState.createAnalyticsEvent) {
                                        createAnalyticsEvent = nextSharedState.createAnalyticsEvent;
                                        unsubscribeAnalytics?.();
                                    }
                                });
                                let analyticsEventSent = false;
                                const sendAnalyticsEvent = ()=>{
                                    if (analyticsEventSent || !createAnalyticsEvent || !sessionId) return;
                                    analyticsEventSent = true;
                                    const ncsSessionStepMetrics = (0, $29f56673b0f31509$export$4fe9abcf7996805c)(sessionId);
                                    if (!ncsSessionStepMetrics) return;
                                    // At this point in the editor lifecycle, we no longer have access to the analytics api
                                    // So we use the stored `createAnalyticsEvent` function to send the event
                                    (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent, {
                                        immediate: true
                                    })({
                                        payload: (0, $b7f2ebaf15dc8b31$export$ccab2b64c5d440)(ncsSessionStepMetrics)
                                    });
                                    (0, $29f56673b0f31509$export$640e7406945bdef4)(sessionId);
                                };
                                const handleBeforeUnload = ()=>{
                                    // On beforeunload, we want to clear the active session
                                    // So when the editor is re-initialized, it will send the stored analytics event
                                    (0, $29f56673b0f31509$export$54d394eae73ee0f9)(sessionId);
                                };
                                const unbindBeforeUnload = (0, $fFa3V.bind)(window, {
                                    type: 'beforeunload',
                                    listener: handleBeforeUnload
                                });
                                return {
                                    destroy () {
                                        /**
										 * We use requestAnimationFrame to ensure that the editor has been unmounted
										 * before we send the analytics event.
										 */ requestAnimationFrame(()=>{
                                            const akEditor = document.querySelector('.akEditor');
                                            if (!akEditor) {
                                                sendAnalyticsEvent();
                                                unbindBeforeUnload();
                                            }
                                        });
                                    }
                                };
                            }
                        })
                }
            ];
        }
    };
};
module.exports["ncsStepMetricsPlugin"] = $76ea322f0da7e317$export$209ae7648d2a7a31;

});

parcelRegister("4NiQW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $1o1Zn = parcelRequire("1o1Zn");


var $1S4f7 = parcelRequire("1S4f7");


var $6qdjm = parcelRequire("6qdjm");


var $1oCLl = parcelRequire("1oCLl");


var $5SAOw = parcelRequire("5SAOw");

const $ebaa87d309582647$export$60dfa91bf509272e = (nodeAdf)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        try {
            const docEnd = state.doc.content.size;
            const modifiedNode = (0, $5SAOw.Node).fromJSON(schema, nodeAdf);
            modifiedNode.check();
            tr.insert(tr.mapping.map(docEnd), modifiedNode).scrollIntoView();
            dispatch(tr);
            return {
                status: 'success'
            };
        } catch (error) {
            return {
                status: 'failed'
            };
        }
    };






var $dh538 = parcelRequire("dh538");

var $10683540b5e10fa0$export$4e6955c142f7044d = /*#__PURE__*/ function(SelectionExtensionActionTypes) {
    SelectionExtensionActionTypes["SET_ACTIVE_EXTENSION"] = "set-active-extension";
    SelectionExtensionActionTypes["UPDATE_ACTIVE_EXTENSION_COORDS"] = "update-active-extension-coords";
    SelectionExtensionActionTypes["CLEAR_ACTIVE_EXTENSION"] = "clear-active-extension";
    SelectionExtensionActionTypes["SET_SELECTED_NODE"] = "set-selected-node";
    SelectionExtensionActionTypes["START_TRACK_CHANGES"] = "start-track-changes";
    return SelectionExtensionActionTypes;
}({});






var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


const $33c6071bb4ca0b0f$export$dcf960b4b6957ad0 = new (0, $ks2lK.PluginKey)('selectionExtensionPlugin');
const $33c6071bb4ca0b0f$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $33c6071bb4ca0b0f$export$dcf960b4b6957ad0,
        state: {
            init: ()=>{
                return {
                    activeExtension: undefined
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($33c6071bb4ca0b0f$export$dcf960b4b6957ad0);
                switch(meta?.type){
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_ACTIVE_EXTENSION:
                        return {
                            ...pluginState,
                            activeExtension: meta.extension
                        };
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).CLEAR_ACTIVE_EXTENSION:
                        return {
                            ...pluginState,
                            activeExtension: undefined
                        };
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE:
                        return {
                            ...pluginState,
                            selectedNode: meta.selectedNode,
                            nodePos: meta.nodePos,
                            startTrackChanges: true,
                            docChangedAfterClick: false
                        };
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).START_TRACK_CHANGES:
                        return {
                            ...pluginState,
                            startTrackChanges: meta.startTrackChanges
                        };
                }
                const docChangedAfterClick = pluginState.startTrackChanges && tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
                if (docChangedAfterClick) return {
                    ...pluginState,
                    docChangedAfterClick: true,
                    startTrackChanges: false
                };
                // clear activeExtension if the selection has changed and not empty
                if (tr.selectionSet && !tr.selection.empty) return {
                    ...pluginState,
                    activeExtension: undefined
                };
                return pluginState;
            }
        }
    });
};


const $3d9f65fcaf1f8972$export$c330a53bc779bb94 = (nodeAdf, api)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // we need to track if any changes were made since user click the toolbar button
        const docChangedAfterClick = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state)?.docChangedAfterClick || false;
        tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
            type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).START_TRACK_CHANGES,
            startTrackChanges: false
        });
        if (docChangedAfterClick) {
            dispatch(tr);
            return {
                status: 'document-changed'
            };
        }
        try {
            const selectedNode = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state)?.selectedNode;
            const nodePos = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state)?.nodePos;
            if (!selectedNode || nodePos === undefined) throw new Error('No selected node or node position found');
            const endPos = selectedNode.type.name === 'doc' && (0, $dh538.fg)('platform_editor_selection_extension_improvement') ? nodePos + selectedNode.content.size : nodePos + selectedNode.nodeSize;
            const modifiedNode = (0, $5SAOw.Node).fromJSON(schema, nodeAdf);
            modifiedNode.check();
            const updatedTr = tr.replaceWith(nodePos, endPos, modifiedNode).scrollIntoView();
            // Allow this transaction in view mode and apply changes
            dispatch(api?.editorViewModeEffects?.actions.allowViewModeTransaction(updatedTr) || updatedTr);
            return {
                status: 'success'
            };
        } catch  {
            dispatch(tr);
            return {
                status: 'failed-to-replace'
            };
        }
    };




var $hWRJP = parcelRequire("hWRJP");


var $h9yJL = parcelRequire("h9yJL");











var $aFUXX = parcelRequire("aFUXX");


var $7XFGZ = parcelRequire("7XFGZ");

var $LmqWp = parcelRequire("LmqWp");




const $7d771949b42eac2a$export$7a43d8c578c062dc = (view, from, to, offset = {
    top: 0,
    bottom: 0
})=>{
    let top = Infinity, left = Infinity, bottom = -Infinity, right = -Infinity;
    // initial version
    for(let pos = from; pos <= to; pos++){
        const coords = view.coordsAtPos(pos);
        top = Math.min(top, coords.top);
        left = Math.min(left, coords.left);
        bottom = Math.max(bottom, coords.bottom);
        right = Math.max(right, coords.right);
    }
    top = top - offset.top;
    bottom = bottom - offset.bottom;
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right
    };
};








const $251f66bb775a9380$var$LIST_ITEM_TYPES = new Set([
    'taskItem',
    'decisionItem',
    'listItem'
]);
const $251f66bb775a9380$var$LIST_NODE_TYPES = new Set([
    'taskList',
    'bulletList',
    'orderedList',
    'decisionList'
]);
/**
 * Build a JSON pointer path for a node within the selectedNode structure.
 * @param pathIndices - Array of content indices representing the path to the node
 */ const $251f66bb775a9380$var$buildJsonPointer = (pathIndices)=>pathIndices.map((index)=>`/content/${index}`).join('');
const $251f66bb775a9380$export$e39cf9e18b11686e = (selectedNode, selectedNodePos, $from, $to)=>{
    const selectionStart = $from.pos;
    const selectionEnd = $to.pos;
    const tokenOffset = selectedNode.type.name === 'doc' ? 0 : 1;
    const nodeStart = selectedNodePos + tokenOffset;
    const nodeEnd = selectedNodePos + selectedNode.nodeSize - tokenOffset;
    // If selection spans entire content, return undefined (complete block selection)
    if (selectionStart <= nodeStart && selectionEnd >= nodeEnd) return undefined;
    const selectionRanges = [];
    // Traverse the selectedNode and find all nodes/text within the selection range
    const traverse = (node, nodePos, path)=>{
        const nodeEndPos = nodePos + node.nodeSize;
        // Skip nodes completely before or after selection
        if (nodeEndPos <= selectionStart || nodePos >= selectionEnd) return;
        if (node.isText) {
            const textStart = nodePos;
            const textEnd = nodePos + (node.text?.length || 0);
            const rangeStart = Math.max(textStart, selectionStart);
            const rangeEnd = Math.min(textEnd, selectionEnd);
            if (rangeStart < rangeEnd) {
                const pointer = `${$251f66bb775a9380$var$buildJsonPointer(path)}/text`;
                selectionRanges.push({
                    start: {
                        pointer: pointer,
                        position: rangeStart - textStart
                    },
                    end: {
                        pointer: pointer,
                        position: rangeEnd - textStart
                    }
                });
            }
        } else if (node.content.size > 0) {
            const contentStart = nodePos + 1;
            const contentEnd = nodeEndPos - 1;
            const isWholeBlockSelected = node.isBlock && !node.isTextblock && !$251f66bb775a9380$var$LIST_NODE_TYPES.has(node.type.name) && selectionStart <= contentStart && selectionEnd >= contentEnd;
            if (isWholeBlockSelected) {
                const pointer = $251f66bb775a9380$var$buildJsonPointer(path);
                selectionRanges.push({
                    start: {
                        pointer: pointer
                    },
                    end: {
                        pointer: pointer
                    }
                });
            } else {
                // Traverse children for textblocks, lists, or partial selections
                let childPos = nodePos + 1;
                for(let i = 0; i < node.content.childCount; i++){
                    traverse(node.content.child(i), childPos, [
                        ...path,
                        i
                    ]);
                    childPos += node.content.child(i).nodeSize;
                }
            }
        } else if (nodePos >= selectionStart && nodeEndPos <= selectionEnd) {
            // Handle leaf nodes (e.g., hardBreak, image)
            const pointer = $251f66bb775a9380$var$buildJsonPointer(path);
            selectionRanges.push({
                start: {
                    pointer: pointer
                },
                end: {
                    pointer: pointer
                }
            });
        }
    };
    // Traverse each child of the selectedNode
    let childPos = nodeStart;
    for(let i = 0; i < selectedNode.content.childCount; i++){
        const child = selectedNode.content.child(i);
        traverse(child, childPos, [
            i
        ]);
        childPos += child.nodeSize;
    }
    return selectionRanges.length > 0 ? selectionRanges : undefined;
};
/** Find the depth of the deepest common ancestor node. */ const $251f66bb775a9380$var$getCommonAncestorDepth = ($from, $to)=>{
    const minDepth = Math.min($from.depth, $to.depth);
    for(let d = 0; d <= minDepth; d++){
        if ($from.node(d) !== $to.node(d)) return d - 1;
    }
    return minDepth;
};
const $251f66bb775a9380$export$d78ea2c01bb8e82a = ($from, $to)=>{
    const commonDepth = $251f66bb775a9380$var$getCommonAncestorDepth($from, $to);
    // Single pass: look for topmost list OR first non-list parent
    let topMostList = null;
    let topMostListPos = -1;
    let firstNonListParent = null;
    let firstNonListParentPos = -1;
    for(let depth = commonDepth; depth > 0; depth--){
        const node = $from.node(depth);
        if ($251f66bb775a9380$var$LIST_NODE_TYPES.has(node.type.name)) {
            // Keep updating to find the topmost list (last one found going upward)
            topMostList = node;
            topMostListPos = $from.before(depth);
        } else if (!firstNonListParent && node.type.name !== 'doc') {
            // Only capture the first (innermost) non-list parent
            firstNonListParent = node;
            firstNonListParentPos = $from.before(depth);
        }
    }
    // Return topmost list if found, else first non-list parent
    if (topMostList) return {
        node: topMostList,
        pos: topMostListPos
    };
    return {
        node: firstNonListParent,
        pos: firstNonListParentPos
    };
};
const $251f66bb775a9380$export$d82d0b7f23147578 = (schema, nodes)=>{
    if (nodes.length === 0) return schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
    // Single node: return unwrapped
    if (nodes.length === 1) return nodes[0];
    // For multiple nodes, wrap in doc
    try {
        return schema.node('doc', null, (0, $5SAOw.Fragment).from(nodes));
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
        return schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
    }
};
const $251f66bb775a9380$export$9234bebc22759e = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return {
        selectedNode: $from.node(),
        selectionRanges: [
            {
                start: {
                    pointer: `/content/${$from.index()}/text`,
                    position: $from.parentOffset
                },
                end: {
                    pointer: `/content/${$from.index()}/text`,
                    position: $to.parentOffset
                }
            }
        ],
        nodePos: $from.before()
    };
};
const $251f66bb775a9380$export$12cdfddaa8fbd6f3 = (selection, schema)=>{
    const { $from: $from, $to: $to } = selection;
    // For same parent selections but not the r, check for parent container
    if ($from.parent === $to.parent && $from.depth > 0) {
        const { node: parentNode, pos: parentNodePos } = $251f66bb775a9380$export$d78ea2c01bb8e82a($from, $to);
        if (parentNode) {
            const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(parentNode, parentNodePos, $from, $to);
            return {
                selectedNode: parentNode,
                nodePos: parentNodePos,
                selectionRanges: selectionRanges
            };
        }
        const nodePos = $from.before();
        const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e($from.node(), nodePos, $from, $to);
        return {
            selectedNode: $from.node(),
            nodePos: nodePos,
            selectionRanges: selectionRanges
        };
    }
    // find the common ancestor
    const range = $from.blockRange($to);
    if (!range) return {
        selectedNode: $from.node(),
        nodePos: $from.depth > 0 ? $from.before() : $from.pos
    };
    if (range.parent.type.name !== 'doc') {
        // For lists, find topmost list parent; otherwise use immediate parent
        if ($251f66bb775a9380$var$LIST_NODE_TYPES.has(range.parent.type.name) || $251f66bb775a9380$var$LIST_ITEM_TYPES.has(range.parent.type.name)) {
            const { node: topList, pos: topListPos } = $251f66bb775a9380$export$d78ea2c01bb8e82a($from, $to);
            if (topList) {
                const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(topList, topListPos, $from, $to);
                return {
                    selectedNode: topList,
                    nodePos: topListPos,
                    selectionRanges: selectionRanges
                };
            }
        }
        const nodePos = range.depth > 0 ? $from.before(range.depth) : 0;
        const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(range.parent, nodePos, $from, $to);
        return {
            selectedNode: range.parent,
            nodePos: nodePos,
            selectionRanges: selectionRanges
        };
    }
    // Extract complete nodes within the block range
    const nodes = [];
    for(let i = range.startIndex; i < range.endIndex; i++)nodes.push(range.parent.child(i));
    const selectedNode = $251f66bb775a9380$export$d82d0b7f23147578(schema, nodes);
    const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(selectedNode, range.start, $from, $to);
    return {
        selectedNode: selectedNode,
        nodePos: range.start,
        selectionRanges: selectionRanges
    };
};


const $8d8280b1e96dab8a$var$getSelectedRect = (selection)=>{
    const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
    const table = $anchorCell.node(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    return rect;
};
const $8d8280b1e96dab8a$var$getSelectionInfoFromCellSelection = (selection)=>{
    const selectedNode = selection.$anchorCell.node(-1);
    const nodePos = selection.$anchorCell.before(-1);
    const selectionRanges = [];
    const rect = $8d8280b1e96dab8a$var$getSelectedRect(selection);
    for(let row = rect.top; row < rect.bottom; row++)selectionRanges.push({
        start: {
            pointer: `/content/${row}/content/${rect.left}`
        },
        end: {
            pointer: `/content/${row}/content/${rect.right - 1}`
        }
    });
    return {
        selectedNode: selectedNode,
        selectionRanges: selectionRanges,
        nodePos: nodePos
    };
};
const $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5 = (view, api)=>{
    const { selection: currentSelection } = view.state;
    const toolbarDocking = api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition;
    const isEditMode = Boolean(api?.editorViewMode?.sharedState.currentState()?.mode === 'edit');
    const shouldOffsetToolbarHeight = toolbarDocking === 'top' && isEditMode;
    const { from: from, to: to } = currentSelection;
    const text = view.state.doc.textBetween(from, to, '\n');
    const coords = (0, $7d771949b42eac2a$export$7a43d8c578c062dc)(view, from, to, {
        top: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0,
        bottom: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0
    });
    return {
        text: text,
        from: from,
        to: to,
        coords: coords
    };
};
const $8d8280b1e96dab8a$export$d2b80e0fb1a7bb6 = (selection, view, api)=>{
    const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
    const isEditMode = Boolean(api?.editorViewMode?.sharedState.currentState()?.mode === 'edit');
    const shouldOffsetToolbarHeight = toolbarDocking === 'top' && isEditMode;
    const { from: from, to: to } = selection;
    const text = view.state.doc.textBetween(from, to, '\n');
    const coords = (0, $7d771949b42eac2a$export$7a43d8c578c062dc)(view, from, to, {
        top: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0,
        bottom: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0
    });
    return {
        text: text,
        from: from,
        to: to,
        coords: coords
    };
};
const $8d8280b1e96dab8a$export$e842a552462e723a = (state)=>{
    const { schema: schema, selection: selection } = state;
    const slice = selection.content();
    let newDoc;
    try {
        const { schema: schema } = state;
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        newDoc = transform.replaceRange(0, 2, slice).doc;
    } catch (error) {
        newDoc = schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
    }
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(newDoc);
    return {
        selectedNodeAdf: selectedNodeAdf
    };
};
const $8d8280b1e96dab8a$export$a2bc00eaece873ac = (selection)=>{
    const { schema: schema } = selection.$from.doc.type;
    const slice = selection.content();
    let newDoc;
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        newDoc = transform.replaceRange(0, 2, slice).doc;
    } catch (error) {
        newDoc = schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
    }
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(newDoc);
    return {
        selectedNodeAdf: selectedNodeAdf
    };
};
function $8d8280b1e96dab8a$export$c794b208e2d52a35(state) {
    const selection = state.selection;
    let selectionInfo = {
        selectedNode: selection.$from.node(),
        nodePos: selection.$from.depth > 0 ? selection.$from.before() : selection.from
    };
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        if ((0, $dh538.fg)('platform_editor_selection_extension_improvement')) // New implementation: unified handler for all text selections
        selectionInfo = (0, $251f66bb775a9380$export$12cdfddaa8fbd6f3)(selection, state.schema);
        else {
            const { $from: $from, $to: $to } = selection;
            if ($from.parent === $to.parent) selectionInfo = (0, $251f66bb775a9380$export$9234bebc22759e)(selection);
        }
    } else if (selection instanceof (0, $7XFGZ.CellSelection)) selectionInfo = $8d8280b1e96dab8a$var$getSelectionInfoFromCellSelection(selection);
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(selectionInfo.selectedNode);
    return {
        ...selectionInfo,
        selectedNodeAdf: selectedNodeAdf
    };
}
function $8d8280b1e96dab8a$export$a93a74bd28a4df9a(selection) {
    const schema = selection.$from.doc.type.schema;
    let selectionInfo = {
        selectedNode: selection.$from.node(),
        nodePos: selection.$from.depth > 0 ? selection.$from.before() : selection.from
    };
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        if ((0, $dh538.fg)('platform_editor_selection_extension_improvement')) selectionInfo = (0, $251f66bb775a9380$export$12cdfddaa8fbd6f3)(selection, schema);
        else {
            const { $from: $from, $to: $to } = selection;
            if ($from.parent === $to.parent && $from.depth > 0) selectionInfo = (0, $251f66bb775a9380$export$9234bebc22759e)(selection);
        }
    } else if (selection instanceof (0, $7XFGZ.CellSelection)) selectionInfo = $8d8280b1e96dab8a$var$getSelectionInfoFromCellSelection(selection);
    else if (selection instanceof (0, $ks2lK.NodeSelection)) selectionInfo = {
        selectedNode: selection.node,
        nodePos: selection.from
    };
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(selectionInfo.selectedNode);
    return {
        ...selectionInfo,
        selectedNodeAdf: selectedNodeAdf
    };
}







var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");




const $577b9250c471581d$export$26a4fbd96883483b = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    const componentRef = (0, $42omo.useRef)();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { activeExtension: activeExtension, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selectionExtension',
        'editorViewMode'
    ], (states)=>({
            activeExtension: states.selectionExtensionState?.activeExtension,
            mode: states.editorViewModeState?.mode
        }));
    // Closed from active extension
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(api?.selectionExtension.commands.clearActiveExtension());
        // Clears reference to active component
        componentRef.current = undefined;
        if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        });
    }, [
        editorAnalyticsAPI,
        api
    ]);
    // Closed from editor page mode change
    (0, $42omo.useEffect)(()=>{
        if (componentRef.current !== undefined) handleOnClose();
    }, [
        handleOnClose,
        mode
    ]);
    // Viewed analytics event for component mount
    (0, $42omo.useEffect)(()=>{
        const extension = activeExtension?.extension;
        if (!extension) return;
        if (isToolbarAIFCEnabled || (0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
            let currentComponent;
            if ('contentComponent' in extension && extension.contentComponent !== undefined) currentComponent = extension.contentComponent;
            else if ('component' in extension && extension.component !== undefined) currentComponent = extension.component;
            if (componentRef.current !== currentComponent && currentComponent !== undefined) {
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).VIEWED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                });
                // Sets reference to active component
                componentRef.current = currentComponent;
            }
            return;
        }
        // delete this when cleaning up platform_editor_toolbar_aifc
        if (extension && 'component' in extension && componentRef.current !== extension.component && extension.component !== undefined) {
            if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            });
            // Sets reference to active component
            componentRef.current = extension.component;
        }
    }, [
        activeExtension,
        editorAnalyticsAPI,
        isToolbarAIFCEnabled
    ]);
    const extension = activeExtension?.extension;
    if (!extension) return null;
    if (isToolbarAIFCEnabled || (0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
        const hasContentComponent = (ext)=>{
            return 'contentComponent' in ext && ext.contentComponent !== undefined;
        };
        const hasComponent = (ext)=>{
            return 'component' in ext && ext.component !== undefined;
        };
        let ExtensionComponent;
        if (hasContentComponent(extension)) ExtensionComponent = extension.contentComponent;
        else if (hasComponent(extension)) ExtensionComponent = extension.component;
        if (!ExtensionComponent) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)(ExtensionComponent, {
            closeExtension: handleOnClose,
            selection: activeExtension.selection
        });
    }
    // delete this when cleaning up platform_editor_toolbar_aifc
    if (!('component' in extension) || !extension.component) return null;
    const ExtensionComponent = extension.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(ExtensionComponent, {
        closeExtension: handleOnClose,
        selection: activeExtension.selection
    });
};


const $4dbf2ec5345f8761$export$7cddd6f4296c4a51 = (extensionList, toolbarType)=>{
    return extensionList.reduce((acc, extension)=>{
        const toolbarConfig = extension[toolbarType];
        if (toolbarConfig?.getToolbarItem) acc.push({
            getToolbarItem: toolbarConfig.getToolbarItem,
            getMenuItems: toolbarConfig.getMenuItems
        });
        return acc;
    }, []);
};
const $4dbf2ec5345f8761$export$1c1c89b40fcaaa6e = (extensionList, targetSource)=>{
    return extensionList.reduce((acc, extension)=>{
        const { source: source, inlineToolbar: inlineToolbar } = extension;
        if (source === targetSource && inlineToolbar?.getMenuItems && !inlineToolbar.getToolbarItem) {
            const menuItems = inlineToolbar.getMenuItems();
            menuItems.forEach((menuItem)=>{
                // Only process ExtensionMenuItemConfiguration, skip ExtensionMenuSectionConfiguration
                if ('label' in menuItem && 'icon' in menuItem) acc.push({
                    name: menuItem.label,
                    icon: menuItem.icon,
                    onClick: menuItem.onClick,
                    isDisabled: ()=>!!menuItem.isDisabled,
                    component: menuItem.contentComponent
                });
            });
        }
        return acc;
    }, []);
};









var $5v8Ta = parcelRequire("5v8Ta");

var $h4TOP = parcelRequire("h4TOP");

var $a4eZN = parcelRequire("a4eZN");

const $813f3f7099047ce6$export$9b00cbcfa1039aae = ({ primaryToolbarItemExtensions: primaryToolbarItemExtensions })=>{
    // NEXT PR: need to render a separator after – if there are extensions added
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: primaryToolbarItemExtensions.map((toolbarItemExtension, i)=>{
            const toolbarItem = toolbarItemExtension.getToolbarItem();
            return /*#__PURE__*/ (0, $l998X.jsx)($813f3f7099047ce6$export$ac67b09b2512a582, {
                toolbarItem: toolbarItem
            }, toolbarItem.tooltip);
        })
    });
};
const $813f3f7099047ce6$export$ac67b09b2512a582 = ({ toolbarItem: toolbarItem, getMenuItems: getMenuItems })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { icon: Icon, tooltip: tooltip, isDisabled: isDisabled, onClick: onClick, label: _label } = toolbarItem;
    if (!getMenuItems) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        spacing: "default",
        disabled: isDisabled,
        selected: isOpen,
        title: tooltip,
        "aria-label": tooltip,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: tooltip
        })
    });
    const toggleOpen = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const toggleOpenByKeyboard = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleOpen();
        }
    };
    const handleItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        item.onClick?.();
        if (shouldCloseMenu) setIsOpen(false);
    };
    const handleOnOpenChange = (attrs)=>{
        setIsOpen(!!attrs?.isOpen);
    };
    const items = isOpen ? getMenuItems().map((menuItem, i)=>{
        // Only process ExtensionMenuItemConfiguration, skip ExtensionMenuSectionConfiguration
        if ('label' in menuItem && 'icon' in menuItem) return {
            key: `menu-item-${i}`,
            content: menuItem.label,
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)(menuItem.icon, {
                label: menuItem.label
            }),
            onClick: ()=>{
                menuItem.onClick?.();
            // NEXT PR: here we need to set the active extension so the contentComponent can render
            // menuItem.contentComponent
            },
            isDisabled: menuItem.isDisabled,
            'aria-label': menuItem.label,
            value: {
                name: menuItem.label
            }
        };
        return undefined;
    }).filter((item)=>item !== undefined) : [];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
        },
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        onItemActivated: handleItemActivated,
        onOpenChange: handleOnOpenChange,
        fitWidth: 200,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
            spacing: "default",
            disabled: isDisabled,
            selected: isOpen,
            title: tooltip,
            "aria-label": tooltip,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            onClick: toggleOpen,
            onKeyDown: toggleOpenByKeyboard,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: tooltip
            })
        })
    });
};





parcelRequire("42omo");



const $8ed0254a02e48d00$export$6937b1e97e59d958 = ({ overflowOptions: overflowOptions, extensionList: extensionList = [] })=>{
    const inlineToolbarItemExtensions = (0, $4dbf2ec5345f8761$export$7cddd6f4296c4a51)(extensionList, 'inlineToolbar');
    return {
        items: [
            ...inlineToolbarItemExtensions.length ? [
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                ...inlineToolbarItemExtensions.map(({ getToolbarItem: getToolbarItem, getMenuItems: getMenuItems })=>({
                        type: 'custom',
                        render: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $813f3f7099047ce6$export$ac67b09b2512a582), {
                                toolbarItem: getToolbarItem(),
                                getMenuItems: getMenuItems
                            }),
                        fallback: [],
                        supportsViewMode: true
                    }))
            ] : [],
            {
                type: 'separator',
                fullHeight: true,
                supportsViewMode: true
            },
            {
                type: 'overflow-dropdown',
                dropdownWidth: 240,
                supportsViewMode: true,
                options: overflowOptions
            }
        ],
        rank: -6
    };
};





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");




parcelRequire("42omo");


var $gzUv9 = parcelRequire("gzUv9");


var $2GVu1 = parcelRequire("2GVu1");


var $5nBzc = parcelRequire("5nBzc");





var $gdv5Z = parcelRequire("gdv5Z");




const $0bd8053ae7c78a3f$export$2ce376c2cc3355c8 = ({ extensionMenuItems: extensionMenuItems, api: api })=>{
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    if (!extensionMenuItems?.length || !editorView || !api) return null;
    const onClickHandle = (extension)=>()=>{
            if (extension.contentComponent) {
                const selection = (0, $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5)(editorView, api);
                api.core.actions.execute(api.selectionExtension.commands.setActiveExtension({
                    extension: extension,
                    selection: selection
                }));
            }
            api.core.actions.execute(({ tr: tr })=>{
                const { selectedNode: selectedNode, nodePos: nodePos } = (0, $8d8280b1e96dab8a$export$a93a74bd28a4df9a)(tr.selection);
                tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                    type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE,
                    selectedNode: selectedNode,
                    nodePos: nodePos
                });
                return tr;
            });
            extension.onClick && extension.onClick();
        };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: extensionMenuItems.map((extension)=>{
            const Icon = extension.icon;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2GVu1.ToolbarDropdownItem), {
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    size: "small",
                    label: ""
                }),
                onClick: onClickHandle(extension),
                isDisabled: extension.isDisabled,
                children: [
                    extension.label,
                    extension.lozenge && (0, $dh538.fg)('platform_editor_selection_extension_lozenge') && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        paddingInline: "space.100",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            appearance: 'new',
                            children: extension.lozenge.label
                        })
                    })
                ]
            }, extension.label);
        })
    });
};





parcelRequire("42omo");












parcelRequire("42omo");

const $d7d766df93b59dd7$export$f65445bd85d2d8d3 = (item)=>{
    return 'getMenuItems' in item && typeof item.getMenuItems === 'function';
};


/* SelectionExtensionDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






















const $ba25c462e5887db8$var$SelectionExtensionComponentContext = (0, $42omo.createContext)(undefined);
const $ba25c462e5887db8$export$42992062fe8cb85b = $ba25c462e5887db8$var$SelectionExtensionComponentContext.Provider;
const $ba25c462e5887db8$export$770396a0bbb06d8d = ()=>{
    const context = (0, $42omo.useContext)($ba25c462e5887db8$var$SelectionExtensionComponentContext);
    if (!context) throw new Error('useSelectionExtensionComponentContext must be used within SelectionExtensionComponentContextProvider');
    return context;
};


const $f9143c68910501cf$var$styles = {
    lozenge: "_18u01b66"
};
const $f9143c68910501cf$export$b9803fa633175cb1 = ({ dropdownItem: dropdownItem })=>{
    const IconComponent = dropdownItem.icon;
    const { api: api, editorView: editorView, extensionKey: extensionKey, extensionSource: extensionSource, extensionLocation: extensionLocation } = (0, $ba25c462e5887db8$export$770396a0bbb06d8d)();
    const handleClick = ()=>{
        const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
        const selection = preservedSelection || editorView.state.selection;
        if (dropdownItem.contentComponent) {
            const selectionInfo = (0, $8d8280b1e96dab8a$export$d2b80e0fb1a7bb6)(selection, editorView, api);
            api.core.actions.execute(api.selectionExtension.commands.setActiveExtension({
                extension: dropdownItem,
                selection: selectionInfo
            }));
        }
        api.core.actions.execute(({ tr: tr })=>{
            const { selectedNode: selectedNode, nodePos: nodePos } = (0, $8d8280b1e96dab8a$export$a93a74bd28a4df9a)(selection);
            tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE,
                selectedNode: selectedNode,
                nodePos: nodePos
            });
            if ((0, $dh538.fg)('platform_editor_block_menu_v2_patch_1')) {
                if (extensionLocation === 'block-menu') api?.blockControls?.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
            } else api?.blockControls?.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        dropdownItem.onClick?.();
        api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionKey: extensionKey,
                extensionSource: extensionSource,
                extensionLocation: extensionLocation,
                extensionElement: 'dropdown-item',
                extensionItemKey: dropdownItem.key
            }
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
            size: extensionLocation === 'inline-toolbar' && (0, $dh538.fg)('platform_editor_block_menu_v2_patch_1') ? 'small' : undefined,
            label: ""
        }) : undefined,
        onClick: handleClick,
        isDisabled: dropdownItem.isDisabled,
        children: [
            dropdownItem.label,
            dropdownItem.lozenge ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $f9143c68910501cf$var$styles.lozenge,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: "new",
                    children: dropdownItem.lozenge.label
                })
            }) : undefined
        ]
    });
};





parcelRequire("42omo");





var $6UWPx = parcelRequire("6UWPx");

var $87Gms = parcelRequire("87Gms");


var $6R5uz = parcelRequire("6R5uz");



const $b917b78d8a152c73$var$ChildItems = ({ nestedDropdownMenu: nestedDropdownMenu })=>{
    const childItems = nestedDropdownMenu.getMenuItems();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        children: childItems.map((dropdownItem)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f9143c68910501cf$export$b9803fa633175cb1), {
                dropdownItem: dropdownItem
            }, dropdownItem.key || dropdownItem.label))
    });
};
const $b917b78d8a152c73$export$6edafa8671941c08 = ({ nestedDropdownMenu: nestedDropdownMenu })=>{
    const IconComponent = nestedDropdownMenu.icon;
    const { api: api, extensionKey: extensionKey, extensionSource: extensionSource, extensionLocation: extensionLocation } = (0, $ba25c462e5887db8$export$770396a0bbb06d8d)();
    const handleClick = ()=>{
        api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionKey: extensionKey,
                extensionSource: extensionSource,
                extensionLocation: extensionLocation,
                extensionElement: 'nested-dropdown',
                extensionItemKey: nestedDropdownMenu.key
            }
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $87Gms.ToolbarNestedDropdownMenu), {
        text: nestedDropdownMenu.label,
        elemBefore: IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
            label: ""
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: ""
        }),
        onClick: handleClick,
        dropdownTestId: "editor-selection-extension-menu",
        children: /*#__PURE__*/ (0, $l998X.jsx)($b917b78d8a152c73$var$ChildItems, {
            nestedDropdownMenu: nestedDropdownMenu
        })
    });
};


const $96150a9fd8b2c0fd$export$6456f966307ab8fd = ({ getMenuItems: getMenuItems })=>{
    const extensionMenuItems = getMenuItems();
    if (!extensionMenuItems?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: extensionMenuItems.map((item)=>{
            if ((0, $d7d766df93b59dd7$export$f65445bd85d2d8d3)(item)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b917b78d8a152c73$export$6edafa8671941c08), {
                nestedDropdownMenu: item
            }, item.key || item.label);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $f9143c68910501cf$export$b9803fa633175cb1), {
                dropdownItem: item
            }, item.key || item.label);
        })
    });
};







parcelRequire("42omo");





var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");

const $e8544947d9b0ad89$var$usePluginState = (_api)=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorToolbarDockingPreference: editorToolbarDockingPreference
    };
};
const $e8544947d9b0ad89$export$e5c1a33878e86e9e = ({ api: api, config: config })=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = $e8544947d9b0ad89$var$usePluginState(api);
    const isDockedAtTop = editorToolbarDockingPreference === 'top';
    if (isDockedAtTop) return null;
    const Icon = config.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: config.tooltip,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: ""
            }),
            isDisabled: config.isDisabled,
            onClick: config.onClick,
            children: config.label
        })
    });
};





parcelRequire("42omo");





var $bTiiT = parcelRequire("bTiiT");






const $2a526b5f450ac02e$var$usePluginState = (_api)=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorToolbarDockingPreference: editorToolbarDockingPreference
    };
};
const $2a526b5f450ac02e$export$1f4688db2a0d3d39 = ({ api: api, config: config, children: children })=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = $2a526b5f450ac02e$var$usePluginState(api);
    const isDockedAtTop = editorToolbarDockingPreference === 'top';
    if (isDockedAtTop) return null;
    const Icon = config.icon;
    if ((0, $1oCLl.expValEquals)('platform_editor_hide_toolbar_tooltips_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: ""
        }),
        isDisabled: config.isDisabled,
        onClick: config.onClick,
        tooltipComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
            content: config.tooltip
        }),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: config.tooltip,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: ""
            }),
            isDisabled: config.isDisabled,
            onClick: config.onClick,
            children: children
        })
    });
};


const $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER = 100;
const $5c03626e2d8c157c$var$InlineToolbarMenuItemComponent = ({ api: api, extension: extension, getMenuItems: getMenuItems })=>{
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    if (!editorView || !api) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ba25c462e5887db8$export$42992062fe8cb85b), {
        value: {
            api: api,
            editorView: editorView,
            extensionKey: extension.key,
            extensionSource: extension.source,
            extensionLocation: 'inline-toolbar'
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96150a9fd8b2c0fd$export$6456f966307ab8fd), {
            getMenuItems: getMenuItems
        })
    });
};
const $5c03626e2d8c157c$export$534fbf86ee38096a = ({ api: api, extension: extension, index: index })=>{
    const { key: key, inlineToolbar: inlineToolbar } = extension;
    const baseKey = `selection-extension-${key}`;
    const components = [];
    if (!inlineToolbar) return components;
    const { getToolbarItem: getToolbarItem, getMenuItems: getMenuItems } = inlineToolbar;
    const groupKey = `${baseKey}-toolbar-group`;
    const toolbarItemKey = `${baseKey}-toolbar-${getMenuItems ? 'menu' : 'button'}`;
    const menuSectionKey = `${baseKey}-toolbar-menu-section`;
    if (getToolbarItem) {
        // first we register the group for the button or menu to be added to
        components.push({
            type: 'group',
            key: groupKey,
            parents: [
                {
                    type: (0, $cPCP8.APPS_SECTION).type,
                    key: (0, $cPCP8.APPS_SECTION).key,
                    rank: (index + 1) * $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ]
        });
        const toolbarItemConfig = getToolbarItem();
        // if toolbar item has menu items, assume it's a menu
        if (getMenuItems) components.push({
            type: 'menu',
            key: toolbarItemKey,
            parents: [
                {
                    type: 'group',
                    key: groupKey,
                    rank: $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2a526b5f450ac02e$export$1f4688db2a0d3d39), {
                    api: api,
                    config: toolbarItemConfig
                });
            }
        });
        else // else just regsiter a button
        components.push({
            type: 'button',
            key: toolbarItemKey,
            parents: [
                {
                    type: 'group',
                    key: groupKey,
                    rank: $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $e8544947d9b0ad89$export$e5c1a33878e86e9e), {
                    api: api,
                    config: toolbarItemConfig
                });
            }
        });
    }
    if (getMenuItems) {
        if (getToolbarItem) components.push({
            type: 'menu-section',
            key: menuSectionKey,
            parents: [
                {
                    type: 'menu',
                    key: toolbarItemKey,
                    rank: $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ]
        });
        // Remove ExtensionMenuSectionConfiguration - only care about items
        const menuItems = (0, $dh538.fg)('platform_editor_block_menu_v2_patch_1') ? [] : getMenuItems().filter((item)=>'label' in item && 'icon' in item);
        components.push({
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: 'menu-section',
                    // if we have a custom menu, place items in there, otherwise in the overflow menu
                    key: getToolbarItem ? menuSectionKey : (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (index + 1) * $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return (0, $dh538.fg)('platform_editor_block_menu_v2_patch_1') ? /*#__PURE__*/ (0, $l998X.jsx)($5c03626e2d8c157c$var$InlineToolbarMenuItemComponent, {
                    api: api,
                    extension: extension,
                    getMenuItems: getMenuItems
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0bd8053ae7c78a3f$export$2ce376c2cc3355c8), {
                    api: api,
                    extensionMenuItems: menuItems
                });
            }
        });
    }
    return components;
};


const $0e95dfb5b95b0fcc$export$caa90b96cfb992a8 = (extension, api)=>{
    if (!extension.icon) return undefined;
    // Warning! These are inlined because the onClick handler must have up to date references to selection (which is awkwaradly set during extension.onClick invocation).
    const getSelection = ()=>{
        const sharedState = api?.selectionExtension.sharedState.currentState();
        return sharedState?.activeExtension?.selection;
    };
    return {
        label: extension.name,
        icon: extension.icon,
        isDisabled: extension.isDisabled && extension.isDisabled({
            selection: getSelection(),
            // pass undefined as no consumers use this
            selectedNodeAdf: undefined,
            selectionRanges: undefined
        }),
        /**
		 * SelectionExtension supports passing through selection, selectionAdf, and selectionRanges.
		 *
		 * To support backwards compatibility wrap the onClick with these parameters here and let MenuItem invoke onClick using its expected signature.
		 */ onClick: ()=>{
            const selectionAdf = api?.selectionExtension.actions.getSelectionAdf();
            extension.onClick && extension.onClick({
                selection: getSelection(),
                selectedNodeAdf: selectionAdf?.selectedNodeAdf,
                selectionRanges: selectionAdf?.selectionRanges
            });
        },
        contentComponent: extension.component
    };
};


const $89f1c415d9a3be59$export$a758406ca53b86a5 = ({ api: api, config: config })=>{
    const extensionToolbarComponents = config?.extensionList?.flatMap((extension, index)=>(0, $5c03626e2d8c157c$export$534fbf86ee38096a)({
            api: api,
            extension: extension,
            index: index
        })) || [];
    /**
	 * Continue to support firstParty apps for now as some apps haven't migrated yet, this simply converts apps to new ExtensionMenuItemConfiguration type
	 * to process easier. extensionList and extensions?.firstParty will most likely be mutually exclusive.
	 *
	 * **Warning:** This is called on every selection change to ensure calls to api?.selectionExtension.actions.getSelectionAdf() are
	 * fresh and up to date.
	 */ const firstPartyExtensions = config?.extensions?.firstParty?.map((extension)=>(0, $0e95dfb5b95b0fcc$export$caa90b96cfb992a8)(extension, api)).filter((extension)=>extension !== undefined) || [];
    const externalExtensions = config?.extensions?.external?.map((extension)=>(0, $0e95dfb5b95b0fcc$export$caa90b96cfb992a8)(extension, api)).filter((extension)=>extension !== undefined) || [];
    return [
        {
            type: (0, $cPCP8.APPS_SECTION).type,
            key: (0, $cPCP8.APPS_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.APPS_SECTION).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.APPS_SECTION).key]
                }
            ]
        },
        ...extensionToolbarComponents,
        ...$89f1c415d9a3be59$var$registerFirstPartyExtensions(api, firstPartyExtensions),
        ...$89f1c415d9a3be59$var$registerExternalExtensions(api, externalExtensions)
    ];
};
const $89f1c415d9a3be59$var$registerFirstPartyExtensions = (api, extensions)=>{
    const components = [];
    components.push({
        type: (0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).type,
        key: (0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key,
        parents: [
            {
                type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                rank: (0, $4Chin.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key]
            }
        ],
        component: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0bd8053ae7c78a3f$export$2ce376c2cc3355c8), {
                api: api,
                extensionMenuItems: extensions
            });
        }
    });
    return components;
};
const $89f1c415d9a3be59$var$registerExternalExtensions = (api, extensions)=>{
    const components = [];
    components.push({
        type: (0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).type,
        key: (0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).key,
        parents: [
            {
                type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                rank: (0, $4Chin.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).key]
            }
        ],
        component: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0bd8053ae7c78a3f$export$2ce376c2cc3355c8), {
                api: api,
                extensionMenuItems: extensions
            });
        }
    });
    return components;
};





parcelRequire("42omo");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");



function $8e7c3bad798ea2f8$export$8685820fcb2ea901({ extensionList: extensionList, api: api, editorViewRef: editorViewRef }) {
    extensionList.forEach(({ source: source, key: key, blockMenu: blockMenu })=>{
        if (source !== 'first-party' || !blockMenu) return;
        if (!api?.blockMenu) return;
        const componentsToRegister = [];
        // Use placement from BlockMenuExtensionConfiguration
        // Featured placement: register under TRANSFORM_MENU_SECTION
        // Default placement: register under TRANSFORM_CREATE_MENU_SECTION
        if (blockMenu.placement === 'featured') componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key,
                rank: (0, $gEb6G.BLOCK_ACTIONS_MENU_SECTION_RANK)[(0, $btNLq.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: ()=>{
                const editorView = editorViewRef?.current;
                if (!editorView) return null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ba25c462e5887db8$export$42992062fe8cb85b), {
                    value: {
                        api: api,
                        editorView: editorView,
                        extensionKey: key,
                        extensionSource: source,
                        extensionLocation: 'block-menu'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96150a9fd8b2c0fd$export$6456f966307ab8fd), {
                        getMenuItems: blockMenu.getMenuItems
                    })
                });
            }
        });
        else componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            isHidden: ()=>blockMenu.getMenuItems().length === 0,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_CREATE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_CREATE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: ()=>{
                const editorView = editorViewRef?.current;
                if (!editorView) return null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ba25c462e5887db8$export$42992062fe8cb85b), {
                    value: {
                        api: api,
                        editorView: editorView,
                        extensionKey: key,
                        extensionSource: source,
                        extensionLocation: 'block-menu'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96150a9fd8b2c0fd$export$6456f966307ab8fd), {
                        getMenuItems: blockMenu.getMenuItems
                    })
                });
            }
        });
        if (componentsToRegister.length > 0) api.blockMenu.actions.registerBlockMenuComponents(componentsToRegister);
    });
}


const $a3ef83c4fda37ec4$export$e35323fb8da5ccd6 = ({ api: api, config: config })=>{
    const editorViewRef = {};
    let cachedSelection;
    let cachedOverflowMenuOptions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { extensionList: extensionList = [], extensions: extensions = {} } = config || {};
    const { firstParty: firstParty = [], external: external = [] } = extensions || {};
    if (!isToolbarAIFCEnabled) {
        const primaryToolbarItemExtensions = (0, $4dbf2ec5345f8761$export$7cddd6f4296c4a51)(extensionList, 'primaryToolbar');
        if (primaryToolbarItemExtensions?.length) api?.primaryToolbar?.actions?.registerComponent({
            name: 'selectionExtension',
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $813f3f7099047ce6$export$9b00cbcfa1039aae), {
                    primaryToolbarItemExtensions: primaryToolbarItemExtensions
                })
        });
    }
    if ((0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) (0, $8e7c3bad798ea2f8$export$8685820fcb2ea901)({
        extensionList: extensionList,
        api: api,
        editorViewRef: editorViewRef
    });
    return {
        name: 'selectionExtension',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(editorState) || null;
        },
        commands: {
            setActiveExtension: (extension)=>({ tr: tr })=>{
                    return tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                        type: 'set-active-extension',
                        extension: extension
                    });
                },
            clearActiveExtension: ()=>({ tr: tr })=>{
                    return tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                        type: 'clear-active-extension'
                    });
                }
        },
        actions: {
            replaceWithAdf: (nodeAdf)=>{
                if (!editorViewRef.current) return {
                    status: 'failed-to-replace'
                };
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                return (0, $3d9f65fcaf1f8972$export$c330a53bc779bb94)(nodeAdf, api)(state, dispatch);
            },
            insertAdfAtEndOfDoc: (nodeAdf)=>{
                if (!editorViewRef.current) return {
                    status: 'failed'
                };
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                return (0, $ebaa87d309582647$export$60dfa91bf509272e)(nodeAdf)(state, dispatch);
            },
            getSelectionAdf: ()=>{
                if (!editorViewRef.current) return null;
                const { state: state } = editorViewRef.current;
                if ((0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
                    const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection || state.selection;
                    return (0, $8d8280b1e96dab8a$export$a93a74bd28a4df9a)(selection);
                }
                const { selectionRanges: selectionRanges, selectedNodeAdf: selectedNodeAdf } = (0, $8d8280b1e96dab8a$export$c794b208e2d52a35)(state);
                return {
                    selectedNodeAdf: selectedNodeAdf,
                    selectionRanges: selectionRanges
                };
            },
            getDocumentFromSelection: ()=>{
                if (!editorViewRef.current) return null;
                const { state: state } = editorViewRef.current;
                if ((0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
                    const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection || state.selection;
                    return (0, $8d8280b1e96dab8a$export$a2bc00eaece873ac)(selection);
                }
                const { selectedNodeAdf: selectedNodeAdf } = (0, $8d8280b1e96dab8a$export$e842a552462e723a)(state);
                return {
                    selectedNodeAdf: selectedNodeAdf
                };
            }
        },
        usePluginHook: ()=>{
            (0, $6qdjm.usePluginStateEffect)(api, [
                'selection'
            ], ()=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $eTj7Y.isSSR)()) return;
                if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $89f1c415d9a3be59$export$a758406ca53b86a5)({
                    api: api,
                    config: config
                }), true);
            });
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $eTj7Y.isSSR)()) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $577b9250c471581d$export$26a4fbd96883483b), {
                editorView: editorView,
                api: api,
                editorAnalyticsAPI: api?.analytics?.actions
            });
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : (state, intl)=>{
                if (!config) return;
                const { pageModes: pageModes } = config;
                // Extensions Config Validation
                // Check whether plugin contains any selection extensions
                if (!firstParty?.length && !external?.length && !extensionList?.length) return;
                // Content Mode Validation
                // Check if pageModes is provided and matches against current content mode
                // This will eventually transition from mode to viewMode
                const editorViewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (pageModes) {
                    // Early Exit: consumer has set pageModes but editorViewMode is undefined
                    if (!editorViewMode) return;
                    // Simplify traversion of pageModes which can be string or array of strings
                    const showOnModesCollection = Array.isArray(pageModes) ? pageModes : [
                        pageModes
                    ];
                    // Early Exit: consumer has set pageModes but current editorViewMode is not in the collection
                    if (!showOnModesCollection.includes(editorViewMode)) return;
                }
                // Active Extension
                // Check if there is an active extension and hide the selection extension dropdown
                const selectionExtensionState = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state);
                if (selectionExtensionState?.activeExtension) return;
                const handleOnExtensionClick = (view)=>(extension)=>{
                        const selection = (0, $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5)(view, api);
                        if (extension.component) api?.core.actions.execute(api?.selectionExtension.commands.setActiveExtension({
                            extension: extension,
                            selection: selection
                        }));
                        const { selectedNodeAdf: selectedNodeAdf, selectionRanges: selectionRanges, selectedNode: selectedNode, nodePos: nodePos } = (0, $8d8280b1e96dab8a$export$c794b208e2d52a35)(view.state);
                        const onClickCallbackOptions = {
                            selectedNodeAdf: selectedNodeAdf,
                            selectionRanges: selectionRanges
                        };
                        extension.onClick?.(onClickCallbackOptions);
                        api?.core?.actions.execute(({ tr: tr })=>{
                            tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                                type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE,
                                selectedNode: selectedNode,
                                nodePos: nodePos
                            });
                            return tr;
                        });
                    };
                const convertExtensionToDropdownMenuItem = (extension, rank)=>{
                    const disabled = extension?.isDisabled instanceof Function ? extension?.isDisabled?.({
                        selection: editorViewRef.current ? (0, $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5)(editorViewRef.current, api) : undefined
                    }) : extension?.isDisabled;
                    return {
                        title: extension.name,
                        icon: extension.icon ? /*#__PURE__*/ (0, $l998X.jsx)(extension.icon, {
                            label: ''
                        }) : undefined,
                        disabled: disabled,
                        rank: rank,
                        onClick: ()=>{
                            editorViewRef.current && handleOnExtensionClick(editorViewRef.current)(extension);
                            return true;
                        }
                    };
                };
                const getFirstPartyExtensions = (extensions)=>{
                    return extensions.map((extension)=>{
                        return convertExtensionToDropdownMenuItem(extension, 30);
                    });
                };
                // Add a heading to the external extensions
                const getExternalExtensions = (extensions)=>{
                    let externalExtensions = [];
                    if (extensions?.length) {
                        externalExtensions = extensions.map((extension)=>{
                            return convertExtensionToDropdownMenuItem(extension);
                        });
                        const externalExtensionsHeading = {
                            type: 'overflow-dropdown-heading',
                            title: intl.formatMessage((0, $1o1Zn.selectionExtensionMessages).externalExtensionsHeading)
                        };
                        externalExtensions.unshift(externalExtensionsHeading);
                    }
                    return externalExtensions;
                };
                // NEXT PR: Make sure we cache the whole generated selection toolbar
                // also debug this to make sure it's actually preventing unnecessary re-renders / work
                if (cachedOverflowMenuOptions && state.selection.eq(cachedSelection)) return (0, $8ed0254a02e48d00$export$6937b1e97e59d958)({
                    overflowOptions: cachedOverflowMenuOptions,
                    extensionList: extensionList
                });
                const allFirstParty = [
                    ...firstParty,
                    ...(0, $4dbf2ec5345f8761$export$1c1c89b40fcaaa6e)(extensionList, 'first-party')
                ];
                const allExternal = [
                    ...external,
                    ...(0, $4dbf2ec5345f8761$export$1c1c89b40fcaaa6e)(extensionList, 'external')
                ];
                const groupedExtensionsArray = [
                    ...getFirstPartyExtensions(allFirstParty),
                    ...getExternalExtensions(allExternal)
                ];
                cachedOverflowMenuOptions = groupedExtensionsArray;
                cachedSelection = state.selection;
                return (0, $8ed0254a02e48d00$export$6937b1e97e59d958)({
                    overflowOptions: cachedOverflowMenuOptions,
                    extensionList: extensionList
                });
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'selectionExtension',
                    plugin: ()=>(0, $33c6071bb4ca0b0f$export$ae829ec7b2625219)()
                },
                {
                    name: 'selectionExtensionGetEditorViewReferencePlugin',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                return {
                                    destroy: ()=>{
                                        delete editorViewRef.current;
                                    }
                                };
                            }
                        });
                    }
                }
            ]
    };
};
module.exports["selectionExtensionPlugin"] = $a3ef83c4fda37ec4$export$e35323fb8da5ccd6;

});

parcelRegister("5Qu3R", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $b3YrF = parcelRequire("b3YrF");


var $dZ8uq = parcelRequire("dZ8uq");


var $jSnXV = parcelRequire("jSnXV");


var $d7ZU3 = parcelRequire("d7ZU3");


var $1S4f7 = parcelRequire("1S4f7");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $1oCLl = parcelRequire("1oCLl");




const $602750d26a26bbb7$var$decorationStyle = `
    background-color: ${"var(--ds-background-neutral, #DCDFE4)"};
  `;
const $602750d26a26bbb7$var$decorationHighlightStyle = `
    background-color: ${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"};
    border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-background-accent-blue-subtler, #cce0ff)"};
  `;
const $602750d26a26bbb7$export$b6f731a5ef32d5cd = (doc, selection, isHighlight)=>{
    const selectionDecorations = [];
    doc.nodesBetween(selection.from, selection.to, (currentNode, nodePos)=>{
        if (!currentNode.isText) return true;
        let decorationFrom = selection.from;
        let decorationTo = selection.to;
        if (nodePos > selection.from) decorationFrom = nodePos;
        if (nodePos + currentNode.nodeSize < selection.to) decorationTo = nodePos + currentNode.nodeSize;
        selectionDecorations.push((0, $ftzrq.Decoration).inline(decorationFrom, decorationTo, {
            style: isHighlight ? $602750d26a26bbb7$var$decorationHighlightStyle : $602750d26a26bbb7$var$decorationStyle,
            'data-testid': 'selection-marker-selection'
        }));
        return true;
    });
    return selectionDecorations;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $6fnsQ = parcelRequire("6fnsQ");

const $0d455a461eda79b8$var$selectionMarkerHighlightStyles = {
    content: "''",
    position: 'absolute',
    backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K')",
    top: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-negative-025, -2px)",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'contain',
    aspectRatio: '3/20',
    left: '0px',
    marginLeft: "var(--ds-space-negative-025, -2px)",
    right: '0px',
    marginRight: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
};
const $0d455a461eda79b8$var$selectionMarkerBlockCursorStyles = {
    content: "''",
    position: 'absolute',
    background: `var(--ds-text, ${(0, $6fnsQ.N500)})`,
    width: '1px',
    display: 'inline-block',
    top: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-negative-025, -2px)",
    left: '1px',
    marginLeft: "var(--ds-space-negative-025, -2px)",
    right: '0px',
    marginRight: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
};
// Same as above but defined as an inline element to avoid breaking long words
const $0d455a461eda79b8$var$selectionMarkerInlineCursorStyles = {
    content: "''",
    position: 'relative',
    pointerEvents: 'none',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-text, ${(0, $6fnsQ.N500)})`}`,
    marginLeft: '-1px',
    left: '0.5px'
};
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $0d455a461eda79b8$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
const $0d455a461eda79b8$var$Widget = ({ type: type, isHighlight: isHighlight, isInWord: isInWord })=>{
    const span = document.createElement('span');
    const selectionMarkerCursorStyles = isInWord ? $0d455a461eda79b8$var$selectionMarkerInlineCursorStyles : $0d455a461eda79b8$var$selectionMarkerBlockCursorStyles;
    const styles = isHighlight ? $0d455a461eda79b8$var$selectionMarkerHighlightStyles : selectionMarkerCursorStyles;
    for (const [rule, value] of Object.entries(styles))span.style.setProperty($0d455a461eda79b8$var$hyphenate(rule), value);
    span.setAttribute('contentEditable', 'false');
    span.dataset.testid = `selection-marker-${type}-cursor`;
    return span;
};
const $0d455a461eda79b8$var$toDOM = (type, isHighlight, isInWord)=>{
    const element = document.createElement('span');
    element.contentEditable = 'false';
    element.setAttribute('style', `position: relative;`);
    element.appendChild($0d455a461eda79b8$var$Widget({
        type: type,
        isHighlight: isHighlight,
        isInWord: isInWord
    }));
    return element;
};
const $0d455a461eda79b8$var$containsText = (resolvedPos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
    return nodeBefore?.isInline || nodeAfter?.isInline;
};
const $0d455a461eda79b8$export$6428b9f2a07e29a5 = (resolvedPos, type, selection, isHighlight)=>{
    // We don't want the cursor to show if it's not text selection
    // ie. if it's on media selection
    if (!(selection instanceof (0, $ks2lK.TextSelection)) || $0d455a461eda79b8$var$containsText(resolvedPos) === false || !selection.empty) return [];
    // We're inside a word if the parent, before, and after nodes are all text nodes
    // and the before/after nodes are appended/prepended with non-whitespace characters
    // Also if we're making a selection and not just a cursor, this isn't relevant
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter, parent: parent } = resolvedPos;
    // Check if the parent is a text node and the before/after nodes are also text nodes
    const areTextNodes = parent.isTextblock && nodeBefore?.isText && nodeAfter?.isText;
    const lastCharacterOfBeforeNode = nodeBefore?.textContent?.slice(-1);
    const firstCharacterOfAfterNode = nodeAfter?.textContent?.slice(0, 1);
    const areAdjacentCharactersNonWhitespace = // @ts-ignore - TS1501 Older versions of TypeScript don't play nice with the u flag. With the current AFM TypeScript version, this *should* be fine, but the pipeline type check fails, hence why a ts-ignore is needed (over a ts-expect-error)
    /\S/u.test(lastCharacterOfBeforeNode || '') && /\S/u.test(firstCharacterOfAfterNode || '');
    const isInWord = Boolean(areTextNodes && areAdjacentCharactersNonWhitespace);
    return [
        (0, $ftzrq.Decoration).widget(resolvedPos.pos, $0d455a461eda79b8$var$toDOM(type, isHighlight, isInWord), {
            side: -1,
            key: `${type}WidgetDecoration`,
            stopEvent: ()=>true,
            ignoreSelection: true
        })
    ];
};


const $214b2ac46330636c$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('selectionMarker');
function $214b2ac46330636c$var$getDecorations(tr, type) {
    const { selection: selection } = tr;
    switch(type){
        case 'none':
            return (0, $ftzrq.DecorationSet).empty;
        case 'highlight':
            return (0, $ftzrq.DecorationSet).create(tr.doc, [
                ...(0, $0d455a461eda79b8$export$6428b9f2a07e29a5)(selection.$anchor, 'anchor', selection, true),
                ...(0, $602750d26a26bbb7$export$b6f731a5ef32d5cd)(tr.doc, selection, true),
                ...(0, $0d455a461eda79b8$export$6428b9f2a07e29a5)(selection.$head, 'head', selection, true)
            ]);
        case 'blur':
            return (0, $ftzrq.DecorationSet).create(tr.doc, [
                ...(0, $0d455a461eda79b8$export$6428b9f2a07e29a5)(selection.$anchor, 'anchor', selection, false),
                ...(0, $602750d26a26bbb7$export$b6f731a5ef32d5cd)(tr.doc, selection, false)
            ]);
    }
}
function $214b2ac46330636c$var$getDecorationType(tr, shouldHideDecorations) {
    if (shouldHideDecorations || (0, $2pjJ5.isEmptyDocument)(tr.doc)) return 'none';
    // TODO: ED-26961 - implement "highlight" for AI features
    return 'blur';
}
const $214b2ac46330636c$export$7dca04eb0e423bd = (tr, currentState, oldEditorState)=>{
    const meta = tr.getMeta($214b2ac46330636c$export$df61b30b684217c0);
    if (!meta && !tr.selectionSet) return currentState;
    const forceHide = meta?.forceHide ?? currentState.forceHide;
    const shouldHideDecorations = meta?.shouldHideDecorations ?? currentState.shouldHideDecorations;
    const type = $214b2ac46330636c$var$getDecorationType(tr, shouldHideDecorations);
    let nextDecorations = currentState.decorations;
    const hasSelectionChangedToRange = oldEditorState.selection.empty && !tr.selection.empty;
    if (hasSelectionChangedToRange || currentState.decorationType !== type) nextDecorations = $214b2ac46330636c$var$getDecorations(tr, type);
    else nextDecorations = nextDecorations.map(tr.mapping, tr.doc, {});
    return {
        decorations: nextDecorations,
        shouldHideDecorations: shouldHideDecorations,
        forceHide: forceHide,
        decorationType: type
    };
};
const $214b2ac46330636c$var$debouncedDecorations = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((state)=>{
    return $214b2ac46330636c$export$df61b30b684217c0.getState(state)?.decorations;
}, 25);
const $214b2ac46330636c$export$ae829ec7b2625219 = (api)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $214b2ac46330636c$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    shouldHideDecorations: true,
                    forceHide: false,
                    decorationType: 'none'
                };
            },
            apply: $214b2ac46330636c$export$7dca04eb0e423bd
        },
        props: {
            decorations: (state)=>{
                const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
                if (browser.ie) return $214b2ac46330636c$var$debouncedDecorations(state);
                else return $214b2ac46330636c$export$df61b30b684217c0.getState(state)?.decorations;
            }
        }
    });
};
function $214b2ac46330636c$export$aaa3a3e05ac72aed(editorView, shouldHideDecorations) {
    const { dispatch: dispatch, state: state } = editorView;
    dispatch(state.tr.setMeta($214b2ac46330636c$export$df61b30b684217c0, {
        shouldHideDecorations: shouldHideDecorations
    }));
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");




function $b697d5da5a4f2d57$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Unset the selection background color as we are using our own
 * Otherwise we might have a mix of grey + our selection marker depending on the state.
 *
 * Edge cases:
 * - We do not apply this reset to input fields or code blocks (ie. expand case) because otherwise
 * selection highlight will not show on those.
 * - We do not apply this reset when the editor is disabled
 */ const $b697d5da5a4f2d57$var$globalStyles = {
    name: "1dgyfx",
    styles: ".ProseMirror:not(:focus):not([contenteditable=\"false\"]) ::selection:not(input, .cm-editor){background:unset;}"
};
const $b697d5da5a4f2d57$var$hideSelectionStyles = {
    name: "1ors4v5",
    styles: ".ProseMirror  *.danger::selection{background:transparent;}"
};
const $b697d5da5a4f2d57$export$cc5403d58ddfa812 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: [
            $b697d5da5a4f2d57$var$globalStyles,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) && $b697d5da5a4f2d57$var$hideSelectionStyles
        ]
    });
};


const $6ebed5c180db8c8b$export$9015f1b1ef870734 = ({ config: config, api: api })=>{
    return {
        name: 'selectionMarker',
        pmPlugins () {
            return [
                {
                    name: 'selectionMarkerPmPlugin',
                    plugin: ()=>(0, $214b2ac46330636c$export$ae829ec7b2625219)(api)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                isForcedHidden: (0, $214b2ac46330636c$export$df61b30b684217c0).getState(editorState)?.forceHide ?? false,
                isMarkerActive: !(0, $214b2ac46330636c$export$df61b30b684217c0).getState(editorState)?.shouldHideDecorations
            };
        },
        actions: {
            // For now this is a very simple locking mechanism that only allows one
            // plugin to hide / release at a time.
            hideDecoration: ()=>{
                if (api?.selectionMarker?.sharedState.currentState()?.isForcedHidden) return undefined;
                const success = api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $214b2ac46330636c$export$df61b30b684217c0), {
                        forceHide: true
                    }));
                if (!success) return undefined;
                return $6ebed5c180db8c8b$var$cleanupHiddenDecoration(api);
            },
            queueHideDecoration: (setCleanup)=>{
                const result = api?.selectionMarker.actions.hideDecoration();
                if (result === undefined) {
                    const cleanup = api?.selectionMarker?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (nextSharedState?.isForcedHidden === false && nextSharedState?.isMarkerActive === false) {
                            const result = api?.selectionMarker.actions.hideDecoration();
                            setCleanup(result);
                            cleanup?.();
                        }
                    });
                    return cleanup;
                }
                setCleanup(result);
                return ()=>{};
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const editorHasNotBeenFocused = (0, $42omo.useRef)(true);
            (0, $42omo.useEffect)(()=>{
                // relatch when editorView changes (pretty good signal for reinit)
                editorHasNotBeenFocused.current = true;
            }, [
                editorView
            ]);
            const { hasFocus: hasFocus, isOpen: isOpen, editorDisabled: editorDisabled, showToolbar: showToolbar, hasDangerDecorations: hasDangerDecorations, currentUserIntent: currentUserIntent } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
                'focus',
                'typeAhead',
                'editorDisabled',
                'toolbar',
                'decorations',
                'userIntent'
            ], (states)=>{
                return {
                    hasFocus: states.focusState?.hasFocus,
                    isOpen: states.typeAheadState?.isOpen,
                    editorDisabled: states.editorDisabledState?.editorDisabled,
                    showToolbar: states.toolbarState?.shouldShowToolbar,
                    hasDangerDecorations: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? states.decorationsState?.hasDangerDecorations : undefined,
                    currentUserIntent: states.userIntentState?.currentUserIntent
                };
            });
            const isForcedHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selectionMarker.isForcedHidden');
            (0, $42omo.useEffect)(()=>{
                // On editor init we should use this latch to keep the marker hidden until
                // editor has received focus. This means editor will be initially hidden until
                // the first focus occurs, and after first focus the normal above rules will
                // apply
                if (hasFocus === true) editorHasNotBeenFocused.current = false;
                const isBlockMenuOpen = currentUserIntent === 'blockMenuOpen' && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true);
                /**
				 * There are a number of conditions we should not show the marker,
				 * - Editor has not been focused: to keep the marker hidden until first focus if config is set
				 * - Focus: to ensure it doesn't interrupt the normal cursor
				 * - Typeahead Open: To ensure it doesn't show when we're typing in the typeahead
				 * - Disabled: So that it behaves similar to the renderer in live pages/disabled
				 * - Via the API: If another plugin has requested it to be hidden (force hidden).
				 * - If danger styles is shown in decorationsPlugin, then we don't need to show the selection marker
				 */ const shouldHide = config?.hideCursorOnInit && editorHasNotBeenFocused.current || hasFocus || (isOpen ?? false) || isForcedHidden || (editorDisabled ?? false) || (showToolbar ?? false) || !!hasDangerDecorations && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) || isBlockMenuOpen;
                requestAnimationFrame(()=>(0, $214b2ac46330636c$export$aaa3a3e05ac72aed)(editorView, shouldHide));
            }, [
                editorView,
                hasFocus,
                isOpen,
                isForcedHidden,
                editorDisabled,
                showToolbar,
                hasDangerDecorations,
                currentUserIntent
            ]);
        },
        contentComponent () {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b697d5da5a4f2d57$export$cc5403d58ddfa812), {});
        }
    };
};
function $6ebed5c180db8c8b$var$cleanupHiddenDecoration(api) {
    let hasRun = false;
    return ()=>{
        if (!hasRun && api?.selectionMarker?.sharedState.currentState()?.isForcedHidden) {
            hasRun = true;
            return api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $214b2ac46330636c$export$df61b30b684217c0), {
                    forceHide: false
                }));
        }
    };
}
module.exports["selectionMarkerPlugin"] = $6ebed5c180db8c8b$export$9015f1b1ef870734;

});

parcelRegister("1ewUw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $1S4f7 = parcelRequire("1S4f7");


var $b3YrF = parcelRequire("b3YrF");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");

var $b4ac84342b069ef3$export$b5b949bd8a2acfff = /*#__PURE__*/ function(AIDefinitionsActionType) {
    AIDefinitionsActionType["UPDATE_STATE"] = "UPDATE_STATE";
    AIDefinitionsActionType["UPDATE_KEYWORD_REGEX"] = "UPDATE_KEYWORD_REGEX";
    AIDefinitionsActionType["UPDATE_KEYWORD_DECORATIONS_SESSION_ID"] = "UPDATE_KEYWORD_DECORATIONS_SESSION_ID";
    AIDefinitionsActionType["UPDATE_KEYWORD_DECORATIONS"] = "UPDATE_KEYWORD_DECORATIONS";
    AIDefinitionsActionType["OPEN_READING_AIDS_POPUP"] = "OPEN_READING_AIDS_POPUP";
    AIDefinitionsActionType["CLOSE_READING_AIDS_POPUP"] = "CLOSE_READING_AIDS_POPUP";
    AIDefinitionsActionType["READING_AIDS_POPUP_LOADED"] = "READING_AIDS_POPUP_LOADED";
    return AIDefinitionsActionType;
}({});


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $lkJUe = parcelRequire("lkJUe");


var $jy7VG = parcelRequire("jy7VG");

var $cuprm = parcelRequire("cuprm");

var $8EkET = parcelRequire("8EkET");

var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");

function $772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) {
    const { name: name } = step.mark.type;
    return name === 'annotation';
}
function $772bf90734cc67a7$export$fd25270dcbdeb96d(step) {
    return(// bold will trigger AddMarkStep and RemoveMarkStep
    step instanceof (0, $aXG5V.AddMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || step instanceof (0, $aXG5V.RemoveMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || // add mark to node
    step instanceof (0, $aXG5V.AddNodeMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || step instanceof (0, $aXG5V.RemoveNodeMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || // update node attribute
    step instanceof (0, $aXG5V.AttrStep) || // update doc attribute
    step instanceof (0, $aXG5V.DocAttrStep) || // tick action item will trigger SetAttrsStep
    step instanceof (0, $9YoeD.SetAttrsStep) || // change link text will trigger LinkMetaStep
    step instanceof (0, $8EkET.LinkMetaStep) || // type / typeahead will trigger InsertTypeAheadStep
    step instanceof (0, $cuprm.InsertTypeAheadStep) || step instanceof (0, $jy7VG.AnalyticsStep));
}



var $ks2lK = parcelRequire("ks2lK");

const $e643aa1f936c8375$export$319f57d42a2c6302 = new (0, $ks2lK.PluginKey)('aiDefinitions');


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead




const $29bfada17494721a$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_STATE:
            return {
                ...state,
                // action is partial state, so we default to current state if not provided
                enabled: action.enabled ?? state.enabled,
                autoHighlightEnabled: action.autoHighlightEnabled ?? state.autoHighlightEnabled,
                enablementSource: action.enablementSource ?? state.enablementSource
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_REGEX:
            return {
                ...state,
                keywordRegex: action.keywordRegex
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS_SESSION_ID:
            return {
                ...state,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                keywordDecorationsSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS:
            return {
                ...state,
                keywordDecorations: action.keywordDecorations
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP:
            return {
                ...state,
                currentKeywordId: action.keywordId,
                isReadingAidsPopupOpen: true,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                readingAidsPopupKey: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                readingAidsPopupProps: action.readingAidsPopupProps,
                isReadingAidsPopupLoading: true
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).CLOSE_READING_AIDS_POPUP:
            return {
                ...state,
                currentKeywordId: undefined,
                isReadingAidsPopupOpen: false,
                readingAidsPopupKey: undefined,
                readingAidsPopupProps: undefined
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).READING_AIDS_POPUP_LOADED:
            return {
                ...state,
                isReadingAidsPopupLoading: false
            };
        default:
            return state;
    }
};
var $29bfada17494721a$export$2e2bcd8739ae039 = $29bfada17494721a$var$reducer;


function $cdfe3e78901f7853$var$mapping(tr, pluginState) {
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
    let { keywordDecorations: keywordDecorations } = pluginState;
    if (!enabled || !autoHighlightEnabled) return pluginState;
    keywordDecorations = keywordDecorations.map(tr.mapping, tr.doc);
    return {
        ...pluginState,
        keywordDecorations: keywordDecorations
    };
}
function $cdfe3e78901f7853$var$onDocChanged(tr, pluginState) {
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, keywordDecorationsSessionCounter: keywordDecorationsSessionCounter } = pluginState;
    if (!enabled || !autoHighlightEnabled) return pluginState;
    // regex has been reset, reset counter only
    if (!pluginState.keywordRegex) return {
        ...pluginState,
        keywordDecorationsSessionCounter: keywordDecorationsSessionCounter + 1
    };
    // changes like bold or text color will also trigger onDocChanged,
    // but changes like these don't include real content change
    // so if there is no content changed, don't reset state
    const noContentChanged = tr.steps.every((step)=>(0, $772bf90734cc67a7$export$fd25270dcbdeb96d)(step));
    if (noContentChanged) return pluginState;
    // doc content changed, reset regex, sessionId and counter
    return {
        ...pluginState,
        keywordRegex: undefined,
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        keywordDecorationsSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        keywordDecorationsSessionCounter: keywordDecorationsSessionCounter + 1
    };
}
const { createCommand: $cdfe3e78901f7853$export$8d4021544bdece00, getPluginState: $cdfe3e78901f7853$export$f05434c51e3762e, createPluginState: $cdfe3e78901f7853$export$656c7661095efe2e } = (0, $lkJUe.pluginFactory)((0, $e643aa1f936c8375$export$319f57d42a2c6302), (0, $29bfada17494721a$export$2e2bcd8739ae039), {
    mapping: $cdfe3e78901f7853$var$mapping,
    onDocChanged: $cdfe3e78901f7853$var$onDocChanged
});



function $7c930f74dee25a58$export$4971331372cec95a({ editorViewRef: editorViewRef }) {
    return (state)=>({ tr: tr })=>{
            if (!editorViewRef.current) return null;
            const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorViewRef.current.state);
            const keys = [
                'enabled',
                'autoHighlightEnabled',
                'enablementSource'
            ];
            const stateUnchanged = keys.every((key)=>{
                return state[key] === undefined || state[key] === pluginState[key];
            });
            if (stateUnchanged) return null;
            const action = {
                type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_STATE,
                ...state
            };
            return tr.setMeta((0, $e643aa1f936c8375$export$319f57d42a2c6302), action);
        };
}



var $jSnXV = parcelRequire("jSnXV");





var $ftzrq = parcelRequire("ftzrq");


var $d925B = parcelRequire("d925B");


var $2QlXt = parcelRequire("2QlXt");

const $09848075d67a4409$var$defineButtonClickedPayload = (readingAidsSessionId, wordCount)=>({
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_DEFINITIONS_DEFINE_BUTTON,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            readingAidsSessionId: readingAidsSessionId,
            wordCount: wordCount
        }
    });
const $09848075d67a4409$var$autoHighlightClickedPayload = (readingAidsSessionId)=>({
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DECORATION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_DEFINITIONS_AUTO_HIGHLIGHT,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            readingAidsSessionId: readingAidsSessionId
        }
    });
const $09848075d67a4409$export$100e4d52f8971e06 = ({ source: source, readingAidsSessionId: readingAidsSessionId, wordCount: wordCount })=>{
    return source === 'define-button-click' ? $09848075d67a4409$var$defineButtonClickedPayload(readingAidsSessionId, wordCount) : $09848075d67a4409$var$autoHighlightClickedPayload(readingAidsSessionId);
};
const $09848075d67a4409$export$aa3898e402a73b22 = ({ error: error, errorInfo: errorInfo })=>{
    return {
        action: (0, $d925B.ACTION).ERRORED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).AI_DEFINITIONS,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error),
            componentStack: errorInfo?.componentStack || ''
        }
    };
};







// id for ReadingAidsPopup portal container
const $ab88a2e785185b00$export$5e663b7e0d8861d1 = 'editor-ai-definitions-reading-aids-popup-portal-container';
const $ab88a2e785185b00$export$6fa82fd5fa91c059 = 'ai-definitions-keyword-decoration';
const $ab88a2e785185b00$export$e6a305940f3628e3 = 'ai-definitions-keyword-styler';
const $ab88a2e785185b00$export$785bdb9ccf5c31c1 = 'ai-definitions-keyword-styler-hover';
const $ab88a2e785185b00$export$bb7bab4b8547d886 = 'ai-definitions-keyword-styler-loading';



const $29d32991ed11e760$var$getSelectedText = (editorState)=>{
    const { from: from, to: to } = editorState.selection;
    const text = editorState.doc.textBetween(from, to, '\n');
    return text.trim();
};
const $29d32991ed11e760$export$4615c92e40b4fcd9 = (editorState)=>{
    if (editorState.selection.empty) return false;
    const text = $29d32991ed11e760$var$getSelectedText(editorState);
    return text.length > 0;
};
const $29d32991ed11e760$var$selectionWordCount = (editorState)=>{
    const text = $29d32991ed11e760$var$getSelectedText(editorState);
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return text.split(/\s+/u).length;
};
const $29d32991ed11e760$var$DEFAULT_MAX_WORD_COUNT = 1;
const $29d32991ed11e760$export$8e4734431f48a29a = (editorState, config)=>{
    const wordCount = $29d32991ed11e760$var$selectionWordCount(editorState);
    return wordCount > (config.readingAidsMaxWordCount ?? $29d32991ed11e760$var$DEFAULT_MAX_WORD_COUNT);
};
function $29d32991ed11e760$export$aa946c0ed562e2ed(range) {
    const portalContainer = document.getElementById((0, $ab88a2e785185b00$export$5e663b7e0d8861d1));
    if (!portalContainer) return null;
    const portalRect = portalContainer.getBoundingClientRect();
    const rect = range.getBoundingClientRect();
    const selectionRect = {
        top: rect.top - portalRect.top,
        left: rect.left - portalRect.left,
        width: rect.width,
        height: rect.height
    };
    return selectionRect;
}
const $29d32991ed11e760$export$fba2e0e287e213ab = (state)=>{
    if (!state || !state.selection || state.selection.empty) return null;
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return null;
    const range = selection.getRangeAt(0);
    if (!range || range.collapsed) return null;
    const { from: from, to: to } = state.selection;
    const selectedText = state.doc.textBetween(from, to, '\n');
    const selectionRect = $29d32991ed11e760$export$aa946c0ed562e2ed(range);
    return {
        selectionRange: range,
        selectionRect: selectionRect,
        selectedText: selectedText,
        // ReadingAidsPopup will apply a position shift to the popup.
        // - see file next/packages/contextual-reading-aids/src/ReadingAidsPopup.tsx
        isEditor: true
    };
};






const $f84f97a6b89a4f7c$export$49efb2449afa2765 = (id)=>{
    const styler = document.querySelector(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
    if (styler) styler.classList.add(`${(0, $ab88a2e785185b00$export$bb7bab4b8547d886)}`);
};
const $f84f97a6b89a4f7c$export$9d5d65b673a5731e = ()=>{
    const stylerArr = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$bb7bab4b8547d886)}`);
    for (const styler of stylerArr)styler.classList.remove(`${(0, $ab88a2e785185b00$export$bb7bab4b8547d886)}`);
};
const $f84f97a6b89a4f7c$export$61e1ef05609254a7 = (event)=>{
    const { target: target } = event;
    if ((0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(target) && target.dataset.id) {
        const id = target.dataset.id;
        const styler = document.querySelector(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
        if (styler) styler.classList.add(`${(0, $ab88a2e785185b00$export$785bdb9ccf5c31c1)}`);
    }
};
const $f84f97a6b89a4f7c$export$67fd1109fb9d83c0 = (event)=>{
    const { target: target } = event;
    if ((0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(target) && target.dataset.id) {
        const id = target.dataset.id;
        const styler = document.querySelector(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
        if (styler) styler.classList.remove(`${(0, $ab88a2e785185b00$export$785bdb9ccf5c31c1)}`);
    }
};
const $f84f97a6b89a4f7c$export$ec86b17ba41fd0b4 = (styler)=>{
    const id = styler.dataset.id;
    if (!id) return;
    // there might be multiple consecutive keyword inline decorations if there are other decorations on the keyword text
    const keywordDecorationArr = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`);
    const keywordStart = keywordDecorationArr[0];
    const keywordEnd = keywordDecorationArr[keywordDecorationArr.length - 1];
    if (styler && styler instanceof HTMLSpanElement && (0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(keywordStart) && (0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(keywordEnd)) {
        const range = document.createRange();
        range.setStartBefore(keywordStart);
        range.setEndAfter(keywordEnd);
        const rect = range.getBoundingClientRect();
        styler.style.setProperty('--ai-definitions-keyword-styler-width', `${rect.width}px`);
        styler.style.setProperty('--ai-definitions-keyword-styler-height', `${rect.height}px`);
    }
};
function $f84f97a6b89a4f7c$export$eb69c22734bde9b4() {
    const containers = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}`);
    for (const container of containers)if (container instanceof HTMLSpanElement) $f84f97a6b89a4f7c$export$ec86b17ba41fd0b4(container);
}
function $f84f97a6b89a4f7c$export$941ff97b157be2e9(dom) {
    const observer = new MutationObserver((records)=>{
        for (const record of records){
            for (const node of record.addedNodes)if (node instanceof HTMLSpanElement && node.classList.contains((0, $ab88a2e785185b00$export$e6a305940f3628e3))) $f84f97a6b89a4f7c$export$ec86b17ba41fd0b4(node);
        }
    });
    observer.observe(dom, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer.disconnect();
    };
}
const $f84f97a6b89a4f7c$export$fa50e52a0393d089 = ({ id: id })=>{
    // add an extra relative container to make the positioning easier
    const container = document.createElement('span');
    container.classList.add((0, $ab88a2e785185b00$export$e6a305940f3628e3), `${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
    container.dataset.id = id;
    return container;
};


function $0c52daf6fa262d4b$export$ec65e27b8f279045(node) {
    return Boolean(node && node instanceof HTMLSpanElement && node.classList.contains((0, $ab88a2e785185b00$export$6fa82fd5fa91c059)));
}
// props here is not a complete list, other common props are passed when rendering ReadingAidsPopup
// props are aligned with confluence/next/packages/contextual-reading-aids/src/ReadingAidsAcronymsHighlighter.tsx
// - some of which are from confluence/next/packages/contextual-reading-aids/src/RendererTextHighlighter.tsx
// props for AI define button are from confluence/next/packages/highlight-actions/src/HighlightActions.tsx
function $0c52daf6fa262d4b$var$getReadingAidsPopupPropsForKeyword({ keywordStart: keywordStart, keywordEnd: keywordEnd, editorView: editorView }) {
    const range = document.createRange();
    range.setStartBefore(keywordStart);
    range.setEndAfter(keywordEnd);
    const selectionRect = (0, $29d32991ed11e760$export$aa946c0ed562e2ed)(range);
    const selectedContext = keywordStart.parentElement;
    const additionalContext = selectedContext ? selectedContext.textContent || selectedContext.innerText : '';
    return {
        selectedText: range.toString(),
        additionalContext: additionalContext,
        selectionRange: range,
        selectionRect: selectionRect,
        onResult: ()=>{},
        onLoad: ()=>{
            (0, $f84f97a6b89a4f7c$export$9d5d65b673a5731e)();
            (0, $8f7cc697b051e2bb$export$4879e261232d25a5)()(editorView.state, editorView.dispatch);
        },
        onClose: ()=>{
            (0, $8f7cc697b051e2bb$export$1a54981d304e6ea8)({
                editorView: editorView
            });
        },
        isAutohighlighted: true,
        isEditor: true
    };
}
function $0c52daf6fa262d4b$var$handleOpenReadingAidsPopup({ event: event, editorView: editorView, api: api, id: id }) {
    // there might be multiple consecutive keyword inline decorations if there are other decorations on the keyword text
    const keywordDecorationArr = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`);
    const keywordStart = keywordDecorationArr[0];
    const keywordEnd = keywordDecorationArr[keywordDecorationArr.length - 1];
    if ($0c52daf6fa262d4b$export$ec65e27b8f279045(keywordStart) && $0c52daf6fa262d4b$export$ec65e27b8f279045(keywordEnd)) {
        const readingAidsPopupProps = $0c52daf6fa262d4b$var$getReadingAidsPopupPropsForKeyword({
            keywordStart: keywordStart,
            keywordEnd: keywordEnd,
            editorView: editorView
        });
        (0, $f84f97a6b89a4f7c$export$49efb2449afa2765)(id);
        (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'auto-highlight-click',
            keywordId: id,
            readingAidsPopupProps: readingAidsPopupProps
        })(editorView.state, editorView.dispatch);
        event.preventDefault();
        event.stopPropagation();
        return true;
    }
    return false;
}
const $0c52daf6fa262d4b$export$78fb7b30edc4d46 = ({ event: event, editorView: editorView, api: api })=>{
    const { target: target } = event;
    const aiDefinitionsPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
    const { isReadingAidsPopupOpen: isReadingAidsPopupOpen, currentKeywordId: currentKeywordId, isReadingAidsPopupLoading: isReadingAidsPopupLoading } = aiDefinitionsPluginState;
    // click keyword
    if ($0c52daf6fa262d4b$export$ec65e27b8f279045(target) && target.dataset.id) {
        const id = target.dataset.id;
        // click the same keyword while loading, do nothing
        if (id === currentKeywordId && isReadingAidsPopupLoading) {
            // prevent the click event from propagating to the popup to close it
            event.stopPropagation();
            event.preventDefault();
            return true;
        }
        // only open popup if there's no popup open
        if (!isReadingAidsPopupOpen) return $0c52daf6fa262d4b$var$handleOpenReadingAidsPopup({
            event: event,
            editorView: editorView,
            api: api,
            id: id
        });
    }
    // all other cases, if there is a ReadingAidsPopup open, close it
    if (isReadingAidsPopupOpen) (0, $8f7cc697b051e2bb$export$1a54981d304e6ea8)({
        editorView: editorView
    });
    return false;
};
// the confluence example is setup to match I&<>"'`.-D as a keyword, visit the example to see the generated ID
function $0c52daf6fa262d4b$var$encodeID(s) {
    if (s === '') return '_';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return s.replace(/[^a-zA-Z0-9-]/g, function(match) {
        return '_' + match[0].charCodeAt(0).toString(16);
    });
}
const $0c52daf6fa262d4b$export$cbc65810ed6fb565 = ({ keywordMatch: keywordMatch })=>{
    const { from: from, to: to, text: text } = keywordMatch;
    const id = `${from}-${to}-${$0c52daf6fa262d4b$var$encodeID(text)}`;
    return [
        (0, $ftzrq.Decoration).inline(from, to, {
            class: `${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)} ${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`,
            'data-id': id,
            'data-testid': (0, $ab88a2e785185b00$export$6fa82fd5fa91c059)
        }, {
            type: 'keyword',
            key: `${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`
        }),
        (0, $ftzrq.Decoration).widget(to, ()=>{
            return (0, $f84f97a6b89a4f7c$export$fa50e52a0393d089)({
                id: id
            });
        }, {
            type: 'keywordStyler',
            key: `${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`,
            stopEvent: ()=>true,
            ignoreSelection: true
        })
    ];
};
/**
 * Exclude the following nodes from keyword matching
 * - code
 * - status
 */ function $0c52daf6fa262d4b$var$excludeNode(node) {
    const { name: name } = node.type;
    return name === 'codeBlock' || name === 'status';
}
/**
 * Check if the text node conflict with keyword decoration
 * - annotation mark
 * - link mark
 * - code mark
 */ function $0c52daf6fa262d4b$var$isTextNodeConflictWithKeywordDecoration(node) {
    return node.isText && node.marks.some((mark)=>{
        const { name: name } = mark.type;
        return name === 'annotation' || name === 'link' || name === 'code';
    });
}
function $0c52daf6fa262d4b$export$80de22890b760cf9({ content: content, keywordRegex: keywordRegex, contentIndex: contentIndex = 0 }) {
    // each keyword is matched only once
    const set = new Set();
    const matches = [];
    let textGrouping = null;
    const collectMatch = (textGrouping)=>{
        if (!textGrouping) return;
        const { text: text, pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        const regexMatches = text.matchAll(keywordRegex);
        for (const regexMatch of regexMatches){
            const text = regexMatch[0];
            const textKey = keywordRegex.ignoreCase ? text.toUpperCase() : text;
            if (!set.has(textKey)) {
                set.add(textKey);
                matches.push({
                    from: pos + regexMatch.index,
                    to: pos + regexMatch.index + text.length,
                    text: text
                });
            }
        }
    };
    content.descendants((node, pos)=>{
        if ($0c52daf6fa262d4b$var$excludeNode(node)) return false;
        if (node.isText && node.text) {
            let text = node.text;
            if ($0c52daf6fa262d4b$var$isTextNodeConflictWithKeywordDecoration(node)) text = ' '.repeat(text.length);
            if (textGrouping === null) textGrouping = {
                pos: pos,
                text: text
            };
            else textGrouping.text += text;
        } else {
            if (textGrouping) collectMatch(textGrouping);
            textGrouping = null;
        }
    });
    // if there's a dangling text grouping and no non-text node to trigger collectMatch, manually collectMatch
    if (textGrouping) collectMatch(textGrouping);
    return matches;
}
function $0c52daf6fa262d4b$export$88a01eac2e110b7d({ editorView: editorView, keywordRegex: keywordRegex }) {
    let decorations = (0, $ftzrq.DecorationSet).empty;
    const keywordMatches = $0c52daf6fa262d4b$export$80de22890b760cf9({
        content: editorView.state.doc,
        keywordRegex: keywordRegex
    });
    for (const keywordMatch of keywordMatches){
        const keywordDecorations = $0c52daf6fa262d4b$export$cbc65810ed6fb565({
            keywordMatch: keywordMatch
        });
        decorations = decorations.add(editorView.state.doc, keywordDecorations);
    }
    return decorations;
}



const $8f7cc697b051e2bb$export$b4ed80ad73192385 = ({ keywordRegex: keywordRegex })=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_REGEX,
        keywordRegex: keywordRegex
    });
};
const $8f7cc697b051e2bb$export$75983c7c2acffd7c = ()=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS_SESSION_ID
    });
};
const $8f7cc697b051e2bb$export$e98d7ec2d44e59f9 = ({ api: api, source: source, keywordId: keywordId, readingAidsPopupProps: readingAidsPopupProps })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const readingAidsSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP,
        keywordId: keywordId,
        readingAidsPopupProps: {
            ...readingAidsPopupProps,
            sessionId: readingAidsSessionId
        }
    }, (tr)=>{
        if (api) {
            // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
            const wordCount = readingAidsPopupProps.selectedText.split(/\s+/u).length;
            const payload = (0, $09848075d67a4409$export$100e4d52f8971e06)({
                source: source,
                readingAidsSessionId: readingAidsSessionId,
                wordCount: wordCount
            });
            api.analytics?.actions.attachAnalyticsEvent(payload)(tr);
        }
        return tr;
    });
};
const $8f7cc697b051e2bb$export$309af81d3a816631 = ()=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).CLOSE_READING_AIDS_POPUP
    });
};
const $8f7cc697b051e2bb$export$4879e261232d25a5 = ()=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).READING_AIDS_POPUP_LOADED
    });
};
const $8f7cc697b051e2bb$export$2d7dadf7eed07e1e = ({ keywordDecorations: keywordDecorations })=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS,
        keywordDecorations: keywordDecorations
    });
};
const $8f7cc697b051e2bb$export$be9d3c2006420ec4 = ()=>{
    return $8f7cc697b051e2bb$export$2d7dadf7eed07e1e({
        keywordDecorations: (0, $ftzrq.DecorationSet).empty
    });
};
function $8f7cc697b051e2bb$var$isKeywordDecorationsSessionIdChanged({ editorView: editorView, keywordDecorationsSessionId: keywordDecorationsSessionId }) {
    const aiDefinitionsPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
    return keywordDecorationsSessionId !== aiDefinitionsPluginState.keywordDecorationsSessionId;
}
const $8f7cc697b051e2bb$export$30568dc20d74a453 = async ({ api: api, config: config, editorView: editorView })=>{
    try {
        const aiDefinitionsPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
        let { keywordRegex: keywordRegex } = aiDefinitionsPluginState;
        // if keywordRegex is not available, fetch it and update decorations
        if (!keywordRegex) {
            const { keywordDecorationsSessionId: keywordDecorationsSessionId } = aiDefinitionsPluginState;
            const res = await config.queryHighlightAcronyms?.({
                cacheKey: keywordDecorationsSessionId
            });
            // if sessionId changed, abandon the response
            if ($8f7cc697b051e2bb$var$isKeywordDecorationsSessionIdChanged({
                editorView: editorView,
                keywordDecorationsSessionId: keywordDecorationsSessionId
            })) return;
            if (res && res.acronymRegex) {
                keywordRegex = res.acronymRegex;
                $8f7cc697b051e2bb$export$b4ed80ad73192385({
                    keywordRegex: keywordRegex
                })(editorView.state, editorView.dispatch);
                const keywordDecorations = (0, $0c52daf6fa262d4b$export$88a01eac2e110b7d)({
                    editorView: editorView,
                    keywordRegex: keywordRegex
                });
                $8f7cc697b051e2bb$export$2d7dadf7eed07e1e({
                    keywordDecorations: keywordDecorations
                })(editorView.state, editorView.dispatch);
            }
        }
    } catch (error) {
        api?.analytics?.actions.fireAnalyticsEvent((0, $09848075d67a4409$export$aa3898e402a73b22)({
            error: error
        }));
    }
};
const $8f7cc697b051e2bb$export$8bb569df7c4f70df = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))($8f7cc697b051e2bb$export$30568dc20d74a453, 1000);
function $8f7cc697b051e2bb$export$1a54981d304e6ea8({ editorView: editorView }) {
    (0, $f84f97a6b89a4f7c$export$9d5d65b673a5731e)();
    $8f7cc697b051e2bb$export$309af81d3a816631()(editorView.state, editorView.dispatch);
}
const $8f7cc697b051e2bb$export$13cfc45f69ed2500 = ({ api: api, config: config, editorView: editorView, autoHighlightEnabled: autoHighlightEnabled, livePageMode: livePageMode })=>{
    // we want to closeReadingAidsPopup if there is one opened
    $8f7cc697b051e2bb$export$1a54981d304e6ea8({
        editorView: editorView
    });
    // currently, only show auto-highlights in view mode
    if (autoHighlightEnabled && livePageMode === 'view') {
        const cleanObserver = (0, $f84f97a6b89a4f7c$export$941ff97b157be2e9)(editorView.dom);
        // when the decorations aren't changed, the DOM nodes are already inserted when `view` is called
        // - only happens on Hello (not locally)
        // so there must be time racing somehow
        // so update DOM nodes positions here to make sure they are all positioned correctly
        (0, $f84f97a6b89a4f7c$export$eb69c22734bde9b4)();
        $8f7cc697b051e2bb$export$30568dc20d74a453({
            api: api,
            config: config,
            editorView: editorView
        });
        return cleanObserver;
    }
};











// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead






function $eb28b19ce9fcca2c$export$53ac33307b5acee9({ config: config }) {
    return {
        enabled: config.enabled ?? true,
        autoHighlightEnabled: config.autoHighlightEnabled ?? true,
        enablementSource: config.enablementSource,
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        keywordDecorationsSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        keywordDecorationsSessionCounter: 0,
        keywordDecorations: (0, $ftzrq.DecorationSet).empty,
        isReadingAidsPopupOpen: false,
        isReadingAidsPopupLoading: false
    };
}




const $316c7f360bb77dd1$export$e1b2f721e11eb39 = ({ dispatch: dispatch }, { api: api, config: config })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $e643aa1f936c8375$export$319f57d42a2c6302),
        state: (0, $cdfe3e78901f7853$export$656c7661095efe2e)(dispatch, ()=>(0, $eb28b19ce9fcca2c$export$53ac33307b5acee9)({
                config: config
            })),
        view: (editorView)=>{
            return {
                update: (editorView, prevState)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    const { keywordRegex: keywordRegex, keywordDecorationsSessionCounter: keywordDecorationsSessionCounter } = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const prevPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(prevState);
                    // if it's view mode, and there is no keywordRegex, and it's a new session, update keywords and decorations
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view' && !keywordRegex && keywordDecorationsSessionCounter !== prevPluginState.keywordDecorationsSessionCounter) (0, $8f7cc697b051e2bb$export$8bb569df7c4f70df)({
                        api: api,
                        config: config,
                        editorView: editorView
                    });
                }
            };
        },
        props: {
            decorations (state) {
                const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, keywordDecorations: keywordDecorations } = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
                if (!enabled || !autoHighlightEnabled) return;
                // currently, only show auto-highlights in view mode
                if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') return keywordDecorations;
                return (0, $ftzrq.DecorationSet).empty;
            },
            // currently, only show auto-highlights in view mode
            // so we only need to handle DOM events in view mode
            // reading mode outside of callbacks is not accurate, so need to read it in callbacks
            handleDOMEvents: {
                mouseover: (editorView, event)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $f84f97a6b89a4f7c$export$61e1ef05609254a7)(event);
                },
                mouseout: (editorView, event)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $f84f97a6b89a4f7c$export$67fd1109fb9d83c0)(event);
                },
                click: (editorView, event)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $0c52daf6fa262d4b$export$78fb7b30edc4d46)({
                        editorView: editorView,
                        event: event,
                        api: api
                    });
                }
            }
        }
    });
};







parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

const $39f414550ec3cd86$export$bd23a517b9ded82f = (0, $cgtv4.defineMessages)({
    aiDefineToolbarButtonTitle: {
        id: "fabric.editor.ai.selectionToolbar.define.title",
        defaultMessage: "Define"
    },
    aiDefineToolbarButtonDisabledTooltip: {
        id: "fabric.editor.ai.selectionToolbar.define.disabled.tooltip",
        defaultMessage: "Highlight a term, acronym, or abbreviation"
    }
});



var $3Mg7y = parcelRequire("3Mg7y");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");




const $71ad1b9295674d8f$export$b1a3c792af85451 = ({ intl: intl, state: state, config: config, api: api })=>{
    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
    const readingAidsPopupProps = (0, $29d32991ed11e760$export$fba2e0e287e213ab)(state);
    const disabled = (0, $29d32991ed11e760$export$8e4734431f48a29a)(state, config) || !readingAidsPopupProps;
    return {
        title: intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonTitle),
        type: 'button',
        showTitle: true,
        testId: 'ak-editor-ai-selection-toolbar-define-button',
        icon: ()=>pluginState.enablementSource === 'rovo' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                size: "small"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                label: ""
            }),
        iconFallback: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                size: "small"
            }),
        tooltipContent: disabled ? intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonDisabledTooltip) : undefined,
        disabled: disabled,
        onClick: readingAidsPopupProps ? (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'define-button-click',
            readingAidsPopupProps: readingAidsPopupProps
        }) : undefined,
        supportsViewMode: true
    };
};
const $71ad1b9295674d8f$export$e3893182b22560a6 = ({ intl: intl, state: state, config: config, api: api })=>{
    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
    const readingAidsPopupProps = (0, $29d32991ed11e760$export$fba2e0e287e213ab)(state);
    const disabled = (0, $29d32991ed11e760$export$8e4734431f48a29a)(state, config) || !readingAidsPopupProps;
    return {
        title: intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonTitle),
        icon: pluginState.enablementSource === 'rovo' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
            label: ""
        }),
        iconFallback: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                size: "small"
            }),
        tooltipContent: disabled ? intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonDisabledTooltip) : undefined,
        disabled: disabled,
        onClick: readingAidsPopupProps ? (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'define-button-click',
            readingAidsPopupProps: readingAidsPopupProps
        }) : undefined,
        rank: 20
    };
};


/* AIDefinitions.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 



var $gMc0m = parcelRequire("gMc0m");





var $eiA8Z = parcelRequire("eiA8Z");


var $dh538 = parcelRequire("dh538");





parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

function $a0b2953aa6fa4384$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/ensure-design-token-usage -- Ignored via go/DSP-18766
const $a0b2953aa6fa4384$var$aiDefinitionsStyle = {
    name: "yu6qqn",
    styles: ".ai-definitions-keyword-decoration{position:relative;cursor:pointer;}.ai-definitions-keyword-styler{--ai-definitions-keyword-styler-width:0;--ai-definitions-keyword-styler-height:0;position:relative;&::after{content:' ';position:absolute;top:0;right:0;width:var(--ai-definitions-keyword-styler-width);height:var(--ai-definitions-keyword-styler-height);cursor:pointer;pointer-events:none;border-image:linear-gradient(to right, #0065ff, #bf63f3, #f5e6a8) 0 0 100% 0;border-width:var(--ds-border-width-selected, 2px);border-bottom-style:solid;}&-hover{&::after{background:linear-gradient(to right, rgba(0, 101, 255, 0.1), rgba(191, 99, 243, 0.1));}}&-loading{&::after{border-color:transparent;border-image:none;}}}"
};
function $a0b2953aa6fa4384$export$982108a47f208f5a() {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9K4OG.Global), {
        styles: $a0b2953aa6fa4384$var$aiDefinitionsStyle
    });
}






function $79e74934abfcc8ca$export$3d264a8b1343e9d3({ api: api, show: show }) {
    (0, $42omo.useEffect)(()=>{
        if (show) api?.selectionToolbar.actions?.suppressToolbar?.();
        else api?.selectionToolbar.actions?.unsuppressToolbar?.();
        return ()=>{
            api?.selectionToolbar.actions?.unsuppressToolbar?.();
        };
    }, [
        api,
        show
    ]);
}


const $2e90d0de63228696$var$readingAidsPopupPortalContainerStyle = null;
function $2e90d0de63228696$var$canShowReadingAidsPopup({ props: props, enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, readingAidsPopupProps: readingAidsPopupProps, readingAidsPopupKey: readingAidsPopupKey, isReadingAidsPopupOpen: isReadingAidsPopupOpen }) {
    const { contentId: contentId, ReadingAidsPopup: ReadingAidsPopup, editorView: editorView } = props;
    if (editorView && enabled !== undefined && autoHighlightEnabled !== undefined && contentId && ReadingAidsPopup && isReadingAidsPopupOpen && readingAidsPopupKey && readingAidsPopupProps) return {
        show: true,
        contentId: contentId,
        ReadingAidsPopup: ReadingAidsPopup,
        isReadingAidsPopupOpen: isReadingAidsPopupOpen,
        readingAidsPopupKey: readingAidsPopupKey,
        readingAidsPopupProps: readingAidsPopupProps
    };
    return {
        show: false,
        contentId: undefined,
        ReadingAidsPopup: undefined,
        isReadingAidsPopupOpen: false,
        readingAidsPopupKey: undefined,
        readingAidsPopupProps: undefined
    };
}
const $2e90d0de63228696$export$fc2b565ec08fe192 = (props)=>{
    const { api: api, editorView: editorView } = props;
    const { enabled: sharedEnabled, autoHighlightEnabled: sharedAutoHighlightEnabled, readingAidsPopupProps: sharedReadingAidsPopupProps, readingAidsPopupKey: sharedReadingAidsPopupKey, isReadingAidsPopupOpen: sharedIsReadingAidsPopupOpen, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiDefinitions',
        'editorViewMode'
    ], (states)=>{
        return {
            enabled: states.aiDefinitionsState?.enabled,
            autoHighlightEnabled: states.aiDefinitionsState?.autoHighlightEnabled,
            readingAidsPopupProps: states.aiDefinitionsState?.readingAidsPopupProps,
            readingAidsPopupKey: states.aiDefinitionsState?.readingAidsPopupKey,
            isReadingAidsPopupOpen: states.aiDefinitionsState?.isReadingAidsPopupOpen,
            mode: states.editorViewModeState?.mode
        };
    });
    const defaultOnResult = (0, $42omo.useCallback)(()=>{}, []);
    const onLoad = (0, $42omo.useCallback)(()=>{
        sharedReadingAidsPopupProps?.onLoad?.(); // maybe log analytics event here in the future if needed
    }, [
        sharedReadingAidsPopupProps
    ]);
    const defaultOnClose = (0, $42omo.useCallback)(()=>{
        (0, $8f7cc697b051e2bb$export$309af81d3a816631)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const { show: show, contentId: contentId, ReadingAidsPopup: ReadingAidsPopup, readingAidsPopupKey: readingAidsPopupKey, readingAidsPopupProps: readingAidsPopupProps } = $2e90d0de63228696$var$canShowReadingAidsPopup({
        props: props,
        enabled: sharedEnabled,
        autoHighlightEnabled: sharedAutoHighlightEnabled,
        readingAidsPopupProps: sharedReadingAidsPopupProps,
        readingAidsPopupKey: sharedReadingAidsPopupKey,
        isReadingAidsPopupOpen: sharedIsReadingAidsPopupOpen
    });
    (0, $79e74934abfcc8ca$export$3d264a8b1343e9d3)({
        api: api,
        show: show
    });
    if (!sharedEnabled || !sharedAutoHighlightEnabled) return null;
    if (!(0, $dh538.fg)('platform_editor_ai_aifc_streaming')) {
        if (mode !== 'view') return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a0b2953aa6fa4384$export$982108a47f208f5a), {}),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                id: (0, $ab88a2e785185b00$export$5e663b7e0d8861d1),
                className: (0, $gMc0m.default)([
                    "_kqswh2mm"
                ])
            }),
            show ? /*#__PURE__*/ (0, $l998X.jsx)(ReadingAidsPopup, {
                ...readingAidsPopupProps,
                isReadingAidsOpen: true,
                popupPortalContainerId: (0, $ab88a2e785185b00$export$5e663b7e0d8861d1),
                contentId: contentId,
                onResult: readingAidsPopupProps?.onResult || defaultOnResult,
                onLoad: onLoad,
                onClose: readingAidsPopupProps?.onClose || defaultOnClose
            }, readingAidsPopupKey) : null
        ]
    });
};






class $cbfaed6854d1495f$export$3e783c4264baeca1 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.api?.analytics?.actions.fireAnalyticsEvent((0, $09848075d67a4409$export$aa3898e402a73b22)({
            error: error,
            errorInfo: errorInfo
        }));
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}



const $241e763b039b724c$export$cfdfeacb0c6e55a6 = ({ api: api, config: config })=>{
    const editorViewRef = {
        current: undefined
    };
    return {
        name: 'aiDefinitions',
        usePluginHook: ({ editorView: editorView })=>{
            const enabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiDefinitions.enabled');
            const autoHighlightEnabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiDefinitions.autoHighlightEnabled');
            const livePageMode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
            (0, $42omo.useEffect)(()=>{
                if (!enabled) return;
                // pass autoHighlightEnabled here, so that
                // when command updateState is called, it will trigger usePluginHook to rerun
                return (0, $8f7cc697b051e2bb$export$13cfc45f69ed2500)({
                    api: api,
                    config: config,
                    editorView: editorView,
                    livePageMode: livePageMode,
                    autoHighlightEnabled: autoHighlightEnabled
                });
            }, [
                editorView,
                enabled,
                autoHighlightEnabled,
                livePageMode
            ]);
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'aiDefinitionsEditorViewRef',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ];
            pmPlugins.push({
                name: 'aiDefinitions',
                plugin: (params)=>(0, $316c7f360bb77dd1$export$e1b2f721e11eb39)(params, {
                        api: api,
                        config: config
                    })
            });
            return pmPlugins;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const pluginState = (0, $e643aa1f936c8375$export$319f57d42a2c6302).getState(editorState);
            if (!pluginState) return null;
            return {
                enabled: pluginState.enabled,
                autoHighlightEnabled: pluginState.autoHighlightEnabled,
                isReadingAidsPopupOpen: pluginState.isReadingAidsPopupOpen,
                readingAidsPopupKey: pluginState.readingAidsPopupKey,
                readingAidsPopupProps: pluginState.readingAidsPopupProps
            };
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $cbfaed6854d1495f$export$3e783c4264baeca1), {
                api: api,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2e90d0de63228696$export$fc2b565ec08fe192), {
                    api: api,
                    editorView: editorView,
                    contentId: config.contentId,
                    ReadingAidsPopup: config.ReadingAidsPopup
                })
            });
        },
        pluginsOptions: {
            selectionToolbar: (state, intl)=>{
                const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
                if (!pluginState.enabled) return;
                const items = [];
                // only show AI define button in consumption mode
                if (api && (0, $29d32991ed11e760$export$4615c92e40b4fcd9)(state)) {
                    const aiDefinitionItem = api?.editorViewMode.sharedState.currentState()?.mode === 'view' ? (0, $71ad1b9295674d8f$export$b1a3c792af85451)({
                        intl: intl,
                        state: state,
                        config: config,
                        api: api
                    }) : null;
                    aiDefinitionItem && items.push(aiDefinitionItem);
                }
                if (items.length) return {
                    rank: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 10 : -10,
                    isToolbarAbove: true,
                    items: items
                };
            }
        },
        commands: {
            // this will update the plugin state and trigger the usePluginHook to rerun
            updateState: (0, $7c930f74dee25a58$export$4971331372cec95a)({
                editorViewRef: editorViewRef
            })
        },
        actions: {
            openReadingAidsPopup: ()=>{
                const readingAidsPopupProps = (0, $29d32991ed11e760$export$fba2e0e287e213ab)(editorViewRef.current?.state);
                if (editorViewRef.current && editorViewRef.current.state && editorViewRef.current.dispatch && readingAidsPopupProps) (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
                    api: api,
                    readingAidsPopupProps: readingAidsPopupProps,
                    source: 'define-button-click'
                })(editorViewRef.current.state, editorViewRef.current.dispatch);
            },
            selectionExceedsMaxWordCount: ()=>{
                const state = editorViewRef.current?.state;
                if (!state) return false;
                return (0, $29d32991ed11e760$export$8e4734431f48a29a)(state, config);
            }
        }
    };
};
module.exports["aiDefinitionsPlugin"] = $241e763b039b724c$export$cfdfeacb0c6e55a6;

});

parcelRegister("jLyos", function(module, exports) {
/**
 * @generated SignedSource<<cd0c84d685c31b6e889b43ed5f563ba0>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;



var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $fb9284d373020379$export$2e2bcd8739ae039);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b
    });
};
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("7WOVi", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $wPrRK = parcelRequire("wPrRK");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $4vyfK = parcelRequire("4vyfK");


var $3D1KL = parcelRequire("3D1KL");







var $kwDQA = parcelRequire("kwDQA");

const $e023a6d7dfd4d02c$export$1ca7520ec7e7778c = (contentId)=>(0, $dYU3e.query)({
        query: (0, $kwDQA.default),
        variables: {
            contentId: contentId
        }
    });



var $3Tnjq = parcelRequire("3Tnjq");





var $e3X7L = parcelRequire("e3X7L");

function $5aaba4497ca7f117$export$57e3b4d699814923(contentId, accountId) {
    return (0, $dYU3e.query)({
        query: (0, $e3X7L.default),
        variables: {
            contentId: contentId,
            accountId: accountId
        }
    });
}






var $8EyOs = parcelRequire("8EyOs");

async function $211ceb0d96c4c9d7$export$b64510f17befad98(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $8EyOs.default),
        variables: {
            contentId: contentId,
            isDraft: false,
            format: 'USER_FRIENDLY'
        },
        fetchPolicy: 'network-only'
    });
}






var $727Kl = parcelRequire("727Kl");

function $16805ac3e1fad5e8$export$e9cb71d0e8e23bd3(contentId, userId) {
    // skip preloading on SSR if user is not logged in
    if (!Boolean(userId)) return Promise.resolve({});
    return (0, $dYU3e.query)({
        query: (0, $727Kl.default),
        variables: {
            contentId: contentId
        }
    });
}



var $kb8ij = parcelRequire("kb8ij");




var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");



var $4VJDS = parcelRequire("4VJDS");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");

function $f78a51e3eee2d07c$export$4a035f320f010fac({ spaceKey: spaceKey, contentId: contentId, isLicensed: isLicensed, userId: userId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute = false, useNewContentTopper: useNewContentTopper = false, isLivePageRoute: isLivePageRoute = false }) {
    const queries = [];
    if (!(0, $6mKj3.expVal)('confluence_remove_fav_watch_preload_on_transitions', 'isEnabled', false)) {
        if (typeof window !== 'undefined') {
            if (!(0, $9wGTI.fg)('confluence_preload_favourite_button') || !isLivePageRoute) queries.push((0, $16805ac3e1fad5e8$export$e9cb71d0e8e23bd3)(contentId, userId));
        }
    }
    // We preload content header unconditionally but when page is restricted we don't
    // render the corresponding components, neither we use the result of preloading.
    // Hence mute the restriction errors on preloading to avoid unnecessary noise.
    // The mute logic is done in muteExpectedGraphQLErrors, here we just want to know if errors happened.
    let hasErrors = false;
    const checkHasGraphQLErrors = (result)=>{
        hasErrors || (hasErrors = Boolean(result?.hasErrors));
        return result;
    };
    // Don't preload queries that will be updated by editor if previous route is edit_page
    if (!isPrevEditRoute) {
        queries.push((()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $dYU3e.query)({
                query: (0, $fxLAA.default),
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    versionOverride: null,
                    embeddedContentRender: null,
                    limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                    useNewContentTopper: useNewContentTopper
                }
            }).then((_result)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                return checkHasGraphQLErrors(_result);
            });
        })());
        // Editor will preload the content state if it's a live page
        if (!isLivePageRoute) queries.push((()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $211ceb0d96c4c9d7$export$b64510f17befad98)(contentId).then((_result)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                return checkHasGraphQLErrors(_result);
            });
        })());
        // SSR Grant Access Restrictions button
        // username is a legacy URL parameter that actually represents accountId in the grant access flow
        if (contentId && username) queries.push((0, $5aaba4497ca7f117$export$57e3b4d699814923)(contentId, username));
        //unlike SPA, no need to check the route since preloadContentHeader is fired only when its VIEW_PAGE.
        const includeAncestors = edition === (0, $80xNa.CONFLUENCE_EDITION).FREE;
        queries.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeAncestors));
    }
    const contentHeaderTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_preload_content_header_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    if (!(0, $6mKj3.expVal)('confluence_remove_fav_watch_preload_on_transitions', 'isEnabled', false)) queries.push((0, $kb8ij.preloadWatchDialog)({
        contentId: contentId,
        isLicensed: isLicensed,
        userId: userId
    }));
    queries.push((0, $3D1KL.preloadEditButton)({
        spaceKey: spaceKey,
        contentId: contentId
    }));
    queries.push((0, $wPrRK.slowQueryGuard)('preloadContentAnalyticsViewers', ()=>(()=>{
            const _beforeResult4 = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $e023a6d7dfd4d02c$export$1ca7520ec7e7778c)(contentId).then((_result)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult4);
                return checkHasGraphQLErrors(_result);
            });
        })(), contentHeaderTimeout));
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !isLivePageRoute && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // preload data for whether "unpublished changes" label should show in view page object header
    queries.push((0, $4vyfK.preloadWebItemLocation)({
        location: 'page.metadata.banner',
        contentId: contentId
    }));
    return (()=>{
        const _beforeResult5 = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $lyWac.waitForAllReturnWhenError)(queries).then((errors)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult5);
            return Boolean(errors || hasErrors);
        });
    })();
}
module.exports["preloadContentHeader"] = $f78a51e3eee2d07c$export$4a035f320f010fac;

});

parcelRegister("cdE3K", function(module, exports) {

var $MyxIQ = parcelRequire("MyxIQ");


var $9wGTI = parcelRequire("9wGTI");


var $9WAeG = parcelRequire("9WAeG");


var $lyWac = parcelRequire("lyWac");

const $5983b7a8cf0f433d$export$5607995cc5080e70 = async (preloadedSessionContext)=>{
    const tasks = [];
    if (preloadedSessionContext.userId && (0, $9wGTI.fg)('post-office-confluence-side-nav-placement-rollout')) {
        const preloadPostOfficeSideNav = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceSideNav', async ()=>{
                return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-side-nav', preloadedSessionContext);
            });
        };
        tasks.push(preloadPostOfficeSideNav());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadPostOfficeConfluenceSideNav"] = $5983b7a8cf0f433d$export$5607995cc5080e70;

});


$parcel$global.rlb("6s6UC")
//# sourceMappingURL=FullPageEditorComponent.9c5a735c.js.map
